import React, { useState, useEffect, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom'; // PATCH_SENHA_V1

const API_BASE = 'https://app.pulsend.online/api';
const MAX_BOTS = 10;
const ALL_BOTS = Array.from({ length: MAX_BOTS }, (_, i) => ({ id: `bot${i + 1}`, label: `WhatsApp ${i + 1}` }));
const PLAN_BOTS = { prime: 1, basic: 1, premium: 2, pro: 3, custom10: 10 };
function getAllowedBots(plan) {
  const n = PLAN_BOTS[plan] || 1;
  return ALL_BOTS.slice(0, n);
}

function api(path, options = {}) {
  const token = localStorage.getItem('zs_token');
  return fetch(`${API_BASE}${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(options.headers || {}) },
  }).then(r => r.json()).catch(() => ({ ok: false, error: 'Erro de conexão' }));
}

function getStoredGroups(b) { try { return JSON.parse(localStorage.getItem(`zs_g_${b}`) || '[]'); } catch { return []; } }
function storeGroups(b, g) { localStorage.setItem(`zs_g_${b}`, JSON.stringify(g)); }
function getStoredSel(b) { try { return JSON.parse(localStorage.getItem(`zs_s_${b}`) || '[]'); } catch { return []; } }
function storeSel(b, s) { localStorage.setItem(`zs_s_${b}`, JSON.stringify(s)); }
function getTheme() { return localStorage.getItem('zs_theme') || 'dark'; }
function setThemePref(t) { localStorage.setItem('zs_theme', t); }

function buildStyles(theme) {
  const d = theme === 'dark';
  return `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --bg:${d ? '#0e1117' : '#f2f4f7'};
  --bg2:${d ? '#161b25' : '#ffffff'};
  --bg3:${d ? '#1c2333' : '#f7f9fc'};
  --bg4:${d ? '#232c3d' : '#edf0f5'};
  --border:${d ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.08)'};
  --border2:${d ? 'rgba(255,255,255,0.13)' : 'rgba(0,0,0,0.14)'};
  --accent:#00d084;--accent2:#00b371;
  --accent-dim:${d ? 'rgba(0,208,132,0.1)' : 'rgba(0,208,132,0.1)'};
  --accent-glow:rgba(0,208,132,0.22);
  --red:#f05252;--red-dim:rgba(240,82,82,0.1);
  --yellow:#e3a008;--yellow-dim:rgba(227,160,8,0.1);
  --blue:#3f83f8;--blue-dim:rgba(63,131,248,0.1);
  --orange:#f97316;--orange-dim:rgba(249,115,22,0.1);
  --text:${d ? '#e2e8f0' : '#1a202c'};
  --text2:${d ? '#8892a4' : '#4a5568'};
  --text3:${d ? '#8892a4' : '#a0aec0'};
  --card-shadow:${d ? '0 2px 12px rgba(0,0,0,0.35)' : '0 2px 12px rgba(0,0,0,0.08)'};
  --card-shadow-hover:${d ? '0 6px 24px rgba(0,0,0,0.5)' : '0 6px 24px rgba(0,0,0,0.13)'};
  --grp-shadow:${d ? '0 2px 8px rgba(0,0,0,0.4)' : '0 2px 8px rgba(0,0,0,0.07)'};
  --sidebar:220px;--r:14px;--r-sm:9px;
}
html,body{background:var(--bg);color:var(--text);font-family:'Inter',system-ui,sans-serif;-webkit-font-smoothing:antialiased;min-height:100vh;font-size:clamp(14px,1vw + 10px,17px);line-height:1.55;transition:background .3s,color .3s}
::-webkit-scrollbar{width:4px;height:4px}::-webkit-scrollbar-thumb{background:var(--border2);border-radius:4px}
@keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
@keyframes spin{to{transform:rotate(360deg)}}
@keyframes pulse{0%,100%{opacity:1}50%{opacity:.3}}
@keyframes toastIn{from{opacity:0;transform:translateX(16px)}to{opacity:1;transform:translateX(0)}}
@keyframes shimmer{0%{background-position:-200% 0}100%{background-position:200% 0}}
@keyframes glowPulse{0%,100%{box-shadow:0 0 8px rgba(0,208,132,.15)}50%{box-shadow:0 0 20px rgba(0,208,132,.35)}}
@keyframes countUp{from{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}
@keyframes checkBounce{0%{transform:scale(0)}50%{transform:scale(1.3)}100%{transform:scale(1)}}
@keyframes slideIn{from{opacity:0;transform:translateX(-8px)}to{opacity:1;transform:translateX(0)}}
@keyframes borderGlow{0%,100%{border-color:rgba(0,208,132,.25)}50%{border-color:rgba(0,208,132,.5)}}
@keyframes bellShake{0%{transform:rotate(0)}15%{transform:rotate(14deg)}30%{transform:rotate(-12deg)}45%{transform:rotate(8deg)}60%{transform:rotate(-6deg)}75%{transform:rotate(3deg)}100%{transform:rotate(0)}}
.fade-up{animation:fadeUp .32s cubic-bezier(.22,1,.36,1) both}
.fade-up>*:nth-child(1){animation:fadeUp .32s cubic-bezier(.22,1,.36,1) .05s both}
.fade-up>*:nth-child(2){animation:fadeUp .32s cubic-bezier(.22,1,.36,1) .1s both}
.fade-up>*:nth-child(3){animation:fadeUp .32s cubic-bezier(.22,1,.36,1) .15s both}
.fade-up>*:nth-child(4){animation:fadeUp .32s cubic-bezier(.22,1,.36,1) .2s both}
.fade-up>*:nth-child(5){animation:fadeUp .32s cubic-bezier(.22,1,.36,1) .25s both}
.layout{display:flex;min-height:100vh}
.sidebar{width:var(--sidebar);background:var(--bg2);border-right:1px solid var(--border);display:flex;flex-direction:column;position:fixed;left:0;top:0;bottom:0;padding-top:env(safe-area-inset-top, 0px);z-index:200;transition:transform .28s cubic-bezier(.4,0,.2,1),background .3s}
.overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:199;backdrop-filter:blur(2px)}
.overlay.show{display:block}
.content{margin-left:var(--sidebar);flex:1;display:flex;flex-direction:column;min-height:100vh}
.topbar{display:none;align-items:center;gap:10px;padding:14px 18px;padding-top:calc(14px + env(safe-area-inset-top, 0px));background:var(--bg2);border-bottom:1px solid var(--border);position:sticky;top:0;z-index:100;transition:background .3s;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px)}
.desktop-header-bar{display:flex}
.topbar-name{font-size:18px;font-weight:900;flex:1;letter-spacing:-.4px}
.topbar-name span{color:var(--accent)}
.ham{background:none;border:none;cursor:pointer;color:var(--text2);padding:6px;border-radius:8px;font-size:20px;line-height:1;display:flex;align-items:center;justify-content:center;transition:all .15s}
.ham:hover{background:var(--bg3);color:var(--text)}
.inner{padding:clamp(4px,1.5vw,32px) clamp(4px,2vw,40px);max-width:min(100%,2200px);width:100%}
@media(max-width:768px){
.sidebar{transform:translateX(-100%)}
.sidebar.open{transform:translateX(0);box-shadow:4px 0 30px rgba(0,0,0,.4)}
.content{margin-left:0}
.topbar{display:flex}
.desktop-header-bar{display:none !important}
.inner{padding:12px 10px;max-width:100%;width:100%}
.ph h1{font-size:22px}
.ph p{font-size:13px}
.card{padding:16px 14px;margin-bottom:12px}
.btn{padding:12px 16px;font-size:15px}
.btn-sm{padding:10px 14px;font-size:14px}
.btn-full{padding:14px;font-size:16px}
.btn-bar{gap:8px}
.grp-grid{grid-template-columns:1fr;gap:8px;max-height:280px}
.gi{padding:12px 14px;font-size:14px}
.gn{font-size:14px}
.gck{width:20px;height:20px;font-size:12px}
.fi,.fs,.fta{padding:13px 14px;font-size:15px}
.type-btn{padding:12px 14px;font-size:15px}
.type-row{gap:6px}
.grp-head{gap:8px}
.grp-cnt{font-size:13px}
.fg{margin-bottom:18px}
.stat{padding:16px 12px}
.stat-n{font-size:28px}
.chip{font-size:12px;padding:4px 10px}
.card-t{font-size:16px}
.card-s{font-size:13px}
.topbar-name{font-size:18px}
.feed-card{border-radius:12px}
.feed-time{white-space:normal;word-break:break-word;font-size:11px}
.feed-row1{flex-wrap:wrap;gap:6px}
.feed-grp{font-size:13px;white-space:normal;word-break:break-word}
.feed-footer{flex-direction:column;align-items:flex-start;gap:8px}
.feed-actions{flex-wrap:wrap;width:100%}
.feed-actions .btn{flex:1;justify-content:center;min-width:0}
.chip{font-size:11px;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.card-hd{flex-wrap:wrap}
.feed-body{padding:12px}
.feed-card .feed-body{padding:10px 12px}
.feed-grp{max-width:calc(100vw - 120px)}
.feed-row1 .chip{flex-shrink:0}
}

@media(min-width:1600px){.inner{max-width:90vw}.grp-grid{grid-template-columns:1fr 1fr 1fr}}
.bot-sel-mobile{display:none;width:100%;background:${d ? '#161b25' : '#ffffff'};border:1.5px solid ${d ? 'rgba(255,255,255,0.13)' : 'rgba(0,0,0,0.14)'};border-radius:var(--r);color:var(--text);font-family:Inter,sans-serif;font-size:15px;font-weight:700;padding:14px 16px;cursor:pointer;outline:none;appearance:none;-webkit-appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2300d084' stroke-width='2.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 14px center;padding-right:44px;box-shadow:0 2px 12px rgba(0,0,0,.15);transition:border-color .15s,box-shadow .15s;margin-bottom:14px}
.bot-sel-mobile:focus{border-color:var(--accent);box-shadow:0 0 0 3px var(--accent-glow)}
.bot-tabs-desktop{display:flex}
@media(max-width:768px){.bot-sel-mobile{display:block !important}.bot-tabs-desktop{display:none !important}}
.logo{padding:22px 18px 18px;border-bottom:1px solid var(--border);position:relative;flex-shrink:0}
.logo::after{content:'';position:absolute;bottom:-1px;left:18px;right:18px;height:1px;background:linear-gradient(90deg,transparent,var(--accent-glow),transparent)}
.logo-row{display:flex;align-items:center;gap:12px}
.logo-icon{width:38px;height:38px;background:linear-gradient(135deg,var(--accent),#00956b);border-radius:11px;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;box-shadow:0 4px 16px var(--accent-glow);transition:transform .3s cubic-bezier(.22,1,.36,1)}
.logo-icon:hover{transform:scale(1.08) rotate(-3deg)}
.logo-n{font-size:clamp(16px,1.2vw,19px);font-weight:900;letter-spacing:-.4px;line-height:1.1}
.logo-n span{color:var(--accent)}
.logo-t{font-size:9.5px;color:var(--text3);text-transform:uppercase;letter-spacing:1.6px;margin-top:3px;font-family:'JetBrains Mono',monospace}
.nav{padding:12px 8px;flex:1 1 0;min-height:0;display:flex;flex-direction:column;gap:2px;overflow-y:auto;overflow-x:hidden;scrollbar-width:thin;scrollbar-color:var(--border2) transparent;-webkit-overflow-scrolling:touch}.nav::-webkit-scrollbar{width:4px}.nav::-webkit-scrollbar-track{background:transparent}.nav::-webkit-scrollbar-thumb{background:var(--border2);border-radius:4px}.nav::-webkit-scrollbar-thumb:hover{background:var(--text3)}
.nb{display:flex;align-items:center;gap:11px;width:100%;padding:11px 14px;border:none;background:transparent;color:var(--text2);border-radius:10px;cursor:pointer;font-size:clamp(13px,0.95vw,14.5px);font-weight:600;font-family:'Inter',sans-serif;transition:all .2s cubic-bezier(.22,1,.36,1);text-align:left;position:relative;overflow:hidden}
.nb::before{content:'';position:absolute;left:0;top:15%;bottom:15%;width:3px;border-radius:0 3px 3px 0;background:var(--accent);transform:scaleY(0);transition:transform .2s cubic-bezier(.22,1,.36,1)}
.nb:hover{background:var(--bg3);color:var(--text);transform:translateX(2px)}
.nb.active{background:linear-gradient(135deg,rgba(0,208,132,.12),rgba(0,208,132,.04));color:var(--accent);font-weight:700;box-shadow:0 2px 12px rgba(0,208,132,.08)}
.nb.active::before{transform:scaleY(1)}
.nb-ico{font-size:18px;width:24px;text-align:center;flex-shrink:0;transition:transform .2s}
.nb:hover .nb-ico{transform:scale(1.1)}
.nb.active .nb-ico{transform:scale(1.15)}
.sfoot{padding:14px 8px;padding-bottom:calc(14px + env(safe-area-inset-bottom, 0px));border-top:1px solid var(--border);display:flex;flex-direction:column;gap:8px;position:relative;flex-shrink:0}
.sfoot::before{content:'';position:absolute;top:-1px;left:8px;right:8px;height:1px;background:linear-gradient(90deg,transparent,var(--border2),transparent)}
.theme-btn{display:flex;align-items:center;gap:9px;padding:10px 13px;background:var(--bg3);border-radius:10px;cursor:pointer;border:1px solid var(--border);width:100%;font-family:'Inter',sans-serif;transition:all .2s}
.theme-btn:hover{border-color:var(--border2);background:var(--bg4);transform:translateY(-1px)}
.theme-label{font-size:13px;font-weight:600;color:var(--text2);flex:1;text-align:left}
.toggle{width:38px;height:21px;background:var(--bg4);border-radius:11px;position:relative;transition:background .2s;flex-shrink:0;border:1px solid var(--border2)}
.toggle.on{background:var(--accent);border-color:var(--accent)}
.toggle::after{content:'';position:absolute;width:15px;height:15px;border-radius:50%;background:#fff;top:2px;left:2px;transition:transform .2s;box-shadow:0 1px 3px rgba(0,0,0,.3)}
.toggle.on::after{transform:translateX(17px)}
.urow{display:flex;align-items:center;gap:10px;padding:10px 13px;background:var(--bg3);border-radius:10px;border:1px solid var(--border);transition:all .2s}
.urow:hover{border-color:var(--border2);background:var(--bg4)}
.av{width:32px;height:32px;border-radius:10px;background:linear-gradient(135deg,var(--accent),var(--blue));display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:800;color:#000;flex-shrink:0;box-shadow:0 2px 8px rgba(0,208,132,.15)}
.av.adm{background:linear-gradient(135deg,#f05252,#e3a008)}
.ue{font-size:12px;color:var(--text2);flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:500}
.lob{background:none;border:none;cursor:pointer;color:var(--text3);padding:4px 7px;border-radius:6px;font-size:13px;transition:all .15s;line-height:1}
.lob:hover{background:var(--red-dim);color:var(--red)}
.ph{margin-bottom:22px}
.ph h1{font-size:clamp(20px,2.5vw,28px);font-weight:800;letter-spacing:-.4px;line-height:1.2}
.ph p{font-size:13px;color:var(--text3);margin-top:4px;font-weight:500}
.card{background:var(--bg2);border:1.5px solid var(--border);border-radius:16px;padding:22px;margin-bottom:18px;box-shadow:var(--card-shadow);transition:all .25s cubic-bezier(.22,1,.36,1);position:relative}
.card:hover{box-shadow:var(--card-shadow-hover);border-color:var(--border2)}
.card-hd{display:flex;align-items:flex-start;justify-content:space-between;gap:10px;margin-bottom:16px}
.card-t{font-size:clamp(14px,1.1vw,17px);font-weight:700;letter-spacing:-.2px}
.card-s{font-size:12px;color:var(--text3);margin-top:3px;font-weight:500}
.bdg{display:inline-flex;align-items:center;gap:6px;padding:5px 12px;border-radius:20px;font-size:11.5px;font-weight:800;white-space:nowrap;flex-shrink:0;transition:all .2s;letter-spacing:.2px}
.bdg .d{width:7px;height:7px;border-radius:50%;flex-shrink:0;transition:all .2s}
.b-open{background:var(--accent-dim);color:var(--accent);border:1px solid rgba(0,208,132,.15)}.b-open .d{background:var(--accent);box-shadow:0 0 6px var(--accent-glow);animation:glowPulse 2.5s ease infinite}
.b-qr{background:var(--yellow-dim);color:var(--yellow);border:1px solid rgba(227,160,8,.15)}.b-qr .d{background:var(--yellow);animation:pulse 1.4s infinite}
.b-connecting{background:var(--blue-dim);color:var(--blue);border:1px solid rgba(63,131,248,.15)}.b-connecting .d{background:var(--blue);animation:pulse 1s infinite}
.b-closed,.b-error{background:var(--red-dim);color:var(--red);border:1px solid rgba(240,82,82,.12)}.b-closed .d,.b-error .d{background:var(--red)}
.b-offline{background:var(--bg4);color:var(--text3);border:1px solid var(--border)}.b-offline .d{background:var(--text3)}
.qr-box{background:var(--bg3);border:2px dashed var(--border2);border-radius:16px;padding:28px;display:flex;flex-direction:column;align-items:center;gap:14px;margin-top:14px;position:relative;overflow:hidden;transition:border-color .3s}
.qr-box::before{content:'';position:absolute;inset:0;background:radial-gradient(circle at 50% 0%,rgba(0,208,132,.06),transparent 70%);pointer-events:none}
.qr-box:hover{border-color:rgba(0,208,132,.3)}
.qr-img{width:200px;height:200px;border-radius:14px;background:#fff;padding:8px;box-shadow:0 8px 32px rgba(0,0,0,.35),0 0 0 1px rgba(255,255,255,.08);animation:fadeUp .4s cubic-bezier(.22,1,.36,1) both;position:relative}
.qr-tip{font-size:12.5px;color:var(--text3);text-align:center;line-height:1.7;font-weight:500;max-width:280px}
.conn-box{display:flex;align-items:center;gap:16px;padding:16px 20px;background:linear-gradient(135deg,rgba(0,208,132,.12),rgba(0,208,132,.04));border:1.5px solid rgba(0,208,132,.25);border-radius:16px;margin-top:14px;position:relative;overflow:hidden;transition:all .3s}
.conn-box::before{content:'';position:absolute;inset:0;background:radial-gradient(circle at 0% 50%,rgba(0,208,132,.08),transparent 60%);pointer-events:none}
.conn-box:hover{box-shadow:0 4px 24px rgba(0,208,132,.12);border-color:rgba(0,208,132,.4)}
.conn-ico{font-size:28px;animation:countUp .4s cubic-bezier(.22,1,.36,1) both}
.conn-t{font-weight:800;font-size:15px;color:var(--accent);letter-spacing:-.2px}
.conn-s{font-size:12.5px;color:var(--text3);margin-top:3px;font-weight:500;font-family:'JetBrains Mono',monospace}
.spinner{width:36px;height:36px;border:3px solid var(--border2);border-top-color:var(--accent);border-radius:50%;animation:spin .7s linear infinite;filter:drop-shadow(0 0 6px var(--accent-glow))}
.btn{display:inline-flex;align-items:center;gap:6px;padding:clamp(7px,0.8vw,11px) clamp(12px,1.2vw,20px);border-radius:var(--r-sm);font-size:clamp(13px,0.9vw,15px);font-weight:700;font-family:'Inter',sans-serif;cursor:pointer;border:none;transition:all .15s;white-space:nowrap;line-height:1.2}
.btn:disabled{opacity:.4;cursor:not-allowed}
.btn-p{background:var(--accent);color:#000}.btn-p:hover:not(:disabled){background:var(--accent2);box-shadow:0 4px 16px var(--accent-glow);transform:translateY(-1px)}
.btn-g{background:var(--bg3);color:var(--text2);border:1.5px solid var(--border)}.btn-g:hover:not(:disabled){border-color:var(--border2);color:var(--text);background:var(--bg4)}
.btn-d{background:var(--red-dim);color:var(--red);border:1.5px solid rgba(240,82,82,.15)}.btn-d:hover:not(:disabled){background:rgba(240,82,82,.18)}
.btn-w{background:var(--yellow-dim);color:var(--yellow);border:1.5px solid rgba(227,160,8,.15)}.btn-w:hover:not(:disabled){background:rgba(227,160,8,.18)}
.btn-o{background:var(--orange-dim);color:var(--orange);border:1.5px solid rgba(249,115,22,.15)}.btn-o:hover:not(:disabled){background:rgba(249,115,22,.22)}
.btn-full{width:100%;justify-content:center;padding:12px}
.btn-sm{padding:6px 12px;font-size:13px}
.btn-bar{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:16px}
.fg{margin-bottom:16px}
.fl{display:block;font-size:clamp(10px,0.75vw,12px);font-weight:800;color:#999;margin-bottom:6px;text-transform:uppercase;letter-spacing:.8px}
.fi,.fs,.fta{width:100%;background:var(--bg3);border:1.5px solid var(--border);border-radius:var(--r-sm);padding:clamp(8px,0.8vw,12px) clamp(12px,1vw,16px);font-size:clamp(13px,0.9vw,15px);color:var(--text);font-family:'Inter',sans-serif;transition:border-color .15s,background .3s;outline:none}
.fi:focus,.fs:focus,.fta:focus{border-color:var(--accent);background:var(--bg2)}
.fta{resize:vertical;min-height:85px;line-height:1.6}
.fs{cursor:pointer}.fs option{background:var(--bg3);color:var(--text)}
.type-row{display:flex;background:var(--bg3);padding:4px;border-radius:var(--r-sm);gap:4px;margin-bottom:16px;border:1px solid var(--border)}
.type-btn{flex:1;padding:8px 14px;border:none;background:transparent;color:var(--text3);font-size:14px;font-weight:700;font-family:'Inter',sans-serif;cursor:pointer;border-radius:7px;transition:all .15s}
.type-btn.active{background:var(--accent);color:#000;box-shadow:0 2px 10px var(--accent-glow);font-weight:800}
.grp-head{display:flex;flex-wrap:wrap;align-items:center;gap:7px;margin-bottom:10px}
.grp-cnt{font-size:11.5px;font-weight:700;color:var(--text3);margin-left:auto;font-family:'JetBrains Mono',monospace}
.grp-grid{display:grid;grid-template-columns:1fr 1fr;gap:6px;max-height:220px;overflow-y:auto;padding:2px}
@media(max-width:480px){
.grp-grid{grid-template-columns:1fr;gap:8px}
.btn{padding:13px 16px;font-size:15px}
.btn-sm{padding:11px 14px;font-size:14px}
.fi,.fs,.fta{font-size:16px}
.ph h1{font-size:20px}
}
.gi{display:flex;align-items:center;gap:10px;padding:10px 14px;background:var(--bg2);border:1.5px solid var(--border);border-radius:12px;cursor:pointer;font-size:13px;color:var(--text2);transition:all .2s cubic-bezier(.22,1,.36,1);user-select:none;box-shadow:var(--grp-shadow);position:relative;overflow:hidden}
.gi::before{content:'';position:absolute;inset:0;background:linear-gradient(135deg,rgba(0,208,132,.06),transparent);opacity:0;transition:opacity .2s}
.gi:hover{border-color:rgba(0,208,132,.4);color:var(--text);box-shadow:0 4px 16px rgba(0,208,132,.1);transform:translateY(-1px)}
.gi:hover::before{opacity:1}
.gi:active{transform:translateY(0) scale(.98)}
.gi.sel{background:linear-gradient(135deg,rgba(0,208,132,.15),rgba(0,208,132,.06));border-color:var(--accent);color:var(--accent);box-shadow:0 4px 20px var(--accent-glow)}
.gn{position:relative;text-overflow:ellipsis;white-space:nowrap;flex:1;padding-right:4px}
.gi.show-tip .gn::after{opacity:1;visibility:visible;transform:translateX(-50%) translateY(0)}
.gi:hover .gn::after{opacity:1;visibility:visible;transform:translateX(-50%) translateY(0)}
.gn::after{content:attr(data-full);position:absolute;bottom:calc(100% + 12px);left:50%;transform:translateX(-50%) translateY(6px);background:var(--bg4);color:var(--text);padding:10px 16px;border-radius:10px;font-size:13px;font-weight:500;white-space:nowrap;pointer-events:none;opacity:0;visibility:hidden;transition:all .28s cubic-bezier(.22,1,.36,1);box-shadow:0 8px 24px rgba(0,0,0,.5);border:1px solid var(--border2);z-index:10000;max-width:min(320px,80vw);word-wrap:break-word;white-space:normal;text-align:center;line-height:1.4}
.gn[data-full]::before{content:'';position:absolute;top:calc(100% + 2px);left:50%;transform:translateX(-50%);border:7px solid transparent;border-top-color:var(--bg4);opacity:0;visibility:hidden;transition:all .28s cubic-bezier(.22,1,.36,1);z-index:10001;pointer-events:none}
.gi.show-tip .gn[data-full]::before{opacity:1;visibility:visible}
.gi:hover .gn[data-full]::before{opacity:1;visibility:visible}
.gn{position:relative;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}
.gi:hover .gn-tooltip{opacity:1 !important;visibility:visible !important;display:block !important}
.gn-tooltip{position:absolute;bottom:calc(100% + 8px);left:12px;transform:translateX(-50%) translateY(4px);background:var(--bg4);color:var(--text);padding:8px 14px;border-radius:10px;font-size:13px;font-weight:500;white-space:nowrap;pointer-events:none;opacity:0;visibility:hidden;transition:all .25s cubic-bezier(.22,1,.36,1);box-shadow:0 6px 20px rgba(0,0,0,.4);border:1px solid var(--border2);z-index:999999;max-width:320px}
.gn-tooltip::after{content:'';position:absolute;top:100%;left:50%;transform:translateX(-50%);border:6px solid transparent;border-top-color:var(--bg4)}
.gi.sel::before{opacity:1}
.gck{width:18px;height:18px;border-radius:6px;border:2px solid var(--border2);flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800;transition:all .2s cubic-bezier(.22,1,.36,1)}
.gi.sel .gck{background:var(--accent);border-color:var(--accent);color:#000;box-shadow:0 0 8px var(--accent-glow);animation:checkBounce .3s cubic-bezier(.22,1,.36,1)}
.gn{position:relative;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1;font-weight:600;font-size:12.5px}
.fdrop{border:2px dashed var(--border2);border-radius:var(--r-sm);padding:16px;display:flex;align-items:center;gap:12px;cursor:pointer;transition:all .15s;background:var(--bg3)}
.fdrop:hover,.fdrop.has{border-color:var(--accent);background:var(--accent-dim)}
.fdrop input{display:none}
.fdrop-ico{font-size:22px;flex-shrink:0}
.fdrop-txt{font-size:13.5px;color:var(--text3);font-weight:600}
.fdrop.has .fdrop-txt{color:var(--accent)}
.feed{display:flex;flex-direction:column;gap:16px}
.feed-card{background:var(--bg2);border:1.5px solid var(--border);border-radius:16px;overflow:hidden;box-shadow:var(--card-shadow);transition:border-color .15s,box-shadow .15s}
.feed-card:hover{border-color:var(--border2);box-shadow:var(--card-shadow-hover)}
.feed-media-wrap{position:relative;background:var(--bg3);overflow:hidden;display:flex;align-items:center;justify-content:center;border-radius:8px;width:100%}
.feed-media-wrap img{width:100%;max-height:360px;object-fit:contain;display:block}
.feed-media-wrap video{width:100%;max-height:360px;object-fit:contain;display:block}
@media(max-width:768px){.feed-media-wrap img,.feed-media-wrap video{max-height:240px}}
.feed-play{position:absolute;background:rgba(0,0,0,.65);border-radius:50%;width:52px;height:52px;display:flex;align-items:center;justify-content:center;font-size:22px;pointer-events:none;backdrop-filter:blur(2px)}
.feed-body{padding:16px}
.feed-row1{display:flex;align-items:flex-start;justify-content:space-between;gap:10px;margin-bottom:6px}
.feed-grp{font-weight:700;font-size:14px;color:var(--text);flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.feed-time{font-size:11.5px;color:var(--text3);font-family:'JetBrains Mono',monospace;white-space:nowrap;margin-top:2px}
.feed-msg{font-size:13.5px;color:var(--text2);margin-top:8px;line-height:1.55;word-break:break-word}
.feed-footer{display:flex;align-items:center;gap:6px;margin-top:12px;padding-top:10px;border-top:1px solid var(--border);flex-wrap:wrap}
.feed-id{font-size:11px;color:var(--text3);font-family:'JetBrains Mono',monospace;margin-right:auto}
.feed-actions{display:flex;gap:6px;flex-wrap:wrap;align-items:center}
.stats-row{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-bottom:18px}
@media(max-width:460px){.stats-row{grid-template-columns:1fr 1fr}}
.stat{background:var(--bg2);border:1.5px solid var(--border);border-radius:var(--r);padding:18px;box-shadow:var(--card-shadow);transition:background .3s}
.stat-n{font-size:32px;font-weight:800;line-height:1;letter-spacing:-1.5px}
.stat-l{font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.8px;margin-top:5px;font-weight:700}
.chip{display:inline-flex;align-items:center;padding:3px 9px;border-radius:20px;font-size:11px;font-weight:800;font-family:'JetBrains Mono',monospace;text-transform:uppercase;letter-spacing:.3px;white-space:nowrap}
.ch-sent{background:var(--accent-dim);color:var(--accent)}
.ch-failed{background:var(--red-dim);color:var(--red)}
.ch-pending{background:var(--blue-dim);color:var(--blue)}
.ch-canceled{background:var(--bg4);color:var(--text3)}
.ch-processing{background:var(--yellow-dim);color:var(--yellow)}
.ch-text{background:var(--blue-dim);color:var(--blue)}
.ch-media{background:var(--accent-dim);color:var(--accent)}
.toasts{position:fixed;bottom:20px;right:20px;z-index:999;display:flex;flex-direction:column;gap:8px;pointer-events:none}
.toast{display:flex;align-items:center;gap:9px;padding:12px 16px;background:var(--bg2);border:1.5px solid var(--border2);border-radius:var(--r-sm);box-shadow:0 8px 32px rgba(0,0,0,.5);font-size:13.5px;animation:toastIn .22s ease;min-width:220px;max-width:320px;font-weight:600}
.toast.t-success{border-left:3px solid var(--accent)}
.toast.t-error{border-left:3px solid var(--red)}
.toast.t-warning{border-left:3px solid var(--yellow)}
.modal-bg{position:fixed;inset:0;background:rgba(0,0,0,.75);display:flex;align-items:center;justify-content:center;z-index:300;backdrop-filter:blur(4px);padding:16px}
.modal{background:var(--bg2);border:1.5px solid var(--border2);border-radius:18px;padding:28px;width:100%;max-width:420px;box-shadow:0 20px 60px rgba(0,0,0,.7);animation:fadeUp .2s ease}
.modal-t{font-size:18px;font-weight:800;margin-bottom:20px;letter-spacing:-.3px}
.modal-ft{display:flex;gap:8px;justify-content:flex-end;margin-top:20px}
.login-wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:20px;background:var(--bg);background-image:radial-gradient(ellipse 60% 35% at 50% -5%,rgba(0,208,132,.09) 0%,transparent 70%)}
.login-card{width:100%;max-width:360px;background:var(--bg2);border:1.5px solid var(--border);border-radius:20px;padding:36px;box-shadow:0 12px 48px rgba(0,0,0,.35)}
.login-logo-row{display:flex;align-items:center;gap:12px;margin-bottom:6px}
.login-icon{width:44px;height:44px;background:linear-gradient(135deg,var(--accent),#00956b);border-radius:13px;display:flex;align-items:center;justify-content:center;font-size:22px;box-shadow:0 4px 16px var(--accent-glow)}
.login-logo{font-size:26px;font-weight:800;letter-spacing:-.4px}
.login-logo span{color:var(--accent)}
.login-sub{font-size:13px;color:var(--text3);margin-bottom:28px;font-weight:500}
.err-box{background:var(--red-dim);color:var(--red);padding:10px 14px;border-radius:9px;font-size:13px;margin-bottom:14px;font-weight:600;border:1px solid rgba(240,82,82,.2)}
.ib{background:none;border:none;cursor:pointer;padding:7px;border-radius:7px;color:var(--text3);font-size:15px;transition:all .13s;line-height:1;display:flex;align-items:center;justify-content:center}
.ib:hover{background:var(--bg3);color:var(--text)}
.ib.del:hover{background:var(--red-dim);color:var(--red)}
.ib.re:hover{background:var(--blue-dim);color:var(--blue)}
.empty{text-align:center;padding:48px;color:var(--text3)}
.empty-ico{font-size:40px;margin-bottom:12px;opacity:.4}
.empty-txt{font-size:14px;font-weight:600}
.tbl-wrap{overflow-x:auto;border-radius:var(--r);border:1.5px solid var(--border);box-shadow:var(--card-shadow)}
table{width:100%;border-collapse:collapse;font-size:13.5px}
thead th{padding:10px 14px;text-align:left;font-size:10.5px;font-weight:800;color:var(--text3);text-transform:uppercase;letter-spacing:.6px;background:var(--bg3);border-bottom:1.5px solid var(--border);white-space:nowrap;transition:background .3s}
tbody td{padding:11px 14px;border-bottom:1px solid var(--border);color:var(--text2);vertical-align:middle}
tbody tr:last-child td{border-bottom:none}
tbody tr:hover td{background:rgba(127,127,127,.03)}
.act-col{display:flex;gap:4px;align-items:center}
`;
}

let _tid = 0;
function useToast() {
  const [toasts, setToasts] = useState([]);
  const show = useCallback((msg, type = 'success') => {
    const id = ++_tid;
    setToasts(t => [...t, { id, msg, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 3500);
  }, []);
  const TC = () => (
    <div className="toasts">
      {toasts.map(t => (
        <div key={t.id} className={`toast t-${t.type}`}>
          <span>{t.type === 'success' ? '✅' : t.type === 'error' ? '❌' : '⚠️'}</span>
          <span>{t.msg}</span>
        </div>
      ))}
    </div>
  );
  return { show, TC };
}

function Badge({ status }) {
  const L = { open: 'Conectado', qr: 'Aguardando QR', connecting: 'Conectando', closed: 'Desconectado', error: 'Erro', offline: 'Offline' };
  return <span className={`bdg b-${status || 'offline'}`}><span className="d" />{L[status] || 'Offline'}</span>;
}

function AnimatedNumber({ value, duration = 800, prefix = '', suffix = '', color }) {
  const target = typeof value === 'number' ? value : parseInt(value) || 0;
  const [display, setDisplay] = React.useState(target);
  const prevRef = React.useRef(target);
  const animRef = React.useRef(null);
  React.useEffect(() => {
    if (prevRef.current === target) return;
    const from = prevRef.current;
    prevRef.current = target;
    if (target === 0 && from === 0) { setDisplay(0); return; }
    const startTime = performance.now();
    const step = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(from + (target - from) * eased);
      setDisplay(current);
      if (progress < 1) animRef.current = requestAnimationFrame(step);
    };
    animRef.current = requestAnimationFrame(step);
    return () => { if (animRef.current) cancelAnimationFrame(animRef.current); };
  }, [target, duration]);
  return <span style={{ color: color || 'inherit' }}>{prefix}{display.toLocaleString('pt-BR')}{suffix}</span>;
}

function dotCls(s) { return s === 'open' ? 'on' : (s === 'qr' || s === 'connecting') ? 'warn' : 'err'; }

function NotificationBell({ onNavigate }) {
  const [open, setOpen] = React.useState(false);
  const [notifs, setNotifs] = React.useState([]);
  const [unread, setUnread] = React.useState(0);
  const bellRef = React.useRef(null);
  const prevUnreadRef = React.useRef(0);
  const [bellAnim, setBellAnim] = React.useState(false);

  const load = React.useCallback(async () => {
    const r = await api('/notifications?limit=20');
    if (r.ok) {
      setNotifs(r.notifications || []);
      const nu = r.unread_count || 0;
      if (nu > prevUnreadRef.current && prevUnreadRef.current >= 0) {
        setBellAnim(true);
        setTimeout(() => setBellAnim(false), 800);
      }
      prevUnreadRef.current = nu;
      setUnread(nu);
    }
  }, []);

  React.useEffect(() => { load(); const iv = setInterval(load, 30000); return () => clearInterval(iv); }, [load]);

  React.useEffect(() => {
    if (!open) return;
    const h = (e) => { if (bellRef.current && !bellRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [open]);

  const markAllRead = async () => {
    await api('/notifications/read', { method: 'PUT' });
    setUnread(0);
    setNotifs(n => n.map(x => ({ ...x, read: 1 })));
  };

  const clearAll = async () => {
    await api('/notifications/clear', { method: 'DELETE' });
    setNotifs([]); setUnread(0);
  };

  const handleOpen = () => {
    setOpen(o => !o);
    if (!open && unread > 0) markAllRead();
  };

  const timeAgo = (d) => {
    const diff = Math.floor((Date.now() - new Date(d).getTime()) / 1000);
    if (diff < 60) return 'agora';
    if (diff < 3600) return Math.floor(diff / 60) + 'min';
    if (diff < 86400) return Math.floor(diff / 3600) + 'h';
    return Math.floor(diff / 86400) + 'd';
  };

  return (
    <div ref={bellRef} style={{ position: 'relative' }}>
      <button onClick={handleOpen} style={{
        background: 'none', border: 'none', cursor: 'pointer', position: 'relative',
        padding: '6px 8px', borderRadius: 10, transition: 'all .15s',
        animation: bellAnim ? 'bellShake .5s ease' : 'none',
      }}
      onMouseEnter={e => { e.currentTarget.style.background = 'var(--bg3)'; }}
      onMouseLeave={e => { e.currentTarget.style.background = 'none'; }}
      >
        <span style={{ fontSize: 20, display: 'block' }}>🔔</span>
        {unread > 0 && (
          <span style={{
            position: 'absolute', top: 1, right: 1,
            minWidth: 18, height: 18, borderRadius: 9,
            background: '#ef4444', color: '#fff',
            fontSize: 10, fontWeight: 900, fontFamily: 'JetBrains Mono,monospace',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '0 4px', boxShadow: '0 2px 8px rgba(239,68,68,.4)',
            animation: 'countUp .3s cubic-bezier(.22,1,.36,1)',
            border: '2px solid var(--bg2)',
          }}>{unread > 99 ? '99+' : unread}</span>
        )}
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 8px)', right: 0,
          width: 360, maxHeight: 480, background: 'var(--bg2)',
          border: '1.5px solid var(--border)', borderRadius: 16,
          boxShadow: '0 12px 48px rgba(0,0,0,.5)', zIndex: 999,
          display: 'flex', flexDirection: 'column',
          animation: 'fadeUp .2s cubic-bezier(.22,1,.36,1)',
          overflow: 'hidden',
        }}>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '14px 16px', borderBottom: '1px solid var(--border)',
          }}>
            <span style={{ fontSize: 14, fontWeight: 800, color: 'var(--text)' }}>Notificações</span>
            {notifs.length > 0 && (
              <button onClick={clearAll} style={{
                background: 'var(--red-dim)', border: '1px solid rgba(240,82,82,.15)',
                borderRadius: 8, padding: '4px 10px', cursor: 'pointer',
                fontSize: 11, fontWeight: 700, color: 'var(--red)',
                fontFamily: 'Inter,sans-serif',
              }}>Limpar</button>
            )}
          </div>

          <div style={{ flex: 1, overflowY: 'auto', padding: '4px 0' }}>
            {notifs.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: 'var(--text3)' }}>
                <div style={{ fontSize: 36, marginBottom: 10, opacity: 0.5 }}>🔔</div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>Nenhuma notificação</div>
                <div style={{ fontSize: 12, marginTop: 4 }}>Vendas e alertas aparecerão aqui</div>
              </div>
            ) : notifs.map(n => (
              <div key={n.id} style={{
                display: 'flex', gap: 12, padding: '12px 16px',
                borderBottom: '1px solid var(--border)',
                background: n.read ? 'transparent' : 'rgba(0,208,132,.03)',
                transition: 'background .15s', cursor: 'default', position: 'relative',
              }}
              onClick={() => {
                if (onNavigate) {
                  if (n.type === 'sale') onNavigate('sales');
                  else if (n.type === 'bot_offline' || n.type === 'bot_online') onNavigate('bots');
                  else if (n.type === 'send_complete' || n.type === 'send_failed') onNavigate('history');
                }
                setOpen(false);
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'var(--bg3)'; e.currentTarget.style.cursor = 'pointer'; }}
              onMouseLeave={e => { e.currentTarget.style.background = n.read ? 'transparent' : 'rgba(0,208,132,.03)'; }}
              >
                {!n.read && <div style={{
                  position: 'absolute', left: 6, top: '50%', transform: 'translateY(-50%)',
                  width: 6, height: 6, borderRadius: '50%', background: 'var(--accent)',
                  boxShadow: '0 0 6px var(--accent-glow)',
                }} />}
                <div style={{
                  width: 38, height: 38, borderRadius: 12, flexShrink: 0,
                  background: (n.color || '#10b981') + '15',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 18, border: '1px solid ' + (n.color || '#10b981') + '25',
                }}>{n.icon || '💰'}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: n.read ? 600 : 800, color: 'var(--text)', lineHeight: 1.3 }}>{n.title}</div>
                  {n.message && <div style={{
                    fontSize: 12, color: 'var(--text3)', marginTop: 2,
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                  }}>{n.message}</div>}
                  <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 4, fontFamily: 'JetBrains Mono,monospace' }}>
                    {timeAgo(n.created_at)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function BotCard({ botId, label }) {
  const [status, setStatus] = useState('offline');
  const [qr, setQr] = useState(null);
  const [restarting, setRestarting] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const [phoneNum, setPhoneNum] = useState('');
  const [pic, setPic] = useState(null);
  const [pname, setPname] = useState('');
  useEffect(() => {
    if (status !== 'open') return;
    api('/bot-pics').then(r => { if (r && r.ok) { setPic((r.data || {})[botId] || null); setPname((r.names || {})[botId] || ''); } });
  }, [status, botId]);
  // Health monitor states
  const [health, setHealth] = useState(null); // {sizeMB, color, label, percent, canRecreate, instanceName}
  const [recreating, setRecreating] = useState(false);
  const [showRecreateModal, setShowRecreateModal] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const refresh = useCallback(async () => {
    const r = await api(`/whatsapp/status?bot=${botId}`);
    if (r.ok) { setStatus(r.status || 'offline'); if (r.number) setPhoneNum(r.number); }
    if (r.status !== 'open') { const q = await api(`/whatsapp/qr?bot=${botId}`); if (q.qr) setQr(q.qr); else if (q.status === 'open') { setQr(null); setStatus('open'); } }
    else setQr(null);
  }, [botId]);
  /*QR_FAST_V1*/ useEffect(() => { refresh(); const iv = setInterval(refresh, status === 'open' ? 20000 : 6000); return () => clearInterval(iv); }, [refresh, status]);
  
  // Health monitor: busca saude da instancia a cada 60s
  const refreshHealth = useCallback(async () => {
    try {
      const r = await api(`/bots/${botId}/health`);
      if (r.ok && r.health) setHealth(r.health);
    } catch (e) { /* silencioso */ }
  }, [botId]);
  
  useEffect(() => {
    refreshHealth();
    const iv = setInterval(refreshHealth, 60000);
    return () => clearInterval(iv);
  }, [refreshHealth]);
  
  // Recriar sessao
  const recreate = async () => {
    if (!health?.instanceName || confirmText !== health.instanceName) {
      alert('Digite exatamente o nome da instancia para confirmar.');
      return;
    }
    setRecreating(true);
    try {
      const r = await api(`/bots/${botId}/recreate`, {
        method: 'POST',
        body: JSON.stringify({ confirm: health.instanceName })
      });
      if (r.ok) {
        setShowRecreateModal(false);
        setConfirmText('');
        setQr(null);
        setStatus('connecting');
        // Aguarda 3s e atualiza tudo
        setTimeout(() => {
          refresh();
          refreshHealth();
        }, 3000);
      } else {
        alert('Erro ao recriar: ' + (r.error || 'erro desconhecido'));
      }
    } catch (e) {
      alert('Erro ao recriar: ' + e.message);
    }
    setRecreating(false);
  };
  
  const restart = async () => {
    setRestarting(true); setQr(null); setStatus('connecting');
    await api('/whatsapp/restart', { method: 'POST', body: JSON.stringify({ bot: botId }) });
    setTimeout(() => { refresh(); setRestarting(false); }, 4000);
  };
  const logout = async () => {
    if (!window.confirm('Desconectar o WhatsApp? Você precisará escanear o QR novamente.')) return;
    setLoggingOut(true); setQr(null); setStatus('closed');
    await api('/whatsapp/logout', { method: 'POST', body: JSON.stringify({ bot: botId }) });
    setTimeout(() => { refresh(); setLoggingOut(false); }, 3000);
  };
  const isConnected = status === 'open';
  const isWaiting = status === 'qr' || status === 'connecting';
  const cardBorderColor = isConnected ? 'rgba(0,208,132,.25)' : isWaiting ? 'rgba(227,160,8,.2)' : 'var(--border)';
  const cardGlow = isConnected ? '0 4px 24px rgba(0,208,132,.08)' : 'var(--card-shadow)';

  return (
    <div className="card" style={{
      borderRadius: 18, border: `1.5px solid ${cardBorderColor}`,
      boxShadow: cardGlow, transition: 'all .3s cubic-bezier(.22,1,.36,1)',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Glow de fundo sutil quando conectado */}
      {isConnected && <div style={{ position: 'absolute', top: -60, right: -60, width: 180, height: 180, borderRadius: '50%', background: 'radial-gradient(circle, rgba(0,208,132,.08), transparent 70%)', pointerEvents: 'none' }} />}

      {/* Header do card */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 18 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{
            width: 44, height: 44, borderRadius: 14,
            background: isConnected ? 'linear-gradient(135deg, rgba(0,208,132,.2), rgba(0,208,132,.08))' : 'var(--bg4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0,
            border: isConnected ? '1.5px solid rgba(0,208,132,.25)' : '1.5px solid var(--border)',
            boxShadow: isConnected ? '0 4px 16px var(--accent-glow)' : 'none',
            transition: 'all .3s',
          }}>📱</div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 800, color: 'var(--text)', letterSpacing: '-.3px' }}>{label}</div>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2, fontWeight: 500 }}>
              {isConnected ? 'Número vinculado' : isWaiting ? 'Aguardando conexão' : 'Vincule seu número'}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
          <Badge status={status} />
          <button className="btn btn-g btn-sm" onClick={refresh}
            style={{ borderRadius: 10, padding: '8px 10px', transition: 'all .2s' }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'rotate(90deg)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'rotate(0deg)'; }}
          >🔄</button>
        </div>
      </div>

      {/* Estado: Conectado */}
      {isConnected && (
        <div className="conn-box">
          <div style={{
            width: 48, height: 48, borderRadius: 14,
            background: 'linear-gradient(135deg, var(--accent), #00956b)', overflow: 'hidden',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 22, flexShrink: 0,
            boxShadow: '0 4px 16px var(--accent-glow)',
          }}>{pic ? <img src={pic} alt="" referrerPolicy="no-referrer" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={() => setPic(null)} /> : '✅'}</div>
          <div style={{ flex: 1 }}>
            <div className="conn-t">Conectado</div>
            {pname && <div style={{ fontSize: 15, fontWeight: 800, color: 'var(--text)', marginTop: 2 }}>{pname}</div>}
            <div className="conn-s">{phoneNum ? '+' + phoneNum.replace(/^(\d{2})(\d{2})(\d+)/, '$1 ($2) $3') : 'Pronto para enviar'}</div>
          </div>
          <div style={{
            width: 10, height: 10, borderRadius: '50%', background: 'var(--accent)',
            boxShadow: '0 0 10px var(--accent-glow)',
            animation: 'glowPulse 2.5s ease infinite', flexShrink: 0,
          }} />
        </div>
      )}

      {/* Estado: QR Code */}
      {!isConnected && qr && (
        <div className="qr-box" style={{ animation: 'fadeUp .4s cubic-bezier(.22,1,.36,1) both' }}>
          {/* Scan line animada */}
          <div style={{ position: 'relative' }}>
            <img className="qr-img" src={qr} alt="QR" />
            <div style={{
              position: 'absolute', left: 8, right: 8, height: 3,
              background: 'linear-gradient(90deg, transparent, var(--accent), transparent)',
              borderRadius: 2, opacity: 0.7,
              animation: 'qrScan 2.5s ease-in-out infinite',
            }} />
            <style>{`@keyframes qrScan{0%{top:8px}50%{top:calc(100% - 11px)}100%{top:8px}}`}</style>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
            <div className="qr-tip" style={{ fontWeight: 700, color: 'var(--text2)', fontSize: 13 }}>Escaneie o QR Code</div>
            <div className="qr-tip" style={{ fontSize: 11.5 }}>WhatsApp → Dispositivos Vinculados → Vincular dispositivo</div>
          </div>
        </div>
      )}

      {/* Estado: Aguardando */}
      {!isConnected && !qr && (
        <div className="qr-box" style={{ animation: 'fadeUp .3s ease both' }}>
          <div className="spinner" />
          <div className="qr-tip" style={{ fontWeight: 600 }}>Gerando QR Code...</div>
        </div>
      )}

      {/* Barra de saude da sessao */}
      {health && (
        <div style={{ marginTop: 14, padding: '12px 14px', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text2)' }}>💚 Saúde da Sessão</span>
              <span style={{
                fontSize: 11, fontWeight: 800, padding: '2px 8px', borderRadius: 8,
                background: health.color === 'green' ? 'rgba(0,208,132,.15)' :
                            health.color === 'yellow' ? 'rgba(227,160,8,.15)' :
                            health.color === 'orange' ? 'rgba(255,140,0,.15)' :
                            'rgba(255,76,76,.15)',
                color: health.color === 'green' ? '#00b876' :
                       health.color === 'yellow' ? '#d4a008' :
                       health.color === 'orange' ? '#ff8c00' :
                       '#ff4c4c'
              }}>{health.label}</span>
            </div>
            <span style={{ fontSize: 12, color: 'var(--text3)', fontWeight: 600 }}>
              {health.sizeMB} MB
            </span>
          </div>
          <div style={{ height: 8, background: 'var(--bg3)', borderRadius: 6, overflow: 'hidden', position: 'relative' }}>
            <div style={{
              height: '100%',
              width: `${Math.max(health.percent, 3)}%`,
              background: health.color === 'green' ? 'linear-gradient(90deg, #00d084, #00b876)' :
                          health.color === 'yellow' ? 'linear-gradient(90deg, #ffd34e, #e3a008)' :
                          health.color === 'orange' ? 'linear-gradient(90deg, #ffa64d, #ff8c00)' :
                          'linear-gradient(90deg, #ff7a7a, #ff4c4c)',
              borderRadius: 6,
              transition: 'width .6s cubic-bezier(.22,1,.36,1)',
              boxShadow: health.color === 'red' ? '0 0 12px rgba(255,76,76,.4)' :
                         health.color === 'orange' ? '0 0 8px rgba(255,140,0,.3)' : 'none'
            }} />
          </div>
          {health.canRecreate && (
            <div style={{ marginTop: 8, fontSize: 11, color: health.color === 'red' ? '#ff4c4c' : '#ff8c00', fontWeight: 600 }}>
              {health.color === 'red'
                ? '⚠️ Recomendado recriar a sessão para evitar bugs'
                : '⚠️ Sessão começando a acumular cache'}
            </div>
          )}
        </div>
      )}
      
      {/* Botões de ação */}
      <div style={{
        display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap',
        paddingTop: 16, borderTop: '1px solid var(--border)',
      }}>
        {!isConnected && (
          <button className="btn btn-g btn-sm" onClick={refresh}
            style={{ borderRadius: 10, transition: 'all .2s' }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.color = 'var(--accent)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = ''; e.currentTarget.style.color = ''; }}
          >📡 Atualizar QR</button>
        )}
        <button className="btn btn-w btn-sm" onClick={restart} disabled={restarting}
          style={{ borderRadius: 10, transition: 'all .2s' }}
        >{restarting ? '⏳ Reiniciando...' : '🔄 Reiniciar'}</button>
        {/* Botao Recriar Sessao - sempre visivel mas so ativo quando >100MB */}
        <button
          className="btn btn-sm"
          onClick={() => setShowRecreateModal(true)}
          disabled={!health?.canRecreate || recreating}
          title={!health?.canRecreate ? 'Disponivel quando a sessao acumular muito cache' : 'Recriar a sessao com novo QR'}
          style={{
            borderRadius: 10,
            background: health?.canRecreate ? 'linear-gradient(135deg, #ff8c00, #ff6b00)' : 'var(--bg3)',
            color: health?.canRecreate ? '#fff' : 'var(--text3)',
            border: health?.canRecreate ? '1.5px solid #ff8c00' : '1.5px solid var(--border)',
            cursor: health?.canRecreate ? 'pointer' : 'not-allowed',
            opacity: health?.canRecreate ? 1 : 0.55,
            transition: 'all .2s',
            fontWeight: 700,
            boxShadow: health?.color === 'red' ? '0 0 12px rgba(255,140,0,.3)' : 'none'
          }}
        >{recreating ? '⏳ Recriando...' : '🔄 Recriar Sessão'}</button>
        
        {isConnected && (
          <button className="btn btn-d btn-sm" onClick={logout} disabled={loggingOut}
            style={{ borderRadius: 10, marginLeft: 'auto', transition: 'all .2s' }}
          >{loggingOut ? '⏳ Desconectando...' : '🔌 Desconectar'}</button>
        )}
      </div>
      
      {/* Modal de confirmacao Recriar Sessao */}
      {showRecreateModal && health?.instanceName && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,.7)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 9999, padding: 20, animation: 'fadeIn .2s'
        }} onClick={() => !recreating && setShowRecreateModal(false)}>
          <div onClick={e => e.stopPropagation()} style={{
            background: 'var(--bg)', borderRadius: 18, padding: 28, maxWidth: 480, width: '100%',
            border: '1.5px solid var(--border)', boxShadow: '0 20px 60px rgba(0,0,0,.5)',
            animation: 'fadeUp .25s cubic-bezier(.22,1,.36,1)'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <div style={{
                width: 48, height: 48, borderRadius: 14,
                background: 'linear-gradient(135deg, rgba(255,140,0,.2), rgba(255,140,0,.08))',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24,
                border: '1.5px solid rgba(255,140,0,.3)'
              }}>⚠️</div>
              <div>
                <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text)' }}>Recriar Sessão</div>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>{label}</div>
              </div>
            </div>
            
            <div style={{
              padding: 14, background: 'rgba(255,140,0,.06)', border: '1px solid rgba(255,140,0,.2)',
              borderRadius: 12, marginBottom: 16, fontSize: 13, color: 'var(--text2)', lineHeight: 1.55
            }}>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>O que vai acontecer:</div>
              <div>• A sessão atual ({health.sizeMB} MB) será apagada</div>
              <div>• Um backup automático será criado</div>
              <div>• Você precisará escanear um novo QR Code</div>
              <div>• Os disparos ficam pausados por ~10 segundos</div>
            </div>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 13, fontWeight: 700, color: 'var(--text2)', display: 'block', marginBottom: 6 }}>
                Para confirmar, digite: <code style={{ background: 'var(--bg3)', padding: '2px 8px', borderRadius: 6, color: '#ff6b00', fontSize: 12 }}>{health.instanceName}</code>
              </label>
              <input
                className="fi"
                value={confirmText}
                onChange={e => setConfirmText(e.target.value)}
                placeholder={health.instanceName}
                disabled={recreating}
                style={{ fontFamily: 'monospace', fontSize: 13 }}
              />
            </div>
            
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-g btn-sm" onClick={() => { setShowRecreateModal(false); setConfirmText(''); }} disabled={recreating}
                style={{ borderRadius: 10 }}>Cancelar</button>
              <button onClick={recreate} disabled={recreating || confirmText !== health.instanceName}
                style={{
                  padding: '8px 18px', borderRadius: 10, fontWeight: 700, fontSize: 13,
                  background: confirmText === health.instanceName ? 'linear-gradient(135deg, #ff8c00, #ff6b00)' : 'var(--bg3)',
                  color: confirmText === health.instanceName ? '#fff' : 'var(--text3)',
                  border: 'none', cursor: (recreating || confirmText !== health.instanceName) ? 'not-allowed' : 'pointer',
                  opacity: (recreating || confirmText !== health.instanceName) ? 0.55 : 1,
                  transition: 'all .2s'
                }}>{recreating ? '⏳ Recriando...' : '🔄 Confirmar Recriação'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const ST_COLORS = ['#1B1F27', '#0F766E', '#1D4ED8', '#7C3AED', '#BE185D', '#B91C1C', '#C2410C', '#A16207', '#15803D', '#374151'];
const ST_FONTS = [{ v: 0, l: 'Padrão' }, { v: 6, l: 'Negrito' }, { v: 2, l: 'Script' }, { v: 8, l: 'Calistoga' }, { v: 10, l: 'Courier' }];
const ST_CHIP = { draft: 'pending', scheduled: 'pending', processing: 'pending', done: 'sent', canceled: 'failed', sent: 'sent', failed: 'failed', pending: 'pending' };
const ST_LABEL = { draft: 'rascunho', scheduled: 'na fila', processing: 'enviando', done: 'concluído', canceled: 'cancelado', sent: 'enviado', failed: 'falhou', pending: 'na fila' };
const ST_ICON = { text: '📝', image: '🖼️', video: '🎬', sequence: '📋' };
function stArgb(hex) { return parseInt('FF' + hex.replace('#', ''), 16); }
function stIso(v) { return v ? new Date(v).toISOString() : undefined; }
function stFmt(iso) { if (!iso) return ''; try { return new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }); } catch (e) { return ''; } }
function stNewStep() { return { kind: 'text', text: '', file_path: null, file: null, bg_argb: stArgb(ST_COLORS[1]), font: 0 }; }
/*ST_UPLOAD_RETRY_V1*/
async function stUpload(file) {
  const tok = localStorage.getItem('zs_token');
  const nome = (file && file.name) || 'arquivo';
  let ultimo = '';
  for (let t = 1; t <= 3; t++) {
    const ctl = new AbortController();
    const timer = setTimeout(() => ctl.abort(), 120000);
    try {
      const form = new FormData();
      form.append('file', file);
      const resp = await fetch(API_BASE + '/upload', { method: 'POST', headers: { Authorization: 'Bearer ' + tok }, body: form, signal: ctl.signal });
      const r = await resp.json();
      clearTimeout(timer);
      if (r && r.ok && r.file_path) return r.file_path;
      ultimo = (r && r.error) || ('HTTP ' + resp.status);
    } catch (e) {
      clearTimeout(timer);
      ultimo = e && e.name === 'AbortError' ? 'demorou demais' : 'conex\u00e3o caiu';
    }
    if (t < 3) await new Promise(res => setTimeout(res, 1500 * t));
  }
  throw new Error('Falha ao enviar "' + nome + '" (' + ultimo + '). Verifique a internet e tente de novo.');
}

/*ST_PASTE_V1*/
function stClipFile(e) {
  const fl = Array.from((e.clipboardData && e.clipboardData.files) || []).filter(f => /^image\/|^video\//.test(f.type || ''));
  if (!fl.length) return null;
  e.preventDefault();
  let f = fl[0];
  if (!f.name || /^image\.[a-z]+$/i.test(f.name)) f = new File([f], 'colado_' + Date.now() + '.' + ((f.type || 'image/png').split('/')[1] || 'png'), { type: f.type });
  return f;
}
function stArgbHex(n) { return '#' + ((Number(n) || 0) & 0xFFFFFF).toString(16).padStart(6, '0'); }
function StPick({ kind, file, step, onPick }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!file) { setUrl(null); return; }
    const u = URL.createObjectURL(file);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [file]);
  const has = !!file || !!step.file_path;
  const name = file ? file.name : (step.file_path ? 'Arquivo já enviado' : 'Nenhum arquivo');
  const sub = file ? (file.size / 1048576).toFixed(1) + ' MB' : (step.file_path ? 'Salvo na sequência' : 'Escolha um arquivo');
  return (
    <div className="stp">
      <div className="stp-prev">
        {file && url
          ? (kind === 'video' ? <video src={url} muted playsInline preload="metadata" /> : <img src={url} alt="" />)
          : (step.file_path ? <StThumb step={step} /> : <span>{kind === 'video' ? '🎬' : '🖼️'}</span>)}
      </div>
      <div className="stp-info">
        <div className="stp-name" title={name}>{name}</div>
        <div className="stp-sub">{sub}</div>
      </div>
      <label className="btn btn-g btn-sm stp-btn">
        {has ? '🔄 Trocar' : '📁 Escolher'}
        <input type="file" accept={kind === 'video' ? 'video/*' : 'image/*'} style={{ display: 'none' }} onChange={e => { onPick(e.target.files[0] || null); e.target.value = ''; }} />
      </label>
    </div>
  );
}

function StThumb({ step }) {
  const url = step.file_path ? API_BASE + '/midias/' + String(step.file_path).split('/midias/').pop() : null;
  const box = { width: 48, height: 48, borderRadius: 8, objectFit: 'cover', flexShrink: 0, border: '1px solid var(--border)', background: 'var(--bg3)' };
  if (step.kind === 'image' && url) return <img src={url} alt="" style={box} onError={e => { e.target.style.visibility = 'hidden'; }} />;
  if (step.kind === 'video' && url) return <video src={url} muted playsInline preload="metadata" style={box} />;
  if (step.kind === 'text') return <div style={{ ...box, background: step.bg_argb != null ? stArgbHex(step.bg_argb) : '#0F766E', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 14 }}>Aa</div>;
  return <div style={{ ...box, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{ST_ICON[step.kind]}</div>;
}

const ST_CSS = `
.stp{display:flex;align-items:center;gap:12px;padding:10px;border:1.5px dashed var(--border2);border-radius:12px;background:var(--bg3)}
.stp-prev{width:64px;height:64px;border-radius:10px;overflow:hidden;background:var(--bg4);display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:24px}
.stp-prev img,.stp-prev video{width:100%;height:100%;object-fit:cover}
.stp-info{flex:1;min-width:0}
.stp-name{font-weight:700;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.stp-sub{font-size:12px;color:var(--text3);margin-top:2px}
.stp-btn{cursor:pointer;flex-shrink:0;margin:0}
.stg-head{display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap}
.stg-count{font-size:13px;color:var(--text3)}
.stg-count b{color:var(--accent);font-size:16px}
.stg-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:12px;max-height:540px;overflow-y:auto;padding:4px}
.stg-card{display:flex;align-items:center;gap:12px;padding:14px 16px;min-height:76px;border-radius:14px;background:var(--bg3);border:1.5px solid var(--border);cursor:pointer;transition:all .15s}
.stg-card:hover{border-color:var(--accent);transform:translateY(-1px)}
.stg-card.sel{background:var(--accent-dim);border-color:var(--accent);box-shadow:0 0 0 3px var(--accent-glow)}
.stg-ck{width:24px;height:24px;border-radius:8px;border:2px solid var(--border2);display:flex;align-items:center;justify-content:center;font-weight:800;font-size:14px;flex-shrink:0;color:#000}
.stg-card.sel .stg-ck{background:var(--accent);border-color:var(--accent)}
.stg-av{width:44px;height:44px;border-radius:50%;background:var(--bg4);display:flex;align-items:center;justify-content:center;font-size:21px;flex-shrink:0}
.stg-card.sel .stg-av{background:var(--accent-glow)}
.stg-name{font-weight:700;font-size:14px;line-height:1.3;word-break:break-word;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.stm-post{padding:16px;margin-top:12px;border:1px solid var(--border);border-radius:14px;background:var(--bg3)}
.stm-bar{height:10px;border-radius:99px;background:var(--bg4);overflow:hidden}
.stm-bar.sm{height:6px;margin-top:6px}
.stm-fill{height:100%;background:var(--accent);border-radius:99px;transition:width .4s}
.stm-sub{font-size:12px;color:var(--text3);margin-top:4px;word-break:break-word}
.stm-nums{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin:12px 0}
.stm-num{text-align:center;padding:14px 8px;border-radius:12px;background:var(--bg2);border:1px solid var(--border)}
.stm-num b{display:block;font-size:28px;line-height:1.1}
.stm-num span{font-size:11px;font-weight:700;letter-spacing:.05em;color:var(--text3)}
.stm-list{max-height:460px;overflow-y:auto;padding-right:4px}
.stm-row{display:flex;align-items:center;gap:12px;padding:10px 12px;margin-top:8px;border-radius:12px;background:var(--bg2);border:1px solid var(--border)}
.stm-gn{font-weight:600;font-size:13px;word-break:break-word}
.stm-r{text-align:right;flex-shrink:0}
.stm-b{display:inline-block;padding:3px 9px;border-radius:8px;font-size:11px;font-weight:800;letter-spacing:.04em;text-transform:uppercase}
.stm-sent,.stm-done{color:#00d084;background:rgba(0,208,132,.12)}
.stm-failed,.stm-canceled{color:#f05252;background:rgba(240,82,82,.12)}
.stm-pending,.stm-scheduled,.stm-draft{color:#3f83f8;background:rgba(63,131,248,.12)}
.stm-processing{color:#e3a008;background:rgba(227,160,8,.12);animation:stmp 1.2s infinite}
@keyframes stmp{50%{opacity:.5}}
`;
function stBadge(st) { return <span className={'stm-b stm-' + st}>{ST_LABEL[st] || st}</span>; }

function StatusPage({ userPlan, show }) {
  const bots = getAllowedBots(userPlan);
  const [tab, setTab] = useState('new');
  const [botId, setBotId] = useState(bots[0] ? bots[0].id : 'bot1');
  const [groups, setGroups] = useState([]);
  const [sel, setSel] = useState([]);
  const [search, setSearch] = useState('');
  const [loadingG, setLoadingG] = useState(false);
  const [busy, setBusy] = useState(false);
  const [kind, setKind] = useState('text');
  /* CONTACT_SINGLE_UI_V1 */
  const [ctS, setCtS] = useState(false);
  const [ctSPre, setCtSPre] = useState(() => { try { return localStorage.getItem('st_ct_pre') || 'Oi! Vi seu status e quero saber mais'; } catch (e) { return 'Oi! Vi seu status e quero saber mais'; } });
  const [text, setText] = useState('');
  const [file, setFile] = useState(null);
  const [prev, setPrev] = useState('');
  const [bg, setBg] = useState(ST_COLORS[1]);
  const [font, setFont] = useState(0);
  const [when, setWhen] = useState('');
  const [seqs, setSeqs] = useState([]);
  const [editing, setEditing] = useState(null);
  const [runSeq, setRunSeq] = useState(null);
  const [runWhen, setRunWhen] = useState('');
  const [posts, setPosts] = useState([]);
  const [live, setLive] = useState(0);
  const [open, setOpen] = useState(null);
  const [items, setItems] = useState([]);

  const stKeyG = (b) => 'zs_st_g_' + b;
  const stKeyS = (b) => 'zs_st_s_' + b;
  const readLS = (k) => { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } };
  const writeLS = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
  const saveTimer = useRef(null);
  const saveRemote = (b, ids) => api('/status-selection', { method: 'PUT', body: JSON.stringify({ bot_id: b, ids }) });
  const pickSel = (next) => {
    setSel(next);
    writeLS(stKeyS(botId), next);
    clearTimeout(saveTimer.current);
    const b = botId;
    saveTimer.current = setTimeout(() => { saveRemote(b, next); }, 800);
  };
  const saveNow = async () => {
    clearTimeout(saveTimer.current);
    writeLS(stKeyS(botId), sel);
    const r = await saveRemote(botId, sel);
    if (r && r.ok) show('✅ Seleção salva (' + sel.length + ' grupo' + (sel.length === 1 ? '' : 's') + ')');
    else show((r && r.error) || 'Erro ao salvar a seleção', 'error');
  };
  const loadGroups = async (b) => {
    setLoadingG(true);
    const r = await api('/groups?bot=' + b);
    if (r.ok) {
      const list = [...(r.data || [])].sort((x, y) => x.name.localeCompare(y.name, 'pt-BR'));
      setGroups(list);
      writeLS(stKeyG(b), list.map(g => ({ id: g.id, name: g.name })));
      const ids = new Set(list.map(g => g.id));
      const before = readLS(stKeyS(b));
      const kept = before.filter(id => ids.has(id));
      writeLS(stKeyS(b), kept);
      setSel(kept);
      if (kept.length !== before.length) saveRemote(b, kept);
    } else show(r.error || 'Erro ao carregar grupos', 'error');
    setLoadingG(false);
  };
  useEffect(() => {
    let dead = false;
    const cached = readLS(stKeyG(botId));
    setGroups(cached);
    setSel(readLS(stKeyS(botId)));
    if (!cached.length) loadGroups(botId);
    api('/status-selection?bot=' + botId).then(r => {
      if (dead || !r || !r.ok) return;
      if (Array.isArray(r.data)) { setSel(r.data); writeLS(stKeyS(botId), r.data); }
      else { const loc = readLS(stKeyS(botId)); if (loc.length) saveRemote(botId, loc); }
    });
    return () => { dead = true; };
  }, [botId]);
  const [pics, setPics] = useState({});
  useEffect(() => {
    if (!groups.length) return undefined;
    let dead = false;
    (async () => {
      let todo = groups.map(g => g.id);
      for (let round = 0; round < 40 && todo.length && !dead; round++) {
        const r = await api('/group-pics', { method: 'POST', body: JSON.stringify({ bot_id: botId, ids: todo.slice(0, 60) }) });
        if (dead || !r.ok || !r.data) break;
        const got = Object.keys(r.data);
        if (!got.length) break;
        setPics(p => ({ ...p, ...r.data }));
        const done = new Set(got);
        todo = todo.filter(id => !done.has(id));
      }
    })();
    return () => { dead = true; };
  }, [groups]);

  const loadSeqs = useCallback(async () => { const r = await api('/status-sequences'); if (r.ok) setSeqs(r.data || []); }, []);
  const loadPosts = useCallback(async () => {
    const r = await api('/status-posts'); if (r.ok) setPosts(r.data || []);
    const l = await api('/status-live'); if (l.ok) setLive((l.data || []).length);
  }, []);
  useEffect(() => { loadSeqs(); loadPosts(); }, []);
  const openRef = useRef(null);
  openRef.current = open;
  const loadDetail = useCallback(async (id) => {
    const r = await api('/status-posts/' + id);
    if (r.ok) setItems(r.items || []);
  }, []);
  useEffect(() => {
    if (tab !== 'hist') return undefined;
    const tick = () => { loadPosts(); if (openRef.current) loadDetail(openRef.current); };
    tick();
    const t = setInterval(tick, 8000);
    return () => clearInterval(t);
  }, [tab]);

  const chosen = groups.filter(g => sel.includes(g.id)).map(g => ({ id: g.id, name: g.name }));
  const filtered = groups.filter(g => g.name.toLowerCase().includes(search.toLowerCase()));
  const chip = s => <span className={'chip ch-' + (ST_CHIP[s] || 'pending')}>{ST_LABEL[s] || s}</span>;
  const tabBtn = (id, label) => (
    <button className={'type-btn ' + (tab === id ? 'active' : '')} style={{ flex: '0 0 auto', padding: '10px 18px', ...(tab === id ? { background: 'var(--accent)', color: '#000' } : {}) }} onClick={() => setTab(id)}>{label}</button>
  );
  const planMsg = (plan) => plan ? ' Tempo estimado: ' + Math.max(1, Math.ceil(plan.total_seconds / 60)) + ' min.' : '';

  const checkLinks = async (hasLink) => {
    if (!hasLink) return true;
    const c = await api('/status-links-check', { method: 'POST', body: JSON.stringify({ groups: chosen }) });
    if (c.ok && c.missing && c.missing.length) {
      return window.confirm(c.missing.length + ' grupo(s) estão sem link cadastrado. A linha com o link será removida neles. Continuar?');
    }
    return true;
  };

  const pickFile = (f) => {
    setFile(f || null);
    setPrev(f ? URL.createObjectURL(f) : '');
  };

  const submitNew = async (draft) => {
    if (!draft && kind === 'text' && !text.trim()) return show('Digite o texto do status', 'warning');
    if (!draft && kind !== 'text' && !file) return show('Escolha o arquivo', 'warning');
    if (!draft && chosen.length === 0) return show('Selecione pelo menos um grupo', 'warning');
    if (kind === 'text' && ctS && text.length > 300) return show('No status de contato o texto pode ter ate 300 caracteres', 'warning');
    if (!draft && !(await checkLinks(text.includes('{LINK}')))) return;
    setBusy(true);
    try {
      let file_path = null;
      if (kind !== 'text' && file) file_path = await stUpload(file);
      const body = { bot_id: botId, kind, groups: chosen, draft, schedule_at: stIso(when), bg_argb: kind === 'text' ? stArgb(bg) : null, font: kind === 'text' ? font : null, file_path };
      if (kind === 'text') body.text = text; else body.caption = text; if (kind === 'text' && ctS) { body.contact = true; body.contact_prefill = ctSPre; }
      const r = await api('/status-posts', { method: 'POST', body: JSON.stringify(body) });
      if (!r.ok) throw new Error(r.error || 'Erro ao salvar');
      show(draft ? '✅ Rascunho salvo' : '✅ Status na fila.' + planMsg(r.plan));
      setText(''); pickFile(null); setWhen('');
      setTab('hist'); loadPosts();
    } catch (e) { show(e.message, 'error'); }
    setBusy(false);
  };

  const setStep = (i, patch) => setEditing(e => ({ ...e, steps: e.steps.map((s, k) => k === i ? { ...s, ...patch } : s) }));
  const moveStep = (i, d) => setEditing(e => {
    const j = i + d; if (j < 0 || j >= e.steps.length) return e;
    const a = [...e.steps]; const t = a[i]; a[i] = a[j]; a[j] = t; return { ...e, steps: a };
  });
  const delStep = (i) => setEditing(e => ({ ...e, steps: e.steps.filter((s, k) => k !== i) }));
  const editSeq = (sq) => setEditing({ id: sq ? sq.id : null, name: sq ? sq.name : '', steps: sq ? sq.steps.map(x => ({ ...stNewStep(), ...x, file: null })) : [stNewStep()] });

  const saveSeq = async () => {
    const e = editing;
    if (!e.name.trim()) return show('Dê um nome para a sequência', 'warning');
    if (!e.steps.length) return show('Adicione pelo menos um passo', 'warning');
    setBusy(true);
    try {
      const steps = [];
      for (let i = 0; i < e.steps.length; i++) {
        const s = e.steps[i];
        let fp = s.file_path;
        if (s.kind !== 'text' && s.file) fp = await stUpload(s.file);
        if (s.kind !== 'text' && !fp) throw new Error('Passo ' + (i + 1) + ': escolha o arquivo');
        steps.push({ kind: s.kind, text: s.text, file_path: s.kind === 'text' ? null : fp, bg_argb: s.kind === 'text' ? s.bg_argb : null, font: s.kind === 'text' ? s.font : null });
      }
      const body = JSON.stringify({ name: e.name, steps });
      const r = e.id ? await api('/status-sequences/' + e.id, { method: 'PUT', body }) : await api('/status-sequences', { method: 'POST', body });
      if (!r.ok) throw new Error(r.error || 'Erro ao salvar');
      show('✅ Sequência salva');
      setEditing(null); loadSeqs();
    } catch (err) { show(err.message, 'error'); }
    setBusy(false);
  };
  // DUP_SEQ_V1
  const dupSeq = async (sq) => {
    setBusy(true);
    try {
      const steps = (sq.steps || []).map(s => ({ kind: s.kind, text: s.text, file_path: s.kind === 'text' ? null : s.file_path, bg_argb: s.kind === 'text' ? s.bg_argb : null, font: s.kind === 'text' ? s.font : null }));
      const r = await api('/status-sequences', { method: 'POST', body: JSON.stringify({ name: String(sq.name || '').slice(0, 70) + ' (c\u00f3pia)', steps }) });
      if (!r.ok) throw new Error(r.error || 'Erro ao duplicar');
      show('\u2705 Sequ\u00eancia duplicada');
      loadSeqs();
    } catch (err) { show(err.message, 'error'); }
    setBusy(false);
  };
  const delSeq = async (sq) => {
    if (!window.confirm('Apagar a sequência "' + sq.name + '"? As execuções já feitas continuam no histórico.')) return;
    const r = await api('/status-sequences/' + sq.id, { method: 'DELETE' });
    if (r.ok) loadSeqs(); else show(r.error || 'Erro', 'error');
  };
  // CONTACT_UI_V1
  const [ctOn, setCtOn] = useState(() => { try { return localStorage.getItem('st_ct_on') === '1'; } catch (e) { return false; } });
  /* CONTACT_UI_V2 */
  const [ctText, setCtText] = useState(() => { try { return localStorage.getItem('st_ct_text3') || 'Fale comigo \uD83D\uDC47'; } catch (e) { return 'Fale comigo \uD83D\uDC47'; } });
  const [ctPre, setCtPre] = useState(() => { try { return localStorage.getItem('st_ct_pre') || 'Oi! Vi seu status e quero saber mais'; } catch (e) { return 'Oi! Vi seu status e quero saber mais'; } });
  useEffect(() => { (async () => { try {
    const r = await api('/status-contact-cfg');
    if (r && r.ok && r.data) {
      if (r.data.prefill) { setCtSPre(r.data.prefill); setCtPre(r.data.prefill); }
      setCtOn(!!r.data.seq_on);
      if (r.data.seq_text) setCtText(r.data.seq_text);
    }
  } catch (e) {} })(); }, []); /*ST_CONTACT_CFG_V1*/
  const stSaveContactCfg = (patch) => { /*ST_CONTACT_CFG_V1*/
    const body = { prefill: patch.prefill !== undefined ? patch.prefill : ctPre, seq_on: patch.seq_on !== undefined ? patch.seq_on : ctOn, seq_text: patch.seq_text !== undefined ? patch.seq_text : ctText };
    api('/status-contact-cfg', { method: 'POST', body: JSON.stringify(body) }).catch(() => {});
  };
  const runIt = async () => {
    if (!chosen.length) return show('Selecione pelo menos um grupo', 'warning');
    if (!(await checkLinks(runSeq.steps.some(s => (s.text || '').includes('{LINK}'))))) return;
    setBusy(true);
    const r = await api('/status-sequences/' + runSeq.id + '/run', { method: 'POST', body: JSON.stringify({ bot_id: botId, groups: chosen, schedule_at: stIso(runWhen), contact_text: ctOn ? ctText : '', contact_prefill: ctOn ? ctPre : '' }) });
    if (r.ok) {
      show('✅ Sequência na fila.' + planMsg(r.plan));
      setRunSeq(null); setRunWhen(''); setTab('hist'); loadPosts();
    } else show(r.error || 'Erro ao iniciar', 'error');
    setBusy(false);
  };

  const openDetail = async (id) => {
    if (open === id) { setOpen(null); return; }
    await loadDetail(id);
    setOpen(id);
  };
  const act = async (p, what) => {
    if (what === 'cancel' && !window.confirm('Cancelar os envios que ainda estão na fila?')) return;
    if (what === 'delete' && !window.confirm('Apagar este registro?')) return;
    if (what === 'retry' && p.kind === 'sequence' && !window.confirm('Reenviar refaz a sequência inteira nos grupos que falharam. Continuar?')) return;
    const r = what === 'delete'
      ? await api('/status-posts/' + p.id, { method: 'DELETE' })
      : await api('/status-posts/' + p.id + '/' + what, { method: 'POST', body: '{}' });
    if (r.ok) { show('✅ Feito'); loadPosts(); if (open === p.id) setOpen(null); }
    else show(r.error || 'Erro', 'error');
  };

  const renderPicker = () => (
    <>
      <div className="fg">
        <label className="fl">WhatsApp</label>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {bots.map(b => (
            <button key={b.id} className={'type-btn ' + (botId === b.id ? 'active' : '')} style={{ flex: '0 0 auto', padding: '10px 18px', ...(botId === b.id ? { background: 'var(--accent)', color: '#000' } : {}) }} onClick={() => setBotId(b.id)}>📱 {b.label}</button>
          ))}
        </div>
      </div>
      <div className="fg">
        <div className="stg-head">
          <label className="fl" style={{ margin: 0 }}>Grupos</label>
          <span className="stg-count"><b>{sel.length}</b> / {groups.length} selecionados</span>
        </div>
        <div style={{ display: 'flex', gap: 8, margin: '10px 0', flexWrap: 'wrap' }}>
          <button className="btn btn-g btn-sm" onClick={() => loadGroups(botId)} disabled={loadingG}>{loadingG ? '⏳' : '🔄'} Atualizar</button>
          <button className="btn btn-g btn-sm" onClick={() => pickSel(Array.from(new Set([...sel, ...filtered.map(g => g.id)])))}>☑ Todos{search ? ' (filtrados)' : ''}</button>
          <button className="btn btn-g btn-sm" onClick={() => pickSel([])}>Limpar</button>
          <button className="btn btn-p btn-sm" onClick={saveNow}>💾 Salvar seleção</button>
        </div>
        <input className="fi" style={{ marginBottom: 10 }} placeholder="🔍 Buscar grupo..." value={search} onChange={e => setSearch(e.target.value)} />
        <div className="stg-grid">
          {groups.length === 0 && <div style={{ gridColumn: '1 / -1', color: 'var(--text3)', fontSize: 13, padding: 12 }}>{loadingG ? 'Carregando grupos...' : 'Nenhum grupo carregado. Clique em Atualizar.'}</div>}
          {filtered.map(g => (
            <div key={g.id} className={'stg-card ' + (sel.includes(g.id) ? 'sel' : '')} onClick={() => pickSel(sel.includes(g.id) ? sel.filter(x => x !== g.id) : [...sel, g.id])}>
              <div className="stg-ck">{sel.includes(g.id) ? '✓' : ''}</div>
              <div className="stg-av" style={{ overflow: 'hidden' }}>{pics[g.id] ? <img src={pics[g.id]} alt="" referrerPolicy="no-referrer" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={() => setPics(p => ({ ...p, [g.id]: null }))} /> : '👥'}</div>
              <div style={{ minWidth: 0, flex: 1 }}><div className="stg-name">{g.name}</div></div>
            </div>
          ))}
        </div>
      </div>
    </>
  );

  const renderStyleBox = (curBg, curFont, onBg, onFont) => (
    <div className="fg">
      <label className="fl">Cor de fundo e fonte</label>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
        {ST_COLORS.map(c => (
          <button key={c} onClick={() => onBg(c)} style={{ width: 26, height: 26, borderRadius: 8, background: c, border: curBg === c ? '3px solid var(--accent)' : '2px solid var(--border2)', cursor: 'pointer' }} />
        ))}
      </div>
      <select className="fi" value={curFont} onChange={e => onFont(parseInt(e.target.value, 10))}>
        {ST_FONTS.map(f => <option key={f.v} value={f.v}>{f.l}</option>)}
      </select>
    </div>
  );

  return (
    <div className="fade-up">
      <div className="ph" style={{ marginBottom: 28 }}>
        <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, #00d084, #00b371)', fontSize: 18 }}>📲</span>
          Status de Grupo
        </h1>
        <p>Poste status dentro do grupo, um por vez ou em sequência{live ? ' · ' + live + ' grupo(s) com status no ar (24h)' : ''}</p>
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {tabBtn('new', '📝 Novo status')}
        {tabBtn('seq', '📋 Sequências')}
        {tabBtn('hist', '📂 Histórico')}
      </div>
      <style>{ST_CSS}</style>

      {tab === 'new' && (
        <div className="card">
          <div className="card-hd"><div><div className="card-t">📝 Novo status</div><div className="card-s">Aparece no círculo da foto do grupo</div></div></div>
          <div className="fg">
            <label className="fl">Tipo</label>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {[['text', '📝 Só texto'], ['image', '🖼️ Imagem'], ['video', '🎬 Vídeo']].map(k => (
                <button key={k[0]} className={'type-btn ' + (kind === k[0] ? 'active' : '')} style={{ flex: '0 0 auto', padding: '10px 18px', ...(kind === k[0] ? { background: 'var(--accent)', color: '#000' } : {}) }} onClick={() => { setKind(k[0]); pickFile(null); }}>{k[1]}</button>
              ))}
            </div>
          </div>
          {kind !== 'text' && (
            <div className="fg">
              <label className="fl">{kind === 'video' ? 'Vídeo (MP4, até 30 s, vertical de preferência)' : 'Imagem'}</label>
              {/*ST_FILENAME_V1*/}<div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                <label className="btn btn-g btn-sm" style={{ cursor: 'pointer' }}>{file ? 'Trocar arquivo' : 'Escolher arquivo'}<input type="file" accept={kind === 'video' ? 'video/*' : 'image/*'} style={{ display: 'none' }} onChange={e => { pickFile(e.target.files[0] || null); e.target.value = ''; }} /></label>
                <span style={{ fontSize: 13, color: 'var(--text2)' }}>{file ? file.name + ' (' + (file.size / 1048576).toFixed(1) + ' MB)' : 'Nenhum arquivo (escolha ou cole com Ctrl+V)'}</span>
                {file && <button type="button" className="btn btn-d btn-sm" onClick={() => pickFile(null)}>Remover</button>}
              </div>
              {prev && kind === 'image' && <img src={prev} alt="prévia" style={{ width: 120, borderRadius: 10, marginTop: 8, border: '1px solid var(--border)' }} />}
              {prev && kind === 'video' && <video src={prev} controls muted playsInline style={{ width: 160, borderRadius: 10, marginTop: 8 }} />}
            </div>
          )}
          <div className="fg">
            <label className="fl">{kind === 'text' ? 'Texto do status' : 'Legenda (opcional)'} ({text.length}/700)</label>
            <textarea className="fi" rows={5} maxLength={700} value={text} onPaste={e => { const f = stClipFile(e); if (!f) return; setKind((f.type || '').startsWith('video') ? 'video' : 'image'); pickFile(f); }} onChange={e => setText(e.target.value)} placeholder="Escreva aqui. Use {GRUPO} e {LINK}" />
            <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 4 }}>{'{GRUPO}'} vira o nome do grupo. {'{LINK}'} vira o link do grupo (a linha some nos grupos sem link).</div>
          </div>
          {kind === 'text' && (
            <div className="fg" style={{ border: '1px solid var(--border)', borderRadius: 10, padding: 12 }}>
              <label style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer', fontSize: 14 }}>
                <input type="checkbox" checked={ctS} onChange={e => setCtS(e.target.checked)} />
                <b>Status de contato (com link do meu WhatsApp)</b>
              </label>
              {ctS && (
                <>
                  <div style={{ fontSize: 12, opacity: 0.7, marginTop: 8 }}>Mensagem que ja vem escrita no chat da pessoa</div>
                  <input className="fi" maxLength={120} style={{ marginTop: 4 }} value={ctSPre} placeholder="Ex: Oi! Vi seu status" onChange={e => { setCtSPre(e.target.value); try { localStorage.setItem('st_ct_pre', e.target.value); } catch (err) {} }} onBlur={() => stSaveContactCfg({ prefill: ctSPre })} />
                  <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>O texto acima vira o status e o link do WhatsApp do bot escolhido entra sozinho embaixo (ate 300 caracteres).</div>
                </>
              )}
            </div>
          )}
          {kind === 'text' && renderStyleBox(bg, font, setBg, setFont)}
          {kind === 'text' && (
            <div className="fg">
              <label className="fl">Prévia</label>
              <div style={{ background: bg, color: '#fff', borderRadius: 14, padding: 24, minHeight: 160, maxWidth: 280, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', whiteSpace: 'pre-wrap', fontWeight: 700, fontSize: 17, wordBreak: 'break-word' }}>{text || 'Seu texto aqui'}</div>
            </div>
          )}
          {renderPicker()}
          <div className="fg">
            <label className="fl">Agendar para (opcional, vazio = enviar agora)</label>
            <input type="datetime-local" className="fi" value={when} onChange={e => setWhen(e.target.value)} />
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <button className="btn btn-p" disabled={busy} onClick={() => submitNew(false)}>{busy ? '⏳ Enviando...' : (when ? '🕐 Agendar' : '⚡ Publicar agora')}</button>
            <button className="btn btn-g" disabled={busy} onClick={() => submitNew(true)}>💾 Salvar rascunho</button>
          </div>
        </div>
      )}

      {tab === 'seq' && (
        <>
          <div className="card">
            <div className="card-hd">
              <div><div className="card-t">📋 Sequências de status</div><div className="card-s">Passos em ordem, um logo após o outro em cada grupo</div></div>
              <button className="btn btn-p btn-sm" onClick={() => { setRunSeq(null); editSeq(null); }}>➕ Nova</button>
            </div>
            {seqs.length === 0 && <div style={{ color: 'var(--text3)', fontSize: 13, padding: 12 }}>Nenhuma sequência salva ainda.</div>}
            {seqs.map(sq => (
              <details key={sq.id} style={{ border: '1px solid var(--border)', borderRadius: 12, marginBottom: 10, background: 'var(--bg3)' }}>
                <summary style={{ cursor: 'pointer', padding: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap', listStyle: 'none' }}>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 700, fontSize: 14 }}>📋 {sq.name}</div>
                    <div style={{ fontSize: 12, color: 'var(--text3)' }}>{sq.steps.length} passo(s) · toque para ver</div>
                  </div>
                  <div style={{ display: 'flex', gap: 6 }} onClick={e => e.stopPropagation()}>
                    <button className="btn btn-p btn-sm" onClick={() => { setEditing(null); setRunSeq(sq); }}>▶ Rodar</button>
                    <button className="btn btn-g btn-sm" onClick={() => { setRunSeq(null); editSeq(sq); }}>✏️</button>
                    <button className="btn btn-g btn-sm" disabled={busy} title={'Duplicar sequ\u00eancia'} onClick={() => dupSeq(sq)}>{'\uD83D\uDCC4'}</button>
                    <button className="btn btn-danger btn-sm" onClick={() => delSeq(sq)}>🗑️</button>
                  </div>
                </summary>
                <div style={{ padding: '0 12px 12px' }}>
                  {sq.steps.map((st, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: 8, marginTop: 6, background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10 }}>
                      <StThumb step={st} />
                      <div style={{ flex: 1, minWidth: 0, fontSize: 13, wordBreak: 'break-word' }}>{ST_ICON[st.kind]} {(st.text || '').replace(/\n/g, ' ').slice(0, 90) || (st.kind === 'text' ? '(sem texto)' : '(sem legenda)')}{(st.text || '').length > 90 ? '…' : ''}</div>
                      <span style={{ fontFamily: 'JetBrains Mono, monospace', fontWeight: 700, color: 'var(--accent)', fontSize: 13 }}>#{i + 1}</span>
                    </div>
                  ))}
                </div>
              </details>
            ))}
          </div>

          {runSeq && (
            <div className="card" style={{ marginTop: 16 }}>
              <div className="card-hd"><div><div className="card-t">▶ Rodar: {runSeq.name}</div><div className="card-s">Cada grupo recebe todos os passos antes de passar para o próximo grupo</div></div></div>
              {renderPicker()}
              <div className="fg">
                <label className="fl">Começar em (opcional, vazio = agora)</label>
                <input type="datetime-local" className="fi" value={runWhen} onChange={e => setRunWhen(e.target.value)} />
              </div>
              <div className="fg" style={{ border: '1px solid var(--border)', borderRadius: 10, padding: 12, marginBottom: 12 }}>
                <label style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer', fontSize: 14 }}>
                  <input type="checkbox" checked={ctOn} onChange={e => { const v = e.target.checked; setCtOn(v); try { localStorage.setItem('st_ct_on', v ? '1' : '0'); } catch (err) {} stSaveContactCfg({ seq_on: v }); }} />
                  <b>Adicionar passo final de contato</b>
                </label>
                {ctOn && (
                  <>
                    <div style={{ fontSize: 12, opacity: 0.7, marginTop: 8 }}>Texto do status</div>
                    <textarea className="fi" rows={2} maxLength={300} style={{ marginTop: 4 }} value={ctText} placeholder="Ex: Fale comigo" onChange={e => { setCtText(e.target.value); try { localStorage.setItem('st_ct_text3', e.target.value); } catch (err) {} }} onBlur={() => stSaveContactCfg({ seq_text: ctText })} />
                    <div style={{ fontSize: 12, opacity: 0.7, marginTop: 8 }}>Mensagem que ja vem escrita no chat da pessoa</div>
                    <input className="fi" maxLength={120} style={{ marginTop: 4 }} value={ctPre} placeholder="Ex: Oi! Vi seu status" onChange={e => { setCtPre(e.target.value); try { localStorage.setItem('st_ct_pre', e.target.value); } catch (err) {} }} onBlur={() => stSaveContactCfg({ prefill: ctPre })} />
                    <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>O link do WhatsApp do bot entra sozinho embaixo do texto.</div>
                  </>
                )}
              </div>
              <div style={{ display: 'flex', gap: 10 }}>
                <button className="btn btn-p" disabled={busy} onClick={runIt}>{busy ? '⏳ Enviando...' : (runWhen ? '🕐 Agendar sequência' : '⚡ Rodar agora')}</button>
                <button className="btn btn-g" onClick={() => setRunSeq(null)}>Cancelar</button>
              </div>
            </div>
          )}

          {editing && (
            <div className="card" style={{ marginTop: 16 }}>
              <div className="card-hd"><div><div className="card-t">{editing.id ? '✏️ Editar sequência' : '➕ Nova sequência'}</div><div className="card-s">Máximo de 20 passos</div></div></div>
              <div className="fg">
                <label className="fl">Nome</label>
                <input className="fi" value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })} placeholder="Ex: Oferta da semana" />
              </div>
              {editing.steps.map((s, i) => (
                <div key={i} style={{ border: '1px solid var(--border)', borderRadius: 10, padding: 12, marginBottom: 10 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <b style={{ fontSize: 13 }}>Passo {i + 1}</b>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-g btn-sm" onClick={() => moveStep(i, -1)} disabled={i === 0}>↑</button>
                      <button className="btn btn-g btn-sm" onClick={() => moveStep(i, 1)} disabled={i === editing.steps.length - 1}>↓</button>
                      <button className="btn btn-d btn-sm" onClick={() => delStep(i)}>🗑️</button>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6, marginBottom: 8, flexWrap: 'wrap' }}>
                    {[['text', '📝 Texto'], ['image', '🖼️ Imagem'], ['video', '🎬 Vídeo']].map(k => (
                      <button key={k[0]} className={'type-btn ' + (s.kind === k[0] ? 'active' : '')} style={{ flex: '0 0 auto', padding: '8px 16px', ...(s.kind === k[0] ? { background: 'var(--accent)', color: '#000' } : {}) }}
                        onClick={() => setStep(i, { kind: k[0], file: null, bg_argb: s.bg_argb == null ? stArgb(ST_COLORS[1]) : s.bg_argb, font: s.font == null ? 0 : s.font })}>{k[1]}</button>
                    ))}
                  </div>
                  {s.kind !== 'text' && (
                    <div style={{ marginBottom: 8 }}>
                      <StPick kind={s.kind} file={s.file} step={s} onPick={f => setStep(i, { file: f })} />
                    </div>
                  )}
                  <textarea className="fi" rows={s.kind === 'text' ? 16 : 8} maxLength={700} value={s.text} onPaste={e => { const f = stClipFile(e); if (!f) return; setStep(i, { kind: (f.type || '').startsWith('video') ? 'video' : 'image', file: f }); }} onChange={e => setStep(i, { text: e.target.value })} placeholder={s.kind === 'text' ? 'Texto do passo. Use {GRUPO} e {LINK}' : 'Legenda (opcional). Use {GRUPO} e {LINK}'} />
                  {s.kind === 'text' && <div style={{ marginTop: 8 }}>{renderStyleBox(s.bg_argb != null ? ST_COLORS.find(c => stArgb(c) === s.bg_argb) : null, s.font == null ? 0 : s.font, c => setStep(i, { bg_argb: stArgb(c) }), v => setStep(i, { font: v }))}</div>}
                </div>
              ))}
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                <button className="btn btn-g" disabled={editing.steps.length >= 20} onClick={() => setEditing({ ...editing, steps: [...editing.steps, stNewStep()] })}>➕ Adicionar passo</button>
                <button className="btn btn-p" disabled={busy} onClick={saveSeq}>{busy ? '⏳ Salvando...' : '💾 Salvar sequência'}</button>
                <button className="btn btn-g" onClick={() => setEditing(null)}>Cancelar</button>
              </div>
            </div>
          )}
        </>
      )}

      {tab === 'hist' && (
        <div className="card">
          <div className="card-hd">
            <div><div className="card-t">📂 Status e sequências</div><div className="card-s">Atualiza sozinho a cada 8 segundos</div></div>
            <button className="btn btn-g btn-sm" onClick={loadPosts}>🔄</button>
          </div>
          {posts.length === 0 && <div style={{ color: 'var(--text3)', fontSize: 13, padding: 12 }}>Nenhum status ainda.</div>}
          {posts.map(p => {
            const title = p.kind === 'sequence' ? (p.seq_name || 'Sequência') : (p.content_text || p.caption || '(sem texto)');
            const total = p.total || 0;
            const doneN = (p.sent || 0) + (p.failed || 0);
            const pct = total ? Math.round((doneN / total) * 100) : 0;
            let nSteps = 1;
            if (p.kind === 'sequence') { try { nSteps = JSON.parse(p.steps_json || '[]').length || 1; } catch (e) { nSteps = 1; } }
            const cnt = { sent: 0, wait: 0, fail: 0 };
            let nextAt = null;
            if (open === p.id) {
              items.forEach(it => {
                if (it.status === 'sent') cnt.sent++;
                else if (it.status === 'failed' || it.status === 'canceled') cnt.fail++;
                else { cnt.wait++; if (it.status === 'pending' && (!nextAt || it.scheduled_for < nextAt)) nextAt = it.scheduled_for; }
              });
            }
            return (
              <div key={p.id} className="stm-post">
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'flex-start' }}>
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, wordBreak: 'break-word' }}>{ST_ICON[p.kind]} {title.length > 70 ? title.slice(0, 70) + '…' : title}</div>
                    <div className="stm-sub">#{p.id} · {p.bot_id}{p.schedule_at ? ' · início ' + stFmt(p.schedule_at) : ''}</div>
                  </div>
                  {stBadge(p.status)}
                </div>
                <div className="stm-bar" style={{ marginTop: 12 }}><div className="stm-fill" style={{ width: pct + '%' }} /></div>
                <div className="stm-sub">{doneN}/{total} grupos ({pct}%) · ✅ {p.sent} · ❌ {p.failed} · ⏳ {p.pending}</div>
                <div style={{ display: 'flex', gap: 6, marginTop: 10, flexWrap: 'wrap' }}>
                  <button className="btn btn-g btn-sm" onClick={() => openDetail(p.id)}>{open === p.id ? '▲ Fechar' : '▼ Monitor'}</button>
                  {p.status === 'draft' && <button className="btn btn-p btn-sm" onClick={() => act(p, 'publish')}>⚡ Publicar</button>}
                  {p.failed > 0 && <button className="btn btn-g btn-sm" onClick={() => act(p, 'retry')}>🔁 Reenviar falhas</button>}
                  {['draft', 'scheduled', 'processing'].includes(p.status) && <button className="btn btn-g btn-sm" onClick={() => act(p, 'cancel')}>⛔ Cancelar</button>}
                  {!['scheduled', 'processing'].includes(p.status) && <button className="btn btn-danger btn-sm" onClick={() => act(p, 'delete')}>🗑️</button>}
                </div>
                {open === p.id && (
                  <div style={{ marginTop: 12 }}>
                    <div className="stm-nums">
                      <div className="stm-num"><b style={{ color: '#00d084' }}>{cnt.sent}</b><span>ENVIADOS</span></div>
                      <div className="stm-num"><b style={{ color: '#3f83f8' }}>{cnt.wait}</b><span>NA FILA</span></div>
                      <div className="stm-num"><b style={{ color: '#f05252' }}>{cnt.fail}</b><span>FALHAS</span></div>
                    </div>
                    {nextAt && <div className="stm-sub" style={{ marginBottom: 6 }}>Próximo envio por volta de {stFmt(nextAt)}</div>}
                    <div className="stm-list">
                      {items.map(it => {
                        const sd = it.step_done || 0;
                        const ipct = it.status === 'sent' ? 100 : (p.kind === 'sequence' ? Math.round((sd / nSteps) * 100) : (it.status === 'processing' ? 50 : 0));
                        return (
                          <div key={it.id} className="stm-row">
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div className="stm-gn">{it.group_name || it.group_id}</div>
                              <div className="stm-bar sm"><div className="stm-fill" style={{ width: ipct + '%', background: (it.status === 'failed' || it.status === 'canceled') ? 'var(--red)' : undefined }} /></div>
                              <div className="stm-sub">{p.kind === 'sequence' ? (it.status === 'sent' ? nSteps : sd) + '/' + nSteps + ' passos' : ''}{it.error ? ' — ' + it.error : ''}{it.link_missing ? ' · sem link' : ''}</div>
                            </div>
                            <div className="stm-r">{stBadge(it.status)}<div className="stm-sub">{stFmt(it.done_at || it.scheduled_for)}</div></div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
// FIM_STATUS_PAGE


function GroupsSelector({ botId, selected, onChange }) {
  const [groups, setGroups] = useState(getStoredGroups(botId));
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  useEffect(() => { setGroups(getStoredGroups(botId)); onChange(getStoredSel(botId)); }, [botId]);
  const [pics, setPics] = useState({});
  useEffect(() => {
    if (!groups.length) return undefined;
    let dead = false;
    (async () => {
      let todo = groups.map(g => g.id);
      for (let round = 0; round < 40 && todo.length && !dead; round++) {
        const r = await api('/group-pics', { method: 'POST', body: JSON.stringify({ bot_id: botId, ids: todo.slice(0, 60) }) });
        if (dead || !r.ok || !r.data) break;
        const got = Object.keys(r.data);
        if (!got.length) break;
        setPics(p => ({ ...p, ...r.data }));
        const done = new Set(got);
        todo = todo.filter(id => !done.has(id));
      }
    })();
    return () => { dead = true; };
  }, [groups, botId]);
  const load = async () => {
    setLoading(true);
    const r = await api(`/groups?bot=${botId}`);
    if (r.ok && r.data.length) {
      const s = [...r.data].sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
      setGroups(s);
      storeGroups(botId, s);
      // Mantém apenas seleções que ainda existem nos grupos carregados
      const ids = s.map(g => g.id);
      const prevSel = getStoredSel(botId).filter(id => ids.includes(id));
      storeSel(botId, prevSel);
      onChange(prevSel);
    }
    setLoading(false);
  };
  const toggle = id => { const n = selected.includes(id) ? selected.filter(x => x !== id) : [...selected, id]; onChange(n); storeSel(botId, n); };
  const selAll = () => { const all = filtered.map(g => g.id); onChange(all); storeSel(botId, all); };
  const clear = () => { onChange([]); storeSel(botId, []); };
  const saveSelection = () => { storeSel(botId, selected); alert('✅ Seleção salva para ' + (botId === 'bot1' ? 'WhatsApp 1' : botId === 'bot2' ? 'WhatsApp 2' : 'WhatsApp 3') + '!'); };
  const filtered = groups.filter(g => g.name.toLowerCase().includes(search.toLowerCase()));
  return (
    <>
      <div className="grp-head">
        <button className="btn btn-g btn-sm" onClick={load} disabled={loading}>{loading ? '⏳' : '🔄'} Atualizar</button>
        <button className="btn btn-g btn-sm" onClick={selAll}>Todos</button>
        <button className="btn btn-g btn-sm" onClick={clear}>Limpar</button>
        <button className="btn btn-p btn-sm" onClick={saveSelection} title="Salvar seleção atual">💾 Salvar</button>
        <span className="grp-cnt">{selected.length}/{groups.length}</span>
      </div>
      <input className="fi" style={{ marginBottom: 10 }} placeholder="🔍 Buscar grupo..." value={search} onChange={e => setSearch(e.target.value)} />
      {groups.length === 0
        ? <div style={{ textAlign: 'center', color: 'var(--text3)', fontSize: 13, padding: '12px 0', fontWeight: 600 }}>Clique em "Atualizar" para carregar os grupos</div>
        : <div className="grp-grid">{filtered.map(g => (
          <div key={g.id} className={`gi ${selected.includes(g.id) ? 'sel' : ''}`} onClick={() => toggle(g.id)}>
            <div className="gck">{selected.includes(g.id) ? '✓' : ''}</div>
            <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'var(--bg4)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 17, flexShrink: 0, overflow: 'hidden' }}>{pics[g.id] ? <img src={pics[g.id]} alt="" referrerPolicy="no-referrer" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={() => setPics(p => ({ ...p, [g.id]: null }))} /> : '👥'}</div>
            <div style={{display:'flex',flexDirection:'column',flex:1,minWidth:0}}>
              <span className="gn">{g.name.length > 25 ? g.name.slice(0,25) + '...' : g.name}</span>
              {g.name.length > 25 && <span style={{fontSize:10,color:'var(--text3)',marginTop:2}}>{g.name}</span>}
            </div>
          </div>
        ))}</div>}
    </>
  );
}

// ── FeedCard ATUALIZADO com botões Reagendar, Cancelar e Excluir ──────────
function FeedCard({ msg, botId, onDelete, onCancel, onReschedule }) {
  const grps = getStoredGroups(botId);
  const g = grps.find(x => x.id === msg.to_id);
  const grpName = g?.name || msg.to_id;
  const ext = msg.file_path?.split('.').pop()?.toLowerCase();
  const isVideo = ['mp4', 'mov', 'avi', 'webm'].includes(ext);
  const isImg = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
  const url = msg.file_path ? `${API_BASE}/midias/${msg.file_path.split('/midias/').pop()}` : null;
  const dt = new Date(msg.schedule_at);
  const dateStr = dt.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit' }) + ' ' + dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  const shortName = grpName.length > 38 ? grpName.slice(0, 38) + '…' : grpName;
  const isPending = msg.status === 'pending';
  return (
    <div className="feed-card">
      {url && isImg && <div className="feed-media-wrap"><img src={url} alt="mídia" onError={e => e.target.style.display = 'none'} /></div>}
      {url && isVideo && <div className="feed-media-wrap"><video src={url} controls playsInline preload="metadata" style={{ width: "100%", maxHeight: 360, objectFit: "contain" }} /></div>}
      <div className="feed-body">
        <div className="feed-row1">
          <div style={{ minWidth: 0 }}>
            <div className="feed-grp">📌 {shortName}</div>
            <div className="feed-time">⏰ {dateStr}</div>
          </div>
          <span className={`chip ch-${msg.status}`}>{msg.status}</span>
        </div>
        {msg.text && <div className="feed-msg">{msg.text.length > 130 ? msg.text.slice(0, 130) + '…' : msg.text}</div>}
        <div className="feed-footer">
          <span className="feed-id">#{msg.id} · {msg.type}</span>
          <div className="feed-actions">
            {/* Reagendar — sempre visível */}
            <button
              className="btn btn-g btn-sm"
              title="Reagendar"
              onClick={() => onReschedule(msg)}
              style={{ gap: 4 }}
            >
              📅 Reagenda
            </button>
            {/* Cancelar — só para pendentes */}
            {isPending && (
              <button
                className="btn btn-o btn-sm"
                title="Cancelar envio"
                onClick={() => onCancel(msg.id)}
                style={{ gap: 4 }}
              >
                ⏹ Cancelar
              </button>
            )}
            {/* Excluir — sempre visível */}
            <button
              className="btn btn-d btn-sm"
              title="Excluir"
              onClick={() => onDelete(msg.id)}
              style={{ gap: 4 }}
            >
              🗑 Excluir
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── SEND MONITOR (Status de envios + Agenda do dia) ──────────────────────
function SendMonitor({ messages, botId, botNumbers, loadMsgs, onCancelGroup, onDeleteGroup, onEditGroup, editLoading }) {
  const [tab, setTab] = useState('active');
  const [futureExpanded, setFutureExpanded] = useState({});
  const [futureDateFilter, setFutureDateFilter] = useState('');

  const botMsgs = messages.filter(m => (m.instance_id || 'bot1') === botId);

  // "Em andamento" mostra TODOS os pendentes/enviados recentes
  const sent = botMsgs.filter(m => m.status === 'sent').length;
  const pending = botMsgs.filter(m => m.status === 'pending' || m.status === 'processing').length;
  const failed = botMsgs.filter(m => m.status === 'failed').length;
  const total = botMsgs.length;

  // Agrupar por texto+horário+data pra agenda — só hoje, concluídos somem após 5min
  const todayStr = (() => { const t = new Date(); return t.getFullYear()+'-'+String(t.getMonth()+1).padStart(2,'0')+'-'+String(t.getDate()).padStart(2,'0'); })();
  const nowTs = Date.now();
  const agenda = [];
  const seen = new Map();
  botMsgs.forEach(m => {
    const dateStr = (m.schedule_at || '').slice(0, 10);
    if (dateStr !== todayStr) return; // só hoje
    if (m.status === 'canceled') return; // ignora cancelados
    const timeStr = (m.schedule_at || '').slice(11, 16);
    const key = dateStr + '||' + timeStr + '||' + (m.text || '').trim().slice(0, 60);
    if (!seen.has(key)) {
      seen.set(key, { text: m.text, time: timeStr, date: dateStr, type: m.type, file_path: m.file_path || null, total: 0, sent: 0, failed: 0, pending: 0, lastSent: m.last_sent_at || null, ids: [], pendingIds: [] });
      agenda.push(seen.get(key));
    }
    const g = seen.get(key);
    g.ids.push(m.id);
    g.total++;
    if (m.status === 'sent') { g.sent++; if (m.last_sent_at && (!g.lastSent || m.last_sent_at > g.lastSent)) g.lastSent = m.last_sent_at; }
    else if (m.status === 'failed') g.failed++;
    else { g.pending++; g.pendingIds.push(m.id); }
  });
  // Remove grupos 100% enviados há mais de 5 minutos
  const agendaFiltrada = agenda.filter(item => {
    if (item.sent < item.total) return true;
    if (!item.lastSent) return false;
    const sentTs = new Date(item.lastSent).getTime();
    return (nowTs - sentTs) < 5 * 60 * 1000;
  });
  agendaFiltrada.sort((a, b) => ((a.date || '') + a.time).localeCompare((b.date || '') + b.time));

  const fmtNum = n => botNumbers[botId] ? '+' + botNumbers[botId].replace(/^(\d{2})(\d{2})(\d+)/, '$1 ($2) $3') : '';
  const waLabel = botId === 'bot1' ? 'WA1' : botId === 'bot2' ? 'WA2' : 'WA3';

  if (total === 0) return null;

  return (
    <div className="card" style={{ marginTop: 16 }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 8, height: 8, borderRadius: '50%', background: pending > 0 ? 'var(--accent)' : 'var(--text3)', animation: pending > 0 ? 'pulse 1.4s infinite' : 'none' }} />
          <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)' }}>Monitor de envios</span>
        </div>
        <div style={{ display: 'flex', background: 'var(--bg3)', borderRadius: 8, padding: 3, gap: 2 }}>
          <button onClick={() => setTab('active')} style={{ padding: '5px 12px', fontSize: 11, fontWeight: 700, border: 'none', borderRadius: 6, cursor: 'pointer', fontFamily: 'Inter,sans-serif',
            background: tab === 'active' ? 'var(--accent)' : 'transparent', color: tab === 'active' ? '#000' : '#94a3b8', boxShadow: tab === 'active' ? '0 1px 4px rgba(0,0,0,.2)' : 'none' }}>Em andamento</button>
          <button onClick={() => setTab('agenda')} style={{ padding: '5px 12px', fontSize: 11, fontWeight: 700, border: 'none', borderRadius: 6, cursor: 'pointer', fontFamily: 'Inter,sans-serif',
            background: tab === 'agenda' ? 'var(--accent)' : 'transparent', color: tab === 'agenda' ? '#000' : '#94a3b8', boxShadow: tab === 'agenda' ? '0 1px 4px rgba(0,0,0,.2)' : 'none' }}>Agenda do dia</button>
          <button onClick={() => setTab('future')} style={{ padding: '5px 12px', fontSize: 11, fontWeight: 700, border: 'none', borderRadius: 6, cursor: 'pointer', fontFamily: 'Inter,sans-serif',
            background: tab === 'future' ? 'var(--accent)' : 'transparent', color: tab === 'future' ? '#000' : '#94a3b8', boxShadow: tab === 'future' ? '0 1px 4px rgba(0,0,0,.2)' : 'none' }}>Agendados</button>
        </div>
      </div>

      {tab === 'active' && (
        <div>
          {/* Info */}
          <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 12, fontSize: 12, color: 'var(--text3)' }}>
            <span style={{ fontWeight: 700, color: '#e2e8f0' }}>{waLabel}</span>
            <span>·</span>
            <span style={{ fontFamily: 'JetBrains Mono,monospace' }}>{fmtNum()}</span>
            <span>·</span>
            <span>{new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
          </div>

          {/* Contadores */}
          <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
            <div style={{ flex: 1, background: 'rgba(255,255,255,.04)', borderRadius: 'var(--r-sm)', padding: '12px 14px', textAlign: 'center', border: '1px solid rgba(255,255,255,.06)' }}>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#22c55e', lineHeight: 1 }}>{sent}</div>
              <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 4, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px' }}>Enviados</div>
            </div>
            <div style={{ flex: 1, background: 'rgba(255,255,255,.04)', borderRadius: 'var(--r-sm)', padding: '12px 14px', textAlign: 'center', border: '1px solid rgba(255,255,255,.06)' }}>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#60a5fa', lineHeight: 1 }}>{pending}</div>
              <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 4, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px' }}>Pendentes</div>
            </div>
            <div style={{ flex: 1, background: 'rgba(255,255,255,.04)', borderRadius: 'var(--r-sm)', padding: '12px 14px', textAlign: 'center', border: '1px solid rgba(255,255,255,.06)' }}>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#f87171', lineHeight: 1 }}>{failed}</div>
              <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 4, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px' }}>Falhas</div>
            </div>
          </div>

          {/* Barra de progresso */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
            <span style={{ fontSize: 11, color: '#94a3b8', fontWeight: 600 }}>Progresso</span>
            <span style={{ fontSize: 13, fontWeight: 800, fontFamily: 'JetBrains Mono,monospace', color: '#e2e8f0' }}>{sent} / {total}</span>
          </div>
          <div style={{ width: '100%', height: 8, background: 'rgba(255,255,255,.08)', borderRadius: 4, overflow: 'hidden', marginBottom: 4 }}>
            <div style={{ width: (total > 0 ? (sent / total * 100) : 0) + '%', height: '100%', background: 'var(--accent)', borderRadius: 3, transition: 'width .5s ease' }} />
          </div>
          {pending > 0 && <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 2 }}>Enviando... próximo em ~60s</div>}
          {pending === 0 && sent > 0 && <div style={{ fontSize: 10, color: 'var(--accent)', marginTop: 2 }}>Todos os envios concluídos</div>}

          <button className="btn btn-g btn-sm" onClick={loadMsgs} style={{ marginTop: 12, color: '#e2e8f0', borderColor: 'rgba(255,255,255,.15)' }}>🔄 Atualizar</button>
        </div>
      )}

      {tab === 'agenda' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: '#e2e8f0' }}>Agenda de envios</span>
            <span style={{ fontSize: 11, color: 'var(--text3)' }}>{agendaFiltrada.length} envio(s) hoje</span>
          </div>

          {agendaFiltrada.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '20px 0', color: 'var(--text3)', fontSize: 13 }}>Nenhum envio para hoje</div>
          ) : (
            <div style={{ position: 'relative', paddingLeft: 22 }}>
              <div style={{ position: 'absolute', left: 7, top: 10, bottom: 10, width: 1.5, background: 'var(--border)', borderRadius: 1 }} />
              {agendaFiltrada.map((item, idx) => {
                const done = item.sent === item.total;
                const sending = item.sent > 0 && !done;
                const hasPending = item.pending > 0;
                const dotColor = done ? 'var(--accent)' : sending ? 'var(--blue)' : 'var(--border2)';
                const timeColor = done ? 'var(--accent)' : sending ? 'var(--blue)' : 'var(--text3)';
                const badgeColor = done ? 'rgba(0,208,132,.1)' : sending ? 'rgba(63,131,248,.1)' : 'var(--bg4)';
                const badgeText = done ? 'var(--accent)' : sending ? 'var(--blue)' : 'var(--text3)';
                return (
                  <div key={idx} style={{ padding: '10px 0', position: 'relative', borderBottom: idx < agendaFiltrada.length - 1 ? '1px solid var(--border)' : 'none' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div style={{ position: 'absolute', left: -19, width: 11, height: 11, borderRadius: '50%', background: dotColor, border: '2px solid var(--bg2)', zIndex: 1 }} />
                      <div style={{ flexShrink: 0, minWidth: 62 }}>
                        <span style={{ fontSize: 13, fontWeight: 700, fontFamily: 'JetBrains Mono,monospace', color: timeColor }}>{item.time}</span>
                      </div>
                      <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                        <span style={{ fontSize: 13, color: done ? '#64748b' : '#e2e8f0', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                          {item.text ? item.text.slice(0, 40) + (item.text.length > 40 ? '...' : '') : (item.type === 'media' ? '🖼 Mídia' : 'Sem texto')}
                        </span>
                      </div>
                      <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 12, background: badgeColor, color: badgeText, fontWeight: 800, fontFamily: 'JetBrains Mono,monospace', flexShrink: 0 }}>
                        {item.sent}/{item.total}
                      </span>
                    </div>
                    {hasPending && onCancelGroup && (
                      <div style={{ display: 'flex', gap: 5, marginTop: 7, marginLeft: 72 }}>
                        <button onClick={() => !editLoading && onEditGroup && onEditGroup(item)} disabled={editLoading}
                          style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 6, border: '1.5px solid var(--border2)', background: 'var(--bg3)', color: 'var(--text2)', cursor: editLoading ? 'wait' : 'pointer', fontFamily: 'Inter,sans-serif', opacity: editLoading ? 0.6 : 1 }}>
                          {editLoading ? '⏳ Carregando...' : '✏️ Editar'}
                        </button>
                        <button onClick={() => onCancelGroup(item)}
                          style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 6, border: '1.5px solid rgba(249,115,22,.3)', background: 'var(--orange-dim)', color: 'var(--orange)', cursor: 'pointer', fontFamily: 'Inter,sans-serif' }}>
                          ⏹ Cancelar
                        </button>
                        <button onClick={() => onDeleteGroup && onDeleteGroup(item)}
                          style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 6, border: '1.5px solid rgba(240,82,82,.3)', background: 'var(--red-dim)', color: 'var(--red)', cursor: 'pointer', fontFamily: 'Inter,sans-serif' }}>
                          🗑 Excluir
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          <button className="btn btn-g btn-sm" onClick={loadMsgs} style={{ marginTop: 12, color: '#e2e8f0', borderColor: 'rgba(255,255,255,.15)' }}>🔄 Atualizar</button>
        </div>
      )}

      {tab === 'future' && (() => {
        // Agrupa mensagens pendentes por data (hoje em diante), ignorando cancelados
        const futureMsgs = botMsgs.filter(m => m.status !== 'canceled' && m.schedule_at);
        const byDate = {};
        futureMsgs.forEach(m => {
          const dateStr = (m.schedule_at || '').slice(0, 10);
          if (!byDate[dateStr]) byDate[dateStr] = [];
          byDate[dateStr].push(m);
        });
        const sortedDates = Object.keys(byDate).sort();
        const filteredDates = futureDateFilter
          ? sortedDates.filter(d => d === futureDateFilter)
          : sortedDates;

        // Agrupa por data > horário+texto
        const dateGroups = filteredDates.map(date => {
          const msgs = byDate[date];
          const seen = new Map();
          const items = [];
          msgs.forEach(m => {
            const timeStr = (m.schedule_at || '').slice(11, 16);
            const key = timeStr + '||' + (m.text || '').trim().slice(0, 60);
            if (!seen.has(key)) {
              seen.set(key, { text: m.text, time: timeStr, date, type: m.type, file_path: m.file_path, total: 0, sent: 0, failed: 0, pending: 0, ids: [], pendingIds: [], jids: [] });
              items.push(seen.get(key));
            }
            const g = seen.get(key);
            g.ids.push(m.id); if (m.to_id && !g.jids.includes(m.to_id)) g.jids.push(m.to_id);
            g.total++;
            if (m.status === 'sent') g.sent++;
            else if (m.status === 'failed') g.failed++;
            else { g.pending++; g.pendingIds.push(m.id); }
          });
          items.sort((a, b) => a.time.localeCompare(b.time));
          const totalPending = items.reduce((s, i) => s + i.pending, 0);
          const totalSent = items.reduce((s, i) => s + i.sent, 0);
          const totalAll = items.reduce((s, i) => s + i.total, 0);
          return { date, items, totalPending, totalSent, totalAll };
        });

        const totalFuturePending = dateGroups.reduce((s, dg) => s + dg.totalPending, 0);
        /* GRP_LABEL_V1 */
        const _gc = {};
        try { for (let i = 0; i < localStorage.length; i++) { const k = localStorage.key(i); if (k && k.indexOf('zs_g_') === 0) { (JSON.parse(localStorage.getItem(k) || '[]') || []).forEach(g => { if (g && g.id && g.name) _gc[g.id] = g.name; }); } } } catch (e) {}
        const gnameOf = j => _gc[j] || ('…' + String(j).replace(/@.*/, '').slice(-4));
        const gHue = k => { let h = 0; for (let i = 0; i < k.length; i++) h = (h * 31 + k.charCodeAt(i)) % 360; return h; };
        /* GRP_LABEL_V2 */
        const gkey = (d, it) => 'g||' + d + '||' + it.time + '||' + (it.text || '').trim().slice(0, 40);

        const fmtDate = d => {
          const [y, mo, da] = d.split('-');
          const dt = new Date(+y, +mo - 1, +da);
          const today = new Date(); today.setHours(0,0,0,0);
          const tomorrow = new Date(today); tomorrow.setDate(tomorrow.getDate() + 1);
          if (dt.getTime() === today.getTime()) return '📅 Hoje';
          if (dt.getTime() === tomorrow.getTime()) return '📅 Amanhã';
          return '📅 ' + dt.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: 'short' });
        };

        return (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: '#e2e8f0' }}>
                Agendamentos {totalFuturePending > 0 && <span style={{ color: 'var(--accent)', fontFamily: 'JetBrains Mono,monospace' }}>({totalFuturePending} pendentes)</span>}
              </span>
              <input type="date" value={futureDateFilter} onChange={e => setFutureDateFilter(e.target.value)}
                style={{ fontSize: 11, padding: '4px 8px', borderRadius: 6, border: '1.5px solid var(--border2)', background: 'var(--bg3)', color: 'var(--text2)', fontFamily: 'Inter,sans-serif' }}
              />
            </div>
            {futureDateFilter && (
              <button className="btn btn-g btn-sm" onClick={() => setFutureDateFilter('')}
                style={{ marginBottom: 10, fontSize: 11 }}>✕ Limpar filtro</button>
            )}

            {dateGroups.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: 'var(--text3)', fontSize: 13 }}>Nenhum agendamento encontrado</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {dateGroups.map(dg => {
                  const exp = futureExpanded[dg.date];
                  return (
                    <div key={dg.date} style={{ border: '1.5px solid var(--border)', borderRadius: 'var(--r)', background: 'var(--bg3)', overflow: 'hidden' }}>
                      {/* Cabeçalho clicável */}
                      <div onClick={() => setFutureExpanded(prev => ({ ...prev, [dg.date]: !prev[dg.date] }))}
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 14px', cursor: 'pointer', userSelect: 'none' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <span style={{ fontSize: 14, color: 'var(--text3)', transition: 'transform 0.2s', transform: exp ? 'rotate(90deg)' : 'rotate(0deg)', display: 'inline-block' }}>▶</span>
                          <span style={{ fontWeight: 700, fontSize: 14, color: 'var(--text)' }}>{fmtDate(dg.date)}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 12, background: 'var(--accent-dim)', color: 'var(--accent)', fontWeight: 800, fontFamily: 'JetBrains Mono,monospace' }}>
                            {dg.items.length} envio(s)
                          </span>
                          <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 12, background: dg.totalPending > 0 ? 'rgba(63,131,248,.1)' : 'rgba(0,208,132,.1)', color: dg.totalPending > 0 ? 'var(--blue)' : 'var(--accent)', fontWeight: 800, fontFamily: 'JetBrains Mono,monospace' }}>
                            {dg.totalSent}/{dg.totalAll}
                          </span>
                        </div>
                      </div>

                      {/* Conteúdo expansível */}
                      {exp && (
                        <div style={{ padding: '0 14px 14px 14px' }}>
                          <div style={{ position: 'relative', paddingLeft: 22 }}>
                            <div style={{ position: 'absolute', left: 7, top: 10, bottom: 10, width: 1.5, background: 'var(--border)', borderRadius: 1 }} />
                            {dg.items.map((item, idx) => {
                              const done = item.sent === item.total;
                              const sending = item.sent > 0 && !done;
                              const hasPending = item.pending > 0;
                              const dotColor = done ? 'var(--accent)' : sending ? 'var(--blue)' : 'var(--border2)';
                              const timeColor = done ? 'var(--accent)' : sending ? 'var(--blue)' : 'var(--text3)';
                              const badgeColor = done ? 'rgba(0,208,132,.1)' : sending ? 'rgba(63,131,248,.1)' : 'var(--bg4)';
                              const badgeText = done ? 'var(--accent)' : sending ? 'var(--blue)' : 'var(--text3)';
                              return (
                                <div key={idx} style={{ padding: '10px 0', position: 'relative', borderBottom: idx < dg.items.length - 1 ? '1px solid var(--border)' : 'none' }}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <div style={{ position: 'absolute', left: -19, width: 11, height: 11, borderRadius: '50%', background: dotColor, border: '2px solid var(--bg2)', zIndex: 1 }} />
                                    <div style={{ flexShrink: 0, minWidth: 52 }}>
                                      <span style={{ fontSize: 13, fontWeight: 700, fontFamily: 'JetBrains Mono,monospace', color: timeColor }}>{item.time}</span>
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0, overflow: 'hidden', display: 'flex', alignItems: 'center', gap: 6 }}>
                                      {item.jids && item.jids.length > 0 && (() => {
                                        const nm = item.jids.map(gnameOf);
                                        const hue = gHue(item.jids.slice().sort().join(','));
                                        return (
                                          <span title="Clique para ver os grupos" onClick={e => { e.stopPropagation(); setFutureExpanded(prev => ({ ...prev, [gkey(dg.date, item)]: !prev[gkey(dg.date, item)] })); }} style={{ cursor: 'pointer', flexShrink: 0, maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 10, fontWeight: 800, padding: '2px 8px', borderRadius: 10, background: 'hsla(' + hue + ',70%,50%,.15)', color: 'hsl(' + hue + ',75%,65%)', border: '1px solid hsla(' + hue + ',70%,50%,.35)' }}>
                                            {'👥 ' + (nm.length === 1 ? nm[0] : nm.length + ' grupos') + (futureExpanded[gkey(dg.date, item)] ? ' ▴' : ' ▾')}
                                          </span>
                                        );
                                      })()}
                                      <span style={{ flex: 1, minWidth: 0, fontSize: 13, color: done ? '#64748b' : '#e2e8f0', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                                        {item.text ? item.text.slice(0, 40) + (item.text.length > 40 ? '...' : '') : (item.type === 'media' ? '🖼 Mídia' : 'Sem texto')}
                                      </span>
                                    </div>
                                    <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 12, background: badgeColor, color: badgeText, fontWeight: 800, fontFamily: 'JetBrains Mono,monospace', flexShrink: 0 }}>
                                      {item.sent}/{item.total}
                                    </span>
                                  </div>
                                  {futureExpanded[gkey(dg.date, item)] && item.jids && item.jids.length > 0 && (
                                    <div style={{ marginLeft: 62, marginTop: 6, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                      {item.jids.map(j => (
                                        <span key={j} style={{ fontSize: 10, padding: '2px 7px', borderRadius: 8, background: 'var(--bg4)', color: 'var(--text2)' }}>{gnameOf(j)}</span>
                                      ))}
                                    </div>
                                  )}
                                  {hasPending && (
                                    <div style={{ display: 'flex', gap: 5, marginTop: 7, marginLeft: 62 }}>
                                      <button onClick={() => !editLoading && onEditGroup && onEditGroup(item)} disabled={editLoading}
                                        style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 6, border: '1.5px solid var(--border2)', background: 'var(--bg3)', color: 'var(--text2)', cursor: editLoading ? 'wait' : 'pointer', fontFamily: 'Inter,sans-serif', opacity: editLoading ? 0.6 : 1 }}>
                                        {editLoading ? '⏳ Carregando...' : '✏️ Editar'}
                                      </button>
                                      <button onClick={() => onCancelGroup && onCancelGroup(item)}
                                        style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 6, border: '1.5px solid rgba(249,115,22,.3)', background: 'var(--orange-dim)', color: 'var(--orange)', cursor: 'pointer', fontFamily: 'Inter,sans-serif' }}>
                                        ⏹ Cancelar
                                      </button>
                                      <button onClick={() => onDeleteGroup && onDeleteGroup(item)}
                                        style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 6, border: '1.5px solid rgba(240,82,82,.3)', background: 'var(--red-dim)', color: 'var(--red)', cursor: 'pointer', fontFamily: 'Inter,sans-serif' }}>
                                        🗑 Excluir
                                      </button>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            <button className="btn btn-g btn-sm" onClick={loadMsgs} style={{ marginTop: 12, color: '#e2e8f0', borderColor: 'rgba(255,255,255,.15)' }}>🔄 Atualizar</button>
          </div>
        );
      })()}
    </div>
  );
}

// ── SEQUENCE QUICK DISPATCH ──────────────────────────────────────────────
const FQ_CSS = `.fq{--fq-bub:#0a6b58;--fq-tx:#eafff8;--fq-tone:#22c55e}
.fq-seg{display:inline-flex;flex-wrap:wrap;gap:2px;padding:3px;border-radius:13px;background:var(--bg2);border:1px solid var(--border);max-width:100%}
.fq-seg>button{appearance:none;border:0;background:transparent;color:var(--text3);font:inherit;font-size:12.5px;font-weight:600;padding:8px 13px;border-radius:10px;cursor:pointer;display:inline-flex;align-items:center;gap:7px;transition:color .12s,background .12s}
.fq-seg>button:hover{color:var(--text2)}
.fq-seg>button[aria-pressed=true]{background:var(--bg3);color:var(--text);box-shadow:0 1px 2px rgba(0,0,0,.28),inset 0 0 0 1px var(--border)}
.fq-seg>button:focus-visible{outline:2px solid var(--accent);outline-offset:1px}
.fq-dot{width:7px;height:7px;border-radius:50%;background:currentColor;opacity:.35;flex:0 0 7px}
.fq-seg>button[aria-pressed=true] .fq-dot{opacity:1;background:var(--fq-tone)}
.fq-note{font-size:12.5px;color:var(--text3);line-height:1.55;margin-top:10px;max-width:68ch}
.fq-bar{display:flex;align-items:center;gap:10px;margin-bottom:14px;flex-wrap:wrap}
.fq-find{position:relative;flex:1 1 240px;min-width:0}
.fq-find input{width:100%;box-sizing:border-box;background:var(--bg2);border:1px solid var(--border);color:var(--text);padding:10px 12px 10px 34px;border-radius:11px;font:inherit;font-size:13px}
.fq-find input:focus{outline:none;border-color:var(--accent)}
.fq-find svg{position:absolute;left:11px;top:50%;transform:translateY(-50%);opacity:.45}
.fq-count{font-size:12px;color:var(--text3);white-space:nowrap}
.fq-list{display:grid;gap:10px}
.fq-card{position:relative;border:1px solid transparent;border-radius:16px;padding:14px 16px 16px;background-image:linear-gradient(var(--bg3),var(--bg3)),linear-gradient(140deg,var(--fq-soft),transparent 52%,var(--fq-soft));background-origin:border-box;background-clip:padding-box,border-box;box-shadow:0 0 22px -15px var(--fq-tone),0 1px 2px rgba(0,0,0,.3);transition:box-shadow .18s}
.fq-card:hover{box-shadow:0 0 30px -9px var(--fq-tone),0 1px 2px rgba(0,0,0,.3)}
.fq-top{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin-bottom:9px}
.fq-cue{font-size:11.5px;color:var(--text3)}
.fq-cue b{color:var(--fq-tone);font-weight:700}
.fq-acts{display:flex;gap:4px;flex:0 0 auto}
.fq-acts>button{appearance:none;font:inherit;font-size:12px;font-weight:700;padding:6px 11px;border-radius:9px;cursor:pointer;transition:background .13s,box-shadow .13s;display:inline-flex;align-items:center;gap:5px}
.fq-edit{color:#34d399;border:1px solid rgba(52,211,153,.4);background:rgba(52,211,153,.12)}
.fq-edit:hover{background:rgba(52,211,153,.22);box-shadow:0 0 14px -5px #34d399}
.fq-del{color:#f87171;border:1px solid rgba(248,113,113,.4);background:rgba(248,113,113,.12)}
.fq-del:hover{background:rgba(248,113,113,.22);box-shadow:0 0 14px -5px #f87171}
.fq-acts>button:focus-visible{outline:2px solid currentColor;outline-offset:1px}
.fq-chips{display:flex;flex-wrap:wrap;gap:5px}
.fq-chip{font-size:12px;line-height:1.1;padding:6px 9px;border-radius:8px;background:var(--bg2);border:1px solid var(--border);color:var(--text2);max-width:250px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.fq-more{appearance:none;background:none;border:0;font:inherit;font-size:12px;font-weight:700;color:var(--fq-tone);cursor:pointer;padding:6px 2px}
.fq-reply{margin-top:12px;display:flex;justify-content:flex-end}
.fq-bub{position:relative;max-width:min(580px,88%);background:var(--fq-bub);color:var(--fq-tx);border-radius:14px 14px 5px 14px;padding:9px 12px 6px;font-size:13.5px;line-height:1.5;box-shadow:0 1px 2px rgba(0,0,0,.25);cursor:pointer}
.fq-bub::after{content:"";position:absolute;right:-7px;bottom:0;width:11px;height:13px;background:var(--fq-bub);clip-path:polygon(0 0,100% 100%,0 100%)}
.fq-clamp{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}
.fq-time{display:block;text-align:right;font-size:10.5px;opacity:.6;margin-top:3px;letter-spacing:.02em}
.fq-voice{display:flex;align-items:center;gap:11px;min-width:min(230px,60vw)}
.fq-play{width:28px;height:28px;border-radius:50%;background:rgba(255,255,255,.16);display:grid;place-items:center;flex:0 0 28px}
.fq-wave{display:flex;align-items:center;gap:2px;height:22px;flex:1}
.fq-wave i{width:2px;border-radius:1px;background:currentColor;opacity:.5}
.fq-thumb{display:block;max-width:220px;max-height:160px;border-radius:9px;margin-bottom:6px}
.fq-empty{border:1px dashed var(--border);border-radius:16px;padding:28px 20px;text-align:center}
.fq-empty p{margin:0;color:var(--text3);font-size:13px;line-height:1.6}
.fq-empty p+p{margin-top:6px}
@media (prefers-reduced-motion:reduce){.fq-card,.fq-seg>button,.fq-acts>button{transition:none}}`;
const FQ_TIPOS = [
  { v: 'text', nome: 'Texto', tone: '#22c55e', soft: 'rgba(34,197,94,.42)', resumo: 'com uma mensagem escrita', dica: 'O bot escreve a resposta. Use para as d\u00favidas r\u00e1pidas: prazo, pagamento, link do grupo.' },
  { v: 'image', nome: 'Imagem', tone: '#8b5cf6', soft: 'rgba(139,92,246,.42)', resumo: 'mandando a imagem', dica: 'O bot manda s\u00f3 o arquivo, sem texto junto. Bom para tabela de pre\u00e7o ou modo de uso.' },
  { v: 'text_image', nome: 'Texto + imagem', tone: '#8b5cf6', soft: 'rgba(139,92,246,.42)', resumo: 'escrevendo e mandando a imagem', dica: 'O bot escreve e, logo depois, manda o arquivo.' },
  { v: 'audio', nome: '\u00c1udio', tone: '#f59e0b', soft: 'rgba(245,158,11,.42)', resumo: 'com um \u00e1udio seu', dica: 'Chega como mensagem de voz, gravada por voc\u00ea. Escreva abaixo o que voc\u00ea falou: a cliente n\u00e3o v\u00ea esse texto, ele serve para o bot entender a conversa.' },
  { v: 'text_audio', nome: 'Texto + \u00e1udio', tone: '#f59e0b', soft: 'rgba(245,158,11,.42)', resumo: 'escrevendo e mandando o \u00e1udio', dica: 'O bot escreve a mensagem e, logo depois, manda o seu \u00e1udio.' }
];
const fqOndas = (id) => { const o = []; let x = (Number(id) || 1) * 7919 + 104729; for (let i = 0; i < 26; i++) { x = (x * 9301 + 49297) % 233280; o.push(28 + Math.round((x / 233280) * 72)); } return o; };
const GRP_STG_CSS = ".type-btn{padding:12px 14px;font-size:15px}\n.type-btn{flex:1;padding:8px 14px;border:none;background:transparent;color:var(--text3);font-size:14px;font-weight:700;font-family:'Inter',sans-serif;cursor:pointer;border-radius:7px;transition:all .15s}\n.type-btn.active{background:var(--accent);color:#000;box-shadow:0 2px 10px var(--accent-glow);font-weight:800}\n.stg-head{display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap}\n.stg-count{font-size:13px;color:var(--text3)}\n.stg-count b{color:var(--accent);font-size:16px}\n.stg-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:12px;max-height:540px;overflow-y:auto;padding:4px}\n.stg-card{display:flex;align-items:center;gap:12px;padding:14px 16px;min-height:76px;border-radius:14px;background:var(--bg3);border:1.5px solid var(--border);cursor:pointer;transition:all .15s}\n.stg-card:hover{border-color:var(--accent);transform:translateY(-1px)}\n.stg-card.sel{background:var(--accent-dim);border-color:var(--accent);box-shadow:0 0 0 3px var(--accent-glow)}\n.stg-ck{width:24px;height:24px;border-radius:8px;border:2px solid var(--border2);display:flex;align-items:center;justify-content:center;font-weight:800;font-size:14px;flex-shrink:0;color:#000}\n.stg-card.sel .stg-ck{background:var(--accent);border-color:var(--accent)}\n.stg-av{width:44px;height:44px;border-radius:50%;background:var(--bg4);display:flex;align-items:center;justify-content:center;font-size:21px;flex-shrink:0}\n.stg-card.sel .stg-av{background:var(--accent-glow)}\n.stg-name{font-weight:700;font-size:14px;line-height:1.3;word-break:break-word;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}";
// GRP_MON_UI_V9
// PZ_LABEL_V1
// PRESSEL_ED_V1 - editor de pressel (roda no navegador; o servidor so guarda o rascunho)
function pzEsc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
function pzBuild(c, trackKey) {
  const px = String(c.pixel || '').replace(/\D/g, '');
  const pixelHead = px ? `
  <script>
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${px}'); fbq('track', 'PageView');
  <\/script>
  <noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${px}&amp;ev=PageView&amp;noscript=1"/></noscript>` : '';
  const verif = c.fbVerif ? `\n  <meta name="facebook-domain-verification" content="${pzEsc(c.fbVerif)}" />` : '';
  const bg = c.bgImg ? `url("${c.bgImg}") center top/cover no-repeat` : 'radial-gradient(circle at 50% 0, #3a1020 0, #000 70%)';
  const city = c.showCity ? `
      <div class="city-bar">
        <div class="city-main">${pzEsc(c.cityBefore)} <strong id="cidade">sua cidade</strong> ${pzEsc(c.cityAfter)}</div>
        ${c.timerMin > 0 ? `<div class="city-timer">${pzEsc(c.timerText)} <span id="timer">${String(c.timerMin).padStart(2, '0')}:00</span></div>` : ''}
      </div>` : '';
  return `<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="utf-8"/>
  <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover"/>${verif}
  <title>${pzEsc(c.pageTitle)}</title>${pixelHead}
  <style>
    :root{ --btn:${c.btnColor}; --top:${c.topColor}; --dest:${c.accent}; }
    *{ box-sizing:border-box; margin:0; padding:0; }
    html{ -webkit-text-size-adjust:100%; text-size-adjust:100%; }
    body{ font-family:Montserrat,system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif; color:#fff; background:#000; line-height:1.4; }
    .top-bar{ background:var(--top); padding:12px 8px; text-align:center; font-weight:800; font-size:16px; position:sticky; top:0; z-index:20; box-shadow:0 2px 10px rgba(0,0,0,.35); }
    .hero{ position:relative; background:#000 ${bg}; padding:0 0 40px; min-height:100vh; }
    @supports (min-height:100dvh){ .hero{ min-height:100dvh; } }
    .hero::before{ content:""; position:absolute; inset:0; background:radial-gradient(circle at top, rgba(0,0,0,.3) 0, rgba(0,0,0,.85) 55%, #000 100%); }
    .wrap{ position:relative; width:min(700px,92vw); margin:0 auto; padding:16px 0 20px; text-align:center; }
    h1{ margin:8px 12px 4px; font-size:24px; font-weight:900; line-height:1.25; text-shadow:0 0 10px rgba(0,0,0,.5); }
    .sub{ margin:4px 12px 0; font-size:15px; opacity:.92; }
    .foto{ width:260px; height:260px; object-fit:cover; border-radius:18px; border:2px solid rgba(255,195,220,.55); display:block; margin:12px auto 16px; box-shadow:0 4px 12px rgba(0,0,0,.35); background:#111; }
    .city-bar{ margin:0 auto 14px; width:min(92vw,520px); padding:8px 12px; border-radius:12px; border:1px solid var(--dest); background:rgba(0,0,0,.55); font-size:14px; font-weight:700; display:flex; flex-direction:column; gap:4px; }
    .city-main strong{ color:var(--dest); }
    .city-timer{ color:#ffe88c; font-size:13px; }
    .micro{ margin:10px auto 6px; font-style:italic; font-size:15px; font-weight:700; color:#c8ff9e; }
    @keyframes pulse{ 0%,100%{ transform:scale(1); box-shadow:0 0 18px var(--btn); } 50%{ transform:scale(1.03); box-shadow:0 0 40px var(--btn); } }
    #btn{ display:block; margin:8px auto 16px; width:min(92vw,520px); background:var(--btn); color:#fff; font-size:18px; font-weight:900; text-align:center; padding:18px 16px; border-radius:999px; text-decoration:none; text-shadow:0 0 8px rgba(0,0,0,.35); animation:pulse 1.8s ease-in-out infinite; }
    .seal{ display:flex; gap:8px; align-items:center; justify-content:center; margin:6px auto 0; font-style:italic; font-size:14px; font-weight:800; }
    .seal .dot{ width:8px; height:8px; border-radius:50%; background:var(--dest); box-shadow:0 0 10px var(--dest); }
    @media (max-width:375px) and (max-height:670px){ #btn{ position:fixed; left:4%; right:4%; bottom:10px; width:auto; margin:0; font-size:16px; padding:14px 12px; z-index:40; } .seal{ display:none; } }
  </style>
</head>
<body>
  ${c.topText ? `<div class="top-bar">${pzEsc(c.topText)}</div>` : ''}
  <section class="hero">
    <div class="wrap">
      <h1>${pzEsc(c.title)}</h1>
      ${c.subtitle ? `<p class="sub">${pzEsc(c.subtitle)}</p>` : ''}
      ${c.mainImg ? `<img src="${c.mainImg}" alt="" class="foto"/>` : ''}${city}
      ${c.micro ? `<div class="micro">${pzEsc(c.micro)}</div>` : ''}
      <a id="btn" href="${c.preview ? '#' : pzEsc(c.link || '#')}">${pzEsc(c.btnText)}</a>
      ${c.seal ? `<div class="seal"><div class="dot"></div>${pzEsc(c.seal)}</div>` : ''}
    </div>
  </section>
<script>
(function(){
  var LINK = ${JSON.stringify(c.preview ? '' : (c.link || '')).replace(/</g, '\\u003c')};
  var DWELL_URL = ${JSON.stringify(c.preview || !trackKey ? '' : ('https://app.pulsend.online/api/grp-track/dwell/' + trackKey)).replace(/</g, '\\u003c')};
  var AUTO_SEC = ${c.preview ? 0 : (Number(c.autoRedirectSec) || 0)};
  var cid = document.getElementById('cidade');
  if (cid) { try { fetch('https://ipapi.co/json/').then(function(r){ return r.ok ? r.json() : null; }).then(function(d){ if (d && d.city) cid.textContent = d.city; }).catch(function(){}); } catch(e){} }
  var t = document.getElementById('timer');
  if (t) { var total = ${Number(c.timerMin) || 0} * 60; setInterval(function(){ if (total <= 0) return; total--; t.textContent = String(Math.floor(total/60)).padStart(2,'0') + ':' + String(total%60).padStart(2,'0'); }, 1000); }
  var btn = document.getElementById('btn');
  var pageStart = Date.now();
  var dwellSent = false, redirected = false;
  function sendDwell(clicked){
    if (dwellSent || !DWELL_URL) return;
    dwellSent = true;
    var ms = Date.now() - pageStart;
    var payload = JSON.stringify({ ms: ms, clicked: (clicked === 2 ? 2 : (clicked ? 1 : 0)), src: (new URLSearchParams(location.search).get('src') || '') });
    try { if (navigator.sendBeacon) { navigator.sendBeacon(DWELL_URL, new Blob([payload], { type: 'text/plain;charset=UTF-8' })); return; } } catch(e){}
    try { fetch(DWELL_URL, { method: 'POST', headers: { 'content-type': 'application/json' }, body: payload, keepalive: true }).catch(function(){}); } catch(e){}
  }
  function buildUrl(){
    var q = new URLSearchParams(location.search), out = new URLSearchParams();
    ['src','fbclid','utm_source','utm_medium','utm_campaign','utm_content','utm_term','sub_id1','sub_id2','sub_id3'].forEach(function(k){ if (q.get(k)) out.set(k, q.get(k)); });
    var m = document.cookie.match(/(^|;)\\s*_fbp=([^;]+)/); if (m) out.set('fbp', m[2]);
    return LINK + (out.toString() ? (LINK.indexOf('?') >= 0 ? '&' : '?') + out.toString() : '');
  }
  function goToWhats(clicked){
    if (!LINK || redirected) return;
    redirected = true;
    sendDwell(clicked);
    var eid = 'lead-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    try { if (typeof fbq === 'function') fbq('track', 'Lead', { value: 1, currency: 'BRL' }, { eventID: eid }); } catch(x){}
    setTimeout(function(){ location.href = buildUrl(); }, 250);
  }
  var busy = false;
  btn.addEventListener('click', function(e){
    if (!LINK) return;
    e.preventDefault();
    if (busy) return; busy = true; setTimeout(function(){ busy = false; }, 2000);
    goToWhats(true);
  });
  if (AUTO_SEC > 0) setTimeout(function(){ goToWhats(2); }, AUTO_SEC * 1000);
  function onLeave(){ if (!redirected) sendDwell(false); }
  document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'hidden') onLeave(); });
  window.addEventListener('pagehide', onLeave);
})();
<\/script>
</body>
</html>
`;
}
function pzShrink(file, max, cb) {
  const fr = new FileReader();
  fr.onload = () => {
    const im = new Image();
    im.onload = () => {
      const s = Math.min(1, max / Math.max(im.width, im.height));
      const cv = document.createElement('canvas');
      cv.width = Math.round(im.width * s); cv.height = Math.round(im.height * s);
      cv.getContext('2d').drawImage(im, 0, 0, cv.width, cv.height);
      let q = 0.82, d = cv.toDataURL('image/jpeg', q);
      while (d.length > 150000 && q > 0.35) { q -= 0.1; d = cv.toDataURL('image/jpeg', q); }
      cb(d);
    };
    im.src = fr.result;
  };
  fr.readAsDataURL(file);
}
const PZ_DEFAULT = {
  topText: '\u26a0\ufe0f Conte\u00fado gratuito liberado hoje',
  title: '\u{1f381} Receba o seu material gr\u00e1tis no WhatsApp',
  subtitle: 'Entre agora e receba tudo passo a passo',
  mainImg: '', bgImg: '', showCity: true,
  cityBefore: '\u{1f525} Pessoas de', cityAfter: 'acessando agora...',
  timerText: '\u23f3 Acesso liberado por tempo limitado:', timerMin: 15,
  micro: '\u{1f4ac} Voc\u00ea recebe tudo pelo WhatsApp',
  btnText: '\u{1f4f2} QUERO RECEBER GR\u00c1TIS NO WHATSAPP',
  seal: 'Conte\u00fado gr\u00e1tis \u2022 Sem compromisso',
  link: '', autoRedirectSec: 0, btnColor: '#1cc833', topColor: '#e41312', accent: '#ff6fae',
  pixel: '', fbVerif: '', pageTitle: 'Conte\u00fado gr\u00e1tis'
};
function PresselEditor({ show, rots, links, rotUrl, goUrl, pixel, trackKey }) {
  const [c, setC] = useState(PZ_DEFAULT);
  const [ready, setReady] = useState(false);
  const [saving, setSaving] = useState(false);
  const [prev, setPrev] = useState('');
  const [dirty, setDirty] = useState(false);
  const set = (k, v) => { setC(p => ({ ...p, [k]: v })); setDirty(true); };
  useEffect(() => {
    let alive = true;
    (async () => {
      const r = await api('/grp-monitor/pressel-draft');
      if (!alive) return;
      if (r.ok && r.draft) setC(p => ({ ...PZ_DEFAULT, ...r.draft }));
      setReady(true);
    })();
    return () => { alive = false; };
  }, []);
  useEffect(() => {
    if (!ready) return;
    setC(p => ({ ...p, link: p.link || (rots && rots[0] ? rotUrl(rots[0].slug) : ''), pixel: p.pixel || pixel || '' }));
  }, [ready, rots, pixel]);
  useEffect(() => {
    const t = setTimeout(() => setPrev(pzBuild({ ...c, pixel: '', preview: true }, trackKey)), 250);
    return () => clearTimeout(t);
  }, [c]);
  const pick = (k, max) => (e) => {
    const f = e.target.files && e.target.files[0];
    if (!f) return;
    pzShrink(f, max, d => set(k, d));
    e.target.value = '';
  };
  const save = async () => {
    setSaving(true);
    const r = await api('/grp-monitor/pressel-draft', { method: 'POST', body: JSON.stringify({ draft: c }) });
    setSaving(false);
    if (!r.ok) return show(r.error || 'N\u00e3o foi poss\u00edvel salvar o rascunho', 'error');
    setDirty(false); show('\u2705 Rascunho salvo');
  };
  const download = () => {
    if (!c.link) return show('Escolha para onde o bot\u00e3o leva (link do rotador)', 'error');
    const blob = new Blob([pzBuild({ ...c, preview: false }, trackKey)], { type: 'text/html' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob); a.download = 'index.html';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 4000);
  };
  const reset = () => { if (!window.confirm('Voltar ao modelo inicial? Os textos e imagens atuais ser\u00e3o trocados.')) return; setC({ ...PZ_DEFAULT, link: c.link, pixel: c.pixel }); setDirty(true); };
  const T = (k, label, ph) => (
    <div style={{ marginBottom: 10 }}>
      <label className="fl">{label}</label>
      <input className="fi" name={'pz-' + k} autoComplete="off" style={{ margin: 0 }} placeholder={ph || ''} value={c[k] == null ? '' : c[k]} onChange={e => set(k, e.target.value)} />
    </div>
  );
  const box = { border: '1px solid var(--border)', borderRadius: 12, padding: 14, marginBottom: 12 };
  const ttl = { fontWeight: 800, marginBottom: 8 };
  const img = (k, label, max) => (
    <div style={{ flex: '1 1 160px', minWidth: 0 }}>
      <label className="fl">{label}</label>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 54, height: 54, borderRadius: 10, background: 'var(--bg3)', overflow: 'hidden', flex: '0 0 54px' }}>{c[k] ? <img src={c[k]} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : null}</div>
        <div style={{ minWidth: 0 }}>
          <label className="btn btn-g btn-sm" style={{ cursor: 'pointer', display: 'inline-block' }}>{'Escolher imagem'}<input type="file" accept="image/*" style={{ display: 'none' }} onChange={pick(k, max)} /></label>
          {c[k] ? <button className="btn btn-g btn-sm" style={{ marginLeft: 6 }} onClick={() => set(k, '')}>{'Remover'}</button> : null}
        </div>
      </div>
    </div>
  );
  return (
    <div className="fg">
      <label className="fl">{'\u{1f3a8} Criar minha pressel'}</label>
      <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12 }}>{'Edite os textos, as imagens e o bot\u00e3o, veja como fica no celular ao lado e baixe o arquivo pronto. A p\u00e1gina \u00e9 montada no seu navegador: o servidor s\u00f3 guarda o rascunho.'}</div>
      <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <div style={{ flex: '1 1 340px', minWidth: 0 }}>
          <div style={box}>
            <div style={ttl}>{'Topo e t\u00edtulo'}</div>
            {T('topText', 'Barra do topo', 'Ex.: Receita liberada hoje')}
            {T('title', 'T\u00edtulo')}
            {T('subtitle', 'Subt\u00edtulo (opcional)')}
          </div>
          <div style={box}>
            <div style={ttl}>{'Imagens'}</div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {img('mainImg', 'Imagem principal', 700)}
              {img('bgImg', 'Fundo (opcional)', 1200)}
            </div>
            <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 8 }}>{'As imagens s\u00e3o reduzidas automaticamente e v\u00e3o dentro do arquivo.'}</div>
          </div>
          <div style={box}>
            <div style={ttl}>{'Prova social e contador'}</div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginBottom: 10, cursor: 'pointer' }}><input type="checkbox" checked={!!c.showCity} onChange={e => set('showCity', e.target.checked)} />{'Mostrar \u201cpessoas da sua cidade\u201d e o contador'}</label>
            {c.showCity && (<div>
              {T('cityBefore', 'Texto antes da cidade')}
              {T('cityAfter', 'Texto depois da cidade')}
              {T('timerText', 'Texto do contador')}
              <div style={{ marginBottom: 4 }}>
                <label className="fl">{'Minutos do contador (0 = sem contador)'}</label>
                <input className="fi" name="pz-timerMin" autoComplete="off" style={{ margin: 0, maxWidth: 120 }} value={c.timerMin} onChange={e => set('timerMin', Math.max(0, Math.min(60, parseInt(e.target.value, 10) || 0)))} />
              </div>
            </div>)}
          </div>
          <div style={box}>
            <div style={ttl}>{'Bot\u00e3o'}</div>
            {T('micro', 'Texto acima do bot\u00e3o')}
            {T('btnText', 'Texto do bot\u00e3o')}
            {T('seal', 'Texto abaixo do bot\u00e3o')}
            <label className="fl">{'Para onde o bot\u00e3o leva'}</label>
            <select className="fi" style={{ margin: '0 0 8px' }} value="" onChange={e => { if (e.target.value) set('link', e.target.value); }}>
              <option value="">{'Escolher um link do Pulsend...'}</option>
              {(rots || []).map(r => <option key={'r' + r.id} value={rotUrl(r.slug)}>{'Rotador: ' + (r.name || r.slug)}</option>)}
              {(links || []).map(l => <option key={'l' + l.id} value={goUrl(l.id)}>{'Link rastreado (' + goUrl(l.id).replace('https://app.pulsend.online/api/', '') + ') \u2192 ' + String(l.dest || '').replace('https://', '').slice(0, 30)}</option>)}
            </select>
            <input className="fi" name="pz-link" autoComplete="off" style={{ margin: 0 }} placeholder={'https://...'} value={c.link} onChange={e => set('link', e.target.value)} />
            <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 6 }}>{'Use o link do rotador: o clique conta como Lead p\u00e1gina e o an\u00fancio (src e fbclid) \u00e9 repassado ao Pulsend.'}</div>
            <div style={{ marginTop: 10 }}>
              <label className="fl">{'Redirecionar sozinho depois de quantos segundos (0 = s\u00f3 no clique)'}</label>
              <input className="fi" name="pz-autoRedirectSec" autoComplete="off" style={{ margin: 0, maxWidth: 120 }} value={c.autoRedirectSec} onChange={e => set('autoRedirectSec', Math.max(0, Math.min(60, parseInt(e.target.value, 10) || 0)))} />
            </div>
          </div>
          <div style={box}>
            <div style={ttl}>{'Cores'}</div>
            <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', fontSize: 13 }}>
              {[['btnColor', 'Bot\u00e3o'], ['topColor', 'Barra do topo'], ['accent', 'Destaque']].map(([k, l]) => (
                <label key={k} style={{ display: 'flex', alignItems: 'center', gap: 8 }}><input type="color" value={c[k]} onChange={e => set(k, e.target.value)} style={{ width: 38, height: 30, border: 0, background: 'none', padding: 0 }} />{l}</label>
              ))}
            </div>
          </div>
          <div style={box}>
            <div style={ttl}>{'Pixel do Meta'}</div>
            {T('pixel', 'ID do pixel', 'S\u00f3 n\u00fameros')}
            {T('fbVerif', 'Verifica\u00e7\u00e3o de dom\u00ednio (opcional)', 'C\u00f3digo do meta facebook-domain-verification')}
            {T('pageTitle', 'T\u00edtulo da aba do navegador')}
            <div style={{ fontSize: 11, color: 'var(--text3)' }}>{'A p\u00e1gina dispara PageView ao abrir e Lead no clique do bot\u00e3o.'}</div>
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
            <button className="btn btn-p" onClick={download}>{'\u2b07\ufe0f Baixar pressel (index.html)'}</button>
            <button className="btn btn-g" onClick={save} disabled={saving}>{saving ? 'Salvando...' : dirty ? '\u{1f4be} Salvar rascunho' : '\u{1f4be} Rascunho salvo'}</button>
            <button className="btn btn-g" onClick={reset}>{'\u21a9\ufe0f Modelo inicial'}</button>
          </div>
          <div style={{ ...box, fontSize: 12, color: 'var(--text3)', lineHeight: 1.6 }}>
            <div style={{ fontWeight: 800, color: 'var(--text)', marginBottom: 4 }}>{'Como colocar no ar (gr\u00e1tis)'}</div>
            {'1. Baixe o arquivo index.html.'}<br />
            {'2. Entre em dash.cloudflare.com \u2192 Workers e Pages \u2192 Criar \u2192 Pages \u2192 Enviar arquivos.'}<br />
            {'3. Arraste o index.html, d\u00ea um nome e clique em Implantar. Sai um link .pages.dev.'}<br />
            {'4. Para usar o seu dom\u00ednio: Dom\u00ednios personalizados dentro do projeto. Alternativa: app.netlify.com/drop.'}<br />
            {'5. Use o link da p\u00e1gina (ou o seu dom\u00ednio) no an\u00fancio.'}
          </div>
        </div>
        <div style={{ flex: '0 0 330px', maxWidth: '100%', margin: '0 auto', position: 'sticky', top: 12 }}>
          <div style={{ width: 330, maxWidth: '100%', height: 700, borderRadius: 32, border: '9px solid #232733', overflow: 'hidden', background: '#000' }}>
            <iframe title="Pr\u00e9via da pressel" srcDoc={prev} sandbox="allow-scripts" style={{ width: '100%', height: '100%', border: 0 }} />
          </div>
        </div>
      </div>
    </div>
  );
}
function GroupMonitorPage({ show }) {
  const [period, setPeriod] = useState(7); /*GM_RANGE_V1*/
  const [cFrom, setCFrom] = useState('');
  const [cTo, setCTo] = useState('');
  const [grpOpen, setGrpOpen] = useState(true);
  const [campOpen, setCampOpen] = useState(false); /*CAMP_FOLD_V1*/
  const [sum, setSum] = useState(null);
  const [cfg, setCfg] = useState({ bots: [], groups: [] });
  const [showCfg, setShowCfg] = useState(false);
  const [bots, setBots] = useState([]);
  const [botList, setBotList] = useState(null); /*GRP_BOTS_V1*/
  const [avail, setAvail] = useState([]);
  const [sel, setSel] = useState({});
  const [pics, setPics] = useState({});
  const [search, setSearch] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (!busy) return; const t = setTimeout(() => setBusy(false), 45000); return () => clearTimeout(t); }, [busy]); /*BUSY_GUARD_V1*/
  const [loadingSum, setLoadingSum] = useState(false);
  const [mcfg, setMcfg] = useState({ has_token: false, token_tail: '', accounts: [] });
  const [mToken, setMToken] = useState('');
  const [mRes, setMRes] = useState(null);
  const [trackKey, setTrackKey] = useState('');
  const [cfgTab, setCfgTab] = useState('grupos');
  const [mList, setMList] = useState(null); /*META_CAMP_UI_V1*/
  const [cmp, setCmp] = useState([]);
  const [cmpSel, setCmpSel] = useState({});
  const [cmpTodas, setCmpTodas] = useState(true);
  const loadCmp = async () => {
    const r = await api('/grp-monitor/meta-campaigns');
    if (!r.ok) return;
    setCmp(r.data || []);
    const o = {}; (r.selecionadas || []).forEach(x => { o[x] = 1; });
    setCmpSel(o); setCmpTodas(!!r.todas);
  };
  const saveCmp = async () => {
    setBusy(true);
    const r = await api('/grp-monitor/meta-campaigns', { method: 'POST', body: JSON.stringify({ campaigns: Object.keys(cmpSel) }) });
    setBusy(false);
    if (!r.ok) return show(r.error || 'Erro ao salvar as campanhas', 'error');
    setCmpTodas(!!r.todas);
    show(r.todas ? 'Agora o painel soma todas as campanhas' : '\u2705 ' + (r.selecionadas || []).length + ' campanha(s) no c\u00e1lculo');
    loadSum();
  };
  const [mSel, setMSel] = useState({});
  const [showHelp, setShowHelp] = useState(false);
  const [links, setLinks] = useState([]);
  const [lDest, setLDest] = useState('');
  const [lSrc, setLSrc] = useState('');
  const [selLinks, setSelLinks] = useState({}); /*GRP_LINKS_EDIT_V1*/
  const [bulkSrc, setBulkSrc] = useState(''); /*GRP_LINKS_EDIT_V1*/
  const [showCode, setShowCode] = useState(false);
  const [rots, setRots] = useState([]);
  const [rEdit, setREdit] = useState(null);
  const [rAvail, setRAvail] = useState([]);
  const [rSearch, setRSearch] = useState('');
  const [rAvisos, setRAvisos] = useState([]);
  const [capi, setCapi] = useState({ configured: false, log: [] });
  const [cPixel, setCPixel] = useState('');
  const [cToken, setCToken] = useState('');
  const [cTest, setCTest] = useState('');
  const [cSite, setCSite] = useState('');
  const [cHelp, setCHelp] = useState(false);
  const [cEv, setCEv] = useState({ click: { on: false, name: 'Lead' }, join: { on: true, name: 'LeadWhatsApp' }, stay: { on: true, name: 'QualifiedLead' } });
  const dayStr = (ms) => new Date(ms - 3 * 3600 * 1000).toISOString().slice(0, 10);
  const dayAdd = (n) => dayStr(Date.now() - n * 86400000);
  const faixa = () => {
    if (period === -1) { const d = dayAdd(1); return { from: d, to: d, n: 1 }; }
    if (period === 0) {
      if (!cFrom || !cTo) { const d = dayAdd(0); return { from: d, to: d, n: 1 }; }
      const a = cFrom <= cTo ? cFrom : cTo, b = cFrom <= cTo ? cTo : cFrom;
      const n = Math.max(1, Math.min(180, Math.round((Date.parse(b + 'T12:00:00Z') - Date.parse(a + 'T12:00:00Z')) / 86400000) + 1));
      return { from: a, to: b, n };
    }
    return { from: dayAdd(period - 1), to: dayAdd(0), n: period };
  };
  const [onlySel, setOnlySel] = useState(false); /*GRP_ONLYSEL_V1*/
  const [monitorAll, setMonitorAll] = useState(false); /*GRP_MON_ALL_V1*/
  const [dwell, setDwell] = useState(null); /*DWELL_UI_V1*/
  const [grpTab, setGrpTab] = useState('mov'); /*GRP_MEMBERS_UI_V1*/
  const [members, setMembers] = useState(null);
  const [memLoading, setMemLoading] = useState(false);
  const loadMembers = async (force) => {
    setMemLoading(true);
    try { const r = await api('/grp-monitor/members' + (force ? '?force=1' : '')); setMembers(r); } catch (e) { setMembers({ ok: false, error: String(e) }); }
    setMemLoading(false);
  };
  const [srcFilter, setSrcFilter] = useState(''); /*GRP_LEADS_SRC_V1*/
  const [srcList, setSrcList] = useState([]); /*GRP_LEADS_SRC_V1*/
  const [srcOpen, setSrcOpen] = useState(false); /*GRP_MULTISRC_UI_V1*/
  const [srcPos, setSrcPos] = useState({ top: 80, right: 20 }); /*GRP_MULTISRC_UI_V1*/
  const loadSum = useCallback(async () => {
    setLoadingSum(true);
    const f = faixa();
    const r = await api('/grp-monitor/summary?from=' + f.from + '&to=' + f.to + (onlySel ? '&only=1' : '') + (srcFilter ? '&src=' + encodeURIComponent(srcFilter) : ''));
    if (r.ok) setSum(r);
    setLoadingSum(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [period, cFrom, cTo, onlySel, srcFilter]);
  const loadDwell = useCallback(async () => { /*DWELL_UI_V1*/
    const f = faixa(); /*GRP_MULTISRC_UI_V1*/
    const r = await api('/grp-monitor/dwell-stats?from=' + f.from + '&to=' + f.to + (srcFilter ? '&src=' + encodeURIComponent(srcFilter) : ''));
    if (r.ok) setDwell(r.n > 0 ? r : { ok: true, n: 0, avg_ms: 0, median_ms: 0, p25_ms: 0, p75_ms: 0, clicked: 0, left_without_click: 0 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [period, cFrom, cTo, srcFilter]);
  const loadSources = useCallback(async () => { /*GRP_LEADS_SRC_V1*/
    const r = await api('/grp-monitor/sources');
    if (r.ok) setSrcList(r.data || []);
  }, []);
  const loadCfg = useCallback(async () => {
    const r = await api('/grp-monitor/config');
    if (r.ok) {
      setCfg(r); setBots(r.bots || []); setMonitorAll(!!r.monitor_all); /*GRP_MON_ALL_V1*/
      api('/grp-monitor/bots').then(x => { if (x && x.ok) setBotList(x.bots || []); }); /*GRP_BOTS_V1*/
      const s = {}; (r.groups || []).forEach(g => { s[g.group_id] = g.group_name || g.group_id; }); setSel(s);
    }
  }, []);
  useEffect(() => { loadSum(); }, [loadSum]);
  useEffect(() => { loadCfg(); }, [loadCfg]);
  useEffect(() => { loadDwell(); }, [loadDwell]); /*DWELL_UI_V1*/
  useEffect(() => { loadSources(); }, [loadSources]); /*GRP_LEADS_SRC_V1*/
  const loadMeta = useCallback(async () => {
    const r = await api('/grp-monitor/meta-config');
    if (r.ok) { setMcfg(r); const o = {}; (r.accounts || []).forEach(a => { o[a] = true; }); setMSel(o); }
    const k = await api('/grp-monitor/track');
    if (k.ok) setTrackKey(k.key || '');
  }, []);
  useEffect(() => { loadMeta(); }, [loadMeta]);
  const saveMeta = async (clear) => {
    if (clear && !window.confirm('Remover a conex\u00e3o com o Meta Ads?')) return;
    setBusy(true);
    const r = await api('/grp-monitor/meta-config', { method: 'POST', body: JSON.stringify(clear ? { clear: true } : { token: mToken, accounts: Object.keys(mSel).filter(a => mSel[a]) }) });
    setBusy(false);
    setMRes(r.contas || null);
    if (!r.ok) return show(r.error || 'Erro ao conectar o Meta', 'error');
    show(clear ? 'Meta desconectado' : '\u2705 Meta Ads conectado');
    setMToken(''); if (clear) setMList(null); loadMeta(); loadSum();
  };
  const fetchAccounts = async (silent) => {
    if (!mToken.trim() && !mcfg.has_token) return show('Cole o token primeiro', 'error');
    setBusy(true);
    const r = await api('/grp-monitor/meta-accounts', { method: 'POST', body: JSON.stringify({ token: mToken.trim() }) });
    setBusy(false);
    if (!r.ok) { if (!silent) show(r.error || 'Token sem acesso', 'error'); return; }
    const list = r.data || [];
    setMList(list);
    if (!list.length && !silent) show('Esse token n\u00e3o tem nenhuma conta de an\u00fancio liberada', 'warning');
    if (!Object.keys(mSel).some(a => mSel[a])) { const o = {}; list.filter(a => a.status === 'ativa').slice(0, 5).forEach(a => { o[a.account] = true; }); setMSel(o); }
  };
  const toggleAcc = (a) => { const o = { ...mSel }; if (o[a]) delete o[a]; else { if (Object.keys(o).filter(k => o[k]).length >= 5) return show('M\u00e1ximo 5 contas', 'warning'); o[a] = true; } setMSel(o); };
  const goUrl = (id) => 'https://app.pulsend.online/api/grp-track/go/' + id;
  const loadLinks = async () => { const r = await api('/grp-monitor/track-links'); if (r.ok) setLinks(r.data || []); };
  const addLink = async () => {
    if (!/^https?:\/\//i.test(lDest.trim())) return show('Cole o link completo, come\u00e7ando com https://', 'error');
    setBusy(true);
    const r = await api('/grp-monitor/track-links', { method: 'POST', body: JSON.stringify({ dest: lDest.trim(), src: lSrc.trim() }) });
    setBusy(false);
    if (!r.ok) return show(r.error || 'Erro ao criar o link', 'error');
    setLDest(''); setLSrc(''); loadLinks(); copyText(goUrl(r.id), '\u2705 Link criado e copiado');
  };
  const delLink = async (id) => { if (!window.confirm('Apagar este link? O bot\u00e3o que usa ele vai parar de funcionar.')) return; await api('/grp-monitor/track-links/' + id, { method: 'DELETE' }); loadLinks(); };
  const toggleLinkSel = (id) => { setSelLinks(s => { const o = { ...s }; if (o[id]) delete o[id]; else o[id] = true; return o; }); }; /*GRP_LINKS_EDIT_V1*/
  const selLinkIds = () => Object.keys(selLinks).filter(k => selLinks[k]); /*GRP_LINKS_EDIT_V1*/
  const applyBulkSrc = async () => { /*GRP_LINKS_EDIT_V1*/
    const ids = selLinkIds();
    if (!ids.length) return show('Selecione pelo menos um link', 'warning');
    setBusy(true);
    const r = await api('/grp-monitor/track-links-bulk', { method: 'PUT', body: JSON.stringify({ ids, src: bulkSrc.trim() }) });
    setBusy(false);
    if (!r.ok) return show(r.error || 'Erro ao atualizar', 'error');
    show('\u2705 ' + (r.updated || ids.length) + ' link(s) atualizados');
    setSelLinks({}); setBulkSrc(''); loadLinks();
  };
  const copyText = async (txt, msg) => { try { await navigator.clipboard.writeText(txt); show(msg || '\u2705 Copiado'); } catch (e) { show('Selecione o texto e copie manualmente', 'warning'); } };
  const rotUrl = (slug) => 'https://app.pulsend.online/api/grp-rot/' + slug;
  const slugify = (x) => String(x || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
  const loadRots = async () => { const r = await api('/grp-monitor/rotators'); if (r.ok) setRots(r.data || []); };
  const loadRAvail = async (bot) => {
    setRAvail([]); if (!bot) return;
    setBusy(true);
    const r = await api('/groups?bot=' + bot);
    setBusy(false);
    const list = []; if (r.ok) (r.data || []).forEach(g => { const id = g.id || g.jid || g.groupId; if (id && String(id).endsWith('@g.us')) list.push({ id, name: String(g.subject || g.name || id) }); });
    list.sort((a, b) => a.name.localeCompare(b.name, 'pt-BR', { numeric: true }));
    setRAvail(list);
    fetchPics(list.map(g => g.id).filter(id => !(id in pics)), [bot]);
  };
  const newRot = () => { const b = (cfg.bots || [])[0] || 'bot1'; setRAvisos([]); setREdit({ id: 0, name: '', slug: '', bot: b, cap: 1024, groups: [] }); loadRAvail(b); };
  const editRot = (r) => { setRAvisos([]); setREdit({ id: r.id, name: r.name || r.slug, slug: r.slug, bot: r.bot, cap: r.cap, groups: r.groups.map(g => ({ id: g.group_id, name: g.name || g.group_id })) }); loadRAvail(r.bot); };
  const rToggle = (g) => { const has = rEdit.groups.some(x => x.id === g.id); setREdit({ ...rEdit, groups: has ? rEdit.groups.filter(x => x.id !== g.id) : [...rEdit.groups, { id: g.id, name: g.name }] }); };
  const rMove = (i, d) => { const gs = [...rEdit.groups]; const j = i + d; if (j < 0 || j >= gs.length) return; const x = gs[i]; gs[i] = gs[j]; gs[j] = x; setREdit({ ...rEdit, groups: gs }); };
  const saveRot = async () => {
    const slug = rEdit.slug || slugify(rEdit.name);
    if (!slug || slug.length < 2) return show('D\u00ea um nome ao rotador', 'error');
    if (!rEdit.groups.length) return show('Escolha os grupos do rotador', 'error');
    setBusy(true);
    const r = await api('/grp-monitor/rotators', { method: 'POST', body: JSON.stringify({ ...rEdit, slug }) });
    setBusy(false);
    if (!r.ok) return show(r.error || 'Erro ao salvar o rotador', 'error');
    const av = r.avisos || [];
    setRAvisos(av);
    if (av.length) show('Rotador salvo, mas veja os avisos', 'warning'); else show('\u2705 Rotador salvo');
    setREdit(null); loadRots(); loadCfg(); loadSum();
  };
  const syncRot = async (r) => { setBusy(true); const x = await api('/grp-monitor/rotators/' + r.id + '/sync', { method: 'POST' }); setBusy(false); if (!x.ok) return show(x.error || 'Erro ao atualizar', 'error'); const av = x.avisos || []; setRAvisos(av); if (av.length) show('Atualizado, mas veja os avisos', 'warning'); else show('\u2705 Rotador atualizado'); loadRots(); };
  const delRot = async (r) => { if (!window.confirm('Apagar o rotador ' + r.slug + '? O link dele vai parar de funcionar.')) return; await api('/grp-monitor/rotators/' + r.id, { method: 'DELETE' }); loadRots(); };
  const loadCapi = async () => { const r = await api('/grp-monitor/capi'); if (r.ok) { setCapi(r); setCPixel(r.pixel_id || ''); setCTest(r.test_code || ''); setCSite(r.site_url || ''); if (r.ev) setCEv(r.ev); } };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadCapi(); }, []);
  const setEv = (k, patch) => setCEv({ ...cEv, [k]: { ...cEv[k], ...patch } });
  const saveCapi = async (clear) => {
    if (clear && !window.confirm('Desconectar o pixel? Os eventos param de ser enviados.')) return;
    setBusy(true);
    const r = await api('/grp-monitor/capi', { method: 'POST', body: JSON.stringify(clear ? { clear: true } : { pixel_id: cPixel, token: cToken, test_code: cTest, site_url: cSite, ev: cEv }) });
    setBusy(false);
    if (!r.ok) return show(r.error || 'Erro ao salvar o pixel', 'error');
    show(clear ? 'Pixel desconectado' : '\u2705 Pixel conectado' + (r.pixel_name ? ': ' + r.pixel_name : ''));
    setCToken(''); loadCapi();
  };
  const testCapi = async () => {
    setBusy(true);
    const r = await api('/grp-monitor/capi/test', { method: 'POST' });
    setBusy(false);
    if (!r.ok) return show('Meta: ' + (r.error || 'erro'), 'error');
    show('\u2705 Evento de teste enviado (' + r.msg + ')');
    loadCapi();
  };
  const hm = (ts) => { const d = new Date(ts * 1000); return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }); };
  const snippet = trackKey ? ("<script>\n(function(){var K='" + trackKey + "',S=new URLSearchParams(location.search).get('src')||'';\ndocument.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a[href*=\"chat.whatsapp.com\"],a[href*=\"redirect-to-group\"],a[href*=\"/gp\"],[data-pulsend-lead]');if(!a)return;\nvar u='https://app.pulsend.online/api/grp-track/lead/'+K+'?src='+encodeURIComponent(S);\nif(navigator.sendBeacon)navigator.sendBeacon(u);else new Image().src=u;},true);})();\n</script>") : '';
  const copySnippet = () => copyText(snippet, '\u2705 C\u00f3digo copiado');
  useEffect(() => { const t = setInterval(loadSum, 60000); return () => clearInterval(t); }, [loadSum]);
  const fetchPics = useCallback(async (ids, botList) => {
    let todo = ids.filter(id => /^[0-9-]+@g\.us$/.test(id));
    for (const b of botList) {
      for (let round = 0; round < 20 && todo.length; round++) {
        const r = await api('/group-pics', { method: 'POST', body: JSON.stringify({ bot_id: b, ids: todo.slice(0, 60) }) });
        if (!r.ok || !r.data) break;
        const got = Object.keys(r.data);
        if (!got.length) break;
        setPics(p => ({ ...p, ...r.data }));
        const done = new Set(got.filter(k => r.data[k]));
        const asked = new Set(got);
        todo = todo.filter(id => !done.has(id));
        if (!todo.some(id => !asked.has(id))) break;
      }
    }
  }, []);
  useEffect(() => {
    const ids = ((sum && sum.groups) || []).map(g => g.group_id).filter(id => !(id in pics));
    if (ids.length && (cfg.bots || []).length) fetchPics(ids, cfg.bots);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sum, cfg]);
  const loadAvail = async () => {
    if (!bots.length) return show('Escolha pelo menos 1 WhatsApp', 'error');
    setBusy(true);
    const map = {}; const byBot = {};
    for (const b of bots) {
      const r = await api('/groups?bot=' + b);
      byBot[b] = [];
      if (r.ok) (r.data || []).forEach(g => { const id = g.id || g.jid || g.groupId; if (id && String(id).endsWith('@g.us')) { map[id] = g.subject || g.name || id; byBot[b].push(id); } });
    }
    Object.keys(sel).forEach(id => { if (!map[id]) map[id] = sel[id]; });
    setAvail(Object.keys(map).map(id => ({ id, name: String(map[id]) })).sort((a, b) => a.name.localeCompare(b.name, 'pt-BR', { numeric: true })));
    setBusy(false);
    for (const b of bots) fetchPics((byBot[b] || []).filter(id => !(id in pics)), [b]);
  };
  const goTab = (tb) => {
    setCfgTab(tb);
    if (tb === 'grupos') setGrpOpen(!(cfg.groups || []).length);
    if (tb === 'grupos' && !avail.length && bots.length) loadAvail();
    if (tb === 'meta' && mcfg.has_token && !mList) fetchAccounts(true);
    if (tb === 'meta' && mcfg.has_token) loadCmp();
    if (tb === 'pressel') loadLinks();
    if (tb === 'rotador') { setREdit(null); loadRots(); }
    if (tb === 'pixel') loadCapi();
    if (tb === 'editor') { loadRots(); loadLinks(); }
  };
  const openCfg = () => { const o = !showCfg; setShowCfg(o); if (o) goTab(!(cfg.groups || []).length ? 'grupos' : !mcfg.has_token ? 'meta' : cfgTab); };
  const save = async () => {
    const groups = Object.keys(sel).map(id => ({ id, name: sel[id] }));
    if (!bots.length || (!monitorAll && !groups.length)) return show('Escolha o(s) WhatsApp' + (monitorAll ? '' : ' e os grupos'), 'error');
    setBusy(true);
    const r = await api('/grp-monitor/config', { method: 'POST', body: JSON.stringify({ bots, groups, monitor_all: monitorAll }) });
    setBusy(false);
    if (!r.ok) return show(r.error || 'Erro ao salvar', 'error');
    const bad = (r.webhooks || []).filter(w => !w.ok);
    if (bad.length) show('Salvo, mas com aviso: ' + bad.map(w => w.inst + ' (' + w.motivo + ')').join(', '), 'warning');
    else show(monitorAll ? '\u2705 Monitorando TODOS os grupos com ' + r.bots.length + ' WhatsApp' : '\u2705 Monitorando ' + r.grupos + ' grupos com ' + r.bots.length + ' WhatsApp');
    loadCfg(); loadSum(); if (!mcfg.has_token) goTab('meta');
  };
  const toggleBot = (b) => setBots(bots.includes(b) ? bots.filter(x => x !== b) : [...bots, b].slice(-3));
  const toggleGrp = (g) => { const s = { ...sel }; if (s[g.id]) delete s[g.id]; else s[g.id] = g.name; setSel(s); };
  const q = search.trim().toLowerCase();
  const filtered = q ? avail.filter(g => g.name.toLowerCase().includes(q)) : avail;
  const t = (sum && sum.totals) || { joins: 0, leaves: 0, removed: 0, net: 0 };
  const out = t.leaves + t.removed;
  const pct = t.joins ? Math.round(out * 100 / t.joins) + '%' : '\u2014';
  const m = (sum && sum.meta) || { configured: false, ok: true, error: '', spend: 0, cpl_gerenciador: null, cpl_real: null, campaigns: [] };
  const brl = (v) => (v === null || v === undefined) ? '\u2014' : 'R$ ' + Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const quick = t.quick_leaves || 0;
  const saldoReal = t.saldo_real !== undefined ? t.saldo_real : t.joins;
  const retPct = t.joins ? Math.round(saldoReal * 100 / t.joins) + '%' : '\u2014';
  const days = (sum && sum.days) || [];
  const grps = (sum && sum.groups) || [];
  const dayMap = {}; days.forEach(d => { dayMap[d.day] = d; });
  const fx = faixa();
  const dayList = Array.from({ length: fx.n }, (_, k) => { const dd = new Date(Date.parse(fx.from + 'T12:00:00Z') + k * 86400000).toISOString().slice(0, 10); const r = dayMap[dd]; return { day: dd, joins: r ? r.joins : 0, out: r ? r.leaves + r.removed : 0 }; });
  const maxDay = Math.max(1, ...dayList.map(d => Math.max(d.joins, d.out)));
  const FIX_BOTS = ['bot1', 'bot2', 'bot3', 'bot4', 'bot5', 'bot6', 'bot7', 'bot8', 'bot9', 'bot10']; /*GRP_BOTS_V1*/
  const allBots = (() => {
    const base = (botList && botList.length) ? botList : FIX_BOTS;
    const seen = {}; const out = [];
    base.concat(cfg.bots || []).concat(bots || []).forEach(b => { if (b && !seen[b]) { seen[b] = 1; out.push(b); } });
    return out.sort((x, y) => parseInt(x.slice(3), 10) - parseInt(y.slice(3), 10));
  })();
  const nice = (name) => (/@g\.us$/.test(String(name)) ? 'Grupo ' + String(name).slice(-8, -5) : name);
  const avatar = (id, size) => (
    <div className="stg-av" style={{ overflow: 'hidden', width: size, height: size, minWidth: size, flex: '0 0 auto' }}>
      {pics[id] ? <img src={pics[id]} alt="" referrerPolicy="no-referrer" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={() => setPics(p => ({ ...p, [id]: null }))} /> : '\u{1F465}'}
    </div>
  );
  const stat = (lbl, val, sub, color) => (
    <div className="card" style={{ margin: 0, minWidth: 0, minHeight: 104, padding: '16px 18px', borderLeft: '4px solid ' + color }}>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: 'var(--text3)' }}>{lbl}</div>
      <div style={{ fontSize: 30, fontWeight: 800, marginTop: 6, color, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{val}</div>
      <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 2 }}>{sub}</div>
    </div>
  );
  const cols = 'minmax(0, 1fr) 76px 76px 84px 76px';
  const th = { fontSize: 11, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: 'var(--text3)', textAlign: 'center' };
  const num = (v, color) => <div style={{ textAlign: 'center', fontWeight: 700, fontSize: 14, color: v ? color : 'var(--text3)' }}>{v}</div>;
  return (
    <div className="fade-up">
      <style>{GRP_STG_CSS + '.gm-g4{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px;margin:12px 0}@media(max-width:900px){.gm-g4{grid-template-columns:repeat(2,minmax(0,1fr))}}'}</style>
      <div className="ph" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: 20 }}>
        <div>
          <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)', fontSize: 18 }}>{'\u{1F465}'}</span>
            {'Monitor de Grupos'}
          </h1>
          <p>{'Entradas e sa\u00eddas em tempo real' + (cfg.groups && cfg.groups.length ? ' \u00b7 ' + cfg.groups.length + ' grupos \u00b7 ' + (cfg.bots || []).map(b => 'WhatsApp ' + b.replace('bot', '')).join(', ') : '')}</p>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {[[1, 'Hoje'], [-1, 'Ontem'], [7, '7 dias'], [30, '30 dias'], [0, '\u{1F4C5} Escolher']].map(([d, l]) => (
            <button key={d} className={'btn btn-sm ' + (period === d ? 'btn-p' : 'btn-g')} onClick={() => { if (d === 0 && !cFrom) { setCFrom(dayAdd(6)); setCTo(dayAdd(0)); } setPeriod(d); }}>{l}</button>
          ))}
          {period === 0 && (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <input className="fi" type="date" name="gm-de" style={{ margin: 0, width: 'auto', padding: '6px 8px', fontSize: 12 }} max={dayAdd(0)} value={cFrom} onChange={e => setCFrom(e.target.value)} />
              <span style={{ fontSize: 12, color: 'var(--text3)' }}>{'at\u00e9'}</span>
              <input className="fi" type="date" name="gm-ate" style={{ margin: 0, width: 'auto', padding: '6px 8px', fontSize: 12 }} max={dayAdd(0)} value={cTo} onChange={e => setCTo(e.target.value)} />
            </span>
          )}
          {srcList.length > 0 && (() => { /*GRP_MULTISRC_UI_V1*/
            const sel = srcFilter ? srcFilter.split(',') : [];
            const toggle = (x) => setSrcFilter((sel.includes(x) ? sel.filter(y => y !== x) : [...sel, x]).join(','));
            const label = sel.length === 0 ? 'Todas as origens' : (sel.length === 1 ? sel[0] : sel.length + ' origens');
            return (
              <div style={{ position: 'relative' }}>
                <button className="fi" style={{ margin: 0, width: 'auto', maxWidth: 260, padding: '6px 10px', fontSize: 12, cursor: 'pointer', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} onClick={(e) => { const r = e.currentTarget.getBoundingClientRect(); setSrcPos({ top: Math.round(r.bottom + 6), right: Math.max(8, Math.round(window.innerWidth - r.right)) }); setSrcOpen(o => !o); }}>{'\u{1F3F7}\ufe0f ' + label + ' \u25be'}</button>
                {srcOpen && createPortal(
                  <div>
                    <div style={{ position: 'fixed', inset: 0, zIndex: 100000 }} onClick={() => setSrcOpen(false)} />
                    <div style={{ position: 'fixed', top: srcPos.top, right: srcPos.right, zIndex: 100001, minWidth: 340, maxWidth: 460, maxHeight: 360, overflowY: 'auto', background: '#111827', color: '#e5e7eb', border: '1px solid rgba(255,255,255,.14)', borderRadius: 10, padding: 8, boxShadow: '0 10px 30px rgba(0,0,0,.45)' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '2px 6px 8px', fontSize: 11, opacity: .8 }}>
                        <span>{'Marque uma ou mais origens (nenhuma = todas)'}</span>
                        <button className="btn btn-g btn-sm" onClick={() => setSrcFilter('')}>{'Limpar'}</button>
                      </div>
                      {srcList.map(s => (
                        <label key={s.src} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px', borderRadius: 6, cursor: 'pointer', fontSize: 12, background: sel.includes(s.src) ? 'rgba(16,185,129,.15)' : 'transparent' }}>
                          <input type="checkbox" checked={sel.includes(s.src)} onChange={() => toggle(s.src)} />
                          <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.src}</span>
                          <span style={{ opacity: .6 }}>{s.n}</span>
                        </label>
                      ))}
                    </div>
                  </div>, document.body)}
              </div>
            );
          })()}
          <button className="btn btn-g btn-sm" onClick={() => { loadSum(); loadCfg(); loadDwell(); loadSources(); }} disabled={loadingSum}>{(loadingSum ? '\u23f3' : '\u{1F504}') + ' Atualizar'}</button>
          <button className={'btn btn-sm ' + (showCfg ? 'btn-p' : 'btn-g')} onClick={openCfg}>{'\u2699\ufe0f Configurar'}</button>
        </div>
      </div>
      {(!cfg.groups || !cfg.groups.length) && !showCfg && (
        <div className="card" style={{ textAlign: 'center', padding: 28 }}>
          <div style={{ fontSize: 34 }}>{'\u{1F465}'}</div>
          <div style={{ fontWeight: 700, marginTop: 6 }}>{'Nenhum grupo monitorado ainda'}</div>
          <div style={{ fontSize: 13, color: 'var(--text3)', marginTop: 4 }}>{'Escolha os WhatsApp que est\u00e3o nos grupos e marque os grupos.'}</div>
          <button className="btn btn-p btn-sm" style={{ marginTop: 12 }} onClick={openCfg}>{'\u2699\ufe0f Configurar agora'}</button>
        </div>
      )}
      {showCfg && (
        <div className="card">
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16, borderBottom: '1px solid var(--border)', paddingBottom: 12 }}>
            {[['grupos', '\u{1F465} Grupos' + ((cfg.groups || []).length ? ' (' + cfg.groups.length + ')' : '')], ['rotador', '\u{1F504} Rotador' + (rots.length ? ' (' + rots.length + ')' : '')], ['meta', '\u{1F4B0} Meta Ads' + (mcfg.has_token ? ' \u2705' : '')], ['pixel', '\u{1F4E1} Pixel' + (capi.configured ? ' \u2705' : '')], ['pressel', '\u{1F3AF} Pressel'], ['editor', '\u{1F3A8} Criar pressel']].map(([k, l]) => (
              <button key={k} className={'type-btn ' + (cfgTab === k ? 'active' : '')} style={{ flex: '0 0 auto', padding: '10px 18px', ...(cfgTab === k ? { background: 'var(--accent)', color: '#000' } : {}) }} onClick={() => goTab(k)}>{l}</button>
            ))}
          </div>
          {cfgTab === 'grupos' && (<div>
          <div className="fg">
            <label className="fl">{'WhatsApp monitores (at\u00e9 3)'}</label>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 8 }}>{'Use os WhatsApp que est\u00e3o nos grupos. Com mais de um, a contagem n\u00e3o duplica.'}</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {allBots.map(b => (
                <button key={b} className={'type-btn ' + (bots.includes(b) ? 'active' : '')} style={{ flex: '0 0 auto', padding: '10px 18px', ...(bots.includes(b) ? { background: 'var(--accent)', color: '#000' } : {}) }} onClick={() => toggleBot(b)}>{'\u{1F4F1} WhatsApp ' + b.replace('bot', '')}</button>
              ))}
            </div>
          </div>
          <div className="fg">
            <div className="stg-head" style={{ cursor: 'pointer' }} onClick={() => setGrpOpen(!grpOpen)}>
              <label className="fl" style={{ margin: 0, cursor: 'pointer' }}>{(grpOpen ? '\u25be' : '\u25b8') + ' Grupos'}</label>
              <span className="stg-count"><b>{Object.keys(sel).length}</b>{' / ' + avail.length + ' selecionados' + (grpOpen ? '' : ' \u00b7 clique para abrir')}</span>
            </div>
            <div style={{ display: 'flex', gap: 8, margin: '10px 0', flexWrap: 'wrap' }}>
              <button className="btn btn-g btn-sm" onClick={loadAvail} disabled={busy}>{(busy ? '\u23f3' : '\u{1F504}') + ' Atualizar'}</button>
              <button className="btn btn-g btn-sm" onClick={() => { const s = { ...sel }; filtered.forEach(g => { s[g.id] = g.name; }); setSel(s); }}>{'\u2611 Todos' + (search ? ' (filtrados)' : '')}</button>
              <button className="btn btn-g btn-sm" onClick={() => setSel({})}>{'Limpar'}</button>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: 'var(--accent)', cursor: 'pointer', fontWeight: 600 }}>
                <input type="checkbox" checked={monitorAll} onChange={e => setMonitorAll(e.target.checked)} />
                {'\u{1F310} Monitorar TODOS os grupos automaticamente'}
              </label>
              <button className="btn btn-p btn-sm" onClick={save} disabled={busy}>{'\u{1F4BE} Salvar monitoramento'}</button>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: 'var(--text3)', cursor: 'pointer' }}>
                <input type="checkbox" checked={onlySel} onChange={e => setOnlySel(e.target.checked)} />
                {'Mostrar s\u00f3 os selecionados (ignorar rotador)'}
              </label>
            </div>
            {monitorAll && <div style={{ fontSize: 12, color: 'var(--text3)', margin: '4px 0 10px' }}>{'Com "Monitorar todos" ligado, a selecao abaixo e opcional (so serve pra dar nome bonito aos grupos).'}</div>}
            {grpOpen && (<div>
            <input className="fi" type="search" name="pulsend-busca-grupo" autoComplete="off" style={{ marginBottom: 10 }} placeholder={'\u{1F50D} Buscar grupo...'} value={search} onChange={e => setSearch(e.target.value)} />
            <div className="stg-grid">
              {avail.length === 0 && <div style={{ gridColumn: '1 / -1', color: 'var(--text3)', fontSize: 13, padding: 12 }}>{busy ? 'Carregando grupos...' : 'Escolha os WhatsApp e clique em Atualizar.'}</div>}
              {filtered.map(g => (
                <div key={g.id} className={'stg-card ' + (sel[g.id] ? 'sel' : '')} onClick={() => toggleGrp(g)}>
                  <div className="stg-ck">{sel[g.id] ? '\u2713' : ''}</div>
                  {avatar(g.id, 44)}
                  <div style={{ minWidth: 0, flex: 1 }}><div className="stg-name">{g.name}</div></div>
                </div>
              ))}
            </div>
            </div>)}
          </div>
          </div>)}
          {cfgTab === 'meta' && (
          <div className="fg">
            <label className="fl">{'\u{1F4B0} Meta Ads (para Investido e CPL)'}</label>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 8 }}>{mcfg.has_token ? ('Conectado \u00b7 token terminando em ' + mcfg.token_tail + ' \u00b7 ' + (mcfg.accounts || []).length + ' conta(s). Para trocar o token, cole um novo.') : 'Cole o token do Meta Ads e clique em Buscar minhas contas. O token fica guardado s\u00f3 no servidor.'}</div>
            <button className="btn btn-g btn-sm" style={{ marginBottom: 10 }} onClick={() => setShowHelp(!showHelp)}>{(showHelp ? '\u25be ' : '\u25b8 ') + 'Como pegar o token? (passo a passo)'}</button>
            {showHelp && (
              <div style={{ background: 'var(--bg3)', borderRadius: 12, padding: '12px 16px', fontSize: 13, lineHeight: 1.6, marginBottom: 12 }}>
                <div><b>{'1.'}</b>{' Abra os Usu\u00e1rios do sistema do seu Gerenciador de Neg\u00f3cios: '}<a href="https://business.facebook.com/settings/system-users" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)', fontWeight: 700 }}>{'abrir \u2197'}</a></div>
                <div><b>{'2.'}</b>{' Clique em Adicionar, d\u00ea um nome (ex.: Pulsend) e escolha a fun\u00e7\u00e3o Funcion\u00e1rio.'}</div>
                <div><b>{'3.'}</b>{' No usu\u00e1rio criado, clique em Atribuir ativos \u2192 Contas de an\u00fancio \u2192 marque suas contas \u2192 ative Ver desempenho \u2192 Salvar.'}</div>
                <div><b>{'4.'}</b>{' Clique em Gerar novo token \u2192 escolha o app \u2192 validade Nunca \u2192 marque ads_read \u2192 Gerar token.'}</div>
                <div style={{ paddingLeft: 18, color: 'var(--text3)' }}>{'N\u00e3o aparece nenhum app? Crie um (tipo Empresa) e volte ao passo 4: '}<a href="https://developers.facebook.com/apps/creation/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)', fontWeight: 700 }}>{'criar app \u2197'}</a></div>
                <div><b>{'5.'}</b>{' Copie o token, cole aqui embaixo e clique em Buscar minhas contas.'}</div>
              </div>
            )}
            <input className="fi" type="password" name="meta-ads-token" autoComplete="new-password" style={{ marginBottom: 8 }} placeholder={mcfg.has_token ? ('Token salvo \u00b7 final ' + (mcfg.token_tail || '') + ' \u00b7 deixe vazio para manter') : 'Cole aqui o token do Meta Ads'} value={mToken} onChange={e => setMToken(e.target.value)} />
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
              <button className="btn btn-g btn-sm" onClick={() => fetchAccounts(false)} disabled={busy}>{(busy ? '\u23f3' : '\u{1F50E}') + ' Buscar minhas contas'}</button>
            </div>
            {mList && (
              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 6 }}>{mList.length ? 'Marque as contas que anunciam para esses grupos (at\u00e9 5):' : 'Nenhuma conta liberada para esse token. Veja o passo 3.'}</div>
                <div className="stg-grid">
                  {mList.map(a => (
                    <div key={a.account} className={'stg-card ' + (mSel[a.account] ? 'sel' : '')} onClick={() => toggleAcc(a.account)}>
                      <div className="stg-ck">{mSel[a.account] ? '\u2713' : ''}</div>
                      <div style={{ minWidth: 0, flex: 1 }}>
                        <div className="stg-name">{a.name || a.account}</div>
                        <div style={{ fontSize: 11, color: 'var(--text3)' }}>{a.account + (a.currency ? ' \u00b7 ' + a.currency : '') + (a.status && a.status !== 'ativa' ? ' \u00b7 ' + a.status : '')}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {mcfg.has_token && (
              <div className="fg" style={{ marginTop: 16, borderTop: '1px solid var(--border)', paddingTop: 14 }}>
                <label className="fl">{'Campanhas que contam no investido'}</label>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 10 }}>{cmpTodas ? 'Nenhuma marcada: o painel soma TODAS as campanhas da conta. Marque as campanhas deste funil para o CPL n\u00e3o misturar com o resto.' : 'S\u00f3 as campanhas marcadas entram no Investido e nos dois CPL.'}</div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
                  <button className="btn btn-g btn-sm" onClick={loadCmp} disabled={busy}>{(busy ? '\u23f3' : '\u{1f504}') + ' Atualizar lista'}</button>
                  <button className="btn btn-g btn-sm" onClick={() => setCmpSel({})}>{'Desmarcar todas'}</button>
                  <button className="btn btn-p btn-sm" onClick={saveCmp} disabled={busy}>{'\u{1f4be} Salvar campanhas'}</button>
                </div>
                {cmp.length === 0 ? (
                  <div style={{ fontSize: 13, color: 'var(--text3)' }}>{'Nenhuma campanha com gasto nos \u00faltimos 90 dias. Depois que a campanha gastar, ela aparece aqui.'}</div>
                ) : (
                  <div className="stg-grid">
                    {cmp.map(c => (
                      <div key={c.campaign_id} className={'stg-card ' + (cmpSel[c.campaign_id] ? 'sel' : '')} onClick={() => { const o = { ...cmpSel }; if (o[c.campaign_id]) delete o[c.campaign_id]; else o[c.campaign_id] = 1; setCmpSel(o); }}>
                        <div className="stg-ck">{cmpSel[c.campaign_id] ? '\u2713' : ''}</div>
                        <div style={{ minWidth: 0, flex: 1 }}>
                          <div className="stg-name">{c.name || c.campaign_id}</div>
                          <div style={{ fontSize: 11, color: 'var(--text3)' }}>{brl(c.spend) + ' \u00b7 at\u00e9 ' + String(c.ultimo || '').slice(8, 10) + '/' + String(c.ultimo || '').slice(5, 7)}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button className="btn btn-p btn-sm" onClick={() => saveMeta(false)} disabled={busy || !Object.keys(mSel).some(a => mSel[a])}>{'\u{1F50C} Salvar e testar'}</button>
              {mcfg.has_token && <button className="btn btn-g btn-sm" onClick={() => saveMeta(true)} disabled={busy}>{'Desconectar'}</button>}
            </div>
            {mRes && <div style={{ marginTop: 8, fontSize: 12 }}>{mRes.map(c => <div key={c.account} style={{ color: c.ok ? '#22c55e' : '#ef4444' }}>{(c.ok ? '\u2705 ' : '\u274c ') + c.account + (c.ok ? ' \u00b7 ' + (c.name || '') + (c.currency ? ' (' + c.currency + ')' : '') : ' \u00b7 ' + c.erro)}</div>)}</div>}
          </div>
          )}
          {cfgTab === 'rotador' && (
          <div className="fg">
            <label className="fl">{'\u{1F504} Rotador de grupos'}</label>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12 }}>{'Um link s\u00f3 para o bot\u00e3o da pressel ou para o an\u00fancio. Cada pessoa vai para o grupo da vez; quando ele chega no limite, passa para o pr\u00f3ximo. Quando todos enchem, volta para o grupo 1. Os cliques j\u00e1 contam como Leads p\u00e1gina.'}</div>
            {rAvisos.length > 0 && <div style={{ background: 'rgba(245,158,11,.12)', border: '1px solid rgba(245,158,11,.4)', borderRadius: 10, padding: '10px 12px', fontSize: 12, marginBottom: 12 }}>{rAvisos.map((a, i) => <div key={i}>{'\u26a0\ufe0f ' + a}</div>)}</div>}
            {!rEdit && (
              <div>
                <button className="btn btn-p btn-sm" style={{ marginBottom: 12 }} onClick={newRot}>{'\u2795 Novo rotador'}</button>
                {rots.length === 0 && <div style={{ fontSize: 13, color: 'var(--text3)' }}>{'Nenhum rotador criado ainda.'}</div>}
                {rots.map(r => (
                  <div key={r.id} style={{ border: '1px solid var(--border)', borderRadius: 12, padding: 14, marginBottom: 12 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                      <div style={{ minWidth: 0 }}>
                        <div style={{ fontWeight: 800 }}>{r.name || r.slug}</div>
                        <div style={{ fontFamily: 'monospace', fontSize: 12, wordBreak: 'break-all' }}>{rotUrl(r.slug)}</div>
                        <div style={{ fontSize: 11, color: 'var(--text3)' }}>{'WhatsApp ' + r.bot.replace('bot', '') + ' \u00b7 limite ' + r.cap + ' por grupo \u00b7 ' + r.groups.length + ' grupos'}</div>
                      </div>
                      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                        <button className="btn btn-p btn-sm" onClick={() => copyText(rotUrl(r.slug), '\u2705 Link do rotador copiado')}>{'\u{1F4CB} Copiar link'}</button>
                        <button className="btn btn-g btn-sm" onClick={() => syncRot(r)} disabled={busy}>{'\u{1F504} Atualizar'}</button>
                        <button className="btn btn-g btn-sm" onClick={() => editRot(r)}>{'\u270f\ufe0f Editar'}</button>
                        <button className="btn btn-g btn-sm" onClick={() => delRot(r)}>{'\u{1F5D1}'}</button>
                      </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      {r.groups.map((g, i) => {
                        const p = Math.min(100, Math.round(g.est * 100 / r.cap));
                        const cur = r.atual === g.group_id;
                        return (
                          <div key={g.group_id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderTop: '1px solid var(--border)' }}>
                            <span style={{ width: 22, textAlign: 'center', fontWeight: 800, color: 'var(--text3)' }}>{i + 1}</span>
                            {avatar(g.group_id, 30)}
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: cur ? '#22c55e' : undefined }}>{(cur ? '\u25b6 recebendo agora \u00b7 ' : '') + (g.name || g.group_id) + (g.tem_link ? '' : ' \u00b7 sem link (o WhatsApp precisa ser admin)')}</div>
                              <div style={{ height: 6, background: 'var(--bg3)', borderRadius: 4, marginTop: 4, overflow: 'hidden' }}><div style={{ height: '100%', width: p + '%', background: p >= 100 ? '#ef4444' : cur ? '#22c55e' : '#8b5cf6' }} /></div>
                            </div>
                            <span style={{ fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap', color: cur ? '#22c55e' : 'var(--text2)' }}>{g.est + '/' + r.cap}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {rEdit && (
              <div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
                  <input className="fi" name="pulsend-rot-nome" autoComplete="off" style={{ flex: '2 1 220px', margin: 0 }} placeholder={'Nome do rotador, ex.: Transforma\u00e7\u00e3o'} value={rEdit.name} onChange={e => setREdit({ ...rEdit, name: e.target.value, slug: rEdit.id ? rEdit.slug : slugify(e.target.value) })} />
                  <input className="fi" name="pulsend-rot-cap" type="number" min={1} max={1024} style={{ flex: '1 1 120px', margin: 0 }} value={rEdit.cap} onChange={e => setREdit({ ...rEdit, cap: e.target.value })} />
                </div>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12 }}>{'Link: ' + rotUrl(rEdit.slug || slugify(rEdit.name) || 'nome') + ' \u00b7 ao lado, o limite por grupo (m\u00e1x. 1024)'}</div>
                <label className="fl">{'WhatsApp que \u00e9 admin dos grupos'}</label>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
                  {allBots.map(b => (
                    <button key={b} className={'type-btn ' + (rEdit.bot === b ? 'active' : '')} style={{ flex: '0 0 auto', padding: '8px 14px', ...(rEdit.bot === b ? { background: 'var(--accent)', color: '#000' } : {}) }} onClick={() => { setREdit({ ...rEdit, bot: b }); loadRAvail(b); }}>{'\u{1F4F1} WhatsApp ' + b.replace('bot', '')}</button>
                  ))}
                </div>
                <label className="fl">{'Ordem dos grupos (' + rEdit.groups.length + ')'}</label>
                {rEdit.groups.length === 0 && <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 10 }}>{'Clique nos grupos abaixo na ordem em que devem encher.'}</div>}
                {rEdit.groups.map((g, i) => (
                  <div key={g.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderTop: '1px solid var(--border)' }}>
                    <span style={{ width: 22, textAlign: 'center', fontWeight: 800 }}>{i + 1}</span>
                    {avatar(g.id, 28)}
                    <span style={{ flex: 1, minWidth: 0, fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{g.name}</span>
                    <button className="btn btn-g btn-sm" onClick={() => rMove(i, -1)} disabled={i === 0}>{'\u2191'}</button>
                    <button className="btn btn-g btn-sm" onClick={() => rMove(i, 1)} disabled={i === rEdit.groups.length - 1}>{'\u2193'}</button>
                    <button className="btn btn-g btn-sm" onClick={() => rToggle(g)}>{'\u2715'}</button>
                  </div>
                ))}
                <div style={{ display: 'flex', gap: 8, margin: '12px 0', flexWrap: 'wrap' }}>
                  <button className="btn btn-p btn-sm" onClick={saveRot} disabled={busy}>{'\u{1F4BE} Salvar rotador'}</button>
                  <button className="btn btn-g btn-sm" onClick={() => setREdit(null)}>{'Cancelar'}</button>
                </div>
                <input className="fi" type="search" name="pulsend-rot-busca" autoComplete="off" style={{ marginBottom: 10 }} placeholder={'\u{1F50D} Buscar grupo...'} value={rSearch} onChange={e => setRSearch(e.target.value)} />
                <div className="stg-grid">
                  {rAvail.length === 0 && <div style={{ gridColumn: '1 / -1', color: 'var(--text3)', fontSize: 13, padding: 12 }}>{busy ? 'Carregando grupos...' : 'Nenhum grupo encontrado nesse WhatsApp.'}</div>}
                  {rAvail.filter(g => !rSearch.trim() || g.name.toLowerCase().includes(rSearch.trim().toLowerCase())).map(g => {
                    const pos = rEdit.groups.findIndex(x => x.id === g.id);
                    return (
                      <div key={g.id} className={'stg-card ' + (pos >= 0 ? 'sel' : '')} onClick={() => rToggle(g)}>
                        <div className="stg-ck">{pos >= 0 ? String(pos + 1) : ''}</div>
                        {avatar(g.id, 44)}
                        <div style={{ minWidth: 0, flex: 1 }}><div className="stg-name">{g.name}</div></div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
          )}
          {cfgTab === 'pixel' && (
          <div className="fg">
            <label className="fl">{'\u{1F4E1} Pixel do Meta (API de Convers\u00f5es)'}</label>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 8 }}>{capi.configured ? ('Conectado \u00b7 pixel ' + capi.pixel_id + ' \u00b7 token terminando em ' + capi.token_tail + ' \u00b7 hoje: ' + ((capi.hoje && capi.hoje.ok) || 0) + ' enviados' + ((capi.hoje && capi.hoje.erro) ? ', ' + capi.hoje.erro + ' com erro' : '')) : 'Envia os eventos direto do servidor para o seu pixel. Assim o Meta aprende quem entra e quem fica no grupo e otimiza os an\u00fancios para trazer gente parecida.'}</div>
            <button className="btn btn-g btn-sm" style={{ marginBottom: 10 }} onClick={() => setCHelp(!cHelp)}>{(cHelp ? '\u25be ' : '\u25b8 ') + 'Onde pego o ID do pixel e o token? (passo a passo)'}</button>
            {cHelp && (
              <div style={{ background: 'var(--bg3)', borderRadius: 12, padding: '12px 16px', fontSize: 13, lineHeight: 1.6, marginBottom: 12 }}>
                <div><b>{'1.'}</b>{' Abra o Gerenciador de Eventos e clique no seu pixel: '}<a href="https://business.facebook.com/events_manager2/list/pixel/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)', fontWeight: 700 }}>{'abrir \u2197'}</a></div>
                <div><b>{'2.'}</b>{' Copie o ID do pixel (o n\u00famero que aparece embaixo do nome dele).'}</div>
                <div><b>{'3.'}</b>{' V\u00e1 em Configura\u00e7\u00f5es \u2192 API de Convers\u00f5es \u2192 Gerar token de acesso. Copie o token.'}</div>
                <div><b>{'4.'}</b>{' Opcional, para conferir: na aba Testar eventos, copie o c\u00f3digo (TEST...) para o campo C\u00f3digo de teste. Depois de conferir, apague o c\u00f3digo e salve de novo.'}</div>
              </div>
            )}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
              <input className="fi" name="pulsend-capi-pixel" autoComplete="off" style={{ flex: '1 1 200px', margin: 0 }} placeholder={'ID do pixel (s\u00f3 n\u00fameros)'} value={cPixel} onChange={e => setCPixel(e.target.value)} />
              <input className="fi" type="password" name="pulsend-capi-token" autoComplete="new-password" style={{ flex: '2 1 280px', margin: 0 }} placeholder={capi.configured ? ('Token salvo \u00b7 final ' + (capi.token_tail || '') + ' \u00b7 deixe vazio para manter') : 'Token da API de Convers\u00f5es'} /*TOKEN_TAIL_V1*/ value={cToken} onChange={e => setCToken(e.target.value)} />
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
              <input className="fi" name="pulsend-capi-test" autoComplete="off" style={{ flex: '1 1 200px', margin: 0 }} placeholder={'C\u00f3digo de teste (opcional), ex.: TEST12345'} value={cTest} onChange={e => setCTest(e.target.value)} />
              <input className="fi" name="pulsend-capi-site" autoComplete="off" style={{ flex: '2 1 280px', margin: 0 }} placeholder={'Link da pressel (opcional): https://...'} value={cSite} onChange={e => setCSite(e.target.value)} />
            </div>
            <label className="fl">{'Eventos enviados'}</label>
            {[['click', 'Clique na pressel ou no rotador', 'Deixe desligado se a pressel j\u00e1 dispara Lead pelo pixel do navegador, para n\u00e3o contar duas vezes.'], ['join', 'Entrou no grupo', 'Vai com o telefone da pessoa criptografado, o que ajuda muito o Meta a saber quem \u00e9.'], ['stay', 'Ficou 3 dias no grupo', 'O lead de qualidade: quem n\u00e3o saiu nos primeiros 3 dias.']].map(([k, t, d]) => (
              <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderTop: '1px solid var(--border)', flexWrap: 'wrap' }}>
                <button className={'type-btn ' + (cEv[k].on ? 'active' : '')} style={{ flex: '0 0 auto', padding: '8px 12px', ...(cEv[k].on ? { background: 'var(--accent)', color: '#000' } : {}) }} onClick={() => setEv(k, { on: !cEv[k].on })}>{cEv[k].on ? '\u2713 Ligado' : 'Desligado'}</button>
                <div style={{ flex: '1 1 240px', minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: 13 }}>{t}</div>
                  <div style={{ fontSize: 11, color: 'var(--text3)' }}>{d}</div>
                </div>
                <input className="fi" name={'pulsend-capi-ev-' + k} autoComplete="off" style={{ flex: '0 1 180px', margin: 0 }} value={cEv[k].name} onChange={e => setEv(k, { name: e.target.value })} title={'Nome do evento no Meta'} />
              </div>
            ))}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
              <button className="btn btn-p btn-sm" onClick={() => saveCapi(false)} disabled={busy}>{'\u{1F50C} Salvar e testar conex\u00e3o'}</button>
              {capi.configured && <button className="btn btn-g btn-sm" onClick={testCapi} disabled={busy}>{'\u{1F9EA} Enviar evento de teste'}</button>}
              {capi.configured && <button className="btn btn-g btn-sm" onClick={() => saveCapi(true)} disabled={busy}>{'Desconectar'}</button>}
            </div>
            {capi.configured && (
              <div style={{ marginTop: 14 }}>
                <label className="fl">{'\u00daltimos envios'}</label>
                {(capi.log || []).length === 0 && <div style={{ fontSize: 12, color: 'var(--text3)' }}>{'Nenhum envio ainda. Os eventos aparecem aqui assim que algu\u00e9m clicar ou entrar no grupo.'}</div>}
                {(capi.log || []).map((l, i) => (
                  <div key={i} style={{ display: 'flex', gap: 10, fontSize: 12, padding: '4px 0', borderTop: '1px solid var(--border)' }}>
                    <span style={{ color: 'var(--text3)', whiteSpace: 'nowrap' }}>{hm(l.ts)}</span>
                    <span style={{ fontWeight: 700, whiteSpace: 'nowrap' }}>{(l.ok ? '\u2705 ' : '\u274c ') + l.ev}</span>
                    <span style={{ color: l.ok ? 'var(--text3)' : '#ef4444', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.msg}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          )}
          {cfgTab === 'editor' && <PresselEditor show={show} rots={rots} links={links} rotUrl={rotUrl} goUrl={goUrl} pixel={cPixel} trackKey={trackKey} />}
          {cfgTab === 'pressel' && (
          <div className="fg">
            <label className="fl">{'\u{1F3AF} Rastreio da pressel (Leads p\u00e1gina)'}</label>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12 }}>{'Conta quantas pessoas clicaram no bot\u00e3o da pressel. Escolha um dos dois jeitos (s\u00f3 um).'}</div>
            <div style={{ border: '1px solid var(--border)', borderRadius: 12, padding: 14, marginBottom: 12 }}>
              <div style={{ fontWeight: 800, marginBottom: 4 }}>{'\u2705 Jeito f\u00e1cil, sem c\u00f3digo: link rastreado'}</div>
              <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 10 }}>{'Cole o link para onde o bot\u00e3o da pressel leva hoje (link do grupo ou do rotador). O Pulsend cria um link novo: troque o link do bot\u00e3o por ele. Cada clique conta 1 lead e a pessoa vai direto para o mesmo lugar.'}</div>
              <input className="fi" name="pulsend-link-destino" autoComplete="off" style={{ marginBottom: 8 }} placeholder={'Link de destino: https://chat.whatsapp.com/...'} value={lDest} onChange={e => setLDest(e.target.value)} />
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <input className="fi" name="pulsend-link-src" autoComplete="off" style={{ flex: '1 1 180px', margin: 0 }} placeholder={'Origem (opcional), ex.: fb1'} value={lSrc} onChange={e => setLSrc(e.target.value)} />
                <button className="btn btn-p btn-sm" onClick={addLink} disabled={busy}>{'\u2795 Gerar link'}</button>
              </div>
              {links.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  {selLinkIds().length > 0 && (
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', padding: '8px 10px', marginBottom: 8, background: 'var(--bg3)', borderRadius: 8 }}>
                      <span style={{ fontSize: 12, fontWeight: 700 }}>{selLinkIds().length + ' selecionado(s)'}</span>
                      <input className="fi" name="pulsend-link-bulk-src" autoComplete="off" style={{ flex: '1 1 160px', margin: 0 }} placeholder={'Novo nome de origem, ex.: CP-fb1'} value={bulkSrc} onChange={e => setBulkSrc(e.target.value)} />
                      <button className="btn btn-p btn-sm" onClick={applyBulkSrc} disabled={busy}>{'\u2705 Aplicar aos selecionados'}</button>
                      <button className="btn btn-g btn-sm" onClick={() => setSelLinks({})}>{'Cancelar'}</button>
                    </div>
                  )}
                  {links.map(l => (
                    <div key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderTop: '1px solid var(--border)', flexWrap: 'wrap' }}>
                      <input type="checkbox" checked={!!selLinks[l.id]} onChange={() => toggleLinkSel(l.id)} style={{ width: 16, height: 16, flexShrink: 0 }} />
                      <div style={{ minWidth: 0, flex: '1 1 260px' }}>
                        <div style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 700, wordBreak: 'break-all' }}>{goUrl(l.id)}</div>
                        <div style={{ fontSize: 11, color: 'var(--text3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{'\u2192 ' + l.dest + (l.src ? ' \u00b7 origem ' + l.src : '') + ' \u00b7 ' + (l.leads || 0) + ' cliques (30 dias)'}</div>
                      </div>
                      <button className="btn btn-g btn-sm" onClick={() => copyText(goUrl(l.id))}>{'\u{1F4CB} Copiar'}</button>
                      <button className="btn btn-g btn-sm" onClick={() => delLink(l.id)}>{'\u{1F5D1}'}</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <button className="btn btn-g btn-sm" style={{ marginBottom: 10 }} onClick={() => setShowCode(!showCode)}>{(showCode ? '\u25be ' : '\u25b8 ') + 'Jeito avan\u00e7ado: c\u00f3digo na p\u00e1gina'}</button>
            {showCode && (
              <div style={{ border: '1px solid var(--border)', borderRadius: 12, padding: 14 }}>
                <div style={{ fontSize: 13, lineHeight: 1.6, marginBottom: 10 }}>
                  <div>{'Conta cliques em qualquer link do WhatsApp da p\u00e1gina e separa pelo ?src= do an\u00fancio. Onde colar:'}</div>
                  <div>{'\u2022 WordPress com Elementor: edite a pressel, arraste o widget HTML para o fim da p\u00e1gina, cole e clique em Atualizar.'}</div>
                  <div>{'\u2022 WordPress sem Elementor: instale o plugin WPCode \u2192 Header & Footer \u2192 cole no Footer \u2192 Salvar.'}</div>
                  <div>{'\u2022 P\u00e1gina em HTML: cole logo antes de </body>.'}</div>
                  <div>{'\u2022 Outra plataforma: procure C\u00f3digo personalizado, Scripts ou Rodap\u00e9 nas configura\u00e7\u00f5es da p\u00e1gina.'}</div>
                </div>
                <textarea className="fi" readOnly rows={5} style={{ fontFamily: 'monospace', fontSize: 11, marginBottom: 8 }} value={snippet} onFocus={e => e.target.select()} />
                <button className="btn btn-g btn-sm" onClick={copySnippet} disabled={!snippet}>{'\u{1F4CB} Copiar c\u00f3digo'}</button>
              </div>
            )}
          </div>
          )}
        </div>
      )}
      <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: '.08em', textTransform: 'uppercase', margin: '18px 0 8px', color: 'var(--text2)' }}>{'\u{1F4B0} Investimento e CPL'}</div>
      {!m.configured && <div className="card" style={{ fontSize: 13, color: 'var(--text3)', padding: 14 }}>{'Conecte o Meta Ads em \u2699\ufe0f Configurar para ver o investido e o CPL.'}</div>}
      {m.configured && m.error && <div className="card" style={{ fontSize: 13, color: '#ef4444', padding: 14 }}>{'Meta Ads: ' + m.error}</div>}
      <div className="gm-g4">
        {stat('Investido Meta', brl(m.spend), m.configured ? ((m.camp_sel && m.camp_sel.length) ? (m.campaigns || []).filter(c => c.on).length + ' campanha(s) escolhida(s)' : (m.campaigns || []).length + ' campanha(s) no per\u00edodo') : 'n\u00e3o conectado', '#8b5cf6')}
        {stat('CPL Gerenciador', brl(m.cpl_gerenciador), 'investido \u00f7 entradas (' + t.joins + ')', '#f59e0b')}
        {stat('CPL Real', brl(m.cpl_real), 'investido \u00f7 saldo (' + saldoReal + ')', '#ef4444')}
        {stat('Leads p\u00e1gina', t.leads || 0, t.leads ? 'taxa de entrada: ' + Math.round(t.joins * 100 / t.leads) + '% (' + t.joins + ' de ' + t.leads + ')' : 'cliques na pressel', '#a78bfa')}
      </div>
      {m.configured && (m.campaigns || []).length > 0 && (
        <div className="card">
          <div className="card-hd" style={{ cursor: 'pointer' }} onClick={() => setCampOpen(!campOpen)}>
            <strong>{(campOpen ? '\u25be' : '\u25b8') + ' \u{1F4E3} Investido por campanha'}</strong>
            <span style={{ marginLeft: 10, fontSize: 12, fontWeight: 600, color: 'var(--text3)' }}>{m.campaigns.length + ' campanha(s) \u00b7 clique para ' + (campOpen ? 'fechar' : 'abrir')}</span>
          </div>
          {campOpen && m.campaigns.map(c => (
            <div key={c.campaign_id} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, fontSize: 13, padding: '6px 0', borderTop: '1px solid var(--border)' }}>
              <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.name || c.campaign_id}</span>
              <b style={{ opacity: c.on === false ? .45 : 1 }}>{brl(c.spend) + (c.on === false ? ' (fora)' : '')}</b>
            </div>
          ))}
        </div>
      )}
      {dwell && (() => { /*GRP_FUNIL_V1*/
        const n = dwell.n || 0;
        const red = dwell.redirected || 0;
        const clk = dwell.clicked || 0;
        const left = dwell.left_without_click || 0;
        const pc = (v) => (n > 0 ? Math.round(v * 100 / n) + '%' : '0%');
        const sx = (v) => (((v || 0) / 1000).toFixed(1) + 's');
        return (
          <>
            <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: '.08em', textTransform: 'uppercase', margin: '18px 0 8px', color: 'var(--text2)' }}>{'\u{1F9ED} Funil da p\u00e1gina'}<span style={{ marginLeft: 10, fontSize: 11, fontWeight: 600, textTransform: 'none', letterSpacing: 0, color: 'var(--text3)' }}>{n + ' visitas no per\u00edodo \u00b7 segue o filtro de origem'}</span></div>
            <div className="gm-g4">
              {stat('\u23f1\ufe0f Tempo mediano', sx(dwell.median_ms), 'P25 ' + sx(dwell.p25_ms) + ' \u00b7 P75 ' + sx(dwell.p75_ms) + ' \u00b7 m\u00e9dia ' + sx(dwell.avg_ms), '#a855f7')}
              {stat('Clicaram no bot\u00e3o', clk, pc(clk) + ' das visitas', '#10b981')}
              {stat('Redirecionados', red, pc(red) + ' foram pelo redirect autom\u00e1tico', '#06b6d4')}
              {stat('Sa\u00edram sem agir', left, pc(left) + ' n\u00e3o clicaram nem foram redirecionados', '#ef4444')}
            </div>
          </>
        );
      })()}
      <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: '.08em', textTransform: 'uppercase', margin: '18px 0 8px', color: 'var(--text2)' }}>{'\u{1F4CA} Desempenho dos grupos'}<span style={{ marginLeft: 10, fontSize: 11, fontWeight: 600, textTransform: 'none', letterSpacing: 0, color: 'var(--text3)' }}>{'entradas e sa\u00eddas n\u00e3o seguem o filtro de origem'}</span></div>
      <div className="gm-g4">
        {stat('Entraram', t.joins, 'no per\u00edodo', '#22c55e')}
        {stat('Sa\u00edram (<3d)', quick, 'total de sa\u00eddas: ' + out + (t.removed ? ' \u00b7 ' + t.removed + ' removidos' : '') + ' \u00b7 ' + pct, '#ef4444')}
        {stat('Ficaram (3+d)', t.stayed || 0, 'passaram de 3 dias', '#10b981')}
        {stat('Saldo per\u00edodo', (saldoReal > 0 ? '+' : '') + saldoReal, 'reten\u00e7\u00e3o ' + retPct + ' \u00b7 saldo total ' + (t.net > 0 ? '+' : '') + t.net, '#06b6d4')}
      </div>
      <div className="card">
        <div className="card-hd" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <strong>{'\u{1F4CA} Por dia'}</strong>
          <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)' }}>
            <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: 3, background: '#22c55e', margin: '0 4px 0 0', verticalAlign: -1 }} />{'Entraram'}
            <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: 3, background: '#ef4444', margin: '0 4px 0 12px', verticalAlign: -1 }} />{'Sa\u00edram'}
          </span>
        </div>
        {(() => {
          const nD = dayList.length;
          const bw = nD <= 7 ? 22 : nD <= 14 ? 12 : 7;
          const showNum = nD <= 14;
          return (
            <div style={{ maxWidth: nD === 1 ? 220 : 'none', margin: '0 auto' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(' + nD + ', minmax(0, 1fr))', gap: nD > 14 ? 3 : 10, height: 190, alignItems: 'end', borderBottom: '1px solid var(--border)', paddingTop: 20 }}>
                {dayList.map(d => (
                  <div key={d.day} title={d.day.slice(8, 10) + '/' + d.day.slice(5, 7) + ': +' + d.joins + ' / -' + d.out} style={{ display: 'flex', gap: nD > 14 ? 1 : 4, justifyContent: 'center', alignItems: 'flex-end', height: '100%' }}>
                    {[[d.joins, '#22c55e'], [d.out, '#ef4444']].map(([v, c], k) => (
                      <div key={k} style={{ width: bw, height: (v ? Math.max(3, v * 100 / maxDay) : 0) + '%', background: c, borderRadius: '5px 5px 0 0', position: 'relative' }}>
                        {showNum && v > 0 && <span style={{ position: 'absolute', top: -17, left: '50%', transform: 'translateX(-50%)', fontSize: 11, fontWeight: 700, color: c }}>{v}</span>}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(' + nD + ', minmax(0, 1fr))', gap: nD > 14 ? 3 : 10, marginTop: 6 }}>
                {dayList.map((d, i) => (
                  <div key={d.day} style={{ textAlign: 'center', fontSize: 11, color: 'var(--text3)', whiteSpace: 'nowrap' }}>{(nD <= 14 || i % 5 === 0 || i === nD - 1) ? d.day.slice(8, 10) + '/' + d.day.slice(5, 7) : ''}</div>
                ))}
              </div>
              {!days.length && <div style={{ fontSize: 13, color: 'var(--text3)', textAlign: 'center', marginTop: 10 }}>{'Sem movimento no per\u00edodo.'}</div>}
            </div>
          );
        })()}
      </div>
      <div className="card">
        <div className="card-hd" style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <button className={'btn btn-sm ' + (grpTab === 'mov' ? 'btn-p' : 'btn-g')} onClick={() => setGrpTab('mov')}>{'\u{1F465} Por grupo'}</button>
          <button className={'btn btn-sm ' + (grpTab === 'mem' ? 'btn-p' : 'btn-g')} onClick={() => { setGrpTab('mem'); if (!members) loadMembers(false); }}>{'\u{1F522} Membros'}</button>
          {grpTab === 'mem' && <button className="btn btn-g btn-sm" onClick={() => loadMembers(true)} disabled={memLoading}>{memLoading ? '\u23f3' : '\u{1F504} Atualizar'}</button>}
        </div>
        {grpTab === 'mem' ? (
          <div>
            {memLoading && <div style={{ fontSize: 13, color: 'var(--text3)', padding: 8 }}>{'Carregando membros...'}</div>}
            {members && !members.ok && <div style={{ fontSize: 13, color: '#ef4444', padding: 8 }}>{'Erro: ' + (members.error || 'falha ao carregar')}</div>}
            {members && members.ok && (
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, padding: '0 12px 10px' }}>{'Total: ' + members.total + ' membros em ' + members.data.length + ' grupos' + (members.missing ? ' \u00b7 ' + members.missing + ' sem dado' : '')}</div>
                {members.data.map(g => (
                  <div key={g.group_id} style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 90px', gap: 8, alignItems: 'center', padding: '10px 12px', borderTop: '1px solid var(--border)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                      {avatar(g.group_id, 36)}
                      <div style={{ minWidth: 0, fontWeight: 600, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nice(g.name)}</div>
                    </div>
                    <div style={{ textAlign: 'center', fontWeight: 800, fontSize: 15, color: '#22c55e' }}>{g.size}</div>
                  </div>
                ))}
                {members.erros && members.erros.length > 0 && <div style={{ fontSize: 11, color: '#f59e0b', padding: '8px 12px' }}>{'Avisos: ' + members.erros.join(' | ')}</div>}
              </div>
            )}
          </div>
        ) : grps.length === 0 ? <div style={{ fontSize: 13, color: 'var(--text3)' }}>{'Sem movimento no per\u00edodo.'}</div> : (
          <div style={{ overflowX: 'auto' }}>
            <div style={{ minWidth: 520 }}>
              <div style={{ display: 'grid', gridTemplateColumns: cols, gap: 8, padding: '0 12px 8px' }}>
                <div style={{ ...th, textAlign: 'left' }}>{'Grupo'}</div>
                <div style={th}>{'Entraram'}</div>
                <div style={th}>{'Sa\u00edram'}</div>
                <div style={th}>{'Removidos'}</div>
                <div style={th}>{'Saldo'}</div>
              </div>
              {grps.map(g => {
                const n = g.joins - g.leaves - g.removed;
                const c = n > 0 ? '#22c55e' : n < 0 ? '#ef4444' : 'var(--text3)';
                return (
                  <div key={g.group_id} style={{ display: 'grid', gridTemplateColumns: cols, gap: 8, alignItems: 'center', padding: '10px 12px', borderTop: '1px solid var(--border)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                      {avatar(g.group_id, 36)}
                      <div style={{ minWidth: 0, fontWeight: 600, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nice(g.name)}</div>
                    </div>
                    {num(g.joins, '#22c55e')}
                    {num(g.leaves, '#ef4444')}
                    {num(g.removed, '#f59e0b')}
                    <div style={{ textAlign: 'center' }}>
                      <span style={{ display: 'inline-block', minWidth: 44, padding: '3px 10px', borderRadius: 999, fontWeight: 800, fontSize: 13, color: c, background: n > 0 ? 'rgba(34,197,94,.12)' : n < 0 ? 'rgba(239,68,68,.12)' : 'var(--bg3)' }}>{(n > 0 ? '+' : '') + n}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function SeqQuickDispatch({ botId, show, loadMsgs }) {
  const [open, setOpen] = useState(false);
  const [seqs, setSeqs] = useState([]);
  const [selSeq, setSelSeq] = useState('');
  const [date, setDate] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => { if (open) api('/sequences').then(r => { if (r.ok) setSeqs(r.data || []); }); }, [open]);

  const dispatch = async () => {
    if (!selSeq || !date) return setMsg('Selecione sequência e data');
    const groups = getStoredSel(botId);
    if (groups.length === 0) return setMsg('Selecione grupos acima');
    const r = await api('/sequences/' + selSeq + '/dispatch', { method: 'POST', body: JSON.stringify({ date, groups_override: groups, instance: botId }) });
    if (r.ok) { show('✅ ' + r.message); setOpen(false); setSelSeq(''); setDate(''); setMsg(''); if (loadMsgs) loadMsgs(); }
    else setMsg(r.error || 'Erro');
  };

  if (!open) return (
    <button className="btn btn-g btn-full" onClick={() => setOpen(true)} style={{ borderStyle: 'dashed' }}>
      📋 Importar sequência salva
    </button>
  );

  return (
    <div style={{ padding: 14, border: '1.5px solid var(--blue)', borderRadius: 'var(--r-sm)', background: 'var(--blue-dim)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)' }}>📋 Disparar sequência</span>
        <button className="ib" onClick={() => { setOpen(false); setMsg(''); }}>✕</button>
      </div>
      <select className="fs" value={selSeq} onChange={e => setSelSeq(e.target.value)} style={{ marginBottom: 8 }}>
        <option value="">Selecione...</option>
        {seqs.map(s => <option key={s.id} value={s.id}>{s.name} ({s.items.length} msgs)</option>)}
      </select>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input type="date" value={date} onChange={e => setDate(e.target.value)}
          style={{ flex: 1, padding: '7px 10px', fontSize: 13, border: '1.5px solid var(--border)', borderRadius: 8, background: 'var(--bg2)', color: 'var(--text)', fontFamily: 'Inter,sans-serif' }} />
        <button className="btn btn-p btn-sm" onClick={dispatch}>🚀 Disparar</button>
      </div>
      <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 6 }}>Usa os grupos selecionados acima.</div>
      {msg && <div style={{ fontSize: 12, color: 'var(--red)', marginTop: 4, fontWeight: 600 }}>{msg}</div>}
    </div>
  );
}

// ── BOT IA: TEMPLATES PRONTOS ──
const BOT_TEMPLATES = {
  infoproduto: {
    label: '💊 Infoproduto',
    emoji: '💊',
    config: {
      bot_name: 'Assistente Virtual',
      product_name: 'Mounjax',
      base_prompt: 'Você vende produtos de emagrecimento. Responda sobre benefícios, como funciona e resultados. Seja simpático e direto. NUNCA dê diagnósticos médicos - sempre recomende consultar médico quando perguntarem sobre saúde.',
      welcome_message: 'Oi! 😊 Sou a assistente virtual. Posso te ajudar com dúvidas sobre o produto!',
      fallback_message: 'Não consegui te responder com segurança. Vou te passar para nossa equipe! 👤'
    },
    faqs: [
      { question: 'Quais os benefícios?', answer: 'Ajuda no emagrecimento saudável, acelera metabolismo e reduz apetite. Resultados variam.' },
      { question: 'Como usar?', answer: 'Use conforme instruções da embalagem. Consulte médico antes.' },
      { question: 'Tem contraindicação?', answer: 'Gestantes, lactantes e menores de 18 anos não devem usar.' }
    ]
  },
  ecommerce: {
    label: '🛒 E-commerce',
    emoji: '🛒',
    config: {
      bot_name: 'Atendente de Vendas',
      product_name: 'Sua Loja',
      base_prompt: 'Você é vendedor de loja online. Tire dúvidas sobre produtos, preços, pagamento, entrega e trocas. Seja educado e prestativo.',
      welcome_message: 'Olá! 👋 Bem-vindo à nossa loja. Como posso ajudar?',
      fallback_message: 'Vou te transferir para um atendente! 😊'
    },
    faqs: [
      { question: 'Formas de pagamento', answer: 'PIX, cartão até 12x, boleto e transferência.' },
      { question: 'Prazo de entrega', answer: '7 a 15 dias úteis. Você recebe código de rastreio.' },
      { question: 'Como trocar', answer: '7 dias para troca. Entre em contato com o número do pedido.' }
    ]
  },
  servico: {
    label: '📅 Agendamento',
    emoji: '📅',
    config: {
      bot_name: 'Assistente de Agendamento',
      product_name: 'Seu Serviço',
      base_prompt: 'Você agenda serviços. Responda sobre horários, valores e localização. Seja objetivo. Ao agendar, pergunte nome, data e horário.',
      welcome_message: 'Olá! 🙂 Quer agendar um horário?',
      fallback_message: 'Vou chamar a equipe!'
    },
    faqs: [
      { question: 'Horários disponíveis', answer: 'Segunda a sexta 9h-18h, sábado 9h-13h.' },
      { question: 'Qual o valor', answer: 'Varia por serviço. Entre em contato para orçamento.' },
      { question: 'Onde fica', answer: 'Centro da cidade. Endereço após confirmação.' }
    ]
  }
};

function BotAIPage({ userPlan, show }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);

  const [config, setConfig] = useState({
    enabled: false,
    bot_name: '',
    product_name: '',
    base_prompt: '',
    welcome_message: '',
    fallback_message: '',
    human_handoff_enabled: true,
    max_messages_per_day: 200
  });

  const [faqs, setFaqs] = useState([]);
  const [keyInfo, setKeyInfo] = useState({ has_key: false, last4: null, mode: 'none', purchase_link: '' });
  const [keyInput, setKeyInput] = useState('');
  const [keySaving, setKeySaving] = useState(false);
  const [linkInput, setLinkInput] = useState('');
  const [faqSuggestions, setFaqSuggestions] = useState([]);
  const [faqQuestion, setFaqQuestion] = useState('');
  const [editingFaqId, setEditingFaqId] = useState(null);
  const [faqAnswer, setFaqAnswer] = useState('');
  const [faqResponseType, setFaqResponseType] = useState('text');
  const [faqImageUrl, setFaqImageUrl] = useState('');
  const [faqImageFile, setFaqImageFile] = useState(null);
  const [faqImagePreview, setFaqImagePreview] = useState('');
  const [faqAudioUrl, setFaqAudioUrl] = useState('');
  const [faqAudioFile, setFaqAudioFile] = useState(null);
  const [faqAudioPreview, setFaqAudioPreview] = useState('');
  const [uploadingFaqAudio, setUploadingFaqAudio] = useState(false);
  const [faqSearch, setFaqSearch] = useState('');
  const [expandedFaq, setExpandedFaq] = useState(null);
  const fqFiltradas = (faqs || []).filter(f => !faqSearch.trim() || ((f.question || '') + ' ' + (f.answer || '')).toLowerCase().includes(faqSearch.trim().toLowerCase()));
  const [uploadingFaqImage, setUploadingFaqImage] = useState(false);
  const [testMessage, setTestMessage] = useState('Quais os beneficios do Mounjax?');
  const [testReply, setTestReply] = useState('');

  const [tab, setTab] = useState('config');
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const messagesEndRef = React.useRef(null);
  const [conversationMessages, setConversationMessages] = useState([]);
  const [messageText, setMessageText] = useState('');
  const [sendingMessage, setSendingMessage] = useState(false);
  const [convoFilter, setConvoFilter] = useState('all');
  /*BOTIA_INST_UI_V1*/
  const [botInsts, setBotInsts] = useState([]);
  const [botInstsBusy, setBotInstsBusy] = useState('');
  const loadBotInsts = async () => {
    try {
      const r = await api('/bot-ai/instances');
      if (r && r.ok) setBotInsts(r.instances || []);
    } catch (e) {}
  };
  const toggleBotInst = async (botId, enabled) => {
    setBotInstsBusy(botId);
    try {
      const r = await api('/bot-ai/instances/' + botId, { method: 'POST', body: JSON.stringify({ enabled }) });
      if (r && r.ok) {
        setBotInsts(prev => prev.map(i => i.bot_id === botId ? { ...i, enabled } : i));
        show(enabled ? 'Bot IA ligado em ' + botId : 'Bot IA desligado em ' + botId);
      } else {
        show((r && r.error) || 'Erro ao alterar', 'error');
      }
    } catch (e) {
      show('Erro ao alterar', 'error');
    }
    setBotInstsBusy('');
  };
  React.useEffect(() => { loadBotInsts(); }, []);

  const updateField = (field, value) => {
    setConfig(prev => ({ ...prev, [field]: value }));
  };

  const applyTemplate = async (templateKey) => {
    const template = BOT_TEMPLATES[templateKey];
    if (!template) return;
    
    setConfig(prev => ({ ...prev, ...template.config }));
    show(`✨ Template "${template.label}" aplicado! Ajuste os detalhes e salve.`);
    
    // Adiciona FAQs do template após 500ms
    setTimeout(async () => {
      for (const faq of template.faqs) {
        await api('/bot-ai/faqs', {
          method: 'POST',
          body: JSON.stringify(faq)
        });
      }
      // Recarregar apenas FAQs, não o config inteiro
      const r = await api('/bot-ai/config');
      if (r.ok) setFaqs(r.faqs || []);
    }, 500);
  };

  const loadBotData = useCallback(async () => {
    setLoading(true);
    const r = await api('/bot-ai/config');
    if (r.ok) {
      setConfig({
        enabled: !!(r.config && r.config.enabled),
        bot_name: (r.config && r.config.bot_name) || '',
        product_name: (r.config && r.config.product_name) || '',
        base_prompt: (r.config && r.config.base_prompt) || '',
        welcome_message: (r.config && r.config.welcome_message) || '',
        fallback_message: (r.config && r.config.fallback_message) || '',
        human_handoff_enabled: !!(r.config && r.config.human_handoff_enabled),
        max_messages_per_day: (r.config && r.config.max_messages_per_day) || 200
      });
      setFaqs(r.faqs || []);
    } else {
      show(r.error || 'Erro ao carregar Bot IA', 'error');
    }
    setLoading(false);
  }, [show]);

  const loadConversations = useCallback(async () => {
    const r = await api('/bot-ai/conversations');
    if (r.ok) setConversations(r.conversations || []);
    else show(r.error || 'Erro ao carregar conversas', 'error');
  }, [show]);
  
  const loadFaqSuggestions = useCallback(async () => {
    try {
      const r = await api('/bot-ai/faq-suggestions');
      if (r.ok) setFaqSuggestions(r.suggestions || []);
    } catch (err) {
      console.error('Erro ao carregar sugestões:', err);
    }
  }, []);
  
  const approveFaqSuggestion = useCallback(async (id) => {
    if (!window.confirm('Criar FAQ baseada nesta sugestão?')) return;
    try {
      const r = await api(`/bot-ai/faq-suggestions/${id}/approve`, { method: 'POST' });
      if (r.ok) {
        show('✅ FAQ criada com sucesso!', 'success');
        loadFaqSuggestions();
        loadBotData();
      } else {
        show(r.error || 'Erro ao aprovar', 'error');
      }
    } catch (err) {
      show('Erro: ' + err.message, 'error');
    }
  }, [show, loadBotData]);
  
  const rejectFaqSuggestion = useCallback(async (id) => {
    try {
      await api(`/bot-ai/faq-suggestions/${id}/reject`, { method: 'POST' });
      loadFaqSuggestions();
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    loadBotData();
    loadFaqSuggestions();
  }, [loadBotData, loadFaqSuggestions]);

  useEffect(() => {
    if (tab === 'conversations') loadConversations();
  }, [tab, loadConversations]);

  const loadKeyInfo = useCallback(async () => {
    const r = await api('/bot-ai/openai-key');
    if (r.ok) {
      setKeyInfo({ has_key: !!r.has_key, last4: r.last4, mode: r.mode, purchase_link: r.purchase_link || '' });
      setLinkInput(r.purchase_link || '');
    }
  }, []);

  useEffect(() => { loadKeyInfo(); }, [loadKeyInfo]);

  const saveOpenaiKey = async () => {
    setKeySaving(true);
    const r = await api('/bot-ai/openai-key', { method: 'POST', body: JSON.stringify({ api_key: keyInput.trim() }) });
    setKeySaving(false);
    if (r.ok) { setKeyInput(''); show('Chave OpenAI conectada com sucesso'); loadKeyInfo(); }
    else show(r.error || 'Erro ao conectar a chave', 'error');
  };

  const removeOpenaiKey = async () => {
    if (!window.confirm('Remover a chave? O bot para de responder ate voce conectar outra.')) return;
    const r = await api('/bot-ai/openai-key', { method: 'DELETE' });
    if (r.ok) { show('Chave removida'); loadKeyInfo(); }
    else show(r.error || 'Erro ao remover a chave', 'error');
  };

  const saveLink = async () => {
    const r = await api('/bot-ai/purchase-link', { method: 'POST', body: JSON.stringify({ purchase_link: linkInput.trim() }) });
    if (r.ok) { show('Link de compra salvo'); loadKeyInfo(); }
    else show(r.error || 'Erro ao salvar o link', 'error');
  };

  const saveConfig = async () => {
    setSaving(true);
    const r = await api('/bot-ai/config', {
      method: 'POST',
      body: JSON.stringify({
        enabled: config.enabled,
        bot_name: config.bot_name,
        product_name: config.product_name,
        base_prompt: config.base_prompt,
        welcome_message: config.welcome_message,
        fallback_message: config.fallback_message,
        human_handoff_enabled: config.human_handoff_enabled,
        max_messages_per_day: Number(config.max_messages_per_day || 200)
      })
    });
    if (r.ok) show('Configuracao do Bot IA salva com sucesso');
    else show(r.error || 'Erro ao salvar configuracao', 'error');
    setSaving(false);
  };


  const uploadFaqImage = async () => {
    if (!faqImageFile) return faqImageUrl;
    
    setUploadingFaqImage(true);
    try {
      const formData = new FormData();
      formData.append('image', faqImageFile);
      
      const token = localStorage.getItem('zs_token');
      const response = await fetch('https://app.pulsend.online/api/bot-ai/faqs/upload-image', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      
      if (!response.ok) throw new Error('Erro no upload');
      
      const data = await response.json();
      setFaqImageUrl(data.imageUrl);
      return data.imageUrl;
    } catch (err) {
      console.error('Upload error:', err);
      show('Erro ao fazer upload da imagem', 'error');
      return null;
    } finally {
      setUploadingFaqImage(false);
    }
  };

  const uploadFaqAudio = async () => { /*FAQ_AUDIO_V1*/
    if (!faqAudioFile) return faqAudioUrl;
    setUploadingFaqAudio(true);
    try {
      const formData = new FormData();
      formData.append('audio', faqAudioFile);
      const token = localStorage.getItem('zs_token');
      const response = await fetch('https://app.pulsend.online/api/bot-ai/faqs/upload-audio', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      const data = await response.json();
      if (!response.ok || !data.audioUrl) throw new Error(data.error || 'falhou');
      setFaqAudioUrl(data.audioUrl);
      return data.audioUrl;
    } catch (err) {
      show('Erro ao enviar o \u00e1udio', 'error');
      return null;
    } finally {
      setUploadingFaqAudio(false);
    }
  };
  const handleFaqAudioChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 16 * 1024 * 1024) { show('\u00c1udio muito grande! M\u00e1ximo 16MB.', 'warning'); return; }
    setFaqAudioFile(file);
    setFaqAudioPreview(URL.createObjectURL(file));
  };
  const removeFaqAudio = () => { setFaqAudioFile(null); setFaqAudioPreview(''); setFaqAudioUrl(''); };
  const handleFaqImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    /*FAQ_VIDEO_UI_V1*/
    const _isVid = /^video\//.test(file.type) || /\.(mp4|mov|m4v|webm)$/i.test(file.name);
    if (file.size > (_isVid ? 16 : 5) * 1024 * 1024) {
      show(_isVid ? 'Vídeo muito grande! Máximo 16MB.' : 'Imagem muito grande! Máximo 5MB.', 'warning');
      return;
    }
    
    if (!_isVid && !file.type.match(/image\/(jpeg|jpg|png|gif|webp)/)) {
      show('Use imagem (JPG, PNG, GIF, WEBP) ou vídeo MP4', 'warning');
      return;
    }
    
    setFaqImageFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setFaqImagePreview(reader.result);
    reader.readAsDataURL(file);
  };

  const removeFaqImage = () => {
    setFaqImageFile(null);
    setFaqImagePreview('');
    setFaqImageUrl('');
  };

  const addFaq = async () => {
    if (!faqQuestion.trim() || !faqAnswer.trim()) {
      show('Preencha pergunta e resposta', 'warning');
      return;
    }

    // Upload de imagem se houver
    let imageUrl = faqImageUrl;
    if (faqImageFile) {
      const uploaded = await uploadFaqImage();
      if (!uploaded) return;
      imageUrl = uploaded;
    }

    let audioUrl = faqAudioUrl; /*FAQ_AUDIO_V1*/
    if (faqAudioFile) { const upA = await uploadFaqAudio(); if (!upA) return; audioUrl = upA; }
    const r = await api('/bot-ai/faqs', {
      method: 'POST',
      body: JSON.stringify({
        question: faqQuestion,
        answer: faqAnswer,
        response_type: faqResponseType,
        image_url: imageUrl,
        audio_url: audioUrl
      })
    });

    if (r.ok) {
      show('FAQ cadastrada com sucesso');
      setFaqQuestion('');
      setFaqAnswer('');
      setFaqResponseType('text');
      setFaqImageUrl('');
      setFaqImagePreview('');
      setFaqImageFile(null);
      setFaqAudioUrl(''); setFaqAudioFile(null); setFaqAudioPreview('');
      loadBotData();
    } else {
      show(r.error || 'Erro ao cadastrar FAQ', 'error');
    }
  };

  const deleteFaq = async (id) => {
    if (!window.confirm('Excluir esta FAQ?')) return;

    const r = await api(`/bot-ai/faqs/${id}`, { method: 'DELETE' });
    if (r.ok) {
      show('FAQ removida');
      loadBotData();
    } else {
      show(r.error || 'Erro ao remover FAQ', 'error');
    }
  };
  
  const editFaq = (faq) => {
    setEditingFaqId(faq.id);
    setFaqQuestion(faq.question);
    setFaqAnswer(faq.answer);
    setFaqResponseType(faq.response_type || 'text');
    setFaqImageUrl(faq.image_url || '');
    setFaqImagePreview(faq.image_url ? 'https://app.pulsend.online' + faq.image_url : '');
    setFaqImageFile(null);
    setFaqAudioUrl(faq.audio_url || ''); setFaqAudioFile(null); setFaqAudioPreview('');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  const updateFaq = async () => {
    if (!faqQuestion.trim() || !faqAnswer.trim()) {
      show('Preencha pergunta e resposta', 'warning');
      return;
    }
    // Upload de imagem se houver
    let imageUrl = faqImageUrl;
    if (faqImageFile) {
      const uploaded = await uploadFaqImage();
      if (!uploaded) return;
      imageUrl = uploaded;
    }

    let audioUrl = faqAudioUrl; /*FAQ_AUDIO_V1*/
    if (faqAudioFile) { const upA = await uploadFaqAudio(); if (!upA) return; audioUrl = upA; }
    const r = await api(`/bot-ai/faqs/${editingFaqId}`, {
      method: 'PUT',
      body: JSON.stringify({
        question: faqQuestion,
        answer: faqAnswer,
        response_type: faqResponseType,
        image_url: imageUrl,
        audio_url: audioUrl
      })
    });
    if (r.ok) {
      show('FAQ atualizada com sucesso');
      setFaqQuestion('');
      setFaqAnswer('');
      setEditingFaqId(null);
      loadBotData();
    } else {
      show(r.error || 'Erro ao atualizar FAQ', 'error');
    }
  };
  
  const cancelEdit = () => {
    setEditingFaqId(null);
    setFaqQuestion('');
    setFaqAnswer('');
    setFaqResponseType('text');
    setFaqImageUrl('');
    setFaqImagePreview('');
    setFaqImageFile(null);
  };

  const testPrompt = async () => {
    if (!testMessage.trim()) {
      show('Digite a mensagem de teste', 'warning');
      return;
    }

    setTesting(true);
    setTestReply('');

    const r = await api('/bot-ai/test-prompt', {
      method: 'POST',
      body: JSON.stringify({
        message: testMessage
      })
    });

    if (r.ok) {
      setTestReply(r.reply || '');
      show('Teste realizado com sucesso');
    } else {
      show(r.error || 'Erro ao testar IA', 'error');
    }

    setTesting(false);
  };

  const [pcSearch, setPcSearch] = useState('');
  const [pcSeen, setPcSeen] = useState(() => { try { return JSON.parse(localStorage.getItem('pc_seen') || '{}'); } catch (e) { return {}; } });
  const pcBoxRef = useRef(null);
  const pcSelRef = useRef(null);
  useEffect(() => { pcSelRef.current = selectedConversation; }, [selectedConversation]);
  useEffect(() => {
    const t = setInterval(async () => {
      if (document.hidden) return;
      try {
        const r = await api('/bot-ai/conversations');
        if (r && r.ok) setConversations(r.conversations || []);
        const cur = pcSelRef.current;
        if (cur) {
          const m = await api('/bot-ai/conversations/' + cur.id + '/messages');
          if (m && m.ok) { setConversationMessages(m.messages || []); setSelectedConversation(m.conversation); }
        }
      } catch (e) {}
    }, 6000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const el = pcBoxRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [(conversationMessages || []).length, selectedConversation && selectedConversation.id]);
  const pcPhotoBusy = useRef(false);
  useEffect(() => {
    if (pcPhotoBusy.current) return;
    const now = Date.now();
    const todo = (conversations || []).filter(c => c.instance_id && (!c.photo_at || (now - Date.parse(c.photo_at)) > 86400000)).slice(0, 6);
    if (!todo.length) return;
    pcPhotoBusy.current = true;
    (async () => {
      const got = {};
      for (const c of todo) {
        try { const r = await api('/bot-ai/conversations/' + c.id + '/photo', { method: 'POST' }); if (r && r.ok) got[c.id] = r; } catch (e) {}
        await new Promise(rs => setTimeout(rs, 400));
      }
      setConversations(prev => prev.map(c => got[c.id] ? { ...c, photo_url: got[c.id].photo_url, photo_at: got[c.id].photo_at } : c));
      pcPhotoBusy.current = false;
    })();
  }, [conversations]);
  const [pcFile, setPcFile] = useState(null);
  const [pcPrevUrl, setPcPrevUrl] = useState('');
  const pcFileRef = useRef(null);
  const pcPick = (f) => {
    if (!f) return;
    const isImg = /^image\/(jpeg|png|webp)$/.test(f.type);
    const isMp4 = f.type === 'video/mp4';
    const lim = isImg ? 8 : isMp4 ? 16 : 30;
    if (f.size > lim * 1024 * 1024) { show('Arquivo muito grande (máximo ' + lim + ' MB para este tipo)', 'error'); return; }
    if (pcPrevUrl) { try { URL.revokeObjectURL(pcPrevUrl); } catch (e) {} }
    setPcFile(f);
    setPcPrevUrl(isImg ? URL.createObjectURL(f) : '');
  };
  const pcClearFile = () => {
    if (pcPrevUrl) { try { URL.revokeObjectURL(pcPrevUrl); } catch (e) {} }
    setPcFile(null); setPcPrevUrl('');
    if (pcFileRef.current) pcFileRef.current.value = '';
  };
  const pcSendMedia = async () => {
    if (!selectedConversation || !pcFile || sendingMessage) return;
    const id = selectedConversation.id;
    setSendingMessage(true);
    try {
      const fd = new FormData();
      fd.append('file', pcFile);
      fd.append('caption', (messageText || '').trim());
      const r = await fetch(`${API_BASE}/bot-ai/conversations/${id}/send-media`, { method: 'POST', headers: { Authorization: `Bearer ${localStorage.getItem('zs_token')}` }, body: fd });
      const d = await r.json();
      if (d.ok) {
        pcClearFile(); setMessageText('');
        const m = await api('/bot-ai/conversations/' + id + '/messages');
        if (m && m.ok) { setConversationMessages(m.messages || []); setSelectedConversation(m.conversation); }
        loadConversations();
      } else show(d.error || 'Erro ao enviar arquivo', 'error');
    } catch (e) { show('Erro ao enviar arquivo', 'error'); }
    setSendingMessage(false);
  };
  const pcOpen = async (c) => {
    await openConversation(c.id);
    try { const sn = { ...pcSeen, [c.id]: c.last_message_at || '' }; setPcSeen(sn); localStorage.setItem('pc_seen', JSON.stringify(sn)); } catch (e) {}
  };
  const pcSend = async () => {
    if (pcFile) { await pcSendMedia(); return; }
    if (!selectedConversation || !(messageText || '').trim() || sendingMessage) return;
    const id = selectedConversation.id;
    if (selectedConversation.status !== 'human') {
      try { await api('/bot-ai/conversations/' + id + '/human', { method: 'POST' }); setSelectedConversation({ ...selectedConversation, status: 'human' }); } catch (e) {}
    }
    await sendHumanMessage();
    try {
      const m = await api('/bot-ai/conversations/' + id + '/messages');
      if (m && m.ok) { setConversationMessages(m.messages || []); setSelectedConversation(m.conversation); }
      loadConversations();
    } catch (e) {}
  };

  const openConversation = async (id) => {
    const r = await api(`/bot-ai/conversations/${id}/messages`);
    if (r.ok) {
      setSelectedConversation(r.conversation);
      setConversationMessages(r.messages || []);
    } else {
      show(r.error || 'Erro ao carregar conversa', 'error');
    }
  };

  const setHumanMode = async (id) => {
    const r = await api(`/bot-ai/conversations/${id}/human`, { method: 'POST' });
    if (r.ok) {
      show('Atendimento humano ativado');
      loadConversations();
      if (selectedConversation && selectedConversation.id === id) openConversation(id);
    } else {
      show(r.error || 'Erro ao assumir conversa', 'error');
    }
  };

  const setBotMode = async (id) => {
    const r = await api(`/bot-ai/conversations/${id}/bot`, { method: 'POST' });
    if (r.ok) {
      show('Bot reativado');
      loadConversations();
      if (selectedConversation && selectedConversation.id === id) openConversation(id);
    } else {
      show(r.error || 'Erro ao reativar bot', 'error');
    }
  };

  const sendHumanMessage = async () => {
    if (!messageText.trim() || !selectedConversation) return;
    setSendingMessage(true);
    const r = await api('/bot-ai/send-message', {
      method: 'POST',
      body: JSON.stringify({
        conversation_id: selectedConversation.id,
        contact_number: selectedConversation.contact_number,
        message: messageText.trim()
      })
    });
    if (r.ok) {
      setMessageText('');
      openConversation(selectedConversation.id);
      show('✅ Mensagem enviada!');
    } else {
      show(r.error || 'Erro ao enviar', 'error');
    }
    setSendingMessage(false);
  };

  // Polling automático
  useEffect(() => {
    if (tab !== 'conversations') return;
    const interval = setInterval(() => {
      loadConversations();
      if (selectedConversation) openConversation(selectedConversation.id);
    }, 10000);
    return () => clearInterval(interval);
  }, [tab, selectedConversation, loadConversations, openConversation]);

  // Auto-scroll para última mensagem
  React.useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'auto', block: 'end', inline: 'nearest' });
    }
  }, [conversationMessages]);

  // Fechar modal com ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && selectedConversation) {
        setSelectedConversation(null);
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [selectedConversation]);

  return (
    <div className="fade-up">
      <div className="ph">
        <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, #a855f7, #7c3aed)', fontSize: 18, boxShadow: '0 4px 16px rgba(168,85,247,.25)' }}>🤖</span>
          Bot IA
        </h1>
        <p>Bot responde automaticamente em TODOS os seus WhatsApp conectados</p>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button
            className={`btn ${tab === 'config' ? 'btn-p' : 'btn-g'}`}
            type="button"
            onClick={() => setTab('config')}
          >
            ⚙️ Configuracao
          </button>
          <button
            className={`btn ${tab === 'conversations' ? 'btn-p' : 'btn-g'}`}
            type="button"
            onClick={() => setTab('conversations')}
          >
            💬 Conversas
          </button>
        </div>
      </div>

      {tab === 'config' && (
        <>
          {/* TEMPLATES PRONTOS */}
          <div className="card" style={{ 
            background: 'linear-gradient(135deg, rgba(168,85,247,.08), rgba(124,58,237,.04))', 
            border: '1.5px solid rgba(168,85,247,.2)', 
            borderRadius: 16,
            marginBottom: 16 
          }}>
            <div className="card-hd">
              <div>
                <div className="card-t">✨ Começar rápido</div>
                <div className="card-s">Escolha um template pronto e personalize depois</div>
              </div>
            </div>
            <div style={{ 
              display: 'grid', 
              gap: 10, 
              gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' 
            }}>
              {Object.entries(BOT_TEMPLATES).map(([key, template]) => (
                <button
                  key={key}
                  onClick={() => applyTemplate(key)}
                  className="btn btn-g"
                  style={{
                    padding: '16px 14px',
                    borderRadius: 14,
                    border: '1.5px solid var(--border)',
                    background: 'var(--bg2)',
                    textAlign: 'left',
                    transition: 'all .2s',
                    height: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.borderColor = 'var(--accent)';
                    e.currentTarget.style.background = 'var(--accent-dim)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.borderColor = 'var(--border)';
                    e.currentTarget.style.background = 'var(--bg2)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <div style={{ fontSize: 28 }}>{template.emoji}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)' }}>
                    {template.label}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--text3)', lineHeight: 1.4 }}>
                    Clique para aplicar
                  </div>
                </button>
              ))}
            </div>
          </div>

          <div className="card" style={{ marginBottom: 16 }}>
            {/*BOTIA_LAYOUT_V2*/}
            <div className="card-hd">
              <div>
                <div className="card-t">{'\uD83D\uDCF1'} Bot IA por WhatsApp</div>
                <div className="card-s">{'Escolha em quais n\u00fameros o Bot IA responde. Desligado: o rob\u00f4 ignora as mensagens daquele n\u00famero.'}</div>
              </div>
              {botInsts.length > 0 && (
                <span className="bdg b-open"><span className="d" />{botInsts.filter(x => x.enabled).length} de {botInsts.length} ligados</span>
              )}
            </div>
            {botInsts.length === 0 ? (
              <div className="empty">Nenhum WhatsApp encontrado</div>
            ) : (
              <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
                {botInsts.map(i => {
                  const d = String(i.number || '').replace(/\D/g, '');
                  const dots = '\u2022\u2022\u2022\u2022';
                  const num = d.length >= 10 ? '+' + d.slice(0, 2) + ' ' + d.slice(2, 4) + ' ' + d.slice(4, 5) + dots + d.slice(-4) : 'sem n\u00famero';
                  const busy = botInstsBusy === i.bot_id;
                  const on = !!i.enabled;
                  return (
                    <div key={i.bot_id} style={{
                      display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px',
                      border: '1.5px solid ' + (on ? 'rgba(16,185,129,.35)' : 'var(--border)'),
                      borderRadius: 14, background: 'var(--bg2)',
                      opacity: busy ? 0.6 : (on ? 1 : 0.7), transition: 'all .2s'
                    }}>
                      <div style={{
                        width: 40, height: 40, borderRadius: 11, flexShrink: 0, fontSize: 18,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: on ? 'rgba(16,185,129,.14)' : 'rgba(148,163,184,.12)'
                      }}>{'\uD83D\uDCF1'}</div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 13.5, fontWeight: 800, color: 'var(--text)' }}>
                          {String(i.bot_id).replace(/^bot/i, 'WhatsApp ')}
                        </div>
                        <div style={{ fontSize: 11.5, color: 'var(--text3)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {num} {'\u00b7'} {on ? 'Bot IA ligado' : 'Bot IA desligado'}
                        </div>
                      </div>
                      <button
                        type="button" role="switch" aria-checked={on} disabled={busy}
                        onClick={() => toggleBotInst(i.bot_id, !on)}
                        style={{
                          position: 'relative', width: 42, height: 24, borderRadius: 999, border: 'none', flexShrink: 0,
                          background: on ? '#10b981' : 'rgba(148,163,184,.35)',
                          cursor: busy ? 'wait' : 'pointer', transition: 'background .2s', padding: 0
                        }}
                      >
                        <span style={{
                          position: 'absolute', top: 3, left: on ? 21 : 3, width: 18, height: 18, borderRadius: '50%',
                          background: '#fff', transition: 'left .2s', boxShadow: '0 1px 3px rgba(0,0,0,.4)'
                        }} />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <div className="card">
            <div className="card-hd">
              <div>
                <div className="card-t">⚙️ Configuracao principal</div>
                <div className="card-s">Defina nome, produto, instrucoes e fallback</div>
              </div>
              <span className={`bdg ${config.enabled ? 'b-open' : 'b-offline'}`}>
                <span className="d" />
                {config.enabled ? 'Ativo' : 'Desativado'}
              </span>
            </div>

            {loading ? (
              <div className="empty">
                <div className="empty-ico">⏳</div>
                <div className="empty-txt">Carregando configuracao...</div>
              </div>
            ) : (
              <>
                <div className="fg">
                  <label className="fl" style={{ display: "block", fontSize: 12, fontWeight: 800, color: "#888", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.8px" }}>Status do bot</label>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <button className={`btn ${config.enabled ? 'btn-p' : 'btn-g'}`} type="button" onClick={() => updateField('enabled', true)}>
                      ✅ Ativar
                    </button>
                    <button className={`btn ${!config.enabled ? 'btn-d' : 'btn-g'}`} type="button" onClick={() => updateField('enabled', false)}>
                      ⛔ Desativar
                    </button>
                  </div>
                </div>

                <div className="fg">
                  <label className="fl" style={{ display: "block", fontSize: 12, fontWeight: 800, color: "#888", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.8px" }}>Nome do bot</label>
                  <input className="fi" value={config.bot_name} onChange={(e) => updateField('bot_name', e.target.value)} placeholder="Ex: Atendimento Mounjax" />
                </div>
                <div className="fg" style={{ border: '1px solid ' + (keyInfo.mode === 'none' ? 'rgba(255,90,90,0.5)' : 'rgba(37,211,102,0.4)'), background: keyInfo.mode === 'none' ? 'rgba(255,90,90,0.07)' : 'rgba(37,211,102,0.07)', borderRadius: 12, padding: 14 }}>
                  <label className="fl" style={{ display: 'block', fontSize: 12, fontWeight: 800, color: '#888', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.8px' }}>🔑 Chave da OpenAI</label>
                  {keyInfo.has_key ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
                      <span>✅ Conectada (termina em ••••{keyInfo.last4})</span>
                      <button className="btn btn-g" type="button" onClick={removeOpenaiKey}>Remover</button>
                    </div>
                  ) : keyInfo.mode === 'global' ? (
                    <div style={{ marginBottom: 10 }}>ℹ️ Usando a chave padrão da plataforma. Conecte a sua para usar a sua conta OpenAI.</div>
                  ) : (
                    <div style={{ marginBottom: 10 }}>⚠️ Nenhuma chave conectada. Enquanto não conectar, o bot NÃO responde as mensagens.</div>
                  )}
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <input className="fi" type="password" autoComplete="off" value={keyInput} onChange={(e) => setKeyInput(e.target.value)} placeholder="Cole sua chave aqui (sk-...)" style={{ flex: 1, minWidth: 200 }} />
                    <button className="btn btn-p" type="button" disabled={keySaving || !keyInput.trim()} onClick={saveOpenaiKey}>
                      {keySaving ? 'Testando...' : keyInfo.has_key ? 'Trocar chave' : 'Conectar'}
                    </button>
                  </div>
                  <div style={{ fontSize: 12, color: '#888', marginTop: 10, lineHeight: 1.6 }}>
                    Como pegar: entre em platform.openai.com/api-keys → Create new secret key → copie e cole acima. Depois adicione crédito em Billing (a partir de US$ 5). O gasto do bot é cobrado direto na sua conta da OpenAI.
                  </div>
                </div>

                <div className="fg">
                  <label className="fl" style={{ display: 'block', fontSize: 12, fontWeight: 800, color: '#888', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.8px' }}>Link de compra do produto</label>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <input className="fi" value={linkInput} onChange={(e) => setLinkInput(e.target.value)} placeholder="https://seusite.com/comprar" style={{ flex: 1, minWidth: 200 }} />
                    <button className="btn btn-g" type="button" onClick={saveLink}>Salvar link</button>
                  </div>
                  <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>Usado quando o cliente pergunta como pagar (PIX, cartão). O bot nunca inventa chave PIX.</div>
                </div>


                <div className="fg">
                  <label className="fl" style={{ display: "block", fontSize: 12, fontWeight: 800, color: "#888", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.8px" }}>Nome do produto</label>
                  <input className="fi" value={config.product_name} onChange={(e) => updateField('product_name', e.target.value)} placeholder="Ex: Mounjax" />
                </div>

                <div className="fg">
                  <label className="fl" style={{ display: "block", fontSize: 12, fontWeight: 800, color: "#888", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.8px" }}>Prompt base</label>
                  <textarea className="fta" value={config.base_prompt} onChange={(e) => updateField('base_prompt', e.target.value)} placeholder="Explique como o bot deve responder, o que pode falar e o que nao pode." />
                </div>

                <div className="fg">
                  <label className="fl" style={{ display: "block", fontSize: 12, fontWeight: 800, color: "#888", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.8px" }}>Mensagem de boas-vindas</label>
                  <textarea className="fta" value={config.welcome_message} onChange={(e) => updateField('welcome_message', e.target.value)} placeholder="Ex: Oi! Eu sou o assistente virtual do Mounjax..." />
                </div>

                <div className="fg">
                  <label className="fl" style={{ display: "block", fontSize: 12, fontWeight: 800, color: "#888", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.8px" }}>Mensagem fallback / humano</label>
                  <textarea className="fta" value={config.fallback_message} onChange={(e) => updateField('fallback_message', e.target.value)} placeholder="Ex: Nao consegui responder com seguranca. Vou te encaminhar para atendimento humano." />
                </div>

                <div className="fg">
                  <label className="fl" style={{ display: "block", fontSize: 12, fontWeight: 800, color: "#888", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.8px" }}>Limite diario de mensagens</label>
                  <input className="fi" type="number" min="1" value={config.max_messages_per_day} onChange={(e) => updateField('max_messages_per_day', e.target.value)} />
                </div>

                <div className="fg">
                  <label className="fl" style={{ display: "block", fontSize: 12, fontWeight: 800, color: "#888", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.8px" }}>Transferir para humano</label>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <button className={`btn ${config.human_handoff_enabled ? 'btn-p' : 'btn-g'}`} type="button" onClick={() => updateField('human_handoff_enabled', true)}>
                      👤 Ativado
                    </button>
                    <button className={`btn ${!config.human_handoff_enabled ? 'btn-d' : 'btn-g'}`} type="button" onClick={() => updateField('human_handoff_enabled', false)}>
                      🚫 Desativado
                    </button>
                  </div>
                </div>

                <div className="btn-bar" style={{ marginTop: 18 }}>
                  <button className="btn btn-p" onClick={saveConfig} disabled={saving}>
                    {saving ? '⏳ Salvando...' : '💾 Salvar configuracao'}
                  </button>
                  <button className="btn btn-g" onClick={loadBotData}>
                    🔄 Recarregar
                  </button>
                </div>
              </>
            )}
          </div>

          <div className="card">
            <div className="card-hd">
              <div>
                <div className="card-t">❓ FAQs do bot</div>
                <div className="card-s">Cadastre perguntas e respostas mais comuns</div>
              </div>
            </div>

            <div className="fg">
              <label className="fl">Pergunta</label>
              <input className="fi" value={faqQuestion} onChange={(e) => setFaqQuestion(e.target.value)} placeholder="Ex: Quais os beneficios do Mounjax?" />
            </div>

            <div className="fg">
              <label className="fl">Tipo de resposta</label>
              <div className="fq">
                <style>{FQ_CSS}</style>
                <div className="fq-seg" role="group">
                  {FQ_TIPOS.map(t => (
                    <button key={t.v} type="button" aria-pressed={faqResponseType === t.v} style={{ '--fq-tone': t.tone }} onClick={() => setFaqResponseType(t.v)}>
                      <span className="fq-dot" />{t.nome}
                    </button>
                  ))}
                </div>
                <div className="fq-note">{(FQ_TIPOS.find(t => t.v === faqResponseType) || FQ_TIPOS[0]).dica}</div>
              </div>
            </div>

            {(faqResponseType === 'text' || faqResponseType === 'text_image' || faqResponseType === 'audio' || faqResponseType === 'text_audio') && ( /*FAQ_AUDIO_V1*/
              <div className="fg">
                <label className="fl">{faqResponseType === 'audio' || faqResponseType === 'text_audio' ? 'O que você falou no áudio (escrito) — o cliente não vê, serve para o bot entender' : 'Resposta (texto)'}</label>
                <textarea className="fta" value={faqAnswer} onChange={(e) => setFaqAnswer(e.target.value)} placeholder="Digite a resposta que a IA pode usar como base." />
              </div>
            )}

            {(faqResponseType === 'audio' || faqResponseType === 'text_audio') && (
              <div className="fg">
                <label className="fl">{'\u{1f3a4} \u00c1udio gravado'}</label>
                {faqAudioPreview && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, flexWrap: 'wrap' }}>
                    <audio src={faqAudioPreview} controls style={{ height: 38 }} />
                    <button onClick={removeFaqAudio} className="btn btn-s">{'\u{1f5d1}\ufe0f Remover'}</button>
                  </div>
                )}
                <input type="file" accept="audio/*" onChange={handleFaqAudioChange} style={{ display: 'none' }} id="faq-audio-upload" />
                <label htmlFor="faq-audio-upload" className="btn btn-s" style={{ display: 'inline-block', cursor: 'pointer' }}>
                  {uploadingFaqAudio ? 'Enviando...' : faqAudioPreview || faqAudioUrl ? '\u{1f504} Trocar \u00e1udio' : '\u{1f399}\ufe0f Escolher \u00e1udio'}
                </label>
                <span style={{ marginLeft: 12, color: 'var(--text3)', fontSize: 12 }}>{'Grave no WhatsApp ou no celular e envie aqui (MP3, M4A, OGG ou WAV, at\u00e9 16MB). Ele chega como \u00e1udio de voz.'}</span>
                {faqAudioUrl && !faqAudioPreview && (
                  <div style={{ marginTop: 10 }}><audio src={'https://app.pulsend.online' + faqAudioUrl} controls style={{ height: 38 }} /></div>
                )}
              </div>
            )}
            {(faqResponseType === 'image' || faqResponseType === 'text_image') && (
              <div className="fg">
                <label className="fl">📷 Imagem ou vídeo</label>
                
                {faqImagePreview && (
                  <div style={{ position: 'relative', display: 'inline-block', marginBottom: 12 }}>
                    {/^data:video|\.(mp4|mov|m4v|webm)(\?|$)/i.test(faqImagePreview) ? <video src={faqImagePreview} controls style={{ maxWidth: 300, maxHeight: 220, borderRadius: 8, border: '1px solid var(--border)' }} /> : <img src={faqImagePreview} alt="Preview" style={{ maxWidth: 300, maxHeight: 200, borderRadius: 8, border: '1px solid var(--border)' }} />}
                    <button onClick={removeFaqImage} style={{ position: 'absolute', top: 8, right: 8, background: 'var(--red)', color: 'white', border: 'none', borderRadius: '50%', width: 28, height: 28, cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
                  </div>
                )}
                
                <input type="file" accept="image/jpeg,image/jpg,image/png,image/gif,image/webp,video/mp4,video/quicktime,video/webm" onChange={handleFaqImageChange} style={{ display: 'none' }} id="faq-image-upload" />
                <label htmlFor="faq-image-upload" className="btn btn-s" style={{ display: 'inline-block', cursor: 'pointer' }}>
                  {faqImagePreview ? '🔄 Trocar arquivo' : '📁 Escolher imagem ou vídeo'}
                </label>
                <span style={{ marginLeft: 12, color: 'var(--text3)', fontSize: 12 }}>Imagem até 5MB (JPG, PNG, GIF, WEBP) · Vídeo até 16MB (MP4)</span>
              </div>
            )}

            <div className="btn-bar">
              {editingFaqId ? (
                <>
                  <button className="btn btn-p" onClick={updateFaq} disabled={uploadingFaqImage}>
                    {uploadingFaqImage ? '📤 Enviando...' : '💾 Salvar FAQ'}
                  </button>
                  <button className="btn btn-s" onClick={cancelEdit} disabled={uploadingFaqImage}>Cancelar</button>
                </>
              ) : (
                <button className="btn btn-p" onClick={addFaq} disabled={uploadingFaqImage}>
                  {uploadingFaqImage ? '📤 Enviando...' : '➕ Adicionar FAQ'}
                </button>
              )}
            </div>

            {/* SUGESTÕES INTELIGENTES */}
            {faqSuggestions && faqSuggestions.length > 0 && (
              <div style={{ marginBottom: 20, padding: 16, background: 'rgba(255,193,7,.1)', border: '1.5px solid rgba(255,193,7,.3)', borderRadius: 12 }}>
                <div style={{ fontWeight: 700, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span>💡</span>
                  <span>Sugestões Inteligentes ({faqSuggestions.length})</span>
                </div>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12 }}>
                  O bot detectou perguntas que não entendeu. Aprove para criar FAQs automaticamente!
                </div>
                <div style={{ display: 'grid', gap: 10 }}>
                  {faqSuggestions.map((sug) => (
                    <div key={sug.id} style={{ padding: 12, background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 10 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: 10 }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 4 }}>
                            📊 {sug.occurrences}x • Confiança: {(sug.confidence * 100).toFixed(0)}%
                            {sug.original_message && ` • "${sug.original_message}"`}
                          </div>
                          <div style={{ fontWeight: 600, marginBottom: 6, color: 'var(--accent)' }}>
                            {sug.question_pattern}
                          </div>
                          <div style={{ fontSize: 13, lineHeight: 1.5 }}>
                            {sug.answer}
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button 
                            className="btn btn-p btn-sm" 
                            onClick={() => approveFaqSuggestion(sug.id)}
                            style={{ borderRadius: 8 }}
                          >
                            ✓
                          </button>
                          <button 
                            className="btn btn-g btn-sm" 
                            onClick={() => rejectFaqSuggestion(sug.id)}
                            style={{ borderRadius: 8 }}
                          >
                            ✕
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="fq">
            {faqs.length === 0 ? (
              <div className="fq-empty">
                <p>Nenhuma pergunta cadastrada.</p>
                <p>Comece pelas que mais chegam: prazo de entrega, forma de pagamento, link do grupo.</p>
              </div>
            ) : (
              <div>
                <div className="fq-bar">
                  <div className="fq-find">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" strokeLinecap="round" /></svg>
                    <input type="search" name="busca-faq" autoComplete="off" placeholder="Buscar por gatilho ou resposta" value={faqSearch} onChange={(e) => setFaqSearch(e.target.value)} />
                  </div>
                  <span className="fq-count">{fqFiltradas.length === faqs.length ? faqs.length + ' perguntas' : fqFiltradas.length + ' de ' + faqs.length}</span>
                </div>
                {fqFiltradas.length === 0 ? (
                  <div className="fq-empty"><p>{'Nada encontrado para \u201c' + faqSearch + '\u201d.'}</p></div>
                ) : (
                <div className="fq-list">
                {fqFiltradas.map((faq) => {
                  const t = FQ_TIPOS.find(x => x.v === (faq.response_type || 'text')) || FQ_TIPOS[0];
                  const gat = String(faq.question || '').split('|').map(x => x.trim()).filter(Boolean);
                  const aberto = expandedFaq === faq.id;
                  const vis = aberto ? gat : gat.slice(0, 5);
                  const voz = faq.response_type === 'audio' || faq.response_type === 'text_audio';
                  return (
                  <div key={faq.id} className="fq-card" style={{ '--fq-tone': t.tone, '--fq-soft': t.soft }}>
                    <div className="fq-top">
                      <span className="fq-cue">{'Quando escreverem \u2192 o bot responde '}<b>{t.resumo}</b></span>
                      <span className="fq-acts">
                        <button type="button" className="fq-edit" onClick={() => editFaq(faq)}>{'\u270f\ufe0f Editar'}</button>
                        <button type="button" className="fq-del" onClick={() => deleteFaq(faq.id)}>{'\u{1f5d1}\ufe0f Excluir'}</button>
                      </span>
                    </div>
                    <div className="fq-chips">
                      {vis.map((g, ix) => <span key={ix} className="fq-chip">{g}</span>)}
                      {gat.length > 5 && <button type="button" className="fq-more" onClick={() => setExpandedFaq(aberto ? null : faq.id)}>{aberto ? 'ver menos' : '+' + (gat.length - 5)}</button>}
                    </div>
                    <div className="fq-reply">
                      <div className="fq-bub" onClick={() => setExpandedFaq(aberto ? null : faq.id)}>
                        {voz ? (
                          <div className="fq-voice">
                            <span className="fq-play"><svg width="10" height="12" viewBox="0 0 10 12" fill="currentColor"><path d="M0 0l10 6-10 6z" /></svg></span>
                            <span className="fq-wave">{fqOndas(faq.id).map((h, ix) => <i key={ix} style={{ height: h + '%' }} />)}</span>
                            <span style={{ fontSize: 11, opacity: .7 }}>{faq.audio_url ? '0:12' : 'sem \u00e1udio'}</span>
                          </div>
                        ) : null}
                        {faq.image_url && (faq.response_type === 'image' || faq.response_type === 'text_image') && (
                          <img className="fq-thumb" src={'https://app.pulsend.online' + String(faq.image_url).split(',')[0]} alt="" />
                        )}
                        {(!voz || faq.response_type === 'text_audio') && faq.answer && (
                          <div className={aberto ? '' : 'fq-clamp'} style={voz ? { marginTop: 8 } : null}>{faq.answer}</div>
                        )}
                        <span className="fq-time">{'14:32 \u2713\u2713'}</span>
                      </div>
                    </div>
                  </div>
                  );
                })}
                </div>
                )}
              </div>
            )}
            </div>
          </div>

          <div className="card">
            <div className="card-hd">
              <div>
                <div className="card-t">🧪 Testar IA</div>
                <div className="card-s">Faça um teste antes de ativar para producao</div>
              </div>
            </div>

            <div className="fg">
              <label className="fl">Mensagem de teste</label>
              <textarea className="fta" value={testMessage} onChange={(e) => setTestMessage(e.target.value)} placeholder="Digite a pergunta que um lead faria no privado." />
            </div>

            <div className="btn-bar">
              <button className="btn btn-o" onClick={testPrompt} disabled={testing}>
                {testing ? '⏳ Testando...' : '🤖 Testar resposta'}
              </button>
            </div>

            {testReply ? (
              <div
                style={{
                  marginTop: 10,
                  padding: 14,
                  borderRadius: 12,
                  border: '1.5px solid rgba(0,208,132,.25)',
                  background: 'rgba(0,208,132,.08)',
                  lineHeight: 1.7,
                  color: 'var(--text)'
                }}
              >
                {testReply}
              </div>
            ) : null}
          </div>
        </>
      )}

      {tab === 'conversations' && (
        <div>
          {/* MÉTRICAS */}
          <div style={{ display: 'grid', gap: 10, gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', marginBottom: 16 }}>
            <div className="card" style={{ padding: '14px 16px', borderRadius: 14 }}>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 4, fontWeight: 700 }}>TOTAL</div>
              <div style={{ fontSize: 26, fontWeight: 800, color: 'var(--text)' }}>{conversations.length}</div>
            </div>
            <div className="card" style={{ padding: '14px 16px', borderRadius: 14 }}>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 4, fontWeight: 700 }}>BOT</div>
              <div style={{ fontSize: 26, fontWeight: 800, color: 'var(--accent)' }}>
                {conversations.filter(c => c.status !== 'human').length}
              </div>
            </div>
            <div className="card" style={{ padding: '14px 16px', borderRadius: 14 }}>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 4, fontWeight: 700 }}>HUMANO</div>
              <div style={{ fontSize: 26, fontWeight: 800, color: 'var(--blue)' }}>
                {conversations.filter(c => c.status === 'human').length}
              </div>
            </div>
          </div>

          {/* FILTROS */}
          <div className="card" style={{ marginBottom: 16, padding: 6, borderRadius: 14 }}>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {['all', 'bot', 'human'].map(f => (
                <button
                  key={f}
                  onClick={() => setConvoFilter(f)}
                  className="btn btn-sm"
                  style={{
                    flex: '1 1 auto',
                    minWidth: 80,
                    background: convoFilter === f ? 'var(--accent)' : 'transparent',
                    color: convoFilter === f ? '#000' : 'var(--text2)',
                    border: convoFilter === f ? 'none' : '1.5px solid var(--border)',
                    fontWeight: convoFilter === f ? 800 : 600,
                    borderRadius: 10
                  }}
                >
                  {f === 'all' ? '📋 Todas' : f === 'bot' ? '🤖 Bot' : '👤 Humano'}
                </button>
              ))}
              <button onClick={loadConversations} className="btn btn-g btn-sm" style={{ borderRadius: 10 }}>
                🔄
              </button>
            </div>
          </div>

          {/* LISTA */}
<div className="card" style={{ padding: 0, overflow: 'hidden' }}>
<style>{`
.pc-wrap{display:grid;grid-template-columns:340px 1fr;height:calc(100vh - 300px);min-height:520px;max-height:820px}
.pc-list{border-right:1.5px solid var(--border);display:flex;flex-direction:column;min-height:0;background:var(--bg2)}
.pc-search{padding:12px;border-bottom:1.5px solid var(--border)}
.pc-search input{width:100%;box-sizing:border-box;padding:10px 14px;border-radius:12px;border:1.5px solid var(--border);background:var(--bg3);color:var(--text);outline:none;font-size:13px}
.pc-search input:focus{border-color:var(--accent)}
.pc-cnt{font-size:11px;color:var(--text3);margin-top:8px;padding-left:2px}
.pc-items{overflow-y:auto;flex:1}
.pc-item{display:flex;gap:12px;padding:12px 14px;cursor:pointer;border-bottom:1px solid var(--border);border-left:3px solid transparent;transition:background .15s}
.pc-item:hover{background:var(--bg3)}
.pc-item.act{background:var(--bg3);border-left-color:var(--accent)}
.pc-meta{min-width:0;flex:1}
.pc-top,.pc-bot{display:flex;align-items:center;gap:8px}
.pc-top{justify-content:space-between}
.pc-name{font-weight:600;font-size:14px;color:var(--text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pc-name.un{font-weight:800}
.pc-tm{font-size:11px;color:var(--text3);flex-shrink:0}
.pc-tm.un{color:var(--accent);font-weight:700}
.pc-bot{margin-top:3px}
.pc-prev{font-size:12.5px;color:var(--text2);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex:1}
.pc-tag{font-size:12px;flex-shrink:0}
.pc-dot{width:10px;height:10px;border-radius:50%;background:var(--accent);flex-shrink:0}
.pc-empty{padding:40px 20px;text-align:center;color:var(--text3);font-size:13px}
.pc-chat{display:flex;flex-direction:column;min-height:0;background:var(--bg, var(--bg2))}
.pc-inner{display:flex;flex-direction:column;flex:1;min-height:0}
.pc-none{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;color:var(--text3);gap:6px;text-align:center;padding:20px}
.pc-head{display:flex;align-items:center;gap:12px;padding:12px 16px;border-bottom:1.5px solid var(--border);background:var(--bg3)}
.pc-back{display:none;background:transparent;border:none;color:var(--text);font-size:22px;cursor:pointer;padding:0 6px 0 0}
.pc-hn{min-width:0;flex:1}
.pc-hn b{display:block;font-size:15px;color:var(--text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pc-hn span{font-size:12px;color:var(--text3)}
.pc-chip{font-size:11px;font-weight:700;padding:4px 10px;border-radius:20px;white-space:nowrap}
.pc-chip.bo{background:rgba(16,185,129,.15);color:#10b981}
.pc-chip.hu{background:rgba(59,130,246,.18);color:#60a5fa}
.pc-msgs{flex:1;overflow-y:auto;padding:16px 18px;display:flex;flex-direction:column;gap:6px}
.pc-day{text-align:center;margin:10px 0 6px}
.pc-day span{font-size:11px;color:var(--text3);background:var(--bg3);border:1px solid var(--border);padding:3px 12px;border-radius:20px}
.pc-row{display:flex}
.pc-row.out{justify-content:flex-end}
.pc-bub{max-width:min(78%,520px);padding:8px 12px 6px;border-radius:14px;font-size:14px;line-height:1.5;color:var(--text);box-shadow:0 1px 2px rgba(0,0,0,.2)}
.pc-bub.cli{background:var(--bg3);border:1px solid var(--border);border-top-left-radius:4px}
.pc-bub.bot{background:rgba(16,185,129,.16);border:1px solid rgba(16,185,129,.35);border-top-right-radius:4px}
.pc-bub.human{background:rgba(59,130,246,.2);border:1px solid rgba(59,130,246,.4);border-top-right-radius:4px}
.pc-who{font-size:10.5px;font-weight:700;opacity:.75;margin-bottom:2px}
.pc-txt{white-space:pre-wrap;word-break:break-word}
.pc-time{font-size:10.5px;opacity:.6;text-align:right;margin-top:2px}
.pc-comp{border-top:1.5px solid var(--border);background:var(--bg3);padding:10px 14px}
.pc-hint{font-size:11.5px;color:var(--text3);margin-bottom:8px}
.pc-cr{display:flex;gap:10px;align-items:flex-end}
.pc-cr textarea{flex:1;resize:none;max-height:120px;padding:11px 14px;border-radius:14px;border:1.5px solid var(--border);background:var(--bg2);color:var(--text);outline:none;font-size:14px;font-family:inherit;line-height:1.4}
.pc-cr textarea:focus{border-color:var(--accent)}
.pc-send{border:none;border-radius:14px;padding:12px 18px;font-weight:800;background:var(--accent);color:#000;cursor:pointer;font-size:14px}
.pc-send:disabled{opacity:.5;cursor:not-allowed}
.pc-img{display:block;max-width:100%;max-height:300px;border-radius:10px;margin-bottom:4px;object-fit:cover}
.pc-file{display:flex;gap:8px;align-items:center;padding:10px 12px;border-radius:10px;background:rgba(0,0,0,.18);color:inherit;text-decoration:none;font-size:13px;word-break:break-all;margin-bottom:4px}
.pc-pv{display:flex;align-items:center;gap:10px;padding:8px 10px;border:1.5px solid var(--border);border-radius:12px;background:var(--bg2);margin-bottom:8px}
.pc-pv img{width:48px;height:48px;object-fit:cover;border-radius:8px}
.pc-clip{border:none;background:transparent;font-size:22px;cursor:pointer;padding:8px;color:var(--text2);line-height:1}
.pc-clip:hover{color:var(--accent)}
@media (max-width:820px){
.pc-wrap{grid-template-columns:1fr;height:calc(100vh - 220px)}
.pc-wrap.pc-open .pc-list{display:none}
.pc-wrap:not(.pc-open) .pc-chat{display:none}
.pc-back{display:block}
.pc-list{border-right:none}
}
`}</style>
{(() => {
  const toDate = (v) => { if (!v) return null; const t = String(v); const iso = /[zZ]$|[+-]\d\d:?\d\d$/.test(t) ? t : t.replace(' ', 'T') + 'Z'; const d = new Date(iso); return isNaN(d.getTime()) ? null : d; };
  const hm = (v) => { const d = toDate(v); return d ? d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : ''; };
  const sameDay = (a, b) => a.toDateString() === b.toDateString();
  const dayLabel = (v) => { const d = toDate(v); if (!d) return ''; const n = new Date(); const y = new Date(); y.setDate(n.getDate() - 1); if (sameDay(d, n)) return 'Hoje'; if (sameDay(d, y)) return 'Ontem'; return d.toLocaleDateString('pt-BR'); };
  const listTime = (v) => { const d = toDate(v); if (!d) return ''; const n = new Date(); const y = new Date(); y.setDate(n.getDate() - 1); if (sameDay(d, n)) return hm(v); if (sameDay(d, y)) return 'Ontem'; return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }); };
  const linkify = (txt) => String(txt || '').split(/(https?:\/\/[^\s]+)/g).map((p, i) => /^https?:\/\//.test(p) ? <a key={i} href={p} target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'underline', wordBreak: 'break-all' }}>{p}</a> : <span key={i}>{p}</span>);
  const palette = ['#10b981', '#3b82f6', '#a855f7', '#f59e0b', '#ef4444', '#14b8a6', '#ec4899', '#6366f1'];
  const avatar = (c, size) => {
    const nm = String(c.contact_name || c.contact_number || '?').trim();
    const h = String(c.contact_number || '').split('').reduce((a, ch) => a + ch.charCodeAt(0), 0);
    const ini = <div style={{ width: size, height: size, borderRadius: '50%', background: palette[h % palette.length], color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: Math.round(size * 0.42) }}>{nm.charAt(0).toUpperCase()}</div>;
    return <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>{ini}{c.photo_url && <img src={c.photo_url} alt="" referrerPolicy="no-referrer" onError={(e) => { e.currentTarget.style.display = 'none'; }} style={{ position: 'absolute', top: 0, left: 0, width: size, height: size, borderRadius: '50%', objectFit: 'cover' }} />}</div>;
  };
  const q = pcSearch.trim().toLowerCase();
  const filtered = conversations.filter(c => {
    if (convoFilter === 'bot') return c.status !== 'human';
    if (convoFilter === 'human') return c.status === 'human';
    return true;
  }).filter(c => !q || String(c.contact_name || '').toLowerCase().includes(q) || String(c.contact_number || '').includes(q) || String(c.last_message || '').toLowerCase().includes(q));
  const sel = selectedConversation;
  const msgs = conversationMessages || [];
  let lastKey = '';
  return (
    <div className={'pc-wrap' + (sel ? ' pc-open' : '')}>
      <div className="pc-list">
        <div className="pc-search">
          <input value={pcSearch} onChange={e => setPcSearch(e.target.value)} placeholder="🔎 Buscar nome, número ou mensagem" />
          <div className="pc-cnt">{filtered.length} conversa{filtered.length === 1 ? '' : 's'}</div>
        </div>
        <div className="pc-items">
          {filtered.length === 0 ? (<div className="pc-empty">Nenhuma conversa encontrada</div>) : filtered.map(c => {
            const act = sel && sel.id === c.id;
            const unread = c.last_direction === 'in' && pcSeen[c.id] !== (c.last_message_at || '') && !act;
            return (
              <div key={c.id} className={'pc-item' + (act ? ' act' : '')} onClick={() => pcOpen(c)}>
                {avatar(c, 46)}
                <div className="pc-meta">
                  <div className="pc-top">
                    <span className={'pc-name' + (unread ? ' un' : '')}>{c.contact_name || c.contact_number}</span>
                    <span className={'pc-tm' + (unread ? ' un' : '')}>{listTime(c.last_message_at || c.updated_at || c.created_at)}</span>
                  </div>
                  <div className="pc-bot">
                    <span className="pc-prev">{c.last_direction === 'out' ? '✓ ' : ''}{c.last_message || ''}</span>
                    <span className="pc-tag">{c.status === 'human' ? '👤' : '🤖'}</span>
                    {unread && <span className="pc-dot" />}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="pc-chat">
        {!sel ? (
          <div className="pc-none">
            <div style={{ fontSize: 56 }}>💬</div>
            <div style={{ fontWeight: 700, color: 'var(--text2)', fontSize: 16 }}>Selecione uma conversa</div>
            <div style={{ fontSize: 13 }}>Veja o histórico e responda seus clientes por aqui</div>
          </div>
        ) : (
          <div className="pc-inner">
            <div className="pc-head">
              <button className="pc-back" onClick={() => setSelectedConversation(null)}>←</button>
              {avatar(sel, 42)}
              <div className="pc-hn"><b>{sel.contact_name || sel.contact_number}</b><span>{sel.contact_number}</span></div>
              <span className={'pc-chip ' + (sel.status === 'human' ? 'hu' : 'bo')}>{sel.status === 'human' ? '👤 Você atendendo' : '🤖 Robô atendendo'}</span>
              {sel.status === 'human' ? (
                <button className="btn btn-p btn-sm" onClick={() => setBotMode(sel.id)}>🤖 Devolver ao robô</button>
              ) : (
                <button className="btn btn-d btn-sm" onClick={() => setHumanMode(sel.id)}>👤 Assumir</button>
              )}
            </div>
            <div className="pc-msgs" ref={pcBoxRef}>
              {msgs.length === 0 && <div className="pc-empty">Sem mensagens ainda</div>}
              {msgs.map((m, i) => {
                const d = toDate(m.created_at);
                const key = d ? d.toDateString() : '';
                const showDay = key !== lastKey; lastKey = key;
                const out = m.direction === 'out';
                const human = out && m.model === 'human';
                return (
                  <div key={m.id || i}>
                    {showDay && <div className="pc-day"><span>{dayLabel(m.created_at)}</span></div>}
                    <div className={'pc-row ' + (out ? 'out' : 'in')}>
                      <div className={'pc-bub ' + (out ? (human ? 'human' : 'bot') : 'cli')}>
                        {out && <div className="pc-who">{human ? '👤 Você' : '🤖 Robô'}</div>}
                        {m.media_file && m.media_type === 'image' && <a href={m.media_file} target="_blank" rel="noreferrer"><img src={m.media_file} alt="" className="pc-img" /></a>}
                        {m.media_file && m.media_type === 'video' && <video src={m.media_file} controls preload="metadata" className="pc-img" />}
                        {m.media_file && m.media_type === 'document' && <a href={m.media_file} target="_blank" rel="noreferrer" className="pc-file">📄 <span>{m.media_name || 'arquivo'}</span></a>}
                        {(!m.media_file || (m.message_text && !/^(📷 Imagem|🎬 Vídeo|📎 )/.test(m.message_text))) && <div className="pc-txt">{linkify(m.message_text)}</div>}
                        <div className="pc-time">{hm(m.created_at)}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="pc-comp">
              {sel.status !== 'human' && <div className="pc-hint">🤖 O robô está atendendo. Ao enviar sua mensagem, você assume e o robô pausa nesta conversa.</div>}
              {pcFile && (
                <div className="pc-pv">
                  {pcPrevUrl ? <img src={pcPrevUrl} alt="" /> : <div style={{ fontSize: 30 }}>{/^video\//.test(pcFile.type) ? '🎬' : '📄'}</div>}
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{pcFile.name}</div>
                    <div style={{ fontSize: 11.5, color: 'var(--text3)' }}>{(pcFile.size / 1024 / 1024).toFixed(2)} MB · o texto abaixo vai como legenda</div>
                  </div>
                  <button className="pc-clip" title="Remover anexo" onClick={pcClearFile}>✕</button>
                </div>
              )}
              <div className="pc-cr">
                <input type="file" ref={pcFileRef} style={{ display: 'none' }} accept=".jpg,.jpeg,.png,.webp,.mp4,.m4v,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.zip,.rar,.odt,.ods,.gif,.mov,.webm" onChange={e => { pcPick(e.target.files && e.target.files[0]); }} />
                <button className="pc-clip" title="Anexar imagem, vídeo ou arquivo" onClick={() => pcFileRef.current && pcFileRef.current.click()}><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" /></svg></button>
                <textarea rows={2} value={messageText} onChange={e => setMessageText(e.target.value)} onPaste={e => { const fl = Array.from((e.clipboardData && e.clipboardData.files) || []); if (fl.length) { e.preventDefault(); pcPick(fl[0]); } }} placeholder="Digite sua resposta… (Enter envia, Shift+Enter quebra a linha)"
                  onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); pcSend(); } }} />
                <button className="pc-send" disabled={sendingMessage || (!(messageText || '').trim() && !pcFile)} onClick={pcSend}>{sendingMessage ? '...' : 'Enviar ➤'}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
})()}

{/* CHAT AO VIVO - MODAL */}
            {false && selectedConversation && (
              <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0,0,0,0.7)',
                backdropFilter: 'blur(4px)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                overflow: 'auto'
              }}>
                <div style={{
                  width: '100%',
                  maxWidth: 700,
                  maxHeight: '90vh',
                  margin: 'auto',
                  borderRadius: 16,
                  border: '1.5px solid var(--border)',
                  background: 'var(--bg2)',
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                {/* HEADER */}
                <div style={{ padding: '14px 18px', borderBottom: '1.5px solid var(--border)', background: 'var(--bg3)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 15 }}>
                      {selectedConversation.contact_name || 'Sem nome'}
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--text3)', fontFamily: 'JetBrains Mono, monospace' }}>
                      {selectedConversation.contact_number}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    {selectedConversation.status === 'human' ? (
                      <button className="btn btn-p btn-sm" onClick={() => setBotMode(selectedConversation.id)} style={{ borderRadius: 10 }}>🤖 Reativar</button>
                    ) : (
                      <button className="btn btn-o btn-sm" onClick={() => setHumanMode(selectedConversation.id)} style={{ borderRadius: 10 }}>👤 Assumir</button>
                    )}
                    <button className="btn btn-g btn-sm" onClick={() => setSelectedConversation(null)} style={{ borderRadius: 10 }}>✕ Fechar</button>
                  </div>
                </div>

                {/* MENSAGENS */}
                <div style={{ 
                  padding: 14, 
                  flex: 1,
                  overflowY: 'auto', 
                  display: 'grid', 
                  gap: 10,
                  minHeight: 200
                }}>
                  {conversationMessages.map((m) => (
                    <div key={m.id} style={{ maxWidth: '85%', padding: '10px 12px', borderRadius: 12, background: m.direction === 'out' ? 'rgba(0,208,132,.12)' : 'var(--bg3)', border: '1.5px solid var(--border)', lineHeight: 1.6, justifySelf: m.direction === 'out' ? 'end' : 'start' }}>
                      <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 4 }}>
                        {m.direction === 'out' ? 'Você/Bot' : 'Lead'} • {m.created_at}
                      </div>
                      <div>{m.message_text}</div>
                    </div>
                  ))}
                  <div ref={messagesEndRef} />
                </div>

                {/* CAMPO ENVIO */}
                {selectedConversation.status === 'human' && (
                  <div style={{ padding: 14, borderTop: '1.5px solid var(--border)', background: 'var(--bg3)' }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <input
                        className="fi"
                        value={messageText}
                        onChange={(e) => setMessageText(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && sendHumanMessage()}
                        placeholder="Digite sua mensagem..."
                        style={{ flex: 1, borderRadius: 10 }}
                        disabled={sendingMessage}
                      />
                      <button
                        className="btn btn-p"
                        onClick={sendHumanMessage}
                        disabled={sendingMessage || !messageText.trim()}
                        style={{ borderRadius: 10, minWidth: 100 }}
                      >
                        {sendingMessage ? '⏳' : '📤 Enviar'}
                      </button>
                    </div>
                    <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 8 }}>
                      💡 Enter para enviar
                    </div>
                  </div>
                )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ── CLIENT PANEL ──────────────────────────────────────────────────────────
function BotSelector({ bots, value, onChange, botNumbers, botStatuses }) {
  const [open, setOpen] = React.useState(false);
  const sel = bots.find(b => b.id === value) || bots[0];
  const num = botNumbers && botNumbers[value];
  const isOn = (botStatuses && botStatuses[value]) || !!num;
  return (
    <div style={{ position: 'relative', marginBottom: 14, zIndex: open ? 1000 : 'auto' }} className="bot-sel-mobile">
      <div onClick={() => setOpen(o => !o)}
        style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px', background: 'var(--bg2)', border: '1.5px solid ' + (open ? 'var(--accent)' : 'var(--border2)'), borderRadius: 'var(--r)', cursor: 'pointer', boxShadow: open ? '0 0 0 3px var(--accent-glow)' : '0 2px 12px rgba(0,0,0,.15)', transition: 'all .15s', userSelect: 'none' }}>
        <div style={{ width: 10, height: 10, borderRadius: '50%', background: isOn ? 'var(--accent)' : 'var(--red)', flexShrink: 0, boxShadow: isOn ? '0 0 6px var(--accent-glow)' : 'none' }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text)' }}>📱 {sel?.label}</div>
          {num && <div style={{ fontSize: 11, color: 'var(--accent)', fontFamily: 'JetBrains Mono,monospace', marginTop: 1 }}>+{num.replace(/^(\d{2})(\d{2})(\d+)/, '$1 ($2) $3')}</div>}
          {!num && <div style={{ fontSize: 11, color: isOn ? 'var(--accent)' : 'var(--text3)', marginTop: 1 }}>{isOn ? 'Conectado' : 'Desconectado'}</div>}
        </div>
        <span style={{ color: 'var(--accent)', fontSize: 18, transition: 'transform .2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)', display: 'inline-block' }}>▾</span>
      </div>
      {open && (
        <div style={{ position: 'absolute', top: 'calc(100% + 6px)', left: 0, right: 0, background: 'var(--bg2)', border: '1.5px solid var(--border2)', borderRadius: 'var(--r)', boxShadow: '0 12px 40px rgba(0,0,0,.6)', zIndex: 1001, maxHeight: 320, overflowY: 'auto' }}>
          {bots.map((b, i) => {
            const n = botNumbers && botNumbers[b.id];
            const isSel = b.id === value;
            return (
              <div key={b.id} onClick={() => { onChange(b.id); setOpen(false); }}
                style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '13px 16px', cursor: 'pointer', background: isSel ? 'var(--accent-dim)' : 'transparent', borderBottom: i < bots.length - 1 ? '1px solid var(--border)' : 'none', transition: 'background .1s' }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: ((botStatuses && botStatuses[b.id]) || !!n) ? 'var(--accent)' : 'var(--red)', flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: isSel ? 700 : 500, color: isSel ? 'var(--accent)' : 'var(--text)' }}>📱 {b.label}</div>
                  {n && <div style={{ fontSize: 11, color: 'var(--text3)', fontFamily: 'JetBrains Mono,monospace', marginTop: 1 }}>+{n.replace(/^(\d{2})(\d{2})(\d+)/, '$1 ($2) $3')}</div>}
                  {!n && <div style={{ fontSize: 11, color: (botStatuses && botStatuses[b.id]) ? 'var(--accent)' : 'var(--text3)', marginTop: 1 }}>{(botStatuses && botStatuses[b.id]) ? 'Conectado' : 'Desconectado'}</div>}
                </div>
                {isSel && <span style={{ color: 'var(--accent)', fontSize: 16 }}>✓</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}


// ============================================================
// PÁGINA DE VENDAS — Relatório + Integrações
// ============================================================
function SalesPage({ show, botNumbers, botStatuses, userPlan }) {
  const [tab, setTab] = React.useState('report');
  const [sales, setSales] = React.useState([]);
  const [totals, setTotals] = React.useState({ total_sales: 0, total_amount: 0, total_commission: 0, braip_amount: 0, monetizze_amount: 0 });
  const [loading, setLoading] = React.useState(false);
  const [webhookInfo, setWebhookInfo] = React.useState(null);
  const [filters, setFilters] = React.useState(() => { const localDate = (dt) => { const y = dt.getFullYear(); const m = String(dt.getMonth()+1).padStart(2,'0'); const dd = String(dt.getDate()).padStart(2,'0'); return y+'-'+m+'-'+dd; }; const today = localDate(new Date()); return { platform: 'all', from: today, to: today, _period: 'today' }; });
  const [adSpend, setAdSpend] = React.useState('');
  const [copied, setCopied] = React.useState('');
  const [shopeeInfo, setShopeeInfo] = React.useState({ has_key: false, app_id: '', last4: null });
  const [shopeeAppIdInput, setShopeeAppIdInput] = React.useState('');
  const [shopeeSecretInput, setShopeeSecretInput] = React.useState('');
  const [shopeeSaving, setShopeeSaving] = React.useState(false);
  const [shopeeSaved, setShopeeSaved] = React.useState(false);

  // Pós-venda
  const [pvConfig, setPvConfig] = React.useState({ enabled: 0, bot_id: 'bot1' });
  const [pvMessages, setPvMessages] = React.useState([]);
  const [pvSaving, setPvSaving] = React.useState(false);
  const [pvSaved, setPvSaved] = React.useState(false);

  // Notificação WhatsApp
  const [notifyPhone, setNotifyPhone] = React.useState('');
  const [notifyPhoneSaving, setNotifyPhoneSaving] = React.useState(false);
  const [notifyPhoneSaved, setNotifyPhoneSaved] = React.useState(false);

  const saveNotifyPhone = async () => {
    setNotifyPhoneSaving(true);
    try {
      const tk = localStorage.getItem('zs_token');
      const r = await fetch('https://app.pulsend.online/api/user/settings', {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${tk}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ delay_min: 60, delay_max: 120, notify_phone: notifyPhone })
      }).then(x => x.json());
      if (r.ok) {
        setNotifyPhone(r.notify_phone || notifyPhone);
        setNotifyPhoneSaved(true);
        setTimeout(() => setNotifyPhoneSaved(false), 3000);
      }
    } catch(e) { console.error(e); }
    setNotifyPhoneSaving(false);
  };

  const loadPosVenda = React.useCallback(async () => {
    try {
      const r = await apiFetch('/pos-venda/config');
      if (r.ok) {
        setPvConfig(r.config || { enabled: 0, bot_id: 'bot1' });
        setPvMessages(r.messages || []);
      }
    } catch(e) {}
  }, []);

  const savePosVenda = async () => {
    setPvSaving(true);
    try {
      await apiFetch('/pos-venda/config', {
        method: 'POST',
        body: JSON.stringify({ config: pvConfig, messages: pvMessages })
      });
      setPvSaved(true);
      setTimeout(() => setPvSaved(false), 2000);
    } catch(e) {}
    setPvSaving(false);
  };

  const addPvMessage = () => {
    setPvMessages(prev => [...prev, { id: Date.now(), type: 'text', message: '', image_url: '', delay_seconds: 3, active: 1, order_idx: prev.length }]);
  };

  const updatePvMessage = (id, field, value) => {
    setPvMessages(prev => prev.map(m => m.id === id ? { ...m, [field]: value } : m));
  };

  const removePvMessage = (id) => {
    setPvMessages(prev => prev.filter(m => m.id !== id));
  };

  const uploadPvImage = async (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    try {
      const r = await fetch('/pos-venda/upload', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      const data = await r.json();
      if (data.ok) updatePvMessage(id, 'image_url', data.url);
    } catch(e) {}
  };

  const token = localStorage.getItem('zs_token');
  const apiBase = '';

  const apiFetch = async (path, opts = {}) => {
    const r = await fetch(apiBase + path, {
      ...opts,
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json', ...(opts.headers || {}) }
    });
    return r.json();
  };

  const loadReport = React.useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.platform !== 'all') params.set('platform', filters.platform);
      if (filters.from) params.set('from', filters.from);
      if (filters.to) params.set('to', filters.to);
      const data = await apiFetch(`/sales/report?${params}`);
      if (data.ok) {
        setSales(data.sales || []);
        setTotals(data.totals || {});
      }
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [filters]);

  const [generatingToken, setGeneratingToken] = React.useState(false);
  const [tokenGenerated, setTokenGenerated] = React.useState(false);

  const loadWebhookInfo = React.useCallback(async () => {
    try {
      const data = await apiFetch('/sales/webhook-info');
      if (data.ok) setWebhookInfo(data);
    } catch (e) { console.error(e); }
  }, []);

  const loadShopeeInfo = React.useCallback(async () => {
    try {
      const data = await apiFetch('/integrations/shopee');
      if (data.ok) { setShopeeInfo(data); setShopeeAppIdInput(data.app_id || ''); }
    } catch (e) { console.error(e); }
  }, []);

  const saveShopee = async () => {
    if (!shopeeAppIdInput.trim() || !shopeeSecretInput.trim()) return;
    setShopeeSaving(true);
    try {
      const data = await apiFetch('/integrations/shopee', { method: 'POST', body: JSON.stringify({ app_id: shopeeAppIdInput.trim(), secret: shopeeSecretInput.trim() }) });
      if (data.ok) {
        setShopeeSecretInput('');
        setShopeeSaved(true);
        setTimeout(() => setShopeeSaved(false), 3000);
        loadShopeeInfo();
      }
    } catch (e) { console.error(e); }
    setShopeeSaving(false);
  };

  const removeShopee = async () => {
    try {
      await apiFetch('/integrations/shopee', { method: 'DELETE' });
      setShopeeInfo({ has_key: false, app_id: '', last4: null });
      setShopeeAppIdInput('');
    } catch (e) { console.error(e); }
  };

  const generateToken = async () => {
    setGeneratingToken(true);
    try {
      const data = await apiFetch('/sales/generate-token', { method: 'POST' });
      if (data.ok) {
        setTokenGenerated(true);
        setTimeout(() => setTokenGenerated(false), 3000);
        loadWebhookInfo();
      }
    } catch (e) { console.error(e); }
    setGeneratingToken(false);
  };

  React.useEffect(() => {
    if (tab === 'integrations') {
      loadWebhookInfo();
      loadShopeeInfo();
      const tk2 = localStorage.getItem('zs_token');
      fetch('https://app.pulsend.online/api/user/settings', { headers: { 'Authorization': `Bearer ${tk2}` } })
        .then(x => x.json()).then(d => { if (d.notify_phone != null) setNotifyPhone(d.notify_phone); }).catch(()=>{});
    }
    if (tab === 'posvenda') loadPosVenda();
  }, [tab]);

  React.useEffect(() => {
    if (tab === 'report') loadReport();
  }, [tab, filters]);

  const copyUrl = (text, key) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(key);
      setTimeout(() => setCopied(''), 2000);
    });
  };

  const fmtBRL = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const fmtDate = (s) => { if (!s) return '-'; const [y,m,d] = s.split('-'); return d+'/'+m+'/'+y; };

  const statusColor = (s) => {
    const sl = String(s).toLowerCase();
    if (['aprovado','aprovada','pago','paga','paid','completed'].includes(sl)) return '#10b981';
    if (['reembolso','refund','cancelado'].includes(sl)) return '#ef4444';
    return '#f59e0b';
  };

  const platformBadge = (p) => ({
    braip: { label: 'Braip', color: '#a855f7' },
    monetizze: { label: 'Monetizze', color: '#1e40af' },
  })[p] || { label: p, color: '#64748b' };

  const cardStyle = (color) => ({
    background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 16,
    padding: '18px 22px', position: 'relative', overflow: 'hidden',
    borderLeft: `4px solid ${color}`,
    boxShadow: 'var(--card-shadow)',
    transition: 'all .25s cubic-bezier(.22,1,.36,1)',
  });

  return (
    <div className="fade-up">
      <style>{`
        .sales-cards-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 20px; }
        .sales-filters-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); gap: 10px; align-items: end; margin-bottom: 16px; }
        .sales-list { display: flex; flex-direction: column; gap: 10px; }
        .sale-card { background: var(--bg2); border: 1.5px solid var(--border); border-radius: 16px; padding: 16px 20px; transition: all .2s cubic-bezier(.22,1,.36,1); }
        .sale-card:hover { border-color: var(--border2); box-shadow: 0 4px 20px rgba(0,0,0,.15); transform: translateY(-1px); }
        .sale-card-header { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
        .sale-card-values { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 6px; }
        @media (max-width: 768px) {
          .sales-cards-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .sales-filters-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 480px) {
          .sales-cards-grid { grid-template-columns: 1fr !important; }
          .sales-filters-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
      <div className="ph" style={{ marginBottom: 28 }}>
        <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, #f59e0b, #d97706)', fontSize: 18, boxShadow: '0 4px 16px rgba(245,158,11,.25)' }}>💰</span>
          Vendas
        </h1>
        <p>Relatório e integrações com Braip e Monetizze</p>
      </div>

      {/* Tabs internas premium */}
      <div style={{ display: 'inline-flex', gap: 4, marginBottom: 22, background: 'var(--bg2)', padding: 4, borderRadius: 12, border: '1.5px solid var(--border)', position: 'relative' }}>
        {[['report','📊 Relatório'],['integrations','🔗 Integrações'],['posvenda','📦 Pós-Venda']].map(([k,l]) => (
          <button key={k} onClick={() => setTab(k)} style={{
            padding: '9px 22px', fontSize: 13, fontWeight: tab === k ? 800 : 600, border: 'none',
            borderRadius: 9, cursor: 'pointer', fontFamily: 'Inter,sans-serif',
            background: tab === k ? 'var(--accent)' : 'transparent',
            color: tab === k ? '#000' : 'var(--text3)',
            boxShadow: tab === k ? '0 2px 12px var(--accent-glow)' : 'none',
            transition: 'all .2s cubic-bezier(.22,1,.36,1)',
            letterSpacing: '-.1px',
          }}>{l}</button>
        ))}
      </div>

      {/* ── RELATÓRIO ── */}
      {/* ── CARD NOTIFICAÇÃO WHATSAPP ── aparece dentro da aba integrations */}
      {tab === 'integrations' && (
        <div style={{ marginTop: 24, background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 16, padding: '22px 24px', boxShadow: 'var(--card-shadow)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <span style={{ fontSize: 22 }}>🔔</span>
            <div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Notificação de Vendas no WhatsApp</div>
              <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>Receba um aviso no WhatsApp a cada venda aprovada</div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 220 }}>
              <label style={{ fontSize: 12, color: 'var(--text3)', display: 'block', marginBottom: 6, fontWeight: 600 }}>Número do WhatsApp (com DDD)</label>
              <input
                type="tel"
                placeholder="Ex: 85999990000"
                value={notifyPhone}
                onChange={e => setNotifyPhone(e.target.value.replace(/\D/g, ''))}
                maxLength={11}
                style={{
                  width: '100%', padding: '10px 14px', borderRadius: 10, border: '1.5px solid var(--border)',
                  background: 'var(--bg)', color: 'var(--text)', fontSize: 14, fontFamily: 'Inter,sans-serif',
                  outline: 'none', boxSizing: 'border-box'
                }}
              />
              <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 5 }}>
                {notifyPhone ? `✅ Será enviado para: 55${notifyPhone}` : 'Deixe em branco para não receber notificações'}
              </div>
            </div>
            <button
              onClick={saveNotifyPhone}
              disabled={notifyPhoneSaving}
              style={{
                padding: '10px 24px', borderRadius: 10, border: 'none', cursor: 'pointer',
                background: notifyPhoneSaved ? '#10b981' : 'var(--accent)', color: '#000',
                fontWeight: 700, fontSize: 13, fontFamily: 'Inter,sans-serif',
                opacity: notifyPhoneSaving ? 0.7 : 1,
                transition: 'all .2s', marginTop: 20,
                minWidth: 100,
              }}
            >
              {notifyPhoneSaving ? '...' : notifyPhoneSaved ? '✅ Salvo!' : 'Salvar'}
            </button>
          </div>
        </div>
      )}

      {tab === 'report' && (
        <div>
          {/* Filtros — Período + Plataforma em linha única */}
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
            {[
              { key: 'today', label: '📅 Hoje' },
              { key: 'yesterday', label: '⏪ Ontem' },
              { key: 'month', label: '🗓️ Este mês' },
              { key: 'custom', label: '🔧 Personalizado' },
            ].map(p => {
              const active = (filters._period || 'all') === p.key;
              const chipStyle = {
                padding: '6px 12px', fontSize: 12, fontWeight: 600, border: 'none',
                borderRadius: 20, cursor: 'pointer', fontFamily: 'Inter,sans-serif',
                background: active ? 'var(--accent)' : 'var(--bg2)',
                color: active ? '#000' : '#94a3b8',
              };
              return (
                <button key={p.key} onClick={() => {
                  const localDate = (dt) => { const y = dt.getFullYear(); const m = String(dt.getMonth()+1).padStart(2,'0'); const dd = String(dt.getDate()).padStart(2,'0'); return y+'-'+m+'-'+dd; };
                  const today = localDate(new Date());
                  const d = new Date();
                  let from = '', to = '';
                  if (p.key === 'today') { from = today; to = today; }
                  else if (p.key === 'yesterday') { d.setDate(d.getDate()-1); const y = localDate(d); from = y; to = y; }
                  else if (p.key === 'month') { from = today.slice(0,8) + '01'; to = today; }
                  else if (p.key === 'custom') { setFilters(f => ({ ...f, _period: 'custom' })); return; }
                  setFilters(f => ({ ...f, from, to, _period: p.key }));
                  
                }} style={chipStyle}>{p.label}</button>
              );
            })}
            <span style={{ width: 1, background: 'var(--border)', margin: '0 2px' }}></span>
            {[
              { key: 'all', label: 'Todas', color: '#94a3b8' },
              { key: 'braip', label: '🟣 Braip', color: '#a855f7' },
              { key: 'monetizze', label: '🔵 Monetizze', color: '#1e40af' },
            ].map(p => {
              const active = filters.platform === p.key;
              return (
                <button key={p.key} onClick={() => {
                  setFilters(f => ({ ...f, platform: p.key }));
                  
                }} style={{
                  padding: '6px 12px', fontSize: 12, fontWeight: 600, border: 'none',
                  borderRadius: 20, cursor: 'pointer', fontFamily: 'Inter,sans-serif',
                  background: active ? p.color + '33' : 'var(--bg2)',
                  color: active ? p.color : '#64748b',
                }}>{p.label}</button>
              );
            })}
          </div>
          {/* Campos de data — só aparece no modo Personalizado */}
          {(filters._period === 'custom') && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end', marginBottom: 12 }}>
              <div>
                <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 3 }}>De</div>
                <input type="date" value={filters.from} onChange={e => setFilters(f => ({ ...f, from: e.target.value }))}
                  style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 8, padding: '6px 10px', color: 'var(--fg)', fontSize: 13, width: 140 }} />
              </div>
              <div>
                <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 3 }}>Até</div>
                <input type="date" value={filters.to} onChange={e => setFilters(f => ({ ...f, to: e.target.value }))}
                  style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 8, padding: '6px 10px', color: 'var(--fg)', fontSize: 13, width: 140 }} />
              </div>
              <button onClick={loadReport} style={{
                background: 'var(--accent)', border: 'none', borderRadius: 8, padding: '7px 16px',
                color: '#000', fontWeight: 700, fontSize: 12, cursor: 'pointer'
              }}>Filtrar</button>
            </div>
          )}
          {/* Cards de resumo */}
          {(() => {
            const spend = parseFloat(String(adSpend).replace(',','.')) || 0;
            const comm = totals.total_commission || 0;
            const lucro = comm - spend;
            const roi = spend > 0 ? ((lucro / spend) * 100).toFixed(0) : '—';
            const roas = spend > 0 ? (comm / spend).toFixed(2) : '—';
            return (
              <div className="sales-cards-grid">
                <div style={cardStyle('#10b981')}>
                  <div style={{ fontSize: 11, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>💰 Total Vendas</div>
                  <div style={{ fontSize: 26, fontWeight: 900 }}>{totals.total_sales || 0}</div>
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>{fmtBRL(totals.total_amount)}</div>
                </div>
                <div style={cardStyle('#f59e0b')}>
                  <div style={{ fontSize: 11, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>🤑 Comissões</div>
                  <div style={{ fontSize: 26, fontWeight: 900 }}>{fmtBRL(comm)}</div>
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>Braip + Monetizze</div>
                </div>
                <div style={cardStyle('#ef4444')}>
                  <div style={{ fontSize: 11, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>📢 Gasto Ads</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ fontSize: 14, color: '#94a3b8' }}>R$</span>
                    <input type="text" inputMode="decimal" value={adSpend} onChange={e => setAdSpend(e.target.value)}
                      placeholder="0,00"
                      style={{ background: 'transparent', border: 'none', borderBottom: '1px solid var(--border)',
                        color: 'var(--fg)', fontSize: 22, fontWeight: 900, width: '100%', outline: 'none',
                        fontFamily: 'Inter,sans-serif', padding: '2px 0' }} />
                  </div>
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>investimento no período</div>
                </div>
                <div style={cardStyle(lucro >= 0 ? '#10b981' : '#ef4444')}>
                  <div style={{ fontSize: 11, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>📊 Lucro</div>
                  <div style={{ fontSize: 26, fontWeight: 900, color: lucro >= 0 ? '#10b981' : '#ef4444' }}>{spend > 0 ? fmtBRL(lucro) : '—'}</div>
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>comissão - gasto</div>
                </div>
                <div style={cardStyle('#3b82f6')}>
                  <div style={{ fontSize: 11, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>📈 ROI</div>
                  <div style={{ fontSize: 26, fontWeight: 900, color: typeof roi === 'string' ? '#94a3b8' : (Number(roi) >= 0 ? '#10b981' : '#ef4444') }}>{roi}{roi !== '—' ? '%' : ''}</div>
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>retorno sobre investimento</div>
                </div>
                <div style={cardStyle('#8b5cf6')}>
                  <div style={{ fontSize: 11, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>⚡ ROAS</div>
                  <div style={{ fontSize: 26, fontWeight: 900, color: typeof roas === 'string' ? '#94a3b8' : '#8b5cf6' }}>{roas}{roas !== '—' ? 'x' : ''}</div>
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>receita por R$1 investido</div>
                </div>
              </div>
            );
          })()}



          {/* Gráfico de vendas por dia */}
          {sales.length > 0 && (() => {
            const dailyMap = {};
            sales.forEach(s => {
              if (!dailyMap[s.sale_date]) dailyMap[s.sale_date] = { amount: 0, commission: 0, count: 0 };
              dailyMap[s.sale_date].amount += s.amount;
              dailyMap[s.sale_date].commission += s.commission;
              dailyMap[s.sale_date].count += 1;
            });
            const days = Object.keys(dailyMap).sort();
            const maxVal = Math.max(...days.map(d => dailyMap[d].amount), 1);
            const fmtDay = (s) => { const [y,m,d] = s.split('-'); return d+'/'+m; };
            const fmtBRL2 = (v) => Number(v).toLocaleString('pt-BR', {style:'currency',currency:'BRL'});
            const totalAmt = days.reduce((a,d) => a + dailyMap[d].amount, 0);
            const totalComm = days.reduce((a,d) => a + dailyMap[d].commission, 0);
            return (
              <div style={{ background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 16, padding: '20px 24px', marginBottom: 18, boxShadow: 'var(--card-shadow)', position: 'relative', overflow: 'hidden' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1 }}>📈 Vendas por dia</span>
                  <div style={{ display: 'flex', gap: 14, fontSize: 11 }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><span style={{ width: 8, height: 8, borderRadius: 2, background: '#10b981', display: 'inline-block' }}></span> <span style={{ color: '#94a3b8' }}>Vendas {fmtBRL2(totalAmt)}</span></span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><span style={{ width: 8, height: 8, borderRadius: 2, background: '#f59e0b', display: 'inline-block' }}></span> <span style={{ color: '#94a3b8' }}>Comissão {fmtBRL2(totalComm)}</span></span>
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {days.map(d => {
                    const pctAmt = Math.max((dailyMap[d].amount / maxVal) * 100, 15);
                    const pctComm = Math.max((dailyMap[d].commission / maxVal) * 100, 10);
                    return (
                      <div key={d} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ fontSize: 12, color: '#94a3b8', fontWeight: 600, minWidth: 42, textAlign: 'right' }}>{fmtDay(d)}</div>
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
                          <div style={{ position: 'relative', height: 22, background: 'var(--bg1)', borderRadius: 6, overflow: 'hidden' }}>
                            <div style={{
                              height: '100%', width: pctAmt + '%',
                              background: 'linear-gradient(90deg, #10b981, #10b981aa)',
                              borderRadius: 6,
                              display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: 8,
                              transition: 'width 0.5s ease',
                              minWidth: 70
                            }}>
                              <span style={{ fontSize: 11, fontWeight: 800, color: '#fff', textShadow: '0 1px 2px rgba(0,0,0,.3)' }}>
                                {fmtBRL2(dailyMap[d].amount)}
                              </span>
                            </div>
                          </div>
                          <div style={{ position: 'relative', height: 16, background: 'var(--bg1)', borderRadius: 5, overflow: 'hidden' }}>
                            <div style={{
                              height: '100%', width: pctComm + '%',
                              background: 'linear-gradient(90deg, #f59e0b, #f59e0baa)',
                              borderRadius: 5,
                              display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: 6,
                              transition: 'width 0.5s ease',
                              minWidth: 60
                            }}>
                              <span style={{ fontSize: 10, fontWeight: 700, color: '#fff', textShadow: '0 1px 2px rgba(0,0,0,.3)' }}>
                                {fmtBRL2(dailyMap[d].commission)}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div style={{ fontSize: 11, minWidth: 28, textAlign: 'center' }}>
                          <span style={{ background: '#10b98122', color: '#10b981', borderRadius: 10, padding: '2px 6px', fontSize: 10, fontWeight: 700 }}>{dailyMap[d].count}x</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })()}

          {/* Tabela */}
          {loading ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#64748b' }}>Carregando...</div>
          ) : sales.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text3)' }}>
              <div style={{ fontSize: 52, marginBottom: 16, opacity: 0.6 }}>📭</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--text2)', marginBottom: 6 }}>Nenhuma venda encontrada</div>
              <div style={{ fontSize: 13, maxWidth: 280, margin: '0 auto' }}>Configure seu webhook na aba Integrações para começar a rastrear vendas</div>
            </div>
          ) : (
            <div className="sales-list">
              {sales.map(s => {
                const pb = platformBadge(s.platform);
                return (
                  <div key={s.id} className="sale-card">
                    <div className="sale-card-header">
                      <span style={{ background: pb.color + '22', color: pb.color, borderRadius: 6, padding: '2px 8px', fontSize: 11, fontWeight: 700 }}>{pb.label}</span>
                      <span style={{ fontSize: 12, color: '#94a3b8' }}>{fmtDate(s.sale_date)}</span>
                      <span style={{ color: statusColor(s.status), fontWeight: 600, fontSize: 12, marginLeft: 'auto' }}>{s.status || '-'}</span>
                    </div>
                    <div style={{ fontSize: 13, fontWeight: 600, margin: '6px 0 4px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.product_name || '-'}{s.src ? <span style={{ marginLeft: 8, background: '#3b82f622', color: '#60a5fa', borderRadius: 6, padding: '2px 8px', fontSize: 11, fontWeight: 700 }}>{/*SALE_SRC_UI_V1*/}SRC: {s.src}</span> : null}</div>
                    <div className="sale-card-values">
                      <div><span style={{ fontSize: 11, color: '#94a3b8' }}>Valor</span><br/><span style={{ fontWeight: 700, color: '#10b981', fontSize: 15 }}>{fmtBRL(s.amount)}</span></div>
                      <div><span style={{ fontSize: 11, color: '#94a3b8' }}>Comissão</span><br/><span style={{ fontWeight: 700, color: '#f59e0b', fontSize: 15 }}>{fmtBRL(s.commission)}</span></div>
                    </div>
                    <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 6, borderTop: '1px solid var(--border)', paddingTop: 6 }}>
                      {s.buyer_name || '-'} {s.buyer_email ? `· ${s.buyer_email}` : ''}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* ── INTEGRAÇÕES ── */}
      {tab === 'posvenda' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

          {/* Config geral */}
          <div style={{ background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 14, padding: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 4 }}>📦 Automação Pós-Venda</div>
                <div style={{ fontSize: 12, color: 'var(--text3)' }}>Envie mensagens automáticas após uma venda aprovada</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 12, color: pvConfig.enabled ? 'var(--accent)' : 'var(--text3)', fontWeight: 600 }}>{pvConfig.enabled ? 'Ativo' : 'Inativo'}</span>
                <div onClick={() => setPvConfig(c => ({ ...c, enabled: c.enabled ? 0 : 1 }))}
                  style={{ width: 44, height: 24, borderRadius: 12, background: pvConfig.enabled ? 'var(--accent)' : 'var(--bg3)', border: '2px solid var(--border)', cursor: 'pointer', position: 'relative', transition: 'background .2s' }}>
                  <div style={{ width: 16, height: 16, borderRadius: '50%', background: '#fff', position: 'absolute', top: 2, left: pvConfig.enabled ? 22 : 2, transition: 'left .2s', boxShadow: '0 1px 4px rgba(0,0,0,.3)' }} />
                </div>
              </div>
            </div>

            {/* Seletor de bot com status */}
            <div style={{ marginTop: 16 }}>
              <div style={{ fontSize: 11, color: 'var(--text3)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>WhatsApp para disparar</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {getAllowedBots(userPlan || 'prime').map(b => {
                  const isOn = !!(botStatuses && botStatuses[b.id]) || !!(botNumbers && botNumbers[b.id]);
                  const num = botNumbers && botNumbers[b.id];
                  const isSel = pvConfig.bot_id === b.id;
                  return (
                    <div key={b.id} onClick={() => setPvConfig(c => ({ ...c, bot_id: b.id }))}
                      style={{ padding: '10px 14px', borderRadius: 10, fontSize: 12, fontWeight: 700, cursor: 'pointer',
                        border: isSel ? '2px solid var(--accent)' : '1.5px solid var(--border)',
                        background: isSel ? 'linear-gradient(135deg, rgba(0,208,132,.15), rgba(0,208,132,.05))' : 'var(--bg3)',
                        color: isSel ? 'var(--accent)' : isOn ? 'var(--text)' : 'var(--text3)',
                        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, transition: 'all .2s',
                        boxShadow: isSel ? '0 0 0 1px var(--accent), 0 4px 12px rgba(0,208,132,.2)' : 'none',
                        opacity: isOn ? 1 : 0.4, minWidth: 72 }}>
                      <div style={{ width: 10, height: 10, borderRadius: '50%', flexShrink: 0,
                        background: isOn ? '#10b981' : '#ef4444',
                        boxShadow: isOn ? '0 0 6px #10b981' : 'none' }} />
                      <span>{b.label}</span>
                      {num && <span style={{ fontSize: 9, opacity: 0.6, fontFamily: 'monospace' }}>{num.slice(-4)}</span>}
                    </div>
                  );
                })}
                <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 8, display: 'flex', gap: 16, width: '100%' }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><span style={{ width: 8, height: 8, borderRadius: '50%', background: '#10b981', display: 'inline-block', boxShadow: '0 0 4px #10b981' }} /> Conectado</span>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4, opacity: 0.5 }}><span style={{ width: 8, height: 8, borderRadius: '50%', background: '#ef4444', display: 'inline-block' }} /> Desconectado</span>
                </div>
              </div>

            </div>
          </div>

          {/* Mensagens */}
          <div style={{ background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 14, overflow: 'hidden' }}>
            <div style={{ padding: '14px 18px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>Sequência de mensagens <span style={{ fontSize: 12, color: 'var(--text3)', fontWeight: 400 }}>({pvMessages.length})</span></div>
              <button onClick={addPvMessage}
                style={{ padding: '7px 14px', background: 'var(--accent)', border: 'none', borderRadius: 8, color: '#000', fontWeight: 700, fontSize: 12, cursor: 'pointer' }}>
                + Adicionar mensagem
              </button>
            </div>

            {pvMessages.length === 0 ? (
              <div style={{ padding: '32px 20px', textAlign: 'center', color: 'var(--text3)' }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>📝</div>
                <div style={{ fontSize: 13 }}>Nenhuma mensagem configurada</div>
                <div style={{ fontSize: 12, marginTop: 4 }}>Clique em "Adicionar mensagem" para começar</div>
              </div>
            ) : (
              <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
                {pvMessages.map((msg, idx) => (
                  <div key={msg.id} style={{ background: 'var(--bg2)', borderRadius: 14, padding: '16px 18px', border: '1.5px solid var(--border)', boxShadow: '0 2px 8px rgba(0,0,0,.1)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ fontSize: 12, color: 'var(--text3)', fontWeight: 700 }}>#{idx + 1}</span>
                        {/* Tipo */}
                        <div style={{ display: 'flex', gap: 4 }}>
                          {[['text','💬 Texto'],['image','🖼️ Imagem'],['text_image','💬+🖼️']].map(([t, l]) => (
                            <button key={t} onClick={() => updatePvMessage(msg.id, 'type', t)}
                              style={{ padding: '3px 10px', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer', border: 'none',
                                background: msg.type === t ? 'var(--accent)' : 'var(--bg2)',
                                color: msg.type === t ? '#fff' : 'var(--text3)' }}>
                              {l}
                            </button>
                          ))}
                        </div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {/* Delay */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <span style={{ fontSize: 11, color: 'var(--text3)' }}>Delay:</span>
                          <select value={msg.delay_seconds} onChange={e => updatePvMessage(msg.id, 'delay_seconds', Number(e.target.value))}
                            style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 6, padding: '3px 6px', fontSize: 11, color: 'var(--text)' }}>
                            {[1,2,3,5,8,10,15,20,30].map(d => <option key={d} value={d}>{d}s</option>)}
                          </select>
                        </div>
                        <button onClick={() => removePvMessage(msg.id)}
                          style={{ background: 'rgba(239,68,68,.12)', border: 'none', borderRadius: 6, padding: '4px 8px', color: '#ef4444', cursor: 'pointer', fontSize: 12 }}>✕</button>
                      </div>
                    </div>

                    {/* Texto */}
                    {(msg.type === 'text' || msg.type === 'text_image') && (
                      <textarea value={msg.message} onChange={e => updatePvMessage(msg.id, 'message', e.target.value)}
                        placeholder="Digite a mensagem... Use {nome}, {produto}, {cpf} para personalizar"
                        rows={3} style={{ width: '100%', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 12px', color: 'var(--text)', fontSize: 13, resize: 'vertical', fontFamily: 'Inter,sans-serif', boxSizing: 'border-box', marginBottom: 8 }} />
                    )}

                    {/* Imagem */}
                    {(msg.type === 'image' || msg.type === 'text_image') && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '7px 12px', background: 'var(--bg2)', border: '1.5px dashed var(--border)', borderRadius: 8, cursor: 'pointer', fontSize: 12, color: 'var(--text3)', whiteSpace: 'nowrap' }}>
                              📁 Upload
                              <input type="file" accept="image/*" style={{ display: 'none' }} onChange={e => e.target.files[0] && uploadPvImage(msg.id, e.target.files[0])} />
                            </label>
                            <input value={msg.image_url} onChange={e => updatePvMessage(msg.id, 'image_url', e.target.value)}
                              placeholder="Ou cole a URL da imagem aqui"
                              style={{ flex: 1, minWidth: 150, background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 10px', color: 'var(--text)', fontSize: 12 }} />
                            {msg.image_url && (
                              <button onClick={() => updatePvMessage(msg.id, 'image_url', '')}
                                style={{ fontSize: 11, color: '#ef4444', background: 'rgba(239,68,68,.1)', border: 'none', borderRadius: 6, padding: '6px 10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>✕</button>
                            )}
                          </div>
                          {msg.image_url ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px', background: 'rgba(0,208,132,.05)', borderRadius: 10, border: '1.5px solid rgba(0,208,132,.25)', marginTop: 8 }}>
                              <img src={msg.image_url} alt="preview"
                                style={{ width: 64, height: 64, borderRadius: 8, objectFit: 'cover', border: '1px solid var(--border)', flexShrink: 0 }} />
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--accent)', marginBottom: 3 }}>✅ Imagem configurada</div>
                                <div style={{ fontSize: 11, color: 'var(--text3)', wordBreak: 'break-all' }}>{msg.image_url.length > 60 ? msg.image_url.slice(0,60)+'...' : msg.image_url}</div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Variáveis disponíveis */}
          <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, padding: 16 }}>
            <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8 }}>💡 Variáveis disponíveis nas mensagens</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {[['{nome}','Nome do comprador'],['{produto}','Produto'],['{cpf}','CPF'],['{email}','Email']].map(([v, d]) => (
                <div key={v} style={{ padding: '4px 10px', background: 'var(--bg3)', borderRadius: 6, fontSize: 11 }}>
                  <span style={{ color: 'var(--accent)', fontWeight: 700, fontFamily: 'monospace' }}>{v}</span>
                  <span style={{ color: 'var(--text3)', marginLeft: 6 }}>{d}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Salvar */}
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button onClick={savePosVenda} disabled={pvSaving}
              style={{ padding: '11px 28px', background: pvSaved ? '#10b981' : 'var(--accent)', border: 'none', borderRadius: 10, color: '#000', fontWeight: 800, fontSize: 14, cursor: 'pointer', transition: 'all .2s', boxShadow: '0 2px 12px var(--accent-glow)' }}>
              {pvSaving ? '⏳ Salvando...' : pvSaved ? '✅ Salvo!' : '💾 Salvar configurações'}
            </button>
          </div>
        </div>
      )}

      {tab === 'integrations' && (
        <div>
          {!webhookInfo ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#64748b' }}>Carregando...</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
              <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, padding: 20 }}>
                <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 6 }}>Como configurar</div>
                <div style={{ fontSize: 13, color: '#94a3b8', lineHeight: 1.7 }}>
                  1. Copie a URL correspondente à plataforma<br/>
                  2. Cole no campo de <strong>Webhook/Postback</strong> dentro do painel da Braip ou Monetizze<br/>
                  3. As vendas aprovadas aparecerão automaticamente no Relatório
                </div>
              </div>

              {[
                { key: 'braip', label: '🟡 Braip', url: webhookInfo.braip_url, color: '#f59e0b',
                  hint: 'Painel Braip → Produtos → Configurações → Webhook de Vendas' },
                { key: 'monetizze', label: '🟣 Monetizze', url: webhookInfo.monetizze_url, color: '#8b5cf6',
                  hint: 'Painel Monetizze → Meus Produtos → Postback URL' },
              ].map(({ key, label, url, color, hint }) => (
                <div key={key} style={{ background: 'var(--bg2)', border: `1px solid ${color}44`, borderRadius: 12, padding: 20 }}>
                  <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 4 }}>{label}</div>
                  <div style={{ fontSize: 11, color: '#64748b', marginBottom: 12 }}>{hint}</div>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <input readOnly value={url}
                      style={{ flex: 1, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8,
                        padding: '10px 14px', color: '#94a3b8', fontSize: 12, fontFamily: 'monospace' }} />
                    <button onClick={() => copyUrl(url, key)} style={{
                      background: copied === key ? '#10b981' : color, border: 'none', borderRadius: 8,
                      padding: '10px 18px', color: '#000', fontWeight: 700, fontSize: 13, cursor: 'pointer',
                      whiteSpace: 'nowrap', transition: 'background .2s'
                    }}>{copied === key ? '✅ Copiado!' : 'Copiar URL'}</button>
                  </div>
                </div>
              ))}

              {/* Gerar novo token */}
              <div style={{ background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 12, padding: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>🔑 Token de autenticação</div>
                  <div style={{ fontSize: 12, color: 'var(--text3)' }}>Gere um novo token se suas URLs estiverem comprometidas. As URLs serão atualizadas automaticamente.</div>
                </div>
                <button onClick={generateToken} disabled={generatingToken}
                  style={{ padding: '10px 18px', background: tokenGenerated ? '#10b981' : 'var(--bg3)', border: '1.5px solid var(--border)', borderRadius: 10, color: tokenGenerated ? '#fff' : 'var(--text)', fontWeight: 700, fontSize: 13, cursor: generatingToken ? 'wait' : 'pointer', whiteSpace: 'nowrap', transition: 'all .2s' }}>
                  {generatingToken ? '⏳ Gerando...' : tokenGenerated ? '✅ Gerado!' : '🔄 Gerar novo token'}
                </button>
              </div>

              <div style={{ background: 'var(--bg2)', border: '1px solid ' + (shopeeInfo.has_key ? 'rgba(238,77,45,0.4)' : 'var(--border)'), borderRadius: 12, padding: 20 }}>
                <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 4 }}>🛍️ Shopee (preview de imagem nas mensagens)</div>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 14 }}>Credenciais da API Afiliados da Shopee — usadas só pra buscar a foto do produto quando o link é da Shopee. Não tem nada a ver com Braip/Monetizze.</div>
                {shopeeInfo.has_key ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
                    <span style={{ fontSize: 13 }}>✅ Conectado (App ID: {shopeeInfo.app_id}, secret terminando em ••••{shopeeInfo.last4})</span>
                    <button className="btn btn-g" type="button" onClick={removeShopee}>Remover</button>
                  </div>
                ) : (
                  <div style={{ fontSize: 13, marginBottom: 12 }}>⚠️ Nenhuma credencial conectada. Sem isso, links da Shopee são enviados sem preview de imagem.</div>
                )}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <input className="fi" value={shopeeAppIdInput} onChange={(e) => setShopeeAppIdInput(e.target.value)} placeholder="App ID" />
                  <input className="fi" type="password" autoComplete="off" value={shopeeSecretInput} onChange={(e) => setShopeeSecretInput(e.target.value)} placeholder="Secret" />
                  <button className="btn btn-p" type="button" disabled={shopeeSaving || !shopeeAppIdInput.trim() || !shopeeSecretInput.trim()} style={{ alignSelf: 'flex-start' }} onClick={saveShopee}>
                    {shopeeSaving ? 'Salvando...' : shopeeSaved ? '✅ Salvo!' : shopeeInfo.has_key ? 'Trocar credencial' : 'Conectar'}
                  </button>
                </div>
              </div>

              <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, padding: 20 }}>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>⚠️ Importante</div>
                <ul style={{ fontSize: 13, color: '#94a3b8', lineHeight: 1.8, paddingLeft: 18 }}>
                  <li>Mantenha a URL em sigilo — ela identifica sua conta</li>
                  <li>Apenas vendas com status <strong>aprovado</strong> são registradas</li>
                  <li>Vendas duplicadas são ignoradas automaticamente</li>
                </ul>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ============================================================
// PÁGINA DE RECUPERAÇÃO DE ABANDONOS — PREMIUM v2
// ============================================================
function RecuperacaoPage({ show, userPlan }) {
  // PATCH_RECUP_V1
  const [rc, setRc] = React.useState({ enabled: false, bot_id: '', msg_pix: '', msg_card: '', link: '', img_pix: '', img_card: '', media_sep: true });
  const [rcUrls, setRcUrls] = React.useState({ braip: '', monetizze: '' });
  const [rcDefaults, setRcDefaults] = React.useState({ msg_pix: '', msg_card: '' });
  const [rcSaving, setRcSaving] = React.useState(false);
  const loadRc = React.useCallback(async () => {
    const r = await api('/recuperacao/config');
    if (r.ok && r.config) {
      setRc({ enabled: !!r.config.enabled, bot_id: r.config.bot_id || '', msg_pix: r.config.msg_pix || '', msg_card: r.config.msg_card || '', link: r.config.link || '', img_pix: r.config.img_pix || '', img_card: r.config.img_card || '', media_sep: r.config.media_sep === undefined ? true : !!r.config.media_sep });
      setRcUrls(r.webhook_urls || {});
      setRcDefaults(r.defaults || {});
      if (r.config.bot_id) {
        try { localStorage.setItem('recovery_bot', r.config.bot_id); } catch (e) {}
        setRecoveryBot(r.config.bot_id);
        setPendingBot(r.config.bot_id);
      }
    }
  }, []);
  React.useEffect(() => { loadRc(); }, [loadRc]);
  const [rcUploading, setRcUploading] = React.useState('');
  const uploadRcImage = async (key, file) => {
    if (!file) return;
    const isVideo = /^video\//.test(file.type);
    if (isVideo && file.size > 16 * 1024 * 1024) { show('Vídeo muito grande (máximo 16 MB)', 'error'); return; }
    if (!isVideo && file.size > 5 * 1024 * 1024) { show('Imagem muito grande (máximo 5 MB)', 'error'); return; }
    setRcUploading(key);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const r = await fetch(`${API_BASE}/recuperacao/upload`, { method: 'POST', headers: { Authorization: `Bearer ${localStorage.getItem('zs_token')}` }, body: fd });
      const d = await r.json();
      if (d.ok) setRc(p => ({ ...p, [key]: d.url }));
      else show(d.error || 'Erro ao enviar imagem', 'error');
    } catch (e) { show('Erro ao enviar imagem', 'error'); }
    setRcUploading('');
  };
  const saveRc = async (patch, okMsg) => {
    setRcSaving(true);
    const r = await api('/recuperacao/config', { method: 'POST', body: JSON.stringify(patch) });
    setRcSaving(false);
    if (r.ok) { if (okMsg) show(okMsg); loadRc(); }
    else show(r.error || 'Erro ao salvar', 'error');
  };
  const ALL_BOTS = getAllowedBots(userPlan || 'prime');
  const [recoveryBot, setRecoveryBot] = React.useState(
    localStorage.getItem('recovery_bot') || (ALL_BOTS[0]?.id || 'bot1')
  );
  const [stats, setStats] = React.useState({ total: 0, enviados: 0, convertidos: 0, pendentes: 0 });
  const [abandonos, setAbandonos] = React.useState([]);
  const [recPer, setRecPer] = React.useState(() => { try { return localStorage.getItem('rec_per') || 'hoje'; } catch (e) { return 'hoje'; } }); /*REC_PERIOD_UI_V1*/
  const [recFrom, setRecFrom] = React.useState('');
  const [recTo, setRecTo] = React.useState('');
  const recQRef = React.useRef('');
  recQRef.current = (() => {
    const t = new Date();
    const f = d => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    const day = n => { const d = new Date(t); d.setDate(d.getDate() - n); return f(d); };
    if (recPer === 'hoje') return '?from=' + day(0) + '&to=' + day(0);
    if (recPer === 'ontem') return '?from=' + day(1) + '&to=' + day(1);
    if (recPer === '7d') return '?from=' + day(6) + '&to=' + day(0);
    if (recPer === 'mes') return '?from=' + f(new Date(t.getFullYear(), t.getMonth(), 1)) + '&to=' + day(0);
    if (recPer === 'custom' && recFrom && recTo) return '?from=' + recFrom + '&to=' + recTo;
    return '';
  })();
  const [botStatus, setBotStatus] = React.useState('offline');
  const [botNumber, setBotNumber] = React.useState('');
  const [qr, setQr] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [filtro, setFiltro] = React.useState('todos');
  const [pulse, setPulse] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  const [tab, setTab] = React.useState('dashboard');
  const [copiedKey, setCopiedKey] = React.useState('');
  const [disconnecting, setDisconnecting] = React.useState(false);

  const copyUrl = (text, key) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedKey(key);
      setTimeout(() => setCopiedKey(''), 2000);
    });
  };

  const [pendingBot, setPendingBot] = React.useState(
    localStorage.getItem('recovery_bot') || (ALL_BOTS[0]?.id || 'bot1')
  );
  const [saved, setSaved] = React.useState(false);

  const saveBot = () => {
    setRecoveryBot(pendingBot);
    localStorage.setItem('recovery_bot', pendingBot);
    saveRc({ bot_id: pendingBot }, 'WhatsApp de recuperação salvo');
    setBotStatus('offline');
    setBotNumber('');
    setQr(null);
    setLoading(true);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const disconnectBot = async () => {
    if (!window.confirm('Deseja desconectar o bot de recuperação?')) return;
    setDisconnecting(true);
    try {
      await api('/whatsapp/logout', { method: 'POST', body: JSON.stringify({ bot: recoveryBot }) });
      setBotStatus('offline');
      setBotNumber('');
      setQr(null);
    } catch(e) {}
    setDisconnecting(false);
    setTimeout(() => loadBotStatus(), 2000);
  };

  // URL base do webhook de recuperação
  const baseUrl = rcUrls.braip || 'Carregando seu link...';

  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const loadData = React.useCallback(async () => {
    try {
      const r = await api('/recuperacao/stats' + recQRef.current);
      if (r.ok) {
        setStats(r.stats || {});
        setAbandonos(r.abandonos || []);
        setPulse(true);
        setTimeout(() => setPulse(false), 600);
      }
    } catch(e) {}
  }, []);

  React.useEffect(() => { loadData(); }, [recPer, recFrom, recTo, loadData]);

  const loadBotStatus = React.useCallback(async () => {
    try {
      const r = await api('/whatsapp/status?bot=' + recoveryBot);
      if (r.ok) {
        setBotStatus(r.status || 'offline');
        if (r.number) setBotNumber(r.number);
        if (r.status !== 'open') {
          const qrR = await api('/whatsapp/qr?bot=' + recoveryBot);
          if (qrR.qr) setQr(qrR.qr);
        } else { setQr(null); }
      }
    } catch(e) {}
    setLoading(false);
  }, [recoveryBot]);

  React.useEffect(() => {
    loadData();
    loadBotStatus();
    const interval = setInterval(() => { loadData(); loadBotStatus(); }, 15000);
    return () => clearInterval(interval);
  }, [loadData, loadBotStatus]);

  const taxa = stats.enviados > 0 ? ((stats.convertidos / stats.enviados) * 100).toFixed(1) : '0.0';
  const isOnline = botStatus === 'open';
  const fmtDate = (dt) => dt ? new Date(dt + 'Z').toLocaleString('pt-BR', { timeZone: 'America/Fortaleza', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';
  // Fix telefone: +55 (85) 92824598 sem espaço extra
  const fmtPhone = (p) => {
    if (!p) return '—';
    const d = p.replace(/\D/g, '');
    if (d.length === 13) return `+${d.slice(0,2)} (${d.slice(2,4)}) ${d.slice(4,5)} ${d.slice(5)}`;
    if (d.length === 12) return `+${d.slice(0,2)} (${d.slice(2,4)}) ${d.slice(4)}`;
    return `+${d}`;
  };

  const filtrados = abandonos.filter(a => {
    if (filtro === 'pendentes') return !a.recovery_sent && !a.converted;
    if (filtro === 'enviados') return a.recovery_sent && !a.converted;
    if (filtro === 'convertidos') return a.converted;
    if (filtro === 'pix') return a.trans_status === 'Aguardando Pagamento';
    return true;
  });

  const rcPreview = (t) => String(t || '').replace(/\{nome\}/gi, 'Maria').replace(/\{produto\}/gi, 'seu produto').replace(/\{link\}/gi, rc.link || '(seu link)');
  const taxaNum = parseFloat(taxa);
  const taxaColor = taxaNum >= 20 ? '#10b981' : taxaNum >= 10 ? '#f59e0b' : '#ef4444';

  // Progress bar correto: enviados/total e convertidos/enviados
  const barWidths = [
    100,
    stats.total > 0 ? Math.min(100, (stats.enviados / stats.total) * 100) : 0,
    stats.enviados > 0 ? Math.min(100, (stats.convertidos / stats.enviados) * 100) : 0,
  ];

  return (
    <div className="fade-up" style={{ paddingBottom: 40, maxWidth: '100%', boxSizing: 'border-box', overflowX: 'hidden' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'space-between', marginBottom: isMobile ? 16 : 24, flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? 8 : 0, width: '100%', boxSizing: 'border-box' }}>
        <div>
          <h1 style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 'clamp(17px, 5vw, 24px)', fontWeight: 800, margin: 0 }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 'clamp(36px, 8vw, 42px)', height: 'clamp(36px, 8vw, 42px)', borderRadius: 12, background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)', boxShadow: '0 6px 20px rgba(139,92,246,.35), inset 0 1px 0 rgba(255,255,255,.15)', flexShrink: 0 }}>
              <span style={{ fontSize: 'clamp(16px, 4vw, 20px)', lineHeight: 1 }}>🎯</span>
            </span>
            Recuperação de Abandonos
          </h1>
          <p style={{ color: 'var(--text3)', marginTop: 4, fontSize: 13, maxWidth: isMobile ? 260 : 'none' }}>Reconquiste leads que abandonaram o checkout automaticamente</p>
        </div>
        <button onClick={() => { loadData(); loadBotStatus(); }}
          style={{ display: 'flex', alignItems: 'center', gap: 6, padding: isMobile ? '7px 12px' : '9px 16px', background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 10, color: 'var(--text2)', cursor: 'pointer', fontSize: isMobile ? 12 : 13, fontWeight: 600, whiteSpace: 'nowrap', alignSelf: isMobile ? 'flex-end' : 'auto' }}>
          <span style={{ display: 'inline-block', transition: 'transform .6s', transform: pulse ? 'rotate(360deg)' : 'rotate(0deg)', fontSize: 14 }}>↺</span>
          <span>{isMobile ? '' : ' Atualizar'}</span>
        </button>
      </div>

      {/* Tabs */}
      <div style={{ display: 'inline-flex', gap: 4, marginBottom: 20, background: 'var(--bg2)', padding: 4, borderRadius: 12, border: '1.5px solid var(--border)' }}>
        {[['dashboard', '📊 Dashboard'], ['mensagens', '✉️ Mensagens'], ['integracao', '🔗 Integração']].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)}
            style={{ padding: '8px 18px', borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: 'pointer', border: 'none', transition: 'all .2s',
              background: tab === k ? 'var(--accent)' : 'transparent',
              color: tab === k ? '#fff' : 'var(--text3)',
              boxShadow: tab === k ? '0 2px 8px rgba(0,208,132,.25)' : 'none' }}>
            {l}
          </button>
        ))}
      </div>

      {/* ABA MENSAGENS */}
      {tab === 'mensagens' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={{ background: 'var(--bg2)', border: '1.5px solid ' + (rc.enabled ? 'rgba(16,185,129,.45)' : 'var(--border)'), borderRadius: 14, padding: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 800 }}>{rc.enabled ? '🟢 Recuperação ligada' : '⚪ Recuperação desligada'}</div>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 4 }}>
                  {rc.bot_id ? 'Enviando pelo WhatsApp ' + String(rc.bot_id).replace('bot', '') : 'Escolha o WhatsApp na aba Integração antes de ligar'}
                </div>
              </div>
              <button disabled={rcSaving} onClick={() => saveRc({ enabled: !rc.enabled }, rc.enabled ? 'Recuperação desligada' : 'Recuperação ligada')}
                style={{ padding: '10px 20px', borderRadius: 10, border: 'none', cursor: 'pointer', fontWeight: 800, fontSize: 13, background: rc.enabled ? '#ef4444' : 'var(--accent)', color: '#fff' }}>
                {rc.enabled ? 'Desligar' : 'Ligar'}
              </button>
            </div>
          </div>

          <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 14, padding: 20 }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>⏳ Pagamento pendente (PIX / boleto gerado)</div>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 10 }}>Enviada para quem gerou o pagamento e não pagou, 10 minutos depois.</div>
            <textarea value={rc.msg_pix} onChange={(e) => setRc(p => ({ ...p, msg_pix: e.target.value }))}
              style={{ width: '100%', minHeight: 130, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 10, padding: 12, color: 'var(--text)', fontFamily: 'inherit', fontSize: 14, resize: 'vertical', boxSizing: 'border-box' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, flexWrap: 'wrap', gap: 8 }}>
              <span style={{ fontSize: 11, color: 'var(--text3)' }}>{rc.msg_pix.length}/1500</span>
              <button onClick={() => setRc(p => ({ ...p, msg_pix: rcDefaults.msg_pix || p.msg_pix }))} style={{ background: 'transparent', border: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' }}>Restaurar padrão</button>
            </div>
            <div style={{ marginTop: 10, padding: '10px 14px', background: 'var(--bg)', borderRadius: 10, fontSize: 13, whiteSpace: 'pre-wrap', color: 'var(--text2)' }}>
              <div style={{ fontSize: 10, fontWeight: 800, color: 'var(--text3)', letterSpacing: 1, marginBottom: 6 }}>PRÉVIA</div>
              {rcPreview(rc.msg_pix)}
            </div>
            <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
              {rc.img_pix ? (
                /\.mp4$/i.test(rc.img_pix) ? (<video src={rc.img_pix} muted controls playsInline preload="metadata" style={{ width: 'min(100%, 300px)', maxHeight: 260, borderRadius: 12, border: '1px solid var(--border)', background: '#000' }} />) : (<img src={rc.img_pix} alt="" style={{ width: 'min(100%, 240px)', maxHeight: 240, objectFit: 'contain', borderRadius: 12, border: '1px solid var(--border)', background: 'var(--bg)' }} />)
              ) : null}
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '11px 20px', borderRadius: 10, border: '1.5px solid rgba(0,208,132,.55)', background: 'rgba(0,208,132,.12)', cursor: 'pointer', fontSize: 14, fontWeight: 800, color: 'var(--accent)' }}>
                {rcUploading === 'img_pix' ? 'Enviando...' : (rc.img_pix ? '🖼️ Trocar mídia' : '🖼️ Adicionar imagem ou vídeo (opcional)')}
                <input type="file" accept="image/jpeg,image/png,image/webp,image/gif,video/mp4" style={{ display: 'none' }} onChange={(e) => { uploadRcImage('img_pix', e.target.files && e.target.files[0]); e.target.value = ''; }} />
              </label>
              {rc.img_pix ? (
                <button onClick={() => setRc(p => ({ ...p, img_pix: '' }))} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>Remover mídia</button>
              ) : null}
            </div>
            <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 6 }}>Enviada junto com o texto, como legenda. Imagem (JPG, PNG, WEBP, GIF) até 5 MB ou vídeo MP4 até 16 MB. Clique em "Salvar mensagens" para aplicar.</div>
          </div>

          <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 14, padding: 20 }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>🛒 Carrinho abandonado</div>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 10 }}>Enviada para quem abriu o checkout e saiu sem finalizar, 10 minutos depois.</div>
            <textarea value={rc.msg_card} onChange={(e) => setRc(p => ({ ...p, msg_card: e.target.value }))}
              style={{ width: '100%', minHeight: 130, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 10, padding: 12, color: 'var(--text)', fontFamily: 'inherit', fontSize: 14, resize: 'vertical', boxSizing: 'border-box' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, flexWrap: 'wrap', gap: 8 }}>
              <span style={{ fontSize: 11, color: 'var(--text3)' }}>{rc.msg_card.length}/1500</span>
              <button onClick={() => setRc(p => ({ ...p, msg_card: rcDefaults.msg_card || p.msg_card }))} style={{ background: 'transparent', border: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' }}>Restaurar padrão</button>
            </div>
            <div style={{ marginTop: 10, padding: '10px 14px', background: 'var(--bg)', borderRadius: 10, fontSize: 13, whiteSpace: 'pre-wrap', color: 'var(--text2)' }}>
              <div style={{ fontSize: 10, fontWeight: 800, color: 'var(--text3)', letterSpacing: 1, marginBottom: 6 }}>PRÉVIA</div>
              {rcPreview(rc.msg_card)}
            </div>
            <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
              {rc.img_card ? (
                /\.mp4$/i.test(rc.img_card) ? (<video src={rc.img_card} muted controls playsInline preload="metadata" style={{ width: 'min(100%, 300px)', maxHeight: 260, borderRadius: 12, border: '1px solid var(--border)', background: '#000' }} />) : (<img src={rc.img_card} alt="" style={{ width: 'min(100%, 240px)', maxHeight: 240, objectFit: 'contain', borderRadius: 12, border: '1px solid var(--border)', background: 'var(--bg)' }} />)
              ) : null}
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '11px 20px', borderRadius: 10, border: '1.5px solid rgba(0,208,132,.55)', background: 'rgba(0,208,132,.12)', cursor: 'pointer', fontSize: 14, fontWeight: 800, color: 'var(--accent)' }}>
                {rcUploading === 'img_card' ? 'Enviando...' : (rc.img_card ? '🖼️ Trocar mídia' : '🖼️ Adicionar imagem ou vídeo (opcional)')}
                <input type="file" accept="image/jpeg,image/png,image/webp,image/gif,video/mp4" style={{ display: 'none' }} onChange={(e) => { uploadRcImage('img_card', e.target.files && e.target.files[0]); e.target.value = ''; }} />
              </label>
              {rc.img_card ? (
                <button onClick={() => setRc(p => ({ ...p, img_card: '' }))} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>Remover mídia</button>
              ) : null}
            </div>
            <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 6 }}>Enviada junto com o texto, como legenda. Imagem (JPG, PNG, WEBP, GIF) até 5 MB ou vídeo MP4 até 16 MB. Clique em "Salvar mensagens" para aplicar.</div>
          </div>

          <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 14, padding: 20 }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>🔗 Link de compra (opcional)</div>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 10 }}>Só aparece nas mensagens se você usar <code>{'{link}'}</code> no texto.</div>
            <input value={rc.link} onChange={(e) => setRc(p => ({ ...p, link: e.target.value }))} placeholder="https://seusite.com/comprar"
              style={{ width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 10, padding: '10px 14px', color: 'var(--text)', fontSize: 14, boxSizing: 'border-box' }} />
            <div style={{ marginTop: 14, fontSize: 12, color: 'var(--text3)', lineHeight: 1.7 }}>
              Variáveis: <code>{'{nome}'}</code> primeiro nome do cliente · <code>{'{produto}'}</code> nome do produto · <code>{'{link}'}</code> seu link de compra
            </div>
          </div>

          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14, cursor: 'pointer', fontSize: 13, color: 'var(--text2)' }}>
              <input type="checkbox" checked={!!rc.media_sep} onChange={(e) => setRc(p => ({ ...p, media_sep: e.target.checked }))} style={{ width: 18, height: 18, accentColor: '#00d084' }} />
              Enviar o texto em uma mensagem separada da imagem/vídeo (primeiro a mídia, depois o texto)
            </label>
            <button disabled={rcSaving} onClick={() => saveRc({ msg_pix: rc.msg_pix, msg_card: rc.msg_card, link: rc.link, img_pix: rc.img_pix, img_card: rc.img_card, media_sep: rc.media_sep ? 1 : 0 }, 'Mensagens salvas')}
              style={{ padding: '12px 26px', borderRadius: 10, border: 'none', cursor: 'pointer', fontWeight: 800, fontSize: 14, background: 'var(--accent)', color: '#fff' }}>
              {rcSaving ? 'Salvando...' : 'Salvar mensagens'}
            </button>
          </div>
        </div>
      )}

      {/* ABA INTEGRAÇÃO */}
      {tab === 'integracao' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {/* Como configurar */}
          <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 14, padding: 20 }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 8 }}>Como configurar</div>
            <div style={{ fontSize: 13, color: 'var(--text3)', lineHeight: 1.8 }}>
              1. Copie a URL correspondente à plataforma<br/>
              2. Cole no campo de <strong>Postback/Webhook</strong> dentro do painel da Braip<br/>
              3. Selecione os eventos: <strong>Abandono de Checkout</strong> + <strong>Aguardando Pagamento</strong><br/>
              4. Os abandonos aparecerão automaticamente no Dashboard
            </div>
          </div>

          {/* Braip */}
          <div style={{ background: 'var(--bg2)', border: '1.5px solid rgba(245,158,11,.3)', borderRadius: 14, padding: 20 }}>
            <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 4 }}>🟡 Braip</div>
            <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 14 }}>Painel Braip → Ferramentas → Postback → Nova configuração</div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <input readOnly value={baseUrl}
                style={{ flex: 1, minWidth: 200, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 14px', color: 'var(--text3)', fontSize: 12, fontFamily: 'monospace' }} />
              <button onClick={() => copyUrl(baseUrl, 'braip')}
                style={{ background: copiedKey === 'braip' ? '#10b981' : '#f59e0b', border: 'none', borderRadius: 8, padding: '10px 18px', color: '#000', fontWeight: 700, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap', transition: 'background .2s' }}>
                {copiedKey === 'braip' ? '✅ Copiado!' : 'Copiar URL'}
              </button>
            </div>
            <div style={{ marginTop: 12, padding: '10px 14px', background: 'rgba(245,158,11,.08)', borderRadius: 8, fontSize: 12, color: 'var(--text3)' }}>
              💡 <strong>Eventos necessários:</strong> Abandono de Checkout + Aguardando Pagamento
            </div>
          </div>

          {/* Monetizze - ativo */}
          <div style={{ background: 'var(--bg2)', border: '1.5px solid rgba(139,92,246,.3)', borderRadius: 14, padding: 20 }}>
            <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 4 }}>🟣 Monetizze</div>
            <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 14 }}>Monetizze → Ferramentas → Postback → Nova configuração</div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <input readOnly value={rcUrls.monetizze || 'Carregando seu link...'}
                style={{ flex: 1, minWidth: 200, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 14px', color: 'var(--text3)', fontSize: 12, fontFamily: 'monospace' }} />
              <button onClick={() => copyUrl(rcUrls.monetizze || '', 'monetizze')}
                style={{ background: copiedKey === 'monetizze' ? '#10b981' : '#8b5cf6', border: 'none', borderRadius: 8, padding: '10px 18px', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap', transition: 'background .2s' }}>
                {copiedKey === 'monetizze' ? '✅ Copiado!' : 'Copiar URL'}
              </button>
            </div>
            <div style={{ marginTop: 12, padding: '10px 14px', background: 'rgba(139,92,246,.08)', borderRadius: 8, fontSize: 12, color: 'var(--text3)' }}>
              💡 <strong>Eventos necessários:</strong> Abandono de Checkout + Aguardando Pagamento
            </div>
          </div>

          {/* Bot de Recuperação — Seletor + QR + Desconectar */}
          <div style={{ background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 14, padding: 20 }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>📱 Bot de Recuperação</div>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 16 }}>Escolha o WhatsApp que vai enviar as mensagens de recuperação automaticamente</div>

            {/* Seletor de bot */}
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 11, color: 'var(--text3)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, display: 'block', marginBottom: 8 }}>Escolha o WhatsApp</label>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
                {ALL_BOTS.map(b => (
                  <button key={b.id} onClick={() => setPendingBot(b.id)}
                    style={{ padding: '7px 14px', borderRadius: 9, fontSize: 12, fontWeight: 600, cursor: 'pointer', border: 'none', transition: 'all .2s',
                      background: pendingBot === b.id ? 'var(--accent)' : 'var(--bg3)',
                      color: pendingBot === b.id ? '#fff' : 'var(--text3)',
                      boxShadow: pendingBot === b.id ? '0 2px 8px rgba(0,208,132,.25)' : 'none',
                      opacity: pendingBot === b.id ? 1 : 0.7 }}>
                    📱 {b.label}
                  </button>
                ))}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <button onClick={saveBot} disabled={pendingBot === recoveryBot && !!rc.bot_id}
                  style={{ padding: '9px 20px', borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: pendingBot === recoveryBot ? 'default' : 'pointer', border: 'none', transition: 'all .2s',
                    background: saved ? '#10b981' : pendingBot === recoveryBot ? 'var(--bg3)' : 'var(--accent)',
                    color: pendingBot === recoveryBot ? 'var(--text3)' : '#fff',
                    boxShadow: pendingBot !== recoveryBot ? '0 2px 12px rgba(0,208,132,.3)' : 'none' }}>
                  {saved ? '✅ Salvo!' : pendingBot === recoveryBot ? 'Bot atual' : '💾 Usar este bot'}
                </button>
                {pendingBot !== recoveryBot && (
                  <span style={{ fontSize: 12, color: 'var(--text3)' }}>Clique em "Usar este bot" para confirmar</span>
                )}
              </div>
            </div>

            {/* Status + ações */}
            {isOnline ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', background: 'rgba(16,185,129,.08)', border: '1.5px solid rgba(16,185,129,.25)', borderRadius: 10, flexWrap: 'wrap', gap: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: 20 }}>✅</span>
                  <div>
                    <div style={{ fontWeight: 700, color: '#10b981', fontSize: 13 }}>Conectado e pronto</div>
                    {botNumber && <div style={{ fontSize: 11, color: 'var(--text3)', fontFamily: 'monospace', marginTop: 2 }}>{fmtPhone(botNumber)}</div>}
                  </div>
                </div>
                <button onClick={disconnectBot} disabled={disconnecting}
                  style={{ padding: '7px 14px', background: 'rgba(239,68,68,.12)', border: '1.5px solid rgba(239,68,68,.3)', borderRadius: 8, color: '#ef4444', fontWeight: 700, fontSize: 12, cursor: 'pointer' }}>
                  {disconnecting ? '⏳ Desconectando...' : '⏏ Desconectar'}
                </button>
              </div>
            ) : (
              <div>
                <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 14 }}>Escaneie o QR Code com o WhatsApp para ativar:</p>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  {qr ? (
                    <div style={{ padding: 14, background: '#fff', borderRadius: 14, boxShadow: '0 8px 32px rgba(0,0,0,.3)' }}>
                      <img src={qr} alt="QR Code" style={{ width: 190, height: 190, display: 'block' }} />
                    </div>
                  ) : (
                    <div style={{ textAlign: 'center', padding: '20px 36px', background: 'var(--bg3)', borderRadius: 12, color: 'var(--text3)' }}>
                      <div style={{ fontSize: 32, marginBottom: 8 }}>⏳</div>
                      <div style={{ fontSize: 13 }}>Aguardando QR Code...</div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Aviso */}
          <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, padding: 16 }}>
            <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6 }}>⚠️ Importante</div>
            <ul style={{ fontSize: 12, color: 'var(--text3)', lineHeight: 1.8, paddingLeft: 16, margin: 0 }}>
              <li>A URL é única para sua conta — mantenha em sigilo</li>
              <li>Abandonos são processados automaticamente a cada 5 minutos</li>
              <li>Mensagem enviada 10 minutos após o abandono</li>
              <li>Não envia se o cliente já comprou</li>
            </ul>
          </div>
        </div>
      )}

      {/* ABA DASHBOARD */}
      {tab === 'dashboard' && (<>

      {/* Bot Status Card */}
      <div style={{ background: isOnline ? 'linear-gradient(135deg, rgba(16,185,129,.1), rgba(16,185,129,.04))' : 'linear-gradient(135deg, rgba(239,68,68,.1), rgba(239,68,68,.04))',
        border: `1.5px solid ${isOnline ? 'rgba(16,185,129,.35)' : 'rgba(239,68,68,.35)'}`, borderRadius: 16, padding: 'clamp(12px, 4vw, 22px)', marginBottom: 18, position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: -30, right: -30, width: 100, height: 100, borderRadius: '50%', background: isOnline ? 'rgba(16,185,129,.08)' : 'rgba(239,68,68,.08)', pointerEvents: 'none' }} />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, position: 'relative' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ position: 'relative', flexShrink: 0 }}>
              <div style={{ width: 52, height: 52, borderRadius: 15, background: isOnline ? 'linear-gradient(135deg, rgba(16,185,129,.35), rgba(16,185,129,.15))' : 'linear-gradient(135deg, rgba(239,68,68,.35), rgba(239,68,68,.15))', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: isOnline ? '0 4px 20px rgba(16,185,129,.3), inset 0 1px 0 rgba(255,255,255,.1)' : '0 4px 20px rgba(239,68,68,.2), inset 0 1px 0 rgba(255,255,255,.1)', border: isOnline ? '1px solid rgba(16,185,129,.4)' : '1px solid rgba(239,68,68,.4)' }}>
                <span style={{ fontSize: 24, lineHeight: 1 }}>💬</span>
              </div>

            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--text)' }}>WhatsApp {String(recoveryBot).replace('bot', '')} — Bot de Recuperação</div>
              <div style={{ fontSize: 12, color: isOnline ? '#10b981' : '#ef4444', fontWeight: 600, marginTop: 2 }}>{isOnline ? '● Online e ativo' : '● Desconectado'}</div>
              {isOnline && botNumber && (
                <div style={{ fontSize: 11, color: 'var(--text3)', fontFamily: 'monospace', marginTop: 2 }}>{fmtPhone(botNumber)}</div>
              )}
            </div>
          </div>
          {isOnline && !isMobile && (
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 10, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 2 }}>Próxima verificação</div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#10b981' }}>15 segundos</div>
            </div>
          )}
        </div>
        {!isOnline && !loading && (
          <div style={{ marginTop: 18 }}>
            <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 14 }}>Escaneie o QR Code para ativar o bot de recuperação:</p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {qr ? (
                <div style={{ padding: 14, background: '#fff', borderRadius: 14, boxShadow: '0 8px 32px rgba(0,0,0,.3)' }}>
                  <img src={qr} alt="QR Code" style={{ width: 190, height: 190, display: 'block' }} />
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '20px 36px', background: 'var(--bg3)', borderRadius: 12, color: 'var(--text3)' }}>
                  <div style={{ fontSize: 32, marginBottom: 8 }}>⏳</div>
                  <div style={{ fontSize: 13 }}>Gerando QR Code...</div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* seletor de periodo */}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', marginBottom: 12 }}>
        {[['hoje', 'Hoje'], ['ontem', 'Ontem'], ['7d', '7 dias'], ['mes', 'Este m\u00eas'], ['tudo', 'Tudo'], ['custom', 'Personalizado']].map(p => (
          <button key={p[0]} onClick={() => { setRecPer(p[0]); try { localStorage.setItem('rec_per', p[0]); } catch (e) {} }}
            style={{ padding: '5px 12px', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer', background: recPer === p[0] ? 'var(--accent)' : 'var(--bg3)', color: recPer === p[0] ? '#fff' : 'var(--text3)', border: recPer === p[0] ? '1.5px solid var(--accent)' : '1.5px solid var(--border)' }}>{p[1]}</button>
        ))}
        {recPer === 'custom' && (<>
          <input type="date" className="fi" value={recFrom} onChange={e => setRecFrom(e.target.value)} style={{ width: 150 }} />
          <span style={{ color: 'var(--text3)', fontSize: 12 }}>{'at\u00e9'}</span>
          <input type="date" className="fi" value={recTo} onChange={e => setRecTo(e.target.value)} style={{ width: 150 }} />
        </>)}
      </div>

      {/* Stats Grid — 2 colunas no mobile, 4 no desktop */}
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)', gap: isMobile ? 8 : 12, marginBottom: isMobile ? 16 : 24, width: '100%', boxSizing: 'border-box' }}>
        {[
          { label: 'Total', value: stats.total || 0, sub: 'abandonos', color: '#6366f1', border: 'rgba(99,102,241,.25)', barW: barWidths[0], emoji: '🛒' },
          { label: 'Enviadas', value: stats.enviados || 0, sub: `${stats.pendentes || 0} pendentes`, color: '#8b5cf6', border: 'rgba(139,92,246,.25)', barW: barWidths[1], emoji: '📤' },
          { label: 'Vendas recuperadas', value: stats.recuperadas || 0, sub: 'pagas ap\u00f3s a mensagem', color: '#10b981', border: 'rgba(16,185,129,.25)', barW: barWidths[2], emoji: '✅' },
          { label: 'Valor recuperado', value: 'R$ ' + Number(stats.valor_recuperado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), sub: 'vendas pagas ap\u00f3s a mensagem', color: '#06b6d4', border: 'rgba(6,182,212,.25)', barW: null, emoji: '\ud83d\udcb0' },
          { label: 'Comiss\u00e3o recuperada', value: 'R$ ' + Number(stats.comissao_recuperada || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), sub: 'das vendas recuperadas', color: '#f59e0b', border: 'rgba(245,158,11,.25)', barW: null, emoji: '\ud83d\udcb5' },
          { label: 'Taxa de recupera\u00e7\u00e3o', value: Number(stats.taxa_recuperacao || 0).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '%', sub: (stats.pessoas_recuperadas || 0) + ' de ' + (stats.pessoas_contatadas || 0) + ' pessoas', color: '#a855f7', border: 'rgba(168,85,247,.25)', barW: null, emoji: '\ud83c\udfaf' }, /*REC_PERIOD_UI_V2*/
        ].map((s, i) => (
          <div key={i} style={{ background: 'var(--bg2)', border: `1.5px solid ${s.border}`, borderRadius: 12, padding: isMobile ? '10px 10px 8px' : '18px 20px 16px', minWidth: 0, boxSizing: 'border-box', overflow: 'hidden' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: isMobile ? 5 : 8 }}>
              <span style={{ fontSize: isMobile ? 11 : 14, lineHeight: 1 }}>{s.emoji}</span>
              <span style={{ fontSize: isMobile ? 8 : 10, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.label}</span>
            </div>
            <div style={{ fontSize: isMobile ? 22 : 30, fontWeight: 900, color: s.color, lineHeight: 1 }}>{s.value}</div>
            <div style={{ fontSize: isMobile ? 9 : 11, color: 'var(--text3)', marginTop: isMobile ? 3 : 5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.sub}</div>
            {s.barW !== null && (
              <div style={{ marginTop: 'clamp(6px, 2vw, 10px)', height: 3, background: 'var(--border)', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ height: '100%', borderRadius: 4, background: s.color, width: `${s.barW}%`, transition: 'width .8s ease' }} />
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Tabela / Cards mobile */}
      <div style={{ background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 16, overflow: 'hidden', width: '100%', boxSizing: 'border-box' }}>
        {/* Toolbar */}
        <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontWeight: 700, fontSize: 14 }}>Abandonos Recentes</span>
            <span style={{ fontSize: 11, background: 'var(--bg3)', color: 'var(--text3)', padding: '2px 8px', borderRadius: 20, fontWeight: 700 }}>{filtrados.length}</span>
          </div>
          {/* Filtros scrolláveis no mobile */}
          <div style={{ display: 'flex', gap: 4, overflowX: 'auto', paddingBottom: 2, flexShrink: 0 }}>
            {[
              { key: 'todos', label: '📋 Todos' },
              { key: 'pendentes', label: '⏳ Pendentes' },
              { key: 'enviados', label: '📤 Enviados' },
              { key: 'convertidos', label: '✅ Convertidos' },
              { key: 'pix', label: '💳 PIX' },
            ].map(f => (
              <button key={f.key} onClick={() => setFiltro(f.key)}
                style={{ padding: isMobile ? '3px 8px' : '4px 12px', borderRadius: 8, fontSize: isMobile ? 11 : 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
                  background: filtro === f.key ? 'var(--accent)' : 'var(--bg3)',
                  color: filtro === f.key ? '#fff' : 'var(--text3)',
                  border: filtro === f.key ? '1.5px solid var(--accent)' : '1.5px solid var(--border)' }}>
                {f.label}
              </button>
            ))}
          </div>
        </div>

        {/* Mobile: cards empilhados | Desktop: tabela */}
        {isMobile ? (
          <div style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 10 }}>
            {filtrados.length === 0 ? (
              <div style={{ padding: '32px 16px', textAlign: 'center', color: 'var(--text3)' }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>🎯</div>
                <div style={{ fontSize: 13 }}>Nenhum abandono encontrado</div>
              </div>
            ) : filtrados.map(a => {
              const statusCfg = a.converted
                ? { label: 'Convertido', color: '#10b981', bg: 'rgba(16,185,129,.12)' }
                : a.recovery_sent
                ? { label: 'Enviado', color: '#8b5cf6', bg: 'rgba(139,92,246,.12)' }
                : { label: 'Pendente', color: '#f59e0b', bg: 'rgba(245,158,11,.12)' };
              const isPix = a.trans_status === 'Aguardando Pagamento';
              const nome = a.buyer_name || '—';
              const iniciais = nome !== '—' ? nome.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase() : '?';
              return (
                <div key={a.id} style={{ background: 'var(--bg3)', borderRadius: 10, padding: '10px 12px', border: '1px solid var(--border)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div style={{ width: 34, height: 34, borderRadius: 10, background: isPix ? 'rgba(99,102,241,.15)' : 'rgba(139,92,246,.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 800, color: isPix ? '#6366f1' : '#8b5cf6', flexShrink: 0 }}>{iniciais}</div>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)' }}>{nome}</div>
                        <div style={{ fontSize: 11, color: 'var(--text3)', fontFamily: 'monospace', marginTop: 1 }}>{a.buyer_phone ? fmtPhone(a.buyer_phone) : 'Sem telefone'}</div>
                      </div>
                    </div>
                    <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 7, background: statusCfg.bg, color: statusCfg.color }}>{statusCfg.label}</span>
                  </div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 11, padding: '3px 9px', borderRadius: 7, background: isPix ? 'rgba(99,102,241,.12)' : 'rgba(245,158,11,.12)', color: isPix ? '#6366f1' : '#f59e0b', fontWeight: 600 }}>{isPix ? 'PIX' : 'Checkout'}</span>
                    <span style={{ fontSize: 11, color: 'var(--text3)' }}>📅 {fmtDate(a.created_at)}</span>
                    {a.recovery_sent_at && <span style={{ fontSize: 11, color: 'var(--accent)', fontWeight: 600 }}>✓ {fmtDate(a.recovery_sent_at)}</span>}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: 'var(--bg3)' }}>
                  {['Cliente', 'Contato', 'Tipo', 'Status', 'Abandono', 'Recuperação'].map(h => (
                    <th key={h} style={{ padding: '11px 16px', textAlign: 'left', fontSize: 10, color: 'var(--text3)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.8, whiteSpace: 'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtrados.length === 0 ? (
                  <tr><td colSpan={6} style={{ padding: '40px 24px', textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>Nenhum abandono encontrado</td></tr>
                ) : filtrados.map(a => {
                  const statusCfg = a.converted
                    ? { label: 'Convertido', color: '#10b981', bg: 'rgba(16,185,129,.12)' }
                    : a.recovery_sent
                    ? { label: 'Enviado', color: '#8b5cf6', bg: 'rgba(139,92,246,.12)' }
                    : { label: 'Pendente', color: '#f59e0b', bg: 'rgba(245,158,11,.12)' };
                  const isPix = a.trans_status === 'Aguardando Pagamento';
                  const nome = a.buyer_name || '—';
                  const iniciais = nome !== '—' ? nome.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase() : '?';
                  return (
                    <tr key={a.id} style={{ borderTop: '1px solid var(--border)', transition: 'background .12s' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'var(--bg3)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '11px 16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <div style={{ width: 32, height: 32, borderRadius: 9, background: isPix ? 'rgba(99,102,241,.15)' : 'rgba(139,92,246,.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 800, color: isPix ? '#6366f1' : '#8b5cf6', flexShrink: 0 }}>{iniciais}</div>
                          <span style={{ fontSize: 13, fontWeight: 600 }}>{nome}</span>
                        </div>
                      </td>
                      <td style={{ padding: '11px 16px', fontSize: 12, fontFamily: 'monospace', color: 'var(--text3)' }}>
                        {a.buyer_phone ? fmtPhone(a.buyer_phone) : <span style={{ color: 'var(--red)', fontSize: 11 }}>Sem telefone</span>}
                      </td>
                      <td style={{ padding: '11px 16px' }}>
                        <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 7, background: isPix ? 'rgba(99,102,241,.12)' : 'rgba(245,158,11,.12)', color: isPix ? '#6366f1' : '#f59e0b' }}>
                          {isPix ? 'PIX' : 'Checkout'}
                        </span>
                      </td>
                      <td style={{ padding: '11px 16px' }}>
                        <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 7, background: statusCfg.bg, color: statusCfg.color }}>{statusCfg.label}</span>
                      </td>
                      <td style={{ padding: '11px 16px', fontSize: 12, color: 'var(--text3)', whiteSpace: 'nowrap' }}>{fmtDate(a.created_at)}</td>
                      <td style={{ padding: '11px 16px', fontSize: 12, color: a.recovery_sent_at ? 'var(--accent)' : 'var(--text3)', whiteSpace: 'nowrap', fontWeight: a.recovery_sent_at ? 600 : 400 }}>
                        {a.recovery_sent_at ? '✓ ' + fmtDate(a.recovery_sent_at) : '—'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {filtrados.length > 0 && (
          <div style={{ padding: '10px 16px', borderTop: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: 11, color: 'var(--text3)' }}>{filtrados.length} de {abandonos.length} registros</span>
            <span style={{ fontSize: 11, color: 'var(--text3)' }}>↻ 15s</span>
          </div>
        )}
      </div>
      </>)}
    </div>
  );
}

function BackupInstancesPage({ show, userPlan }) {
  const BACKUP_BOTS = [
    { id: 'bot11', label: 'Backup 1' },
    { id: 'bot12', label: 'Backup 2' },
  ];
  const [instances, setInstances] = React.useState([]);
  const [statusMap, setStatusMap] = React.useState({});
  const [qrMap, setQrMap] = React.useState({});
  const [labelMap, setLabelMap] = React.useState({ bot11: 'Backup 1', bot12: 'Backup 2' });
  const [loadingMap, setLoadingMap] = React.useState({});

  const [suspendedBots, setSuspendedBots] = React.useState([]);

  const load = React.useCallback(async () => {
    const r = await api('/backup-instances');
    if (r.ok) {
      setInstances(r.data || []);
      setSuspendedBots(r.suspended_bots || []);
      const lm = {};
      (r.data || []).forEach(b => { lm[b.bot_id] = b.label; });
      setLabelMap(prev => ({ ...prev, ...lm }));
    }
  }, []);

  const [logs, setLogs] = React.useState([]);
  const loadLogs = React.useCallback(async () => {
    const r = await api('/backup-logs');
    if (r.ok) setLogs(r.data || []);
  }, []);
  React.useEffect(() => { load(); loadLogs(); }, [load, loadLogs]);

  const loadStatus = React.useCallback(async (botId) => {
    const r = await api(`/backup-instances/${botId}/status`);
    if (r.ok) setStatusMap(prev => ({ ...prev, [botId]: r }));
  }, []);

  React.useEffect(() => {
    BACKUP_BOTS.forEach(b => loadStatus(b.id));
  }, [instances, loadStatus]);

  const handleAdd = async (botId) => {
    setLoadingMap(prev => ({ ...prev, [botId]: true }));
    const r = await api('/backup-instances', { method: 'POST', body: JSON.stringify({ bot_id: botId, label: labelMap[botId] || botId }) });
    if (r.ok) { show('✅ Instância de backup cadastrada!'); load(); }
    else show(r.error || 'Erro ao cadastrar', 'error');
    setLoadingMap(prev => ({ ...prev, [botId]: false }));
  };

  const handleRemove = async (botId) => {
    if (!window.confirm('Remover esta instância de backup?')) return;
    const r = await api(`/backup-instances/${botId}`, { method: 'DELETE' });
    if (r.ok) { show('Removido'); load(); setQrMap(prev => ({ ...prev, [botId]: null })); setStatusMap(prev => ({ ...prev, [botId]: null })); }
    else show(r.error || 'Erro', 'error');
  };

  const handleToggle = async (botId, active) => {
    await api(`/backup-instances/${botId}`, { method: 'PUT', body: JSON.stringify({ active }) });
    load();
  };

  const handleQr = async (botId) => {
    setLoadingMap(prev => ({ ...prev, [botId + '_qr']: true }));
    const r = await api(`/backup-instances/${botId}/qr`);
    if (r.ok) {
      setQrMap(prev => ({ ...prev, [botId]: r.qr }));
      setStatusMap(prev => ({ ...prev, [botId]: { ready: r.status === 'open', status: r.status } }));
      if (r.status === 'open') show('✅ Conectado!');
    } else show(r.error || 'Erro ao gerar QR', 'error');
    setLoadingMap(prev => ({ ...prev, [botId + '_qr']: false }));
  };

  const handleLogout = async (botId) => {
    if (!window.confirm('Desconectar este número de backup?')) return;
    await api(`/backup-instances/${botId}/logout`, { method: 'POST' });
    show('Desconectado', 'warning');
    setQrMap(prev => ({ ...prev, [botId]: null }));
    loadStatus(botId);
  };

  const isRegistered = (botId) => instances.some(i => i.bot_id === botId);
  const getInstance = (botId) => instances.find(i => i.bot_id === botId);

  const statusColor = (s) => {
    if (!s) return 'var(--text3)';
    if (s.ready || s.status === 'open') return 'var(--accent)';
    if (s.status === 'qr') return 'var(--yellow)';
    return 'var(--red)';
  };
  const statusLabel = (s) => {
    if (!s) return 'Desconhecido';
    if (s.ready || s.status === 'open') return 'Conectado';
    if (s.status === 'qr') return 'Aguardando QR';
    if (s.status === 'connecting') return 'Conectando';
    return 'Desconectado';
  };

  return (
    <div className="fade-up">
      <div className="ph">
        <h1>🛡️ Números Backup</h1>
        <p>Instâncias de contingência — assumem automaticamente quando um bot principal cai</p>
      </div>

      <div className="card" style={{ marginBottom: 16, padding: '14px 18px', background: 'var(--blue-dim)', border: '1.5px solid rgba(63,131,248,.25)' }}>
        <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.7 }}>
          <strong style={{ color: 'var(--blue)' }}>Como funciona:</strong> Se qualquer um dos seus WhatsApp principais ficar offline, o sistema detecta automaticamente e redireciona os envios pendentes para o número de backup disponível — exatamente de onde parou, sem perder nenhuma mensagem.
        </div>
      </div>

      {logs.length > 0 && (
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="card-hd">
            <div>
              <div className="card-t">📋 Histórico de transferências</div>
              <div className="card-s">Quando o backup assumiu automaticamente</div>
            </div>
            <button className="btn btn-g btn-sm" onClick={loadLogs}>🔄</button>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {logs.map(log => {
              const dt = new Date(log.created_at);
              const dateStr = dt.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit' }) + ' ' + dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
              return (
                <div key={log.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', background: 'var(--bg3)', borderRadius: 'var(--r-sm)', border: '1px solid var(--border)' }}>
                  <span style={{ fontSize: 18 }}>🔄</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)' }}>
                      WA{log.original_bot.replace('bot','')} → WA{log.backup_bot.replace('bot','')}
                      <span style={{ fontSize: 11, fontWeight: 500, color: 'var(--text3)', marginLeft: 8 }}>{log.messages_transferred} msg(s) transferidas</span>
                    </div>
                    <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 2, fontFamily: 'JetBrains Mono,monospace' }}>{dateStr}</div>
                  </div>
                  <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 12, background: 'var(--orange-dim)', color: 'var(--orange)', fontWeight: 700 }}>BACKUP ATIVO</span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {BACKUP_BOTS.map(bot => {
          const reg = isRegistered(bot.id);
          const inst = getInstance(bot.id);
          const st = statusMap[bot.id];
          const qr = qrMap[bot.id];
          const connected = st?.ready || st?.status === 'open';
          const loading = loadingMap[bot.id];
          const loadingQr = loadingMap[bot.id + '_qr'];

          return (
            <div key={bot.id} className="card">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: reg ? 16 : 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ width: 44, height: 44, borderRadius: '50%', background: reg ? (connected ? 'rgba(0,208,132,.12)' : 'var(--bg4)') : 'var(--bg4)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>
                    🛡️
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15 }}>{inst?.label || bot.label}</div>
                    <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>{bot.id}</div>
                    {reg && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 4 }}>
                        <div style={{ width: 7, height: 7, borderRadius: '50%', background: statusColor(st) }} />
                        <span style={{ fontSize: 12, color: statusColor(st), fontWeight: 600 }}>{statusLabel(st)}</span>
                        {inst && (
                          <span style={{ fontSize: 11, color: 'var(--text3)', marginLeft: 6 }}>
                            {inst.active ? '● Ativo' : '○ Inativo'}
                          </span>
                        )}
                      </div>
                    )}
                    {reg && st?.number && (
                      <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 3, fontFamily: 'JetBrains Mono, monospace' }}>
                        +{st.number.replace(/^(\d{2})(\d{2})(\d+)/, '$1 ($2) $3')}
                      </div>
                    )}
                  </div>
                </div>

                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {!reg ? (
                    <button className="btn btn-p btn-sm" onClick={() => handleAdd(bot.id)} disabled={loading}>
                      {loading ? 'Cadastrando...' : '+ Cadastrar'}
                    </button>
                  ) : (
                    <>
                      <button className="btn btn-g btn-sm" onClick={() => handleQr(bot.id)} disabled={loadingQr}>
                        {loadingQr ? 'Carregando...' : connected ? '🔄 Reconectar' : '📱 Conectar QR'}
                      </button>
                      {connected && (
                        <button className="btn btn-w btn-sm" onClick={() => handleLogout(bot.id)}>
                          Desconectar
                        </button>
                      )}
                      <button className={`btn btn-sm ${inst?.active ? 'btn-g' : 'btn-p'}`} onClick={() => handleToggle(bot.id, !inst?.active)}>
                        {inst?.active ? '⏸ Pausar' : '▶ Ativar'}
                      </button>
                      <button className="btn btn-d btn-sm" onClick={() => handleRemove(bot.id)}>
                        ❌ Remover
                      </button>
                    </>
                  )}
                </div>
              </div>

              {reg && !connected && qr && (
                <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, padding: 20, background: 'var(--bg3)', borderRadius: 'var(--r)', border: '1.5px dashed var(--border2)' }}>
                  <div style={{ fontSize: 13, color: 'var(--text3)', fontWeight: 600 }}>📷 Escaneie com o WhatsApp do número de backup</div>
                  <div style={{ background: '#fff', padding: 10, borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,.2)' }}>
                    <img src={qr.startsWith('data:') ? qr : `data:image/png;base64,${qr}`} alt="QR Backup" style={{ width: 220, display: 'block' }} />
                  </div>
                  <button className="btn btn-g btn-sm" onClick={() => loadStatus(bot.id)}>🔄 Verificar conexão</button>
                </div>
              )}

              {reg && connected && (() => {
                const myBotsSuspended = (inst?.suspended_bots || []);
                const isActive = myBotsSuspended.length > 0;
                return (
                  <div style={{ marginTop: 12, padding: '12px 16px', background: isActive ? 'rgba(249,115,22,.08)' : 'rgba(0,208,132,.08)', border: `1.5px solid ${isActive ? 'rgba(249,115,22,.3)' : 'rgba(0,208,132,.2)'}`, borderRadius: 'var(--r-sm)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontSize: 20 }}>{isActive ? '🔄' : '✅'}</span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 700, color: isActive ? 'var(--orange)' : 'var(--accent)', fontSize: 14 }}>
                          {isActive ? 'Backup ativo — disparando no lugar do principal' : 'Número de backup pronto'}
                        </div>
                        <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>
                          {isActive
                            ? `Assumiu: ${myBotsSuspended.map(b => b.replace('bot', 'WhatsApp ')).join(', ')} — clique "Pausar" para liberar o principal`
                            : 'Assumirá automaticamente se um bot principal ficar offline'}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function ClientPanel({ onLogout, userEmail, theme, toggleTheme, userPlan = "prime" }) {
  const [showPw, setShowPw] = useState(false); // PATCH_SENHA_V1
  useEffect(() => { api('/auth/me').then(r => { if (r && r.ok && r.must_change_password) setShowPw('forced'); }); }, []);
  // Extrair userId do JWT
  const userId = React.useMemo(() => {
    try {
      const token = localStorage.getItem('zs_token');
      if (!token) return null;
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.userId || payload.id || null;
    } catch { return null; }
  }, []);
  const [page, setPage] = useState('dashboard');
  const [sideOpen, setSideOpen] = useState(false);
  const [botId, setBotId] = useState('bot1');
  const [status, setStatus] = useState('offline');
  const [selectedGroups, setSelectedGroups] = useState(getStoredSel('bot1'));
  const [msgType, setMsgType] = useState('text');
  const [text, setText] = useState('');
  const [filePath, setFilePath] = useState('');
  const [fileName, setFileName] = useState('');
  const [scheduleAt, setScheduleAt] = useState('');
  const [messages, setMessages] = useState([]);
  const [historyStatus, setHistoryStatus] = useState('all');
  const [historyPeriod, setHistoryPeriod] = useState('today');
  const [uploading, setUploading] = useState(false);
  const [mediaPrev, setMediaPrev] = useState(''); /*PASTE_MEDIA_V1*/
  const [mediaPrevKind, setMediaPrevKind] = useState('');
  const [mentionAll, setMentionAll] = useState(false);
  const [scheduling, setScheduling] = useState(false);
  const [delayMin, setDelayMin] = useState(60);
  const [delayMax, setDelayMax] = useState(120);
  const [delayOpen, setDelayOpen] = useState(false);
  const [delaySaving, setDelaySaving] = useState(false);
  const [botNumbers, setBotNumbers] = useState({});
  const [botStatuses, setBotStatuses] = useState({});
  const [botPics, setBotPics] = useState({});
  useEffect(() => { api('/bot-pics').then(r => { if (r && r.ok) setBotPics(r.data || {}); }); }, []);
  const [rescheduleModal, setRescheduleModal] = useState(null);
  const [editModal, setEditModal] = useState(null); // { m, editText, editFilePath, editFileName, editTime, uploading }
  const [mobMore, setMobMore] = useState(false);
  const [newTime, setNewTime] = useState('');
  const [agendaEditModal, setAgendaEditModal] = useState(null); // { item, allGroups, selectedIds }
  const [agendaEditLoading, setAgendaEditLoading] = useState(false);
  const groupsCacheRef = useRef({ botId: null, groups: [], ts: 0 });
  const [polls, setPolls] = useState([]);
  const [pollName, setPollName] = useState('');
  const [pollOptions, setPollOptions] = useState(['', '']);
  const [pollSelectable, setPollSelectable] = useState(1);
  const [pollSchedule, setPollSchedule] = useState('');
  const [pollGroups, setPollGroups] = useState(getStoredSel('bot1'));
  const [pollBotId, setPollBotId] = useState('bot1');
  const [pollMode, setPollMode] = useState('once');
  const [pollRules, setPollRules] = useState([{ days: [], time: '' }]);
  const [pollRecs, setPollRecs] = useState([]);
  const [sequences, setSequences] = useState([]);
  const [previewItem, setPreviewItem] = useState(null);
  const [seqSearch, setSeqSearch] = useState('');
  const [seqExpanded, setSeqExpanded] = useState({});
  const [seqName, setSeqName] = useState('');
  const [seqEditId, setSeqEditId] = useState(null);
  const [seqItems, setSeqItems] = useState([{ type: 'text', text: '', file_path: '', time_offset: '07:00', mention_all: false }]);
  const [seqUploadingIdx, setSeqUploadingIdx] = useState(-1);
  const [seqDispatchId, setSeqDispatchId] = useState(null);
  const [seqDispatchDate, setSeqDispatchDate] = useState('');
  const [seqDispatchBot, setSeqDispatchBot] = useState('bot1');
  const [seqMsg, setSeqMsg] = useState('');
  const [seqEditGroups, setSeqEditGroups] = useState(null); // { seqId, botId, groups, allGroups }
  const [seqCancelId, setSeqCancelId] = useState(null);
  const [linkConfigs, setLinkConfigs] = useState([]);
  const [linkGroups, setLinkGroups] = useState([]);
  const [linkBotId, setLinkBotId] = useState('bot1');
  const [linkNewGroup, setLinkNewGroup] = useState('');
  const [linkSelectedGroups, setLinkSelectedGroups] = useState([]);
  const [linkGroupPics, setLinkGroupPics] = useState({});
  const [linkNewSrc, setLinkNewSrc] = useState('');
  const [linkNewUrl, setLinkNewUrl] = useState('');
  const [campaigns, setCampaigns] = useState([]);
  const [campaignBotId, setCampaignBotId] = useState('bot2');
  const [campaignGroups, setCampaignGroups] = useState([]);
  const [campaignSelectedGroups, setCampaignSelectedGroups] = useState([]);
  const [campaignSubjectBase, setCampaignSubjectBase] = useState('');
  const [campaignNumbering, setCampaignNumbering] = useState(true);
  const [campaignImageFile, setCampaignImageFile] = useState(null);
  const [campaignImagePreview, setCampaignImagePreview] = useState('');
  const [campaignScheduledAt, setCampaignScheduledAt] = useState('');
  const [campaignSaving, setCampaignSaving] = useState(false);
  const [campaignPics, setCampaignPics] = useState({}); // CAMPAIGN_CARDS_V1
  const [campaignNums, setCampaignNums] = useState({}); // CAMPAIGN_NUM_BADGE_V1
  const { show, TC } = useToast();

  const refreshSt = useCallback(async () => {
    const r = await api(`/whatsapp/status?bot=${botId}`);
    setStatus(r.status || 'offline');
    if (r.number) setBotNumbers(prev => ({ ...prev, [botId]: r.number }));
    setBotStatuses(prev => ({ ...prev, [botId]: r.ready || r.status === 'open' }));
    if (r.status !== 'open') { /* não apaga grupos/seleção quando offline */ }
    // Busca números de todos os bots
    for (const b of getAllowedBots(userPlan).map(x => x.id)) {
      const s = await api('/whatsapp/status?bot=' + b);
      if (s.number) setBotNumbers(prev => ({ ...prev, [b]: s.number }));
      setBotStatuses(prev => ({ ...prev, [b]: s.ready || s.status === 'open' }));
    }
  }, []);
  useEffect(() => { refreshSt(); const iv = setInterval(refreshSt, 8000); return () => clearInterval(iv); }, [refreshSt]);

  const loadMsgs = useCallback(async () => {
    const r = await api(`/messages?bot=${botId}`); if (r.ok) setMessages(r.data);
  }, [botId]);
  useEffect(() => { loadMsgs(); const iv = setInterval(loadMsgs, 15000); return () => clearInterval(iv); }, [loadMsgs]);

  // Carregar delay configurado
  useEffect(() => {
    api('/user/settings').then(d => {
      if (d.delay_min != null) setDelayMin(d.delay_min);
      if (d.delay_max != null) setDelayMax(d.delay_max);
    }).catch(() => {});
  }, []);

  const mpSrc = mediaPrev || (filePath ? API_BASE + '/midias/' + String(filePath).split('/midias/').pop() : '');
  const mpVideo = mediaPrevKind ? mediaPrevKind === 'video' : /\.(mp4|mov|m4v|webm)$/i.test(String(filePath));
  const doUpload = async file => {
    if (!file) return;
    try { if (mediaPrev) URL.revokeObjectURL(mediaPrev); } catch (e) {}
    const ft = file.type || '';
    setMediaPrev(URL.createObjectURL(file));
    setMediaPrevKind(ft.startsWith('video') ? 'video' : ft.startsWith('audio') ? 'audio' : 'image');
    setUploading(true);
    try {
      const form = new FormData(); form.append('file', file);
      const token = localStorage.getItem('zs_token');
      const r = await fetch(`${API_BASE}/upload`, { method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: form }).then(x => x.json());
      if (r.ok) { setFilePath(r.file_path); setFileName(file.name); show('Arquivo enviado!'); } else { setMediaPrev(''); show('Erro no upload', 'error'); }
    } catch (err) { setMediaPrev(''); show('Erro no upload', 'error'); }
    setUploading(false);
  };
  const handleUpload = e => doUpload(e.target.files[0]);
  const handlePasteMedia = e => {
    const fl = Array.from((e.clipboardData && e.clipboardData.files) || []).filter(f => /^image\/|^video\//.test(f.type || ''));
    if (!fl.length) return;
    e.preventDefault();
    let f = fl[0];
    if (!f.name || /^image\.[a-z]+$/i.test(f.name)) f = new File([f], 'colado_' + Date.now() + '.' + ((f.type || 'image/png').split('/')[1] || 'png'), { type: f.type });
    setMsgType('media');
    doUpload(f);
  };

  const saveDelay = async () => {
    const min = Math.max(2, Math.min(600, parseInt(delayMin) || 60));
    const max = Math.max(min, Math.min(600, parseInt(delayMax) || 120));
    setDelayMin(min); setDelayMax(max);
    setDelaySaving(true);
    await api('/user/settings', { method: 'PUT', body: JSON.stringify({ delay_min: min, delay_max: max }) });
    setDelaySaving(false);
  };



  const handleSchedule = async () => {
    if (!selectedGroups.length) return show('Selecione ao menos 1 grupo', 'warning');
    if (!scheduleAt) return show('Defina data e hora', 'warning');
    if (msgType === 'text' && !text.trim()) return show('Digite a mensagem', 'warning');
    if (msgType === 'media' && !filePath) return show('Envie uma mídia', 'warning');
    setScheduling(true);
    let ok = 0;
    for (const to_id of selectedGroups) {
      const r = await api('/messages', { method: 'POST', body: JSON.stringify({ to_id, type: msgType, text, file_path: filePath, schedule_at: scheduleAt, instance_id: botId, mention_all: mentionAll }) });
      if (r.ok) ok++;
    }
    show(`✅ ${ok} agendamento(s) criado(s)!`); setText(''); setFilePath(''); setFileName(''); setScheduleAt(''); loadMsgs(); setScheduling(false);
  };

  // Excluir da base (DELETE)
  const handleDeleteOne = async id => {
    if (!window.confirm('Excluir esta mensagem permanentemente?')) return;
    await api(`/messages/${id}`, { method: 'DELETE' });
    show('Excluído', 'error');
    loadMsgs();
  };

  // Cancelar todos os pendentes de um grupo da agenda
  const handleAgendaCancelGroup = async (item) => {
    // Busca mensagens frescas pra ter pendingIds atualizados
    const freshR = await api(`/messages?bot=${botId}`);
    const freshMsgs = freshR.ok ? freshR.data : messages;
    const itemKey = item.date + '||' + item.time + '||' + (item.text || '').trim().slice(0, 60);
    const freshPendingIds = [];
    freshMsgs.forEach(m => {
      if ((m.instance_id || 'bot1') !== botId) return;
      const d = (m.schedule_at || '').slice(0, 10);
      const t = (m.schedule_at || '').slice(11, 16);
      const k = d + '||' + t + '||' + (m.text || '').trim().slice(0, 60);
      if (k === itemKey && (m.status === 'pending' || m.status === 'processing')) freshPendingIds.push(m.id);
    });
    if (freshPendingIds.length === 0) { show('Nenhum pendente encontrado', 'warning'); loadMsgs(); return; }
    if (!window.confirm(`Cancelar ${freshPendingIds.length} envio(s) pendente(s) de "${(item.text || '').slice(0, 30)}..."?`)) return;
    for (const id of freshPendingIds) {
      await api(`/messages/${id}/cancel`, { method: 'POST' });
    }
    show(`⏹ ${freshPendingIds.length} cancelado(s)`, 'warning');
    loadMsgs();
  };

  // Excluir todos os pendentes de um grupo da agenda
  const handleAgendaDeleteGroup = async (item) => {
    // Busca mensagens frescas pra ter IDs atualizados
    const freshR = await api(`/messages?bot=${botId}`);
    const freshMsgs = freshR.ok ? freshR.data : messages;
    const itemKey = item.date + '||' + item.time + '||' + (item.text || '').trim().slice(0, 60);
    const freshIds = [];
    freshMsgs.forEach(m => {
      if ((m.instance_id || 'bot1') !== botId) return;
      if (m.status === 'canceled') return;
      const d = (m.schedule_at || '').slice(0, 10);
      const t = (m.schedule_at || '').slice(11, 16);
      const k = d + '||' + t + '||' + (m.text || '').trim().slice(0, 60);
      if (k === itemKey && (m.status === 'pending' || m.status === 'processing')) freshIds.push(m.id);
    });
    if (freshIds.length === 0) { show('Nenhum pendente para excluir', 'warning'); loadMsgs(); return; }
    if (!window.confirm(`Excluir ${freshIds.length} envio(s) pendente(s) permanentemente?`)) return;
    for (const id of freshIds) {
      await api(`/messages/${id}`, { method: 'DELETE' });
    }
    show(`🗑 ${freshIds.length} excluído(s)`, 'error');
    loadMsgs();
  };

  // Abre modal para editar grupos de um item da agenda (com cache + refresh)
  const handleAgendaEditGroups = async (item) => {
    setAgendaEditLoading(true);
    try {
      // Busca mensagens frescas pra ter pendingIds atualizados
      const freshMsgsR = await api(`/messages?bot=${botId}`);
      const freshMsgs = freshMsgsR.ok ? freshMsgsR.data : messages;
      if (freshMsgsR.ok) setMessages(freshMsgsR.data);

      // Recalcula pendingIds frescos baseado no mesmo agrupamento (date+time+text)
      const itemKey = item.date + '||' + item.time + '||' + (item.text || '').trim().slice(0, 60);
      const freshPendingIds = [];
      const freshPendingToIds = [];
      freshMsgs.forEach(m => {
        if ((m.instance_id || 'bot1') !== botId) return;
        const dateStr = (m.schedule_at || '').slice(0, 10);
        const timeStr = (m.schedule_at || '').slice(11, 16);
        const key = dateStr + '||' + timeStr + '||' + (m.text || '').trim().slice(0, 60);
        if (key === itemKey && (m.status === 'pending' || m.status === 'processing')) {
          freshPendingIds.push(m.id);
          freshPendingToIds.push(m.to_id);
        }
      });

      // Atualiza o item com dados frescos
      const freshItem = { ...item, pendingIds: freshPendingIds, pending: freshPendingIds.length };

      // Cache de grupos
      const cache = groupsCacheRef.current;
      const now = Date.now();
      let allGroups;
      if (cache.botId === botId && cache.groups.length > 0 && (now - cache.ts) < 60000) {
        allGroups = cache.groups;
      } else {
        const r = await api(`/groups?bot=${botId}`);
        allGroups = r.ok ? r.data : [];
        groupsCacheRef.current = { botId, groups: allGroups, ts: now };
      }

      setAgendaEditModal({ item: freshItem, allGroups, selectedIds: freshPendingToIds, botId });
    } finally {
      setAgendaEditLoading(false);
    }
  };

  // Salva os grupos editados: cancela os pendentes atuais e recria com os novos grupos
  const handleAgendaSaveGroups = async () => {
    if (!agendaEditModal) return;
    const { item, selectedIds } = agendaEditModal;
    if (selectedIds.length === 0) return show('Selecione ao menos 1 grupo', 'warning');
    // Cancela os pendentes atuais
    for (const id of item.pendingIds) {
      await api(`/messages/${id}/cancel`, { method: 'POST' });
    }
    // Recria com os novos grupos no mesmo horário
    const scheduleAt = item.date + 'T' + item.time + ':00';
    let ok = 0;
    for (const to_id of selectedIds) {
      const r = await api('/messages', { method: 'POST', body: JSON.stringify({ to_id, type: item.type || 'text', text: item.text, file_path: item.file_path, schedule_at: scheduleAt, instance_id: botId, mention_all: false }) });
      if (r.ok) ok++;
    }
    show(`✅ Reagendado para ${ok} grupo(s)!`);
    setAgendaEditModal(null);
    loadMsgs();
  };

  // Cancelar envio (mantém no histórico como cancelado)
  const handleCancelOne = async id => {
    await api(`/messages/${id}/cancel`, { method: 'POST' });
    show('Cancelado', 'warning');
    loadMsgs();
  };

  const handleReschedule = async () => {
    if (!newTime || !rescheduleModal) return;
    const m = rescheduleModal;
    await api('/messages', { method: 'POST', body: JSON.stringify({ to_id: m.to_id, type: m.type, text: m.text, file_path: m.file_path, schedule_at: newTime, instance_id: botId }) });
    show('Reagendado!'); setRescheduleModal(null); setNewTime(''); loadMsgs();
  };

  // Salva edição de texto/mídia/horário de um agendamento pendente
  const handleEditSave = async () => {
    if (!editModal) return;
    const { m, editText, editFilePath, editTime } = editModal;
    if (!editText.trim() && !editFilePath) return show('Digite o texto ou envie uma mídia', 'warning');
    const schedAt = editTime || m.first_at?.slice(0, 16);
    if (!schedAt) return show('Defina o horário', 'warning');

    // Busca mensagens FRESCAS da API para ter IDs e to_ids atualizados
    const freshR = await api(`/messages?bot=${botId}`);
    const freshMsgs = freshR.ok ? freshR.data : messages;

    // Filtra apenas os pendentes que pertencem a este grupo de agendamento
    const pendingFresh = freshMsgs.filter(x =>
      m.ids.includes(x.id) && (x.status === 'pending' || x.status === 'processing')
    );
    const toIds = [...new Set(pendingFresh.map(x => x.to_id))];

    if (pendingFresh.length === 0) {
      show('Nenhum agendamento pendente encontrado para editar', 'warning');
      setEditModal(null);
      loadMsgs();
      return;
    }

    // Cancela TODOS os pendentes primeiro, aguardando cada um
    for (const msg of pendingFresh) {
      await api(`/messages/${msg.id}/cancel`, { method: 'POST' });
    }

    // Só após todos os cancels, cria os novos agendamentos
    let ok = 0;
    for (const to_id of toIds) {
      const r = await api('/messages', { method: 'POST', body: JSON.stringify({
        to_id,
        type: editFilePath ? 'media' : 'text',
        text: editText,
        file_path: editFilePath || '',
        schedule_at: schedAt + ':00',
        instance_id: m.instance_id || botId,
        mention_all: m.mention_all || false
      })});
      if (r.ok) ok++;
    }

    show(`✅ Editado e reagendado para ${ok} grupo(s)!`);
    setEditModal(null);
    loadMsgs();
  };

  // === ENQUETES ===
  const loadPolls = useCallback(async () => {
    const r = await api('/polls'); if (r.ok) setPolls(r.data || []);
  }, []);
  useEffect(() => { loadPolls(); }, [loadPolls]);

  const handleCreatePoll = async () => {
    if (pollMode === 'repeat') return handleCreatePollRec();
    if (!pollSchedule) return show('Defina data/hora', 'warning');
    if (!pollName.trim()) return show('Digite o título', 'warning');
    const validOpts = pollOptions.filter(o => o.trim());
    if (validOpts.length < 2) return show('Mínimo 2 opções', 'warning');
    if (pollGroups.length === 0) return show('Selecione grupos', 'warning');
    let ok = 0;
    for (const gid of pollGroups) {
      const r = await api('/polls', { method: 'POST', body: JSON.stringify({ to_id: gid, poll_name: pollName, poll_options: validOpts, selectable_count: pollSelectable, schedule_at: pollSchedule, instance: pollBotId }) });
      if (r.ok) ok++;
    }
    show('✅ Enquete agendada para ' + ok + ' grupo(s)!');
    setPollName(''); setPollOptions(['', '']); setPollSelectable(1); setPollSchedule('');
    loadPolls();
  };

  // POLL_REC_UI_V1
  const PR_DIAS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'S\u00e1b'];
  const PR_CSS = `
/* POLL_REC_CARDS_V1 */
.pr-wrap{margin-top:16px}
.pr-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px}
.pr-head h3{margin:0;font-size:16px;font-weight:700;display:flex;align-items:center;gap:10px}
.pr-count{font-size:12px;font-weight:600;padding:3px 10px;border-radius:999px;background:rgba(139,92,246,.15);color:#a78bfa;border:1px solid rgba(139,92,246,.3)}
.pr-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(360px,1fr));gap:14px}
.pr-card{position:relative;overflow:hidden;border-radius:18px;padding:18px 18px 14px;border:1px solid rgba(139,92,246,.28);background:linear-gradient(160deg,rgba(139,92,246,.12),rgba(16,185,129,.04) 65%);box-shadow:0 10px 28px rgba(0,0,0,.18);transition:transform .18s ease,box-shadow .18s ease,border-color .18s ease}
.pr-card:before{content:'';position:absolute;left:0;top:0;right:0;height:3px;background:linear-gradient(90deg,#8b5cf6,#10b981)}
.pr-card:hover{transform:translateY(-2px);border-color:rgba(139,92,246,.5);box-shadow:0 16px 36px rgba(139,92,246,.18)}
.pr-card.off{filter:grayscale(.85);opacity:.6}
.pr-card.off:before{background:rgba(128,128,128,.4)}
.pr-top{display:flex;align-items:center;gap:12px}
.pr-ico{width:42px;height:42px;border-radius:13px;display:flex;align-items:center;justify-content:center;font-size:19px;background:linear-gradient(135deg,#8b5cf6,#6d28d9);box-shadow:0 6px 18px rgba(139,92,246,.35);flex:none}
.pr-tt{flex:1;min-width:0}
.pr-name{font-weight:700;font-size:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pr-meta{font-size:12px;opacity:.65;margin-top:3px}
.pr-pill{display:inline-flex;align-items:center;gap:6px;font-size:11px;font-weight:700;letter-spacing:.4px;text-transform:uppercase;padding:5px 10px;border-radius:999px;flex:none}
.pr-pill.on{background:rgba(16,185,129,.14);color:#10b981;border:1px solid rgba(16,185,129,.35)}
.pr-pill.pause{background:rgba(128,128,128,.15);color:inherit;border:1px solid rgba(128,128,128,.3)}
.pr-dot{width:7px;height:7px;border-radius:50%;background:#10b981;animation:prPulse 1.8s infinite}
@keyframes prPulse{0%{box-shadow:0 0 0 0 rgba(16,185,129,.55)}70%{box-shadow:0 0 0 7px rgba(16,185,129,0)}100%{box-shadow:0 0 0 0 rgba(16,185,129,0)}}
.pr-opts{display:flex;flex-wrap:wrap;gap:6px;margin-top:14px}
.pr-opt{font-size:11.5px;padding:4px 10px;border-radius:8px;background:rgba(128,128,128,.12);border:1px solid rgba(128,128,128,.2);max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pr-rules{margin-top:14px;display:flex;flex-direction:column;gap:8px}
.pr-rule{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 12px;border-radius:12px;background:rgba(128,128,128,.1);border:1px solid rgba(128,128,128,.18)}
.pr-days{display:flex;gap:4px;flex-wrap:wrap}
.pr-day{min-width:34px;text-align:center;font-size:10.5px;font-weight:700;padding:5px 0;border-radius:8px;background:rgba(128,128,128,.12);opacity:.5}
.pr-day.on{opacity:1;color:#fff;background:linear-gradient(135deg,#8b5cf6,#6d28d9);box-shadow:0 3px 10px rgba(139,92,246,.4)}
.pr-time{font-variant-numeric:tabular-nums;font-weight:700;font-size:13px;padding:6px 11px;border-radius:10px;background:rgba(16,185,129,.12);border:1px solid rgba(16,185,129,.35);color:#10b981;white-space:nowrap;flex:none}
.pr-foot{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:14px;padding-top:12px;border-top:1px dashed rgba(128,128,128,.28)}
.pr-next{font-size:11px;opacity:.9;line-height:1.35}
.pr-next span{display:block;opacity:.6;text-transform:uppercase;letter-spacing:.5px;font-size:10px}
.pr-next b{font-size:13px}
.pr-acts{display:flex;gap:8px;align-items:center}
.pr-btn{cursor:pointer;font-size:12px;font-weight:700;padding:8px 14px;border-radius:10px;border:1px solid rgba(128,128,128,.35);background:rgba(128,128,128,.1);color:inherit}
.pr-btn:hover{background:rgba(128,128,128,.2)}
.pr-btn.go{border-color:rgba(16,185,129,.5);background:rgba(16,185,129,.14);color:#10b981}
.pr-btn.del{width:36px;padding:8px 0;border-color:rgba(239,68,68,.35);background:rgba(239,68,68,.1);color:#ef4444}
.pr-btn.del:hover{background:rgba(239,68,68,.22)}
`;
  const prNext = (rc) => {
    if (!rc.active) return '';
    const now = new Date(); let best = null;
    for (let i = 0; i <= 7; i++) {
      const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
      for (const r of rc.rules) {
        if (r.days.indexOf(d.getDay()) < 0) continue;
        const hm = r.time.split(':'); d.setHours(parseInt(hm[0]), parseInt(hm[1]), 0, 0);
        if (d > now && (!best || d < best.d)) best = { d: new Date(d), i, t: r.time };
      }
      if (best) break;
    }
    if (!best) return '';
    return (best.i === 0 ? 'Hoje' : best.i === 1 ? 'Amanh\u00e3' : PR_DIAS[best.d.getDay()]) + ' \u00e0s ' + best.t;
  };
  const loadPollRecs = useCallback(async () => {
    const r = await api('/poll-rec'); if (r.ok) setPollRecs(r.data || []);
  }, []);
  useEffect(() => { loadPollRecs(); }, [loadPollRecs]);

  const handleCreatePollRec = async () => {
    if (!pollName.trim()) return show('Digite o t\u00edtulo', 'warning');
    const validOpts = pollOptions.filter(o => o.trim());
    if (validOpts.length < 2) return show('M\u00ednimo 2 op\u00e7\u00f5es', 'warning');
    const rules = pollRules.filter(r => r.days.length > 0 && r.time);
    if (rules.length === 0) return show('Escolha os dias e o hor\u00e1rio', 'warning');
    if (pollGroups.length === 0) return show('Selecione grupos', 'warning');
    const r = await api('/poll-rec', { method: 'POST', body: JSON.stringify({ poll_name: pollName, poll_options: validOpts, selectable_count: pollSelectable, groups: pollGroups, rules, instance: pollBotId }) });
    if (!r.ok) return show(r.error || 'Erro ao criar', 'error');
    show('\u2705 Enquete recorrente criada! ' + r.created + ' envio(s) agendado(s) nos pr\u00f3ximos 7 dias');
    setPollName(''); setPollOptions(['', '']); setPollSelectable(1); setPollRules([{ days: [], time: '' }]); setPollMode('once');
    loadPollRecs(); loadPolls();
  };

  const handleTogglePollRec = async (id) => {
    await api('/poll-rec/' + id + '/toggle', { method: 'POST' });
    loadPollRecs(); loadPolls();
  };

  const handleDeletePollRec = async (id) => {
    if (!window.confirm('Excluir esta enquete recorrente e os envios pendentes dela?')) return;
    await api('/poll-rec/' + id, { method: 'DELETE' });
    show('Exclu\u00edda', 'warning'); loadPollRecs(); loadPolls();
  };

  const handleCancelPoll = async (id) => {
    await api('/polls/' + id + '/cancel', { method: 'POST' });
    show('Cancelada', 'warning'); loadPolls();
  };

  const handleCancelAllPolls = async () => {
    if (!window.confirm('Cancelar todas as enquetes pendentes?')) return;
    await api('/polls/cancel-all', { method: 'POST' });
    show('Canceladas', 'warning'); loadPolls();
  };

  const handleDeleteAllPolls = async () => {
    if (!window.confirm('Excluir histórico de enquetes?')) return;
    await api('/polls', { method: 'DELETE' });
    show('Excluído'); loadPolls();
  };

  // === SEQUÊNCIAS ===
  // === BACKUP & RESTORE ===
  // eslint-disable-next-line no-unused-vars
  const handleBackupExport = async () => {
    try {
      const r = await api('/backup/export');
      if (!r.ok) return show('Erro ao gerar backup', 'error');
      const blob = new Blob([JSON.stringify(r.data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `pulsend-backup-${new Date().toISOString().slice(0,10)}.json`;
      a.click();
      URL.revokeObjectURL(url);
      show('✅ Backup baixado com sucesso!');
    } catch (e) {
      show('Erro ao exportar backup', 'error');
    }
  };

  // SEQ_SHARE_UI_V1
  const handleShareExport = async () => {
    const r = await api('/seq-share/export');
    if (!r.ok) return show(r.error || 'Erro ao exportar', 'error');
    const blob = new Blob([JSON.stringify(r.data)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'pulsend-sequencias-compartilhar-' + new Date().toISOString().slice(0, 10) + '.json';
    a.click(); URL.revokeObjectURL(url);
    show('\u2705 Exportado: ' + r.data.counts.agendador + ' do Agendador e ' + r.data.counts.status + ' de Status');
  };
  // SEQ_SHARE_CODE_UI_V1
  const runShareImport = async (bodyBase, url) => {
    const pv = await api(url, { method: 'POST', body: JSON.stringify({ ...bodyBase, dry: true }) });
    if (!pv.ok) return show(pv.error || 'Recusado', 'error');
    const msg = 'Importar ' + pv.preview.agendador + ' sequ\u00eancias do Agendador e ' + pv.preview.status + ' sequ\u00eancias de Status?\n\nElas ser\u00e3o criadas como c\u00f3pias "(importada)". Voc\u00ea escolhe os grupos na hora de disparar.';
    if (!window.confirm(msg)) return;
    show('Importando... aguarde');
    const r = await api(url, { method: 'POST', body: JSON.stringify(bodyBase) });
    if (!r.ok) return show(r.error || 'Erro ao importar', 'error');
    show('\u2705 Importadas: ' + r.agendador + ' do Agendador e ' + r.status + ' de Status' + (r.midias_faltando ? ' (' + r.midias_faltando + ' m\u00eddias n\u00e3o encontradas)' : ''));
    loadSequences();
  };
  const handleShareCode = async () => {
    if (!window.confirm('Gerar um c\u00f3digo com TODAS as suas sequ\u00eancias (Agendador e Status)?\n\nO c\u00f3digo vale 7 dias e pode ser usado at\u00e9 10 vezes.')) return;
    const r = await api('/seq-share/code', { method: 'POST', body: JSON.stringify({}) });
    if (!r.ok) return show(r.error || 'Erro ao gerar c\u00f3digo', 'error');
    try { await navigator.clipboard.writeText(r.code); } catch (e) {}
    window.prompt('C\u00f3digo gerado e copiado. Envie para o cliente (vale 7 dias, at\u00e9 10 usos):', r.code);
  };
  const handleShareCodeUse = async () => {
    const code = window.prompt('Digite o c\u00f3digo recebido (ex.: PS-8F3K2Q):');
    if (!code || !code.trim()) return;
    await runShareImport({ code: code.trim().toUpperCase() }, '/seq-share/code-import');
  };
  const handleShareImport = async (e) => {
    const f = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!f) return;
    let data;
    try { data = JSON.parse(await f.text()); } catch (err) { return show('Arquivo inv\u00e1lido', 'error'); }
    if (!data || !data.pulsend_share || !data.payload) return show('Este arquivo n\u00e3o \u00e9 de compartilhamento de sequ\u00eancias', 'error');
    const pv = await api('/seq-share/import', { method: 'POST', body: JSON.stringify({ file: data, dry: true }) });
    if (!pv.ok) return show(pv.error || 'Arquivo recusado', 'error');
    const msg = 'Importar ' + pv.preview.agendador + ' sequ\u00eancias do Agendador e ' + pv.preview.status + ' sequ\u00eancias de Status?\n\nElas ser\u00e3o criadas como c\u00f3pias "(importada)". Voc\u00ea escolhe os grupos na hora de disparar.';
    if (!window.confirm(msg)) return;
    show('Importando... aguarde');
    const r = await api('/seq-share/import', { method: 'POST', body: JSON.stringify({ file: data }) });
    if (!r.ok) return show(r.error || 'Erro ao importar', 'error');
    show('\u2705 Importadas: ' + r.agendador + ' do Agendador e ' + r.status + ' de Status' + (r.midias_faltando ? ' (' + r.midias_faltando + ' m\u00eddias n\u00e3o encontradas)' : ''));
    loadSequences();
  };
  // eslint-disable-next-line no-unused-vars
  const handleBackupImport = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    try {
      const text = await file.text();
      const data = JSON.parse(text);
      if (!data.sequences && !data.link_configs) return show('Arquivo inválido', 'error');

      // Verifica duplicatas primeiro
      const checkR = await api('/backup/import', {
        method: 'POST',
        body: JSON.stringify({ sequences: data.sequences || [], link_configs: data.link_configs || [], overwrite_mode: 'ask' })
      });

      let overwrite_mode = 'duplicate';
      if (checkR.ok && checkR.duplicates && checkR.duplicates.length > 0) {
        const names = checkR.duplicates.join(', ');
        const choice = window.confirm(
          `As seguintes sequências já existem:

${names}

OK = Substituir as existentes
Cancelar = Criar cópias com "(importado)"`
        );
        overwrite_mode = choice ? 'overwrite' : 'duplicate';
      }

      const r = await api('/backup/import', {
        method: 'POST',
        body: JSON.stringify({ sequences: data.sequences || [], link_configs: data.link_configs || [], overwrite_mode })
      });

      if (r.ok) {
        show(`✅ ${r.seqCreated} sequências criadas, ${r.seqOverwritten} substituídas, ${r.seqSkipped} ignoradas, ${r.linkCreated} links restaurados`);
        loadSequences();
        loadLinkConfigs();
      } else {
        show(r.error || 'Erro ao importar', 'error');
      }
    } catch (err) {
      show('Arquivo inválido ou corrompido', 'error');
    }
  };

  const loadSequences = useCallback(async () => {
    const r = await api('/sequences'); if (r.ok) setSequences(r.data || []);
  }, []);
  useEffect(() => { loadSequences(); }, [loadSequences]);

  const seqAddItem = () => {
    const last = seqItems.length > 0 ? seqItems[seqItems.length - 1].time_offset : '07:00';
    const [h, m] = last.split(':').map(Number);
    const nextH = Math.min(h + 2, 23);
    setSeqItems([...seqItems, { type: 'text', text: '', file_path: '', time_offset: String(nextH).padStart(2,'0') + ':' + String(m).padStart(2,'0'), mention_all: false }]);
  };
  const seqRemoveItem = idx => { if (seqItems.length > 1) setSeqItems(seqItems.filter((_, i) => i !== idx)); };
  const seqUpdateItem = (idx, field, val) => { const n = [...seqItems]; n[idx] = { ...n[idx], [field]: val }; setSeqItems(n); };

  const seqUploadFile = async (idx, file) => {
    if (!file) return;
    setSeqUploadingIdx(idx);
    const form = new FormData(); form.append('file', file);
    const token = localStorage.getItem('zs_token');
    const r = await fetch(API_BASE + '/upload', { method: 'POST', headers: { Authorization: 'Bearer ' + token }, body: form }).then(x => x.json());
    if (r.ok) { setSeqItems(prev => { const n = [...prev]; n[idx] = { ...n[idx], file_path: r.file_path, type: 'media' }; return n; }); }
    setSeqUploadingIdx(-1);
  };

  const seqSave = async () => {
    setSeqMsg('');
    if (!seqName.trim()) return setSeqMsg('Digite o nome');
    if (seqItems.length === 0) return setSeqMsg('Adicione pelo menos 1 item');
    const payload = { name: seqName, items: seqItems.map(it => ({ ...it, groups_json: getStoredSel(botId) })) };
    if (seqEditId) {
      await api('/sequences/' + seqEditId, { method: 'PUT', body: JSON.stringify(payload) });
      show('✅ Sequência atualizada!'); setSeqEditId(null);
    } else {
      await api('/sequences', { method: 'POST', body: JSON.stringify(payload) });
      show('✅ Sequência salva!');
    }
    setSeqName(''); setSeqItems([{ type: 'text', text: '', file_path: '', time_offset: '07:00', mention_all: false }]);
    loadSequences();
  };

  const seqEdit = seq => {
    setSeqEditId(seq.id); setSeqName(seq.name);
    setSeqItems(seq.items.map(it => ({ type: it.type, text: it.text || '', file_path: it.file_path || '', time_offset: it.time_offset || '07:00', mention_all: !!it.mention_all })));
  };

  const seqDelete = async id => { if (!window.confirm('Excluir?')) return; await api('/sequences/' + id, { method: 'DELETE' }); loadSequences(); };
  const seqDuplicate = async id => { await api('/sequences/' + id + '/duplicate', { method: 'POST' }); show('Duplicada!'); loadSequences(); };
  
  const openPreview = (sequence, index = 0) => {
    setPreviewItem({
      sequenceId: sequence.id,
      sequenceName: sequence.name,
      items: sequence.items || [],
      currentIndex: index
    });
  };
  
  const closePreview = () => {
    setPreviewItem(null);
  };
  
  const previewNext = () => {
    if (previewItem && previewItem.currentIndex < previewItem.items.length - 1) {
      setPreviewItem({ ...previewItem, currentIndex: previewItem.currentIndex + 1 });
    }
  };
  
  const previewPrev = () => {
    if (previewItem && previewItem.currentIndex > 0) {
      setPreviewItem({ ...previewItem, currentIndex: previewItem.currentIndex - 1 });
    }
  };
  
  const previewEdit = () => {
    if (!previewItem) return;
    const seq = sequences.find(s => s.id === previewItem.sequenceId);
    if (seq) {
      closePreview();
      seqEdit(seq);
      // Scroll suave para o topo
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const seqDispatch = async () => {
    if (!seqDispatchDate) return setSeqMsg('Escolha a data');
    const groups = getStoredSel(seqDispatchBot);
    if (groups.length === 0) return setSeqMsg('Selecione grupos na aba Agendar primeiro');
    const r = await api('/sequences/' + seqDispatchId + '/dispatch', { method: 'POST', body: JSON.stringify({ date: seqDispatchDate, groups_override: groups, instance: seqDispatchBot }) });
    if (r.ok) { show('✅ ' + r.message); setSeqDispatchId(null); setSeqDispatchDate(''); loadMsgs(); }
    else setSeqMsg(r.error || 'Erro');
  };

  const seqCancelEdit = () => { setSeqEditId(null); setSeqName(''); setSeqItems([{ type: 'text', text: '', file_path: '', time_offset: '07:00', mention_all: false }]); };

  // Abre modal de edição de grupos de uma sequência
  const seqOpenEditGroups = async (seq) => {
    const botForGroups = seqDispatchBot || 'bot1';
    const r = await api('/groups?bot=' + botForGroups);
    const allGroups = r.ok ? r.data : [];
    // Pega grupos salvos no primeiro item da sequência
    let savedGroups = [];
    try { savedGroups = seq.items[0]?.groups_json ? JSON.parse(seq.items[0].groups_json) : []; } catch {}
    setSeqEditGroups({ seqId: seq.id, seqName: seq.name, botId: botForGroups, groups: savedGroups, allGroups, items: seq.items });
  };

  // Salva nova lista de grupos numa sequência existente
  const seqSaveGroups = async () => {
    if (!seqEditGroups) return;
    const { seqId, seqName, groups, items } = seqEditGroups;
    const updatedItems = items.map(it => ({ ...it, groups_json: groups, mention_all: it.mention_all, instance: it.instance }));
    await api('/sequences/' + seqId, { method: 'PUT', body: JSON.stringify({ name: seqName, items: updatedItems }) });
    show('✅ Grupos da sequência atualizados!');
    setSeqEditGroups(null);
    loadSequences();
  };

  // Cancela todos os agendamentos pendentes de uma sequência (pela data do dispatch)
  const seqCancelScheduled = async (seqId) => {
    if (!window.confirm('Cancelar todos os agendamentos pendentes desta sequência?')) return;
    setSeqCancelId(seqId);
    const r = await api('/sequences/' + seqId + '/cancel-pending', { method: 'POST' });
    if (r.ok) show('✅ ' + (r.canceled || 0) + ' agendamento(s) cancelado(s)!', 'warning');
    else show(r.error || 'Erro ao cancelar', 'error');
    setSeqCancelId(null);
    loadMsgs();
  };

  // === LINK CONFIGS ===
  const loadLinkConfigs = useCallback(async () => {
    const r = await api('/link-configs'); if (r.ok) setLinkConfigs(r.data || []);
  }, []);
  useEffect(() => { loadLinkConfigs(); }, [loadLinkConfigs]);

  const loadLinkGroups = async (bot) => {
    const r = await api('/groups?bot=' + bot); if (r.ok) setLinkGroups(r.data || []);
  };

  useEffect(() => { // LINK_PICS_EFFECT_V1
    if (!linkGroups.length) return undefined;
    let dead = false;
    (async () => {
      let todo = linkGroups.map(g => g.id);
      for (let round = 0; round < 40 && todo.length && !dead; round++) {
        const r = await api('/group-pics', { method: 'POST', body: JSON.stringify({ bot_id: linkBotId, ids: todo.slice(0, 60) }) });
        if (dead || !r.ok || !r.data) break;
        const got = Object.keys(r.data);
        if (!got.length) break;
        setLinkGroupPics(p => ({ ...p, ...r.data }));
        const done = new Set(got);
        todo = todo.filter(id => !done.has(id));
      }
    })();
    return () => { dead = true; };
  }, [linkGroups, linkBotId]);

  const handleSaveLink = async () => {
    if (!linkSelectedGroups.length || !linkNewUrl) return show('Selecione ao menos um grupo e a URL', 'warning');
    const r = await api('/link-configs/bulk', { method: 'POST', body: JSON.stringify({ groups: linkSelectedGroups.map(gid => ({ group_id: gid, src: linkNewSrc, link: linkNewUrl })) }) });
    if (r.ok) { show(`✅ Link salvo em ${linkSelectedGroups.length} grupo(s)!`); setLinkSelectedGroups([]); setLinkNewSrc(''); loadLinkConfigs(); }
    else show(r.error || 'Erro ao salvar', 'error');
  };

  const handleDeleteLink = async (id) => {
    await api('/link-configs/' + id, { method: 'DELETE' }); loadLinkConfigs();
  };
  const handleToggleLink = async (id) => {
    const r = await api('/link-configs/' + id + '/toggle', { method: 'PUT' });
    if (r.ok) loadLinkConfigs();
  };
  const handleToggleAll = async (active) => {
    const r = await api('/link-configs/toggle-all', { method: 'PUT', body: JSON.stringify({ active }) });
    if (r.ok) loadLinkConfigs();
  };
  // === CAMPANHAS DE GRUPO (nome + foto) ===
  const loadCampaigns = useCallback(async () => {
    const r = await api('/group-campaigns'); if (r.ok) setCampaigns(r.data || []);
  }, []);
  useEffect(() => { loadCampaigns(); }, [loadCampaigns]);
  const loadCampaignGroups = async (bot) => {
    const r = await api('/groups?bot=' + bot); if (r.ok) setCampaignGroups(r.data || []);
  };
  useEffect(() => { // CAMPAIGN_PICS_EFFECT_V1
    if (!campaignGroups.length) return undefined;
    let dead = false;
    (async () => {
      let todo = campaignGroups.map(g => g.id);
      for (let round = 0; round < 40 && todo.length && !dead; round++) {
        const r = await api('/group-pics', { method: 'POST', body: JSON.stringify({ bot_id: campaignBotId, ids: todo.slice(0, 60) }) });
        if (dead || !r.ok || !r.data) break;
        const got = Object.keys(r.data);
        if (!got.length) break;
        setCampaignPics(p => ({ ...p, ...r.data }));
        const done = new Set(got);
        todo = todo.filter(id => !done.has(id));
      }
    })();
    return () => { dead = true; };
  }, [campaignGroups, campaignBotId]);

  useEffect(() => { // CAMPAIGN_NUM_BADGE_FETCH_V1
    let dead = false;
    api('/campaign-group-nums').then(r => { if (!dead && r.ok) setCampaignNums(r.data || {}); });
    return () => { dead = true; };
  }, [campaignGroups]);
  const toggleCampaignGroup = (groupId) => {
    setCampaignSelectedGroups(prev => prev.includes(groupId) ? prev.filter(g => g !== groupId) : [...prev, groupId]);
  };
  const toggleAllCampaignGroups = () => {
    setCampaignSelectedGroups(prev => prev.length === campaignGroups.length ? [] : campaignGroups.map(g => g.id));
  };

  const removeCampaignNum = async (groupId) => { // CAMPAIGN_NUM_REMOVE_FN_V1
    if (!window.confirm('Remover o numero fixo desse grupo? Na proxima campanha ele pega um numero novo.')) return;
    const r = await api('/campaign-group-nums/' + encodeURIComponent(groupId), { method: 'DELETE' });
    if (r.ok) setCampaignNums(prev => { const n = { ...prev }; delete n[groupId]; return n; });
    else show((r && r.error) || 'Erro ao remover numero', 'error');
  };
  const resetAllCampaignNums = async () => {
    if (!window.confirm('Resetar TODOS os numeros fixados? Isso apaga a numeracao de todos os grupos.')) return;
    const r = await api('/campaign-group-nums', { method: 'DELETE' });
    if (r.ok) { setCampaignNums({}); show('Numeros resetados'); }
    else show((r && r.error) || 'Erro ao resetar numeros', 'error');
  };
  const handleCampaignImageChange = (file) => {
    if (!file) return;
    setCampaignImageFile(file);
    const reader = new FileReader();
    reader.onload = (e) => setCampaignImagePreview(e.target.result);
    reader.readAsDataURL(file);
  };
  const handleSaveCampaign = async (applyNow) => {
    if (!campaignSubjectBase.trim()) return show('Digite o nome base', 'warning');
    if (campaignSelectedGroups.length === 0) return show('Selecione pelo menos um grupo', 'warning');
    setCampaignSaving(true);
    try {
      let imageUrl = '';
      if (campaignImageFile) {
        const formData = new FormData();
        formData.append('file', campaignImageFile);
        const upRes = await fetch(API_BASE + '/upload', {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('zs_token') },
          body: formData
        });
        const upData = await upRes.json();
        if (upData.ok) imageUrl = 'https://app.pulsend.online' + upData.file_path.replace('/var/www/whats-saas', '');
      }
      const body = {
        name: campaignSubjectBase,
        subject_base: campaignSubjectBase,
        image_url: imageUrl || null,
        bot_id: campaignBotId,
        groups: campaignSelectedGroups,
        numbering: campaignNumbering,
        scheduled_at: applyNow ? null : (campaignScheduledAt || null),
      };
      const r = await api('/group-campaigns', { method: 'POST', body: JSON.stringify(body) });
      if (r.ok) {
        show(applyNow ? '✅ Campanha aplicada!' : '✅ Campanha agendada!');
        setCampaignSubjectBase(''); setCampaignSelectedGroups([]); setCampaignImageFile(null); setCampaignImagePreview(''); setCampaignScheduledAt('');
        loadCampaigns();
      } else {
        show(r.error || 'Erro ao salvar campanha', 'error');
      }
    } catch(e) {
      show('Erro: ' + e.message, 'error');
    }
    setCampaignSaving(false);
  };
  const handleDeleteCampaign = async (id) => {
    await api('/group-campaigns/' + id, { method: 'DELETE' }); loadCampaigns();
  };

  const stats = {
    sent: messages.filter(m => m.status === 'sent').length,
    pending: messages.filter(m => m.status === 'pending').length,
    failed: messages.filter(m => m.status === 'failed').length,
  };

  const closeSide = () => setSideOpen(false);
  const nav = (p, lbl, ico) => (
    <button className={`nb ${page === p ? 'active' : ''}`} onClick={() => { setPage(p); closeSide(); }}>
      <span className="nb-ico">{ico}</span>{lbl}
    </button>
  );

  return (
    <div className="layout">
      <aside className={`sidebar ${sideOpen ? 'open' : ''}`}>
        <div className="logo">
          <div className="logo-row">
            <div className="logo-icon">⚡</div>
            <div className="logo-text"><div className="logo-n">Pulse<span>nd</span></div><div className="logo-t">Agendador Pro</div></div>
          </div>
        </div>
        <nav className="nav">
        {nav('dashboard', 'Dashboard', '🏠')}
        <div style={{ height: 1, background: 'var(--border)', margin: '6px 12px', opacity: 0.5 }} />
	{nav('bots', 'WhatsApp', '📱')}
	{nav('ai-bot', 'Bot IA', '🤖')}
	{nav('schedule', 'Agendar', '📅')}
	{nav('polls', 'Enquetes', '📊')}
	{nav('sequences', 'Sequências', '📋')}
	{nav('links', 'Links/SRC', '🔗')}
   {nav('grp-monitor', 'Monitor Grupos', '\u{1F465}')}
        {nav('campaigns', 'Campanhas', '🎯')}
        {nav('status', 'Status', '📲')}
	{nav('history', 'Histórico', '📂')}
{nav('backup-instances', 'Nº Backup', '🛡️')}
        {nav('sales', 'Vendas', '💰')}
        {nav('recuperacao', 'Recuperação', '🔄')}
        </nav>
        <div className="sfoot">
          <button className="theme-btn" onClick={toggleTheme}>
            <span style={{ fontSize: 16 }}>{theme === 'dark' ? '🌙' : '☀️'}</span>
            <span className="theme-label">{theme === 'dark' ? 'Tema Escuro' : 'Tema Claro'}</span>
            <div className={`toggle ${theme === 'dark' ? 'on' : ''}`} />
          </button>
          <div className="urow">
            <div className="av">{userEmail?.[0]?.toUpperCase() || 'U'}</div>
            <div className="ue">{userEmail}</div>
            <button className="lob" onClick={() => setShowPw(true)} title="Trocar senha">🔑</button>
            <button className="lob" onClick={onLogout} title="Sair">✕</button>
            {showPw && <ChangePasswordModal forced={showPw === 'forced'} onClose={() => setShowPw(false)} />}
          </div>
        </div>
      </aside>

      {sideOpen && <div className="overlay show" onClick={closeSide} />}

      <div className="content">
        {/* Mobile topbar */}
        <div className="topbar">
          <button className="ham" onClick={() => setSideOpen(s => !s)}>☰</button>
          <span className="topbar-name">Pulse<span>nd</span></span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <NotificationBell onNavigate={(p) => { setPage(p); setSideOpen(false); }} />
            <Badge status={status} />
          </div>
        </div>

        {/* Desktop header bar */}
        <div className="desktop-header-bar" style={{
          display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
          gap: 10, padding: '10px 24px',
          borderBottom: '1px solid var(--border)',
          background: 'var(--bg2)',
          position: 'sticky', top: 0, zIndex: 100,
          backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)',
        }}>
          <NotificationBell onNavigate={setPage} />
          <Badge status={status} />
        </div>

        <div className="inner">
          {page === 'dashboard' && (() => {
            const bots = getAllowedBots(userPlan);
            const connectedCount = bots.filter(b => botStatuses[b.id] || botNumbers[b.id]).length;
            const totalBots = bots.length;
            const todayMsgs = messages.filter(m => {
              const d = new Date(); const today = d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
              return (m.schedule_at || '').startsWith(today);
            });
            const sentToday = todayMsgs.filter(m => m.status === 'sent').length;
            const pendingToday = todayMsgs.filter(m => m.status === 'pending').length;
            const failedToday = todayMsgs.filter(m => m.status === 'failed').length;
            const totalToday = todayMsgs.length;

            const DashCard = ({ icon, label, value, sub, color, glow }) => (
              <div style={{
                background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 16,
                padding: '20px 22px', position: 'relative', overflow: 'hidden',
                boxShadow: 'var(--card-shadow)', transition: 'all .25s cubic-bezier(.22,1,.36,1)',
                cursor: 'default',
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = `0 8px 32px ${glow || 'rgba(0,0,0,.15)'}`; e.currentTarget.style.borderColor = color || 'var(--border2)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'var(--card-shadow)'; e.currentTarget.style.borderColor = 'var(--border)'; }}
              >
                <div style={{ position: 'absolute', top: -20, right: -20, width: 80, height: 80, borderRadius: '50%', background: `radial-gradient(circle, ${glow || 'rgba(0,208,132,.06)'}, transparent 70%)`, pointerEvents: 'none' }} />
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                  <div style={{
                    width: 42, height: 42, borderRadius: 12,
                    background: `linear-gradient(135deg, ${color || 'var(--accent)'}22, ${color || 'var(--accent)'}08)`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20,
                    border: `1.5px solid ${color || 'var(--accent)'}25`,
                  }}>{icon}</div>
                  <div style={{ fontSize: 11, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 1, fontWeight: 800 }}>{label}</div>
                </div>
                <div style={{ fontSize: 32, fontWeight: 900, color: color || 'var(--text)', letterSpacing: '-1.5px', lineHeight: 1 }}>{typeof value === 'number' ? <AnimatedNumber value={value} color={color} /> : value}</div>
                {sub && <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 6, fontWeight: 500 }}>{sub}</div>}
              </div>
            );

            return (
              <div className="fade-up">
                <div className="ph" style={{ marginBottom: 28 }}>
                  <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, var(--accent), #00956b)', fontSize: 18, boxShadow: '0 4px 16px var(--accent-glow)' }}>🏠</span>
                    Dashboard
                  </h1>
                  <p>Visão geral do seu painel</p>
                </div>

                {/* Saudação */}
                <div style={{
                  padding: '20px 24px', marginBottom: 22,
                  background: 'linear-gradient(135deg, rgba(0,208,132,.13) 0%, rgba(0,208,132,.05) 55%, rgba(0,179,113,.02) 100%)',
                  border: '1.5px solid rgba(0,208,132,.22)', borderRadius: 16,
                  display: 'flex', alignItems: 'center', gap: 16,
                  position: 'relative', overflow: 'hidden',
                }}>
                  {/* Glow decorativo */}
                  <div style={{ position: 'absolute', top: -30, right: -20, width: 130, height: 130, borderRadius: '50%', background: 'radial-gradient(circle, rgba(0,208,132,.08), transparent 70%)', pointerEvents: 'none' }} />
                  {/* Avatar com gradiente */}
                  <div style={{ width: 50, height: 50, borderRadius: 14, background: 'linear-gradient(135deg, var(--accent), #00956b)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, boxShadow: '0 4px 16px rgba(0,208,132,.35)', flexShrink: 0 }}>👋</div>
                  {/* Texto */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--text)', letterSpacing: '-.4px' }}>
                      Olá, <span style={{ color: 'var(--accent)' }}>{userEmail?.split('@')[0] || 'usuário'}</span>!
                    </div>
                    <div style={{ fontSize: 12.5, color: 'var(--text3)', marginTop: 3, fontWeight: 500 }}>
                      {new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })}
                    </div>
                  </div>
                  {/* Status do sistema */}
                  <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <div style={{ fontSize: 10, color: 'var(--text3)', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 5 }}>Sistema</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: 'flex-end' }}>
                      <div style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--accent)', boxShadow: '0 0 6px var(--accent-glow)', animation: 'glowPulse 2.5s ease infinite', flexShrink: 0 }} />
                      <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--accent)' }}>Online</span>
                    </div>
                  </div>
                </div>

                {/* Cards de métricas */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 14, marginBottom: 24 }}>
                  <DashCard icon="📱" label="Bots Online" value={`${connectedCount}/${totalBots}`}
                    sub={connectedCount === totalBots ? 'Todos conectados' : `${totalBots - connectedCount} offline`}
                    color={connectedCount === totalBots ? '#10b981' : '#f59e0b'}
                    glow={connectedCount === totalBots ? 'rgba(0,208,132,.12)' : 'rgba(245,158,11,.1)'} />
                  <DashCard icon="📤" label="Enviados Hoje" value={sentToday}
                    sub={totalToday > 0 ? `de ${totalToday} total` : 'Nenhum agendamento'}
                    color="#10b981" glow="rgba(0,208,132,.12)" />
                  <DashCard icon="⏳" label="Pendentes" value={pendingToday}
                    sub={pendingToday > 0 ? 'Aguardando envio' : 'Tudo enviado'}
                    color="#3b82f6" glow="rgba(59,130,246,.1)" />
                  <DashCard icon="❌" label="Falhas" value={failedToday}
                    sub={failedToday > 0 ? 'Verificar envios' : 'Nenhuma falha'}
                    color={failedToday > 0 ? '#ef4444' : '#10b981'}
                    glow={failedToday > 0 ? 'rgba(239,68,68,.1)' : 'rgba(0,208,132,.08)'} />
                </div>

                {/* Status dos bots */}
                <div style={{
                  background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 16,
                  padding: '20px 22px', boxShadow: 'var(--card-shadow)', marginBottom: 20,
                }}>
                  <div style={{ fontSize: 13, fontWeight: 800, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: 16 }}>📡</span> Status das instâncias
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {bots.map((b, idx) => {
                      const num = botNumbers[b.id];
                      const isOn = botStatuses[b.id] || !!num;
                      return (
                        <div key={b.id} style={{
                          display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px',
                          background: isOn ? 'rgba(0,208,132,.04)' : 'var(--bg3)',
                          border: `1px solid ${isOn ? 'rgba(0,208,132,.15)' : 'var(--border)'}`,
                          borderRadius: 12, transition: 'all .2s', cursor: 'pointer',
                        }}
                        onClick={() => { setPage('bots'); }}
                        onMouseEnter={e => { e.currentTarget.style.transform = 'translateX(4px)'; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = 'translateX(0)'; }}
                        >
                          <div style={{
                            width: 10, height: 10, borderRadius: '50%', flexShrink: 0,
                            background: isOn ? 'var(--accent)' : 'var(--red)',
                            boxShadow: isOn ? '0 0 8px var(--accent-glow)' : 'none',
                            animation: isOn ? 'glowPulse 2.5s ease infinite' : 'none',
                          }} />
                          <div style={{ flex: 1 }}>
                            <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)' }}>{b.label}</span>
                          </div>
                          {num && <span style={{ fontSize: 11, color: 'var(--text3)', fontFamily: 'JetBrains Mono,monospace' }}>+{num.replace(/^(\d{2})(\d{2})(\d+)/, '$1 ($2) $3')}</span>}
                          <span style={{
                            fontSize: 10, fontWeight: 800, padding: '3px 10px', borderRadius: 20,
                            background: isOn ? 'var(--accent-dim)' : 'var(--red-dim)',
                            color: isOn ? 'var(--accent)' : 'var(--red)',
                          }}>{isOn ? 'ONLINE' : 'OFFLINE'}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Atalhos rápidos */}
                <div style={{
                  background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 16,
                  padding: '20px 22px', boxShadow: 'var(--card-shadow)',
                }}>
                  <div style={{ fontSize: 13, fontWeight: 800, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: 16 }}>⚡</span> Atalhos rápidos
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 10 }}>
                    {[
                      { page: 'schedule', icon: '📅', label: 'Agendar envio' },
                      { page: 'sequences', icon: '📋', label: 'Sequências' },
                      { page: 'sales', icon: '💰', label: 'Vendas' },
                      { page: 'polls', icon: '📊', label: 'Enquetes' },
                      { page: 'links', icon: '🔗', label: 'Links/SRC' },
                      { page: 'campaigns', icon: '🎯', label: 'Campanhas' },
                      { page: 'history', icon: '📂', label: 'Histórico' },
                    ].map(s => (
                      <button key={s.page} onClick={() => setPage(s.page)}
                        style={{
                          display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px',
                          background: 'var(--bg3)', border: '1.5px solid var(--border)', borderRadius: 12,
                          cursor: 'pointer', fontFamily: 'Inter,sans-serif', transition: 'all .2s cubic-bezier(.22,1,.36,1)',
                          color: 'var(--text2)', fontSize: 13, fontWeight: 600,
                        }}
                        onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.color = 'var(--accent)'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,208,132,.1)'; }}
                        onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--text2)'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
                      >
                        <span style={{ fontSize: 18 }}>{s.icon}</span>
                        {s.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            );
          })()}

          {page === 'bots' && (
            <div className="fade-up">
              <div className="ph" style={{ marginBottom: 28 }}>
                <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, #25D366, #128C7E)', fontSize: 18, boxShadow: '0 4px 16px rgba(37,211,102,.25)' }}>📱</span>
                  WhatsApp
                </h1>
                <p>Conecte seu número ao sistema</p>
              </div>
              {/* Resumo rápido de conexões */}
              {(() => {
                const total = getAllowedBots(userPlan).length;
                return (
                  <div style={{
                    display: 'flex', gap: 12, marginBottom: 20, padding: '14px 18px',
                    background: 'var(--bg2)', border: '1.5px solid var(--border)', borderRadius: 14,
                    boxShadow: 'var(--card-shadow)', alignItems: 'center',
                    animation: 'fadeUp .3s cubic-bezier(.22,1,.36,1) both',
                  }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)', flex: 1 }}>
                      {total} instância{total > 1 ? 's' : ''} disponíve{total > 1 ? 'is' : 'l'}
                    </div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      {getAllowedBots(userPlan).map((b, i) => (
                        <div key={b.id} style={{
                          width: 10, height: 10, borderRadius: '50%',
                          background: 'var(--bg4)', border: '2px solid var(--border)',
                          transition: 'all .3s',
                        }} title={b.label} />
                      ))}
                    </div>
                  </div>
                );
              })()}
              {getAllowedBots(userPlan).map(b => <BotCard key={b.id} botId={b.id} label={b.label} />)}
            </div>
          )}
		{page === 'ai-bot' && (
  <BotAIPage userPlan={userPlan} show={show} />
)}
          {page === 'schedule' && (
            <div className="fade-up">
              <div className="ph" style={{ marginBottom: 28 }}>
                <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, var(--accent), #00956b)', fontSize: 18, boxShadow: '0 4px 16px var(--accent-glow)' }}>📅</span>
                  Agendar
                </h1>
                <p>Programe envios para seus grupos</p>
              </div>
              {/* Desktop: tabs horizontais premium */}
              <div className="bot-tabs-desktop" style={{ display: 'flex', gap: 8, marginBottom: 18, background: 'var(--bg2)', padding: 6, borderRadius: 16, overflowX: 'auto', WebkitOverflowScrolling: 'touch', border: '1.5px solid var(--border)', boxShadow: 'var(--card-shadow)' }}>
                {getAllowedBots(userPlan).map((bot, idx) => {
                  const b = bot.id;
                  const sel = botId === b;
                  const num = botNumbers[b];
                  const isConnected = !!num;
                  return (
                    <div key={b} onClick={() => { setBotId(b); setSelectedGroups(getStoredSel(b)); }}
                      style={{
                        flex: '1 1 0', minWidth: 150, display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px',
                        borderRadius: 12, cursor: 'pointer', position: 'relative', overflow: 'hidden',
                        background: sel ? 'linear-gradient(135deg, rgba(0,208,132,.12), rgba(0,208,132,.04))' : 'transparent',
                        border: sel ? '1.5px solid rgba(0,208,132,.35)' : '1.5px solid transparent',
                        boxShadow: sel ? '0 4px 20px rgba(0,208,132,.12), inset 0 1px 0 rgba(255,255,255,.04)' : 'none',
                        transition: 'all .25s cubic-bezier(.22,1,.36,1)',
                        animation: sel && isConnected ? 'none' : 'none',
                        transform: sel ? 'scale(1)' : 'scale(0.98)',
                      }}
                      onMouseEnter={e => { if (!sel) { e.currentTarget.style.background = 'var(--bg3)'; e.currentTarget.style.transform = 'scale(1)'; }}}
                      onMouseLeave={e => { if (!sel) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.transform = 'scale(0.98)'; }}}
                    >
                      <div style={{
                        width: 36, height: 36, borderRadius: 10,
                        background: sel ? 'linear-gradient(135deg, rgba(0,208,132,.2), rgba(0,208,132,.08))' : 'var(--bg4)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                        border: sel ? '1.5px solid rgba(0,208,132,.25)' : '1.5px solid var(--border)',
                        transition: 'all .25s',
                      }}>
                        {(botPics[bot.id] && isConnected) ? <img src={botPics[bot.id]} alt="" referrerPolicy="no-referrer" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }} onError={() => setBotPics(p => ({ ...p, [bot.id]: null }))} /> : <div style={{
                          width: 10, height: 10, borderRadius: '50%',
                          background: isConnected ? 'var(--accent)' : 'var(--red)',
                          boxShadow: isConnected ? '0 0 8px var(--accent-glow)' : '0 0 6px rgba(240,82,82,.3)',
                          animation: isConnected && sel ? 'glowPulse 2.5s ease infinite' : 'none',
                        }} />}
                      </div>
                      <div style={{ overflow: 'hidden', flex: 1 }}>
                        <div style={{ fontSize: 14, fontWeight: sel ? 800 : 600, color: sel ? 'var(--text)' : 'var(--text2)', letterSpacing: '-.2px', transition: 'all .2s' }}>{bot.label}</div>
                        <div style={{ fontSize: 11, color: isConnected ? (sel ? 'var(--accent)' : 'var(--text3)') : 'var(--red)', fontFamily: 'JetBrains Mono,monospace', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginTop: 1, transition: 'color .2s' }}>
                          {isConnected ? '+' + num.replace(/^(\d{2})(\d{2})(\d+)/, '$1 ($2) $3') : '● Desconectado'}
                        </div>
                      </div>
                      {sel && <div style={{ position: 'absolute', bottom: 0, left: '15%', right: '15%', height: 3, borderRadius: '3px 3px 0 0', background: 'linear-gradient(90deg, transparent, var(--accent), transparent)' }} />}
                    </div>
                  );
                })}
              </div>
              <BotSelector bots={getAllowedBots(userPlan)} value={botId} onChange={v => { setBotId(v); setSelectedGroups(getStoredSel(v)); }} botNumbers={botNumbers} botStatuses={botStatuses} />
              {/* Status bar premium */}
              <div style={{
                display: 'flex', alignItems: 'center', gap: 14, marginBottom: 18, padding: '14px 18px',
                background: status === 'open'
                  ? 'linear-gradient(135deg, rgba(0,208,132,.12), rgba(0,208,132,.03))'
                  : 'linear-gradient(135deg, rgba(240,82,82,.1), rgba(240,82,82,.03))',
                borderRadius: 14,
                border: status === 'open' ? '1.5px solid rgba(0,208,132,.25)' : '1.5px solid rgba(240,82,82,.2)',
                boxShadow: status === 'open' ? '0 4px 20px rgba(0,208,132,.08)' : '0 4px 20px rgba(240,82,82,.06)',
                backdropFilter: 'blur(8px)',
                transition: 'all .3s',
              }}>
                <div style={{
                  width: 10, height: 10, borderRadius: '50%', flexShrink: 0,
                  background: status === 'open' ? 'var(--accent)' : status === 'qr' ? 'var(--yellow)' : 'var(--red)',
                  boxShadow: status === 'open' ? '0 0 12px var(--accent-glow)' : 'none',
                  animation: status === 'open' ? 'glowPulse 2.5s ease infinite' : 'none',
                }} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
                  <span style={{ fontSize: 14, fontWeight: 800, color: status === 'open' ? 'var(--accent)' : 'var(--text)', letterSpacing: '-.2px' }}>{getAllowedBots(userPlan).find(b => b.id === botId)?.label || botId}</span>
                  {botNumbers[botId] && <span style={{ fontSize: 11, color: 'var(--text3)', fontFamily: 'JetBrains Mono,monospace' }}>+{botNumbers[botId].replace(/^(\d{2})(\d{2})(\d+)/, '$1 ($2) $3')}</span>}
                </div>
                <Badge status={status} />
              </div>
              <div className="card" style={{ borderRadius: 18, border: '1.5px solid var(--border)', boxShadow: 'var(--card-shadow)', overflow: 'visible' }}>
                <div className="fg">
                  <label className="fl" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ fontSize: 14 }}>📨</span> Tipo de mensagem
                  </label>
                  <div className="type-row" style={{ position: 'relative', padding: 4, borderRadius: 12, background: 'var(--bg3)', border: '1.5px solid var(--border)', display: 'flex' }}>
                    <div style={{
                      position: 'absolute', top: 4, bottom: 4,
                      left: msgType === 'text' ? 4 : msgType === 'media' ? 'calc(33.33% + 2px)' : 'calc(66.66% + 2px)',
                      width: 'calc(33.33% - 4px)',
                      background: 'var(--accent)',
                      borderRadius: 9,
                      transition: 'left .3s cubic-bezier(.22,1,.36,1)',
                      boxShadow: '0 2px 12px var(--accent-glow)',
                      zIndex: 0,
                    }} />
                    <button className="type-btn" onClick={() => setMsgType('text')} style={{
                      position: 'relative', zIndex: 1, borderRadius: 9, flex: 1,
                      color: msgType === 'text' ? '#000' : 'var(--text3)',
                      fontWeight: msgType === 'text' ? 800 : 600,
                      background: 'transparent', boxShadow: 'none',
                      transition: 'color .2s, font-weight .2s',
                    }}>💬 Texto</button>
                    <button className="type-btn" onClick={() => setMsgType('media')} style={{
                      position: 'relative', zIndex: 1, borderRadius: 9, flex: 1,
                      color: msgType === 'media' ? '#000' : 'var(--text3)',
                      fontWeight: msgType === 'media' ? 800 : 600,
                      background: 'transparent', boxShadow: 'none',
                      transition: 'color .2s, font-weight .2s',
                    }}>🖼️ Mídia</button>
                    <button className="type-btn" onClick={() => setMsgType('audio')} style={{
                      position: 'relative', zIndex: 1, borderRadius: 9, flex: 1,
                      color: msgType === 'audio' ? '#000' : 'var(--text3)',
                      fontWeight: msgType === 'audio' ? 800 : 600,
                      background: 'transparent', boxShadow: 'none',
                      transition: 'color .2s, font-weight .2s',
                    }}>🎤 Áudio</button>
                  </div>
                </div>
                <div className="fg">
                  <label className="fl" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ fontSize: 14 }}>👥</span> Grupos de destino
                    {selectedGroups.length > 0 && (
                      <span style={{
                        marginLeft: 'auto', fontSize: 12, fontWeight: 800, color: '#000',
                        background: 'var(--accent)', padding: '2px 10px', borderRadius: 20,
                        fontFamily: 'JetBrains Mono,monospace',
                        animation: 'countUp .25s cubic-bezier(.22,1,.36,1)',
                        boxShadow: '0 2px 8px var(--accent-glow)',
                      }}>{selectedGroups.length}</span>
                    )}
                  </label>
                  <GroupsSelector botId={botId} selected={selectedGroups} onChange={setSelectedGroups} />
                </div>
                <div className="fg">
                  <label className="fl" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ fontSize: 14 }}>{msgType === 'text' ? '✍️' : '📝'}</span>
                    {msgType === 'text' ? 'Mensagem' : 'Legenda (opcional)'}
                  </label>
                  <div style={{ position: 'relative' }}>
                    <textarea className="fta" placeholder="Digite sua mensagem..." value={text} onPaste={handlePasteMedia} onChange={e => setText(e.target.value)}
                      style={{ paddingBottom: 32, borderRadius: 12, minHeight: 100, transition: 'border-color .2s, box-shadow .2s' }}
                      onFocus={e => { e.target.style.boxShadow = '0 0 0 3px var(--accent-glow)'; }}
                      onBlur={e => { e.target.style.boxShadow = 'none'; }}
                    />
                    <div style={{
                      position: 'absolute', bottom: 8, right: 12,
                      fontSize: 11, fontWeight: 700, fontFamily: 'JetBrains Mono,monospace',
                      color: text.length > 4000 ? 'var(--red)' : text.length > 2000 ? 'var(--yellow)' : 'var(--text3)',
                      transition: 'color .2s',
                      pointerEvents: 'none',
                    }}>{text.length > 0 ? text.length.toLocaleString('pt-BR') + ' chars' : ''}</div>
                  </div>
                </div>
                {msgType === 'media' && (
                  <div className="fg">
                    <label className="fl">Arquivo de mídia</label>
                    <label className={`fdrop ${filePath ? 'has' : ''}`}>
                      <input type="file" accept="image/*,video/*" onChange={handleUpload} />
                      <div className="fdrop-ico">{filePath ? '✅' : '📁'}</div>
                      <div className="fdrop-txt">{uploading ? 'Enviando...' : filePath ? fileName : 'Clique para escolher imagem ou vídeo'}</div>
                    </label>
                    {mpSrc && (<div style={{ marginTop: 10, position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
                      {mpVideo ? <video src={mpSrc} controls style={{ maxWidth: '100%', maxHeight: 240, borderRadius: 10, display: 'block' }} /> : <img src={mpSrc} alt="" style={{ maxWidth: '100%', maxHeight: 240, borderRadius: 10, display: 'block' }} />}
                      <button type="button" onClick={() => { setFilePath(''); setFileName(''); setMediaPrev(''); setMediaPrevKind(''); }} style={{ position: 'absolute', top: 6, right: 6, width: 26, height: 26, borderRadius: 13, border: 'none', background: 'rgba(0,0,0,.7)', color: '#fff', cursor: 'pointer', fontWeight: 800 }}>x</button>
                    </div>)}
                  </div>
                )}
                {msgType === 'audio' && (
                  <div className="fg">
                    <label className="fl">Arquivo de áudio (aparece como gravado 🎤)</label>
                    <label className={`fdrop ${filePath ? 'has' : ''}`}>
                      <input type="file" accept="audio/*" onChange={handleUpload} />
                      <div className="fdrop-ico">{filePath ? '✅' : '🎤'}</div>
                      <div className="fdrop-txt">{uploading ? 'Enviando...' : filePath ? fileName : 'Clique para escolher arquivo de áudio (mp3, ogg, m4a...)'}</div>
                    </label>
                  </div>
                )}
                <div className="fg">
                  <label className="fl">Data e hora do envio</label>
                  <input className="fi" type="datetime-local" value={scheduleAt} onChange={e => setScheduleAt(e.target.value)} />
                </div>
                <div className="fg" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', background: 'var(--bg3)', borderRadius: 'var(--r-sm)', border: '1.5px solid var(--border)', cursor: 'pointer' }} onClick={() => setMentionAll(m => !m)}>
                  <div style={{ width: 20, height: 20, borderRadius: 5, border: '2px solid ' + (mentionAll ? 'var(--accent)' : 'var(--border2)'), background: mentionAll ? 'var(--accent)' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 800, color: '#000', flexShrink: 0, transition: 'all .15s' }}>{mentionAll ? '✓' : ''}</div>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: mentionAll ? 'var(--accent)' : 'var(--text)' }}>🔔 Mencionar todos (@all)</div>
                    <div style={{ fontSize: 11.5, color: 'var(--text3)', marginTop: 2 }}>Notifica todos os membros do grupo</div>
                  </div>
                </div>
                {/* ── Delay entre grupos ── */}
                <div style={{marginBottom:12,border:'1px solid var(--border2)',borderRadius:12,overflow:'hidden',background:'var(--bg2)'}}>
                  <button onClick={() => setDelayOpen(o => !o)}
                    style={{width:'100%',display:'flex',alignItems:'center',justifyContent:'space-between',padding:'11px 14px',background:'none',border:'none',cursor:'pointer',color:'var(--text)'}}>
                    <span style={{display:'flex',alignItems:'center',gap:8,fontWeight:700,fontSize:13}}>
                      <span>⏱️</span> Delay entre grupos
                    </span>
                    <span style={{display:'flex',alignItems:'center',gap:8}}>
                      <span style={{background:'rgba(0,208,132,.12)',color:'var(--accent)',borderRadius:6,padding:'2px 9px',fontSize:11,fontWeight:700}}>
                        {delayMin}s – {delayMax}s
                      </span>
                      <span style={{fontSize:12,color:'var(--text3)',display:'inline-block',transition:'transform .2s',transform:delayOpen?'rotate(180deg)':'rotate(0deg)'}}>▾</span>
                    </span>
                  </button>
                  {delayOpen && (
                    <div style={{padding:'0 14px 14px',display:'flex',flexDirection:'column',gap:10}}>
                      <p style={{margin:0,fontSize:12,color:'var(--text3)',lineHeight:1.5}}>
                        Intervalo aleatório entre cada grupo. Em segundos (mín 10s, máx 600s).
                      </p>
                      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                        <div>
                          <label style={{display:'block',fontSize:11,color:'var(--text3)',marginBottom:5,fontWeight:600}}>Mínimo (s)</label>
                          <input type="number" min="2" max="600" value={delayMin}
                            onChange={e => setDelayMin(e.target.value)}
                            style={{width:'100%',padding:'8px 10px',borderRadius:8,border:'1.5px solid var(--border2)',background:'var(--bg3)',color:'var(--text)',fontSize:14,boxSizing:'border-box'}} />
                        </div>
                        <div>
                          <label style={{display:'block',fontSize:11,color:'var(--text3)',marginBottom:5,fontWeight:600}}>Máximo (s)</label>
                          <input type="number" min="2" max="600" value={delayMax}
                            onChange={e => setDelayMax(e.target.value)}
                            style={{width:'100%',padding:'8px 10px',borderRadius:8,border:'1.5px solid var(--border2)',background:'var(--bg3)',color:'var(--text)',fontSize:14,boxSizing:'border-box'}} />
                        </div>
                      </div>
                      <button onClick={saveDelay} disabled={delaySaving}
                        style={{alignSelf:'flex-end',padding:'7px 18px',borderRadius:8,border:'none',cursor:'pointer',fontWeight:700,fontSize:13,
                          background:delaySaving?'var(--bg4)':'linear-gradient(135deg,var(--accent),#00956b)',
                          color:delaySaving?'var(--text3)':'#000',transition:'all .2s'}}>
                        {delaySaving ? 'Salvando...' : '💾 Salvar'}
                      </button>
                    </div>
                  )}
                </div>

                <button className="btn btn-p btn-full" onClick={handleSchedule} disabled={scheduling}
                  style={{
                    padding: '16px 20px', fontSize: 15, fontWeight: 800, borderRadius: 14, position: 'relative', overflow: 'hidden',
                    background: scheduling ? 'var(--bg4)' : 'linear-gradient(135deg, var(--accent), #00956b)',
                    color: scheduling ? 'var(--text3)' : '#000',
                    boxShadow: scheduling ? 'none' : '0 6px 24px var(--accent-glow)',
                    transform: scheduling ? 'none' : 'translateY(0)',
                    transition: 'all .25s cubic-bezier(.22,1,.36,1)',
                    letterSpacing: '-.2px',
                  }}
                  onMouseEnter={e => { if (!scheduling) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,208,132,.35)'; }}}
                  onMouseLeave={e => { if (!scheduling) { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 6px 24px var(--accent-glow)'; }}}
                >
                  {scheduling ? '⏳ Agendando...' : `🚀 Agendar para ${selectedGroups.length} grupo(s)`}
                </button>

                {/* Importar sequência salva */}
                <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px dashed var(--border2)' }}>
                  <SeqQuickDispatch botId={botId} show={show} loadMsgs={loadMsgs} />
                </div>
              </div>

              {/* ========== MONITOR DE ENVIOS ========== */}
              <SendMonitor messages={messages} botId={botId} botNumbers={botNumbers} loadMsgs={loadMsgs} onCancelGroup={handleAgendaCancelGroup} onDeleteGroup={handleAgendaDeleteGroup} onEditGroup={handleAgendaEditGroups} editLoading={agendaEditLoading} />
            </div>
          )}

          {page === 'polls' && (
            <div className="fade-up">
              <div className="ph" style={{ marginBottom: 28 }}>
                <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)', fontSize: 18, boxShadow: '0 4px 16px rgba(139,92,246,.25)' }}>📊</span>
                  Enquetes
                </h1>
                <p>Crie enquetes para seus grupos</p>
              </div>

              <div className="bot-tabs-desktop" style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                {getAllowedBots(userPlan).map(b => (
                  <button key={b.id} className={`type-btn ${pollBotId === b.id ? 'active' : ''}`} onClick={() => { setPollBotId(b.id); setPollGroups(getStoredSel(b.id)); }}>📱 {b.label}</button>
                ))}
              </div>
              <BotSelector bots={getAllowedBots(userPlan)} value={pollBotId} onChange={v => { setPollBotId(v); setPollGroups(getStoredSel(v)); }} botNumbers={botNumbers} botStatuses={botStatuses} />

              <div className="card">
                <div className="fg">
                  <label className="fl">Título da Enquete</label>
                  <input className="fi" value={pollName} onChange={e => setPollName(e.target.value)} placeholder="Ex: Qual melhor horário?" maxLength={255} />
                </div>

                <div className="fg">
                  <label className="fl">Opções (mín: 2, máx: 12)</label>
                  {pollOptions.map((opt, idx) => (
                    <div key={idx} style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
                      <span style={{ fontSize: 12, color: 'var(--text3)', minWidth: 20 }}>{idx + 1}.</span>
                      <input className="fi" value={opt} onChange={e => { const n = [...pollOptions]; n[idx] = e.target.value; setPollOptions(n); }} placeholder={'Opção ' + (idx + 1)} maxLength={100} />
                      {pollOptions.length > 2 && (
                        <button className="ib del" onClick={() => setPollOptions(pollOptions.filter((_, i) => i !== idx))}>✕</button>
                      )}
                    </div>
                  ))}
                  {pollOptions.length < 12 && (
                    <button className="btn btn-g btn-sm" onClick={() => setPollOptions([...pollOptions, ''])}>+ Adicionar opção</button>
                  )}
                </div>

                <div className="fg">
                  <label className="fl">Seleção múltipla?</label>
                  <select className="fs" value={pollSelectable} onChange={e => setPollSelectable(parseInt(e.target.value))}>
                    <option value={1}>Não (apenas 1 opção)</option>
                    <option value={0}>Sim (múltiplas opções)</option>
                  </select>
                </div>

                <div className="fg">
                  <label className="fl">{'Envio'}</label>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <button type="button" className={`type-btn ${pollMode === 'once' ? 'active' : ''}`} onClick={() => setPollMode('once')}>{'\u{1F4C5} \u00danico'}</button>
                    <button type="button" className={`type-btn ${pollMode === 'repeat' ? 'active' : ''}`} onClick={() => setPollMode('repeat')}>{'\u{1F501} Repetir toda semana'}</button>
                  </div>
                </div>

                {pollMode === 'once' ? (
                  <div className="fg">
                    <label className="fl">Data e hora do envio</label>
                    <input className="fi" type="datetime-local" value={pollSchedule} onChange={e => setPollSchedule(e.target.value)} />
                  </div>
                ) : (
                  <div className="fg">
                    <label className="fl">{'Dias e hor\u00e1rios'}</label>
                    {pollRules.map((rule, ri) => (
                      <div key={ri} style={{ border: '1px solid var(--border, rgba(255,255,255,.1))', borderRadius: 12, padding: 12, marginBottom: 10 }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                          {PR_DIAS.map((lb, di) => (
                            <button key={di} type="button" className={`type-btn ${rule.days.includes(di) ? 'active' : ''}`} style={{ flex: '0 0 auto', minWidth: 58, padding: '8px 14px', border: '1px solid var(--border, rgba(255,255,255,.18))' }} /* POLL_CHIPS_V1 */ onClick={() => setPollRules(pollRules.map((r, i) => i !== ri ? r : { ...r, days: r.days.includes(di) ? r.days.filter(x => x !== di) : [...r.days, di] }))}>{lb}</button>
                          ))}
                        </div>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                          <input className="fi" type="time" value={rule.time} onChange={e => setPollRules(pollRules.map((r, i) => i !== ri ? r : { ...r, time: e.target.value }))} style={{ maxWidth: 160 }} />
                          {pollRules.length > 1 && (
                            <button type="button" className="ib del" onClick={() => setPollRules(pollRules.filter((_, i) => i !== ri))}>{'\u2715'}</button>
                          )}
                        </div>
                      </div>
                    ))}
                    {pollRules.length < 14 && (
                      <button type="button" className="btn btn-g btn-sm" onClick={() => setPollRules([...pollRules, { days: [], time: '' }])}>{'+ Adicionar outro hor\u00e1rio'}</button>
                    )}
                    <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 8 }}>{'A enquete se repete toda semana nesses dias, sem data final. Voc\u00ea pode pausar ou excluir na lista abaixo.'}</div>
                  </div>
                )}

                <div className="fg">
                  <label className="fl">Grupos de destino</label>
                  <GroupsSelector botId={pollBotId} selected={pollGroups} onChange={setPollGroups} />
                </div>

                <button className="btn btn-p btn-full" onClick={handleCreatePoll}>
                  📊 {pollMode === 'repeat' ? 'Criar enquete recorrente para' : 'Agendar enquete para'} {pollGroups.length} grupo(s)
                </button>
              </div>

                            {pollRecs.length > 0 && (
                <div className="pr-wrap">
                  <style>{PR_CSS}</style>
                  <div className="pr-head">
                    <h3>{'\u{1F501} Enquetes recorrentes'} <span className="pr-count">{pollRecs.length}</span></h3>
                  </div>
                  <div className="pr-grid">
                    {pollRecs.map(rc => (
                      <div key={rc.id} className={'pr-card' + (rc.active ? '' : ' off')}>
                        <div className="pr-top">
                          <div className="pr-ico">{'\u{1F4CA}'}</div>
                          <div className="pr-tt">
                            <div className="pr-name">{rc.poll_name}</div>
                            <div className="pr-meta">{'WhatsApp ' + String(rc.instance_id).replace('bot', '') + ' \u2022 ' + rc.groups.length + ' grupo(s)'}</div>
                          </div>
                          <span className={'pr-pill ' + (rc.active ? 'on' : 'pause')}>{!!rc.active && <i className="pr-dot" />}{rc.active ? 'Ativa' : 'Pausada'}</span>
                        </div>
                        <div className="pr-opts">
                          {rc.poll_options.slice(0, 4).map((o, oi) => (<span key={oi} className="pr-opt">{o}</span>))}
                          {rc.poll_options.length > 4 && (<span className="pr-opt">{'+' + (rc.poll_options.length - 4)}</span>)}
                        </div>
                        <div className="pr-rules">
                          {rc.rules.map((r, ri) => (
                            <div key={ri} className="pr-rule">
                              <div className="pr-days">
                                {PR_DIAS.map((lb, di) => (<span key={di} className={'pr-day' + (r.days.includes(di) ? ' on' : '')}>{lb}</span>))}
                              </div>
                              <div className="pr-time">{'\u23f0 ' + r.time}</div>
                            </div>
                          ))}
                        </div>
                        <div className="pr-foot">
                          <div className="pr-next"><span>{rc.active ? 'Pr\u00f3ximo envio' : 'Envios'}</span><b>{rc.active ? (prNext(rc) || '\u2014') : 'Em pausa'}</b>{!!rc.active && <small style={{ opacity: .6 }}>{' \u2022 ' + rc.pend + ' na fila'}</small>}</div>
                          <div className="pr-acts">
                            <button type="button" className={'pr-btn' + (rc.active ? '' : ' go')} onClick={() => handleTogglePollRec(rc.id)}>{rc.active ? '\u23f8 Pausar' : '\u25b6 Retomar'}</button>
                            <button type="button" className="pr-btn del" onClick={() => handleDeletePollRec(rc.id)} title="Excluir">{'\u{1F5D1}'}</button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Lista de enquetes */}
              <div className="card" style={{ marginTop: 16 }}>
                <div className="card-hd">
                  <div><div className="card-t">📊 Enquetes agendadas</div></div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button className="btn btn-g btn-sm" onClick={loadPolls}>🔄</button>
                    <button className="btn btn-w btn-sm" onClick={handleCancelAllPolls}>⏹ Cancelar</button>
                    <button className="btn btn-d btn-sm" onClick={handleDeleteAllPolls}>🗑 Limpar</button>
                  </div>
                </div>
                {polls.length === 0 ? (
                  <div className="empty"><div className="empty-ico">📊</div><div className="empty-txt">Nenhuma enquete</div></div>
                ) : (
                  <div className="feed">
                    {(() => {
                      // Agrupa enquetes por poll_name + horário + instância
                      const pgrouped = new Map();
                      polls.forEach(p => {
                        const key = (p.instance_id || p.instance || 'bot1') + '__' + (p.schedule_at||'').slice(0,16) + '__' + (p.poll_name||'');
                        if (!pgrouped.has(key)) pgrouped.set(key, { ...p, count: 0, ids: [], statuses: [], instance_id: p.instance_id || p.instance || 'bot1' });
                        const g = pgrouped.get(key); g.count++; g.ids.push(p.id); g.statuses.push(p.status);
                      });
                      const dominantStatus = (statuses) => {
                        if (statuses.every(s => s === 'sent')) return 'sent';
                        if (statuses.some(s => s === 'pending')) return 'pending';
                        if (statuses.some(s => s === 'failed')) return 'failed';
                        return statuses[0];
                      };
                      return Array.from(pgrouped.values()).map(p => {
                      const dt = new Date(p.schedule_at);
                      const dateStr = dt.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) + ' ' + dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
                      const status = dominantStatus(p.statuses);
                      const sent = p.statuses.filter(s => s === 'sent').length;
                      return (
                        <div key={p.ids[0]} className="feed-card">
                          <div className="feed-body">
                            <div className="feed-row1">
                              <div className="feed-grp">📊 {p.poll_name}</div>
                              <span className={'chip ch-' + status}>{status}</span>
                            </div>
                            <div style={{ fontSize: 12, color: 'var(--accent)', fontWeight: 700, marginBottom: 6 }}>
                              {p.count} grupo(s) · WA{(p.instance_id||p.instance||'bot1').replace('bot','')}
                              {sent > 0 && sent < p.count && <span style={{ color: 'var(--text3)', fontWeight: 500 }}> · {sent}/{p.count} enviados</span>}
                            </div>
                            <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', margin: '8px 0', maxWidth: '100%', overflow: 'hidden' }}>
                              {(Array.isArray(p.poll_options) ? p.poll_options : []).map((opt, idx) => (
                                <span key={idx} className="chip" style={{ background: 'var(--bg4)', color: 'var(--text)', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>{idx + 1}. {opt}</span>
                              ))}
                            </div>
                            <div className="feed-time">⏰ {dateStr} · {p.selectable_count === 1 ? 'Seleção única' : 'Múltipla'}</div>
                            {p.error && <div style={{ fontSize: 12, color: 'var(--red)', marginTop: 6 }}>❌ {p.error}</div>}
                            <div className="feed-footer">
                              <span className="feed-id">{p.count} enquete(s)</span>
                              <div className="feed-actions">
                                {status === 'pending' && (
                                  <button className="btn btn-o btn-sm" onClick={() => p.ids.forEach(id => handleCancelPoll(id))}>⏹ Cancelar ({p.count})</button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    });
                    })()}
                  </div>
                )}
              </div>
            </div>
          )}

          {page === 'sequences' && (
            <div className="fade-up">
              <div className="ph" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: 0 }}>
                <div>
                  <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)', fontSize: 18, boxShadow: '0 4px 16px rgba(59,130,246,.25)' }}>📋</span>
                    Sequências
                  </h1>
                  <p style={{ fontSize: 13, color: 'var(--text3)', marginTop: 4 }}>Salve templates para reutilizar</p>
                </div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  <button className="btn btn-g btn-sm" onClick={handleShareExport} title={'Exportar suas sequ\u00eancias (Agendador e Status) para outro cliente'}>
                    {'\u{1F4E4} Exportar arquivo'}
                  </button>
                  <label className="btn btn-g btn-sm" style={{ cursor: 'pointer', margin: 0 }} title={'Importar sequ\u00eancias recebidas de outro usu\u00e1rio'}>
                    {'\u{1F4E5} Importar arquivo'}
                    <input type="file" accept=".json" style={{ display: 'none' }} onChange={handleShareImport} />
                  </label>
                  <button className="btn btn-g btn-sm" onClick={handleShareCode} title={'Gerar um c\u00f3digo para outro cliente importar suas sequ\u00eancias'}>
                    {'\u{1F511} Gerar c\u00f3digo'}
                  </button>
                  <button className="btn btn-g btn-sm" onClick={handleShareCodeUse} title={'Importar sequ\u00eancias com um c\u00f3digo recebido'}>
                    {'\u{1F511} Usar c\u00f3digo'}
                  </button>
                </div>
              </div>

              {/* FORMULÁRIO */}
              <div className="card">
                <div className="card-hd">
                  <div>
                    <div className="card-t">{seqEditId ? '✏️ Editando' : '📋 Nova Sequência'}</div>
                    <div className="card-s">Salvar grava o template. Use "Disparar" para agendar.</div>
                  </div>
                </div>

                <div className="fg">
                  <label className="fl">Nome da sequência</label>
                  <input className="fi" value={seqName} onChange={e => setSeqName(e.target.value)} placeholder="Ex: Promoção Segunda-feira" />
                </div>

                <label className="fl">Mensagens ({seqItems.length})</label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxHeight: 950, overflowY: 'auto', marginBottom: 12 }}> {/* SEQ_CONTAINER_TALLER_V1 */}
                  {seqItems.map((item, idx) => (
                    <div key={idx} style={{ padding: 14, border: '1.5px solid var(--border)', borderRadius: 'var(--r-sm)', background: 'var(--bg3)' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <span style={{ fontSize: 12, fontWeight: 800, color: 'var(--accent)' }}>#{idx + 1}</span>
                        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                          <div style={{ display: 'flex', gap: 3, padding: 3, borderRadius: 20, border: '1px solid var(--border)', background: 'var(--bg2)' }}>
                            {['text', 'media'].map(tp => (
                              <button key={tp} onClick={() => seqUpdateItem(idx, 'type', tp)}
                                style={{ padding: '3px 10px', fontSize: 11, fontWeight: 700, border: 'none', borderRadius: 16, cursor: 'pointer', fontFamily: 'Inter,sans-serif',
                                  background: item.type === tp ? 'var(--accent)' : 'transparent', color: item.type === tp ? '#000' : 'var(--text3)' }}>
                                {tp === 'text' ? 'Txt' : 'Míd'}
                              </button>
                            ))}
                          </div>
                          {seqItems.length > 1 && <button className="ib del" onClick={() => seqRemoveItem(idx)}>✕</button>}
                        </div>
                      </div>

                      <textarea className="fta" style={{ minHeight: 350, marginBottom: 8 }} value={item.text || ''} onChange={e => seqUpdateItem(idx, 'text', e.target.value)} placeholder="Texto / legenda..." /> {/* BIGGER_TEXTAREA_PREVIEW_V2 */}

                      <div style={{ marginBottom: 8 }}>
                        <span style={{ fontSize: 11, color: 'var(--text3)' }}>Mídia:</span>
                        <input type="file" accept="image/*,video/*" onChange={e => seqUploadFile(idx, e.target.files[0])} style={{ fontSize: 11, marginLeft: 6 }} />
                        {seqUploadingIdx === idx && <span style={{ fontSize: 11, color: 'var(--yellow)' }}> Enviando...</span>}
                        {item.file_path && <div style={{ fontSize: 10, color: 'var(--accent)', marginTop: 4 }}>✅ {item.file_path.split('/').pop()}</div>}
                        {item.file_path && (() => {
                          const url = 'https://app.pulsend.online' + item.file_path.replace('/var/www/whats-saas', '');
                          const isVideo = /\.(mp4|mov|webm|m4v)$/i.test(item.file_path);
                          return isVideo
                            ? <video src={url} controls style={{ maxWidth: '100%', maxHeight: 350, borderRadius: 8, marginTop: 6, display: 'block' }} />
                            : <img src={url} alt="preview" style={{ maxWidth: '100%', maxHeight: 350, borderRadius: 8, marginTop: 6, objectFit: 'contain', display: 'block' }} />;
                        })()}
                      </div>

                      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                        <div>
                          <span style={{ fontSize: 10, color: 'var(--text3)' }}>Horário</span>
                          <input type="time" value={item.time_offset || '07:00'} onChange={e => seqUpdateItem(idx, 'time_offset', e.target.value)}
                            style={{ display: 'block', padding: '6px 10px', fontSize: 13, border: '1.5px solid var(--border)', borderRadius: 8, background: 'var(--bg2)', color: 'var(--text)', fontFamily: 'Inter,sans-serif' }} />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', marginTop: 14 }} onClick={() => seqUpdateItem(idx, 'mention_all', !item.mention_all)}>
                          <div style={{ width: 16, height: 16, borderRadius: 4, border: '2px solid ' + (item.mention_all ? 'var(--accent)' : 'var(--border2)'), background: item.mention_all ? 'var(--accent)' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 800, color: '#000' }}>{item.mention_all ? '✓' : ''}</div>
                          <span style={{ fontSize: 12, fontWeight: 600, color: item.mention_all ? 'var(--accent)' : 'var(--text3)' }}>🔔 Mencionar</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <button className="btn btn-g btn-sm" onClick={seqAddItem} style={{ marginBottom: 14 }}>+ Adicionar mensagem</button>

                {seqMsg && <div style={{ fontSize: 13, color: seqMsg.includes('Erro') ? 'var(--red)' : 'var(--accent)', marginBottom: 10, fontWeight: 600 }}>{seqMsg}</div>}

                <div style={{ display: 'flex', gap: 8 }}>
                  <button className="btn btn-p" onClick={seqSave}>{seqEditId ? 'Atualizar' : 'Salvar sequência'}</button>
                  {seqEditId && <button className="btn btn-g" onClick={seqCancelEdit}>Cancelar</button>}
                </div>
              </div>

              {/* LISTA DE SEQUÊNCIAS SALVAS */}
              <div className="card" style={{ marginTop: 16 }}>
                <div className="card-hd">
                  <div><div className="card-t">📂 Sequências salvas</div></div>
                  <button className="btn btn-g btn-sm" onClick={loadSequences}>🔄</button>
                </div>
                {/* Campo de busca */}
                <div style={{ padding: '0 0 12px 0' }}>
                  <input
                    className="fi"
                    type="text"
                    placeholder="🔍 Buscar sequência pelo nome..."
                    value={seqSearch}
                    onChange={e => setSeqSearch(e.target.value)}
                    style={{ width: '100%' }}
                  />
                </div>

                {/* Card de disparo */}
                {seqDispatchId && (
                  <div style={{ padding: 14, border: '1.5px solid var(--accent)', borderRadius: 'var(--r-sm)', background: 'var(--accent-dim)', marginBottom: 14 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8, color: 'var(--text)' }}>
                      🚀 Disparar: {sequences.find(s => s.id === seqDispatchId)?.name}
                    </div>
                    <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 10 }}>
                      Escolha a data e o bot. Os horários salvos serão mantidos.
                    </div>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                      <input type="date" value={seqDispatchDate} onChange={e => setSeqDispatchDate(e.target.value)}
                        style={{ padding: '7px 12px', fontSize: 13, border: '1.5px solid var(--accent)', borderRadius: 8, background: 'var(--bg2)', color: 'var(--text)', fontFamily: 'Inter,sans-serif' }} />
                      <select value={seqDispatchBot} onChange={e => setSeqDispatchBot(e.target.value)}
                        style={{ padding: '7px 12px', fontSize: 13, border: '1.5px solid var(--border)', borderRadius: 8, background: 'var(--bg2)', color: 'var(--text)', fontFamily: 'Inter,sans-serif' }}>
                        {getAllowedBots(userPlan).map(b => <option key={b.id} value={b.id}>{b.label}</option>)}
                      </select>
                      <button className="btn btn-p btn-sm" onClick={seqDispatch}>🚀 Confirmar</button>
                      <button className="btn btn-g btn-sm" onClick={() => { setSeqDispatchId(null); setSeqDispatchDate(''); setSeqMsg(''); }}>Cancelar</button>
                    </div>
                    {seqMsg && <div style={{ fontSize: 12, color: 'var(--red)', marginTop: 6, fontWeight: 600 }}>{seqMsg}</div>}
                  </div>
                )}

                {sequences.length === 0 ? (
                  <div className="empty"><div className="empty-ico">📋</div><div className="empty-txt">Nenhuma sequência salva</div></div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {sequences.filter(seq => seq.name.toLowerCase().includes(seqSearch.toLowerCase())).map(seq => (
                      <div key={seq.id} style={{ border: '1.5px solid var(--border)', borderRadius: 'var(--r)', background: 'var(--bg3)', boxShadow: 'var(--card-shadow)', overflow: 'hidden', maxWidth: '100%' }}>
                        {/* Cabeçalho clicável */}
                        <div
                          onClick={() => setSeqExpanded(prev => ({ ...prev, [seq.id]: !prev[seq.id] }))}
                          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', cursor: 'pointer', userSelect: 'none' }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <span style={{ fontSize: 14, color: 'var(--text3)', transition: 'transform 0.2s', transform: seqExpanded[seq.id] ? 'rotate(90deg)' : 'rotate(0deg)', display: 'inline-block' }}>▶</span>
                            <span style={{ fontWeight: 800, fontSize: 15, color: 'var(--text)' }}>📋 {seq.name}</span>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span className="chip" style={{ background: 'var(--accent-dim)', color: 'var(--accent)', fontSize: 12, padding: '4px 12px' }}>{seq.items.length} msgs</span>
                            <span style={{ fontSize: 11, color: 'var(--text3)' }}>{new Date(seq.created_at).toLocaleDateString('pt-BR')}</span>
                          </div>
                        </div>

                        {/* Conteúdo expansível */}
                        {seqExpanded[seq.id] && (
                        <div style={{ padding: '0 12px 12px 12px', overflow: 'hidden', maxWidth: '100%' }}>
                        {/* Items com thumbnail + texto + horário */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '12px', overflow: 'hidden' }}>
                          {seq.items.map((it, idx) => {
                            const mediaUrl = it.file_path ? (API_BASE + '/midias/' + it.file_path.split('/midias/').pop()) : null;
                            const ext = (it.file_path || '').split('.').pop().toLowerCase();
                            const isVideo = ['mp4','mov','avi','webm'].includes(ext);
                            return (
                              <div key={idx} style={{ 
                                display: 'flex', 
                                gap: '8px', 
                                alignItems: 'center', 
                                padding: '8px', 
                                borderRadius: '10px', 
                                background: 'var(--bg2)', 
                                border: '1px solid var(--border)', 
                                minWidth: 0, 
                                overflow: 'hidden',
                                maxWidth: '100%'
                              }}>
                                {/* Thumbnail */}
                                {mediaUrl && !isVideo ? (
                                  <img src={mediaUrl} alt="" style={{ width: '42px', height: '42px', borderRadius: '8px', objectFit: 'cover', flexShrink: 0, cursor: 'pointer' }} onError={e => e.target.style.display='none'} onClick={() => openPreview(seq, idx)} />
                                ) : mediaUrl && isVideo ? (
                                  <div style={{ width: '42px', height: '42px', borderRadius: '8px', background: 'var(--bg4)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '18px', cursor: 'pointer' }} onClick={() => openPreview(seq, idx)}>🎬</div>
                                ) : (
                                  <div style={{ width: '42px', height: '42px', borderRadius: '8px', background: 'var(--bg4)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '18px', cursor: 'pointer' }} onClick={() => openPreview(seq, idx)}>📝</div>
                                )}

                                {/* Texto + menção */}
                                <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                                  <div style={{ 
                                    fontSize: '11.5px', 
                                    color: 'var(--text)', 
                                    overflow: 'hidden', 
                                    textOverflow: 'ellipsis', 
                                    whiteSpace: 'nowrap',
                                    maxWidth: '100%'
                                  }}>
                                    {it.text ? it.text.slice(0, 32) + (it.text.length > 32 ? '...' : '') : (it.type === 'media' ? 'Mídia sem legenda' : 'Sem texto')}
                                  </div>
                                  {it.mention_all ? <span style={{ fontSize: '10px', color: 'var(--accent)', whiteSpace: 'nowrap' }}>🔔 Mencionar</span> : null}
                                </div>

                                {/* Horário */}
                                <span style={{ 
                                  fontSize: '14px', 
                                  fontWeight: 800, 
                                  color: 'var(--accent)', 
                                  flexShrink: 0, 
                                  fontFamily: 'JetBrains Mono, monospace',
                                  minWidth: '45px',
                                  textAlign: 'right'
                                }}>{it.time_offset}</span>
                              </div>
                            );
                          })}
                        </div>

                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', maxWidth: '100%' }}>
                          <button className="btn btn-p btn-sm" onClick={() => { setSeqDispatchId(seq.id); setSeqDispatchDate(''); setSeqMsg(''); }}>🚀 Disparar</button>
                          <button className="btn btn-w btn-sm" onClick={() => {
                          const newTimes = seq.items.map(it => window.prompt('Horário #' + (seq.items.indexOf(it)+1) + ' (atual: ' + it.time_offset + '):', it.time_offset) || it.time_offset);
                          const updated = seq.items.map((it, i) => ({ type: it.type, text: it.text, file_path: it.file_path, time_offset: newTimes[i], instance: it.instance, mention_all: it.mention_all, groups_json: it.groups_json ? JSON.parse(it.groups_json) : [] }));
                          api('/sequences/' + seq.id, { method: 'PUT', body: JSON.stringify({ name: seq.name, items: updated }) }).then(() => { show('✅ Horários atualizados!'); loadSequences(); });
                        }}>⏰ Horários</button>
                          <button className="btn btn-g btn-sm" onClick={() => seqEdit(seq)}>✏️ Editar</button>
                          <button className="btn btn-g btn-sm" onClick={() => seqOpenEditGroups(seq)} title="Editar grupos desta sequência">👥 Grupos</button>
                          <button className="btn btn-o btn-sm" onClick={() => seqCancelScheduled(seq.id)} disabled={seqCancelId === seq.id} title="Cancelar todos agendamentos pendentes">⏹ Cancelar</button>
                          <button className="btn btn-g btn-sm" onClick={() => seqDuplicate(seq.id)}>📄 Duplicar</button>
                          <button className="btn btn-d btn-sm" onClick={() => seqDelete(seq.id)}>🗑</button>
                        </div>
                        </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* MODAL DE PREVIEW - PREMIUM */}
          {previewItem && (
            <div 
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0,0,0,0.92)',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                zIndex: 99999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
                animation: 'fadeIn 0.2s ease-out'
              }}
              onClick={closePreview}
            >
              <div 
                style={{
                  width: '100%',
                  height: '100%',
                  maxWidth: '900px',
                  maxHeight: '100vh',
                  background: 'var(--bg2)',
                  borderRadius: 0,
                  border: 'none',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
                  animation: 'slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
                }}
                onClick={(e) => e.stopPropagation()}
                ref={(el) => {
                  if (el && window.innerWidth > 768) {
                    el.style.borderRadius = '16px';
                    el.style.maxHeight = '90vh';
                    el.style.height = 'auto';
                    el.parentElement.style.padding = '20px';
                  }
                }}
              >
                <div style={{
                  padding: '14px 18px',
                  borderBottom: '1.5px solid var(--border)',
                  background: 'linear-gradient(to bottom, var(--bg3), var(--bg2))',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '10px',
                  flexWrap: 'wrap'
                }}>
                  <div style={{ flex: 1, minWidth: '150px' }}>
                    <div style={{ fontWeight: 700, fontSize: '15px' }}>
                      {previewItem.sequenceName}
                    </div>
                    <div style={{ fontSize: '12px', color: 'var(--text3)', marginTop: '2px' }}>
                      {previewItem.currentIndex + 1} de {previewItem.items.length}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button 
                      className="btn btn-p btn-sm" 
                      onClick={previewEdit}
                      style={{ borderRadius: '10px' }}
                    >
                      ✏️ Editar
                    </button>
                    <button 
                      className="btn btn-g btn-sm" 
                      onClick={closePreview}
                      style={{ borderRadius: '10px' }}
                    >
                      ✕
                    </button>
                  </div>
                </div>

                <div style={{
                  flex: 1,
                  overflowY: 'auto',
                  padding: 20,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 16
                }}>
                  {(() => {
                    const item = previewItem.items[previewItem.currentIndex];
                    if (!item) return null;
                    const mediaUrl = item.file_path ? (API_BASE + '/midias/' + item.file_path.split('/midias/').pop()) : null;
                    const ext = (item.file_path || '').split('.').pop().toLowerCase();
                    const isVideo = ['mp4','mov','avi','webm'].includes(ext);
                    
                    return (
                      <>
                        {mediaUrl && (
                          <div style={{ 
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            background: 'var(--bg3)',
                            borderRadius: 12,
                            padding: 10
                          }}>
                            {isVideo ? (
                              <video 
                                src={mediaUrl}
                                controls
                                style={{
                                  maxWidth: '100%',
                                  maxHeight: '60vh',
                                  borderRadius: 8
                                }}
                              />
                            ) : (
                              <img 
                                src={mediaUrl} 
                                alt="Preview"
                                style={{
                                  maxWidth: '100%',
                                  maxHeight: '60vh',
                                  objectFit: 'contain',
                                  borderRadius: 8
                                }}
                              />
                            )}
                          </div>
                        )}
                        
                        {item.text && (
                          <div style={{
                            padding: 16,
                            background: 'var(--bg3)',
                            borderRadius: 12,
                            border: '1.5px solid var(--border)',
                            whiteSpace: 'pre-wrap',
                            lineHeight: 1.6,
                            fontFamily: 'system-ui, -apple-system, sans-serif'
                          }}>
                            {item.text}
                          </div>
                        )}
                        
                        <div style={{
                          fontSize: 12,
                          color: 'var(--text3)',
                          textAlign: 'center',
                          display: 'flex',
                          gap: 16,
                          justifyContent: 'center',
                          flexWrap: 'wrap'
                        }}>
                          <span>⏰ {item.time_offset}</span>
                          {item.mention_all && <span>🔔 Mencionar todos</span>}
                        </div>
                      </>
                    );
                  })()}
                </div>

                <div style={{
                  padding: '14px 18px',
                  borderTop: '1.5px solid var(--border)',
                  background: 'linear-gradient(to top, var(--bg3), var(--bg2))',
                  display: 'flex',
                  gap: '10px',
                  justifyContent: 'center',
                  flexWrap: 'wrap'
                }}>
                  <button
                    className="btn btn-p"
                    onClick={previewPrev}
                    disabled={previewItem.currentIndex === 0}
                    style={{ 
                      borderRadius: '10px', 
                      minWidth: '100px',
                      flex: '1',
                      maxWidth: '200px'
                    }}
                  >
                    ← Anterior
                  </button>
                  <button
                    className="btn btn-p"
                    onClick={previewNext}
                    disabled={previewItem.currentIndex >= previewItem.items.length - 1}
                    style={{ 
                      borderRadius: '10px', 
                      minWidth: '100px',
                      flex: '1',
                      maxWidth: '200px'
                    }}
                  >
                    Próximo →
                  </button>
                </div>
                <div style={{
                  padding: '8px',
                  fontSize: '11px',
                  color: 'var(--text3)',
                  textAlign: 'center',
                  background: 'var(--bg3)',
                  borderTop: '1px solid var(--border2)'
                }}>
                  💡 Deslize para navegar no mobile
                </div>
              </div>
            </div>
          )}

          {page === 'grp-monitor' && <GroupMonitorPage show={show} />}
          {page === 'links' && (
            <div className="fade-up">
              <div className="ph" style={{ marginBottom: 28 }}>
                <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, #06b6d4, #0891b2)', fontSize: 18, boxShadow: '0 4px 16px rgba(6,182,212,.25)' }}>🔗</span>
                  Links / SRC
                </h1>
                <p>Configure o rastreio de links por grupo. Use {'{LINK}'} na mensagem.</p>
              </div>

              <div className="card">
                <div className="card-hd">
                  <div><div className="card-t">🔗 Configurar Link</div><div className="card-s">Associe um link de redirecionamento a cada grupo</div></div>
                </div>

                <div className="fg">
                  <label className="fl">WhatsApp</label>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                    {getAllowedBots(userPlan).map(b => (
                    <button key={b.id} className={`type-btn ${linkBotId === b.id ? 'active' : ''}`} onClick={() => { setLinkBotId(b.id); loadLinkGroups(b.id); }} style={linkBotId === b.id ? { background: 'var(--accent)', color: '#000' } : {}}>
                      📱 {b.label}
                      {botNumbers[b.id] && <span style={{ display: 'block', fontSize: 10, fontFamily: 'monospace', opacity: 0.8, marginTop: 2 }}>{('+' + botNumbers[b.id]).replace(/^(\+\d{2})(\d{2})(\d{1})(\d{4})(\d{4})$/, '$1 ($2) $3 $4-$5')}</span>}
                    </button>
                  ))}
                  </div>
                  <button className="btn btn-g btn-sm" onClick={() => loadLinkGroups(linkBotId)} style={{ marginBottom: 10 }}>🔄 Carregar grupos</button>
                </div>

                <div className="fg">
                  <label className="fl">Grupo(s) <span style={{ opacity: .6, fontWeight: 400 }}>({linkSelectedGroups.length} selecionado{linkSelectedGroups.length === 1 ? '' : 's'})</span></label>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                    <button type="button" className="btn btn-g btn-sm" onClick={() => setLinkSelectedGroups(linkGroups.map(g => g.id))}>Selecionar todos</button>
                    <button type="button" className="btn btn-g btn-sm" onClick={() => setLinkSelectedGroups([])}>Limpar seleção</button>
                  </div>
                  <style>{GRP_STG_CSS}</style>
                  <div className="stg-grid">
                    {linkGroups.length === 0 && <div style={{ gridColumn: '1 / -1', color: 'var(--text3)', fontSize: 13, padding: 12 }}>Carregue os grupos acima primeiro.</div>}
                    {linkGroups.map(g => (
                      <div key={g.id} className={'stg-card ' + (linkSelectedGroups.includes(g.id) ? 'sel' : '')}
                        onClick={() => setLinkSelectedGroups(prev => prev.includes(g.id) ? prev.filter(id => id !== g.id) : [...prev, g.id])}>
                        <div className="stg-ck">{linkSelectedGroups.includes(g.id) ? '✓' : ''}</div>
                        <div className="stg-av" style={{ overflow: 'hidden' }}>
                          {linkGroupPics[g.id] ? <img src={linkGroupPics[g.id]} alt="" referrerPolicy="no-referrer" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={() => setLinkGroupPics(p => ({ ...p, [g.id]: null }))} /> : '👥'}
                        </div>
                        <div style={{ minWidth: 0, flex: 1 }}><div className="stg-name">{g.name}</div></div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="fg">
                  <label className="fl">SRC (identificador do rastreio)</label>
                  <input className="fi" value={linkNewSrc} onChange={e => setLinkNewSrc(e.target.value)} placeholder="Ex: GP1, GP2, TP..." />
                </div>

                <div className="fg">
                  <label className="fl">URL de redirecionamento</label>
                  <input className="fi" value={linkNewUrl} onChange={e => setLinkNewUrl(e.target.value)} placeholder="https://seusite.com/gp1" />
                </div>

                <button className="btn btn-p" onClick={handleSaveLink}>💾 Salvar link</button>
              </div>

              {/* Lista de links configurados */}
              <div className="card" style={{ marginTop: 16 }}>
                <div className="card-hd">
                  <div><div className="card-t">📋 Links configurados</div><div className="card-s">Esses links substituem o {'{LINK}'} automaticamente</div></div>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    <button className="btn btn-sm" onClick={() => handleToggleAll(true)} style={{ background: 'rgba(34,197,94,.15)', color: '#22c55e', border: '1px solid rgba(34,197,94,.3)', borderRadius: 8, padding: '4px 10px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>▶ Ativar todos</button>
                    <button className="btn btn-sm" onClick={() => handleToggleAll(false)} style={{ background: 'rgba(239,68,68,.15)', color: '#ef4444', border: '1px solid rgba(239,68,68,.3)', borderRadius: 8, padding: '4px 10px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>⏸ Desativar todos</button>
                    <button className="btn btn-g btn-sm" onClick={loadLinkConfigs}>🔄</button>
                  </div>
                </div>

                {linkConfigs.length === 0 ? (
                  <div className="empty"><div className="empty-ico">🔗</div><div className="empty-txt">Nenhum link configurado</div></div>
                ) : (
                  <div className="tbl-wrap">
                    <table>
                      <thead>
                        <tr><th>Grupo</th><th>SRC</th><th>Link</th><th>Status</th><th>Ação</th></tr>
                      </thead>
                      <tbody>
                        {linkConfigs.map(lc => (
                          <tr key={lc.id}>
                            <td style={{ fontSize: 11, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={lc.group_id}>{linkGroups.find(g => g.id === lc.group_id)?.name || lc.group_id.slice(0, 20) + '...'}</td>
                            <td><span className="chip" style={{ background: 'var(--accent-dim)', color: 'var(--accent)' }}>{lc.src || '-'}</span></td>
                            <td style={{ fontSize: 12, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              <a href={lc.link} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--blue)' }}>{lc.link}</a>
                            </td>
                            <td>
                              <button
                                onClick={() => handleToggleLink(lc.id)}
                                style={{
                                  background: lc.active === 0 ? 'rgba(239,68,68,.15)' : 'rgba(34,197,94,.15)',
                                  color: lc.active === 0 ? '#ef4444' : '#22c55e',
                                  border: 'none', borderRadius: 8, padding: '3px 10px', fontSize: 11,
                                  fontWeight: 700, cursor: 'pointer'
                                }}
                              >{lc.active === 0 ? '⏸ Inativo' : '▶ Ativo'}</button>
                            </td>
                            <td><button className="ib del" onClick={() => handleDeleteLink(lc.id)}>🗑</button></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              {/* Dica de uso */}
              <div className="card" style={{ marginTop: 16, background: 'var(--accent-dim)', border: '1.5px solid rgba(0,208,132,.2)' }}>
                <div className="card-t" style={{ fontSize: 14 }}>💡 Como usar</div>
                <div style={{ fontSize: 13, color: 'var(--text2)', marginTop: 8, lineHeight: 1.7 }}>
                  1. Configure o link de cada grupo acima<br/>
                  2. Na mensagem de agendamento, use <strong style={{ color: 'var(--accent)' }}>{'{LINK}'}</strong> onde quer o link<br/>
                  3. O sistema substitui automaticamente pelo link correto de cada grupo<br/>
                  4. Exemplo: "Garanta o seu aqui: {'{LINK}'}" → "Garanta o seu aqui: https://seusite.com/gp1"
                </div>
              </div>
            </div>
          )}
          {page === 'status' && <StatusPage userPlan={userPlan} show={show} />}
          {page === 'campaigns' && (
            <div className="fade-up">
              <div className="ph" style={{ marginBottom: 28 }}>
                <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, #f59e0b, #d97706)', fontSize: 18, boxShadow: '0 4px 16px rgba(245,158,11,.25)' }}>🎯</span>
                  Campanhas de Grupo
                </h1>
                <p>Troque nome e foto de vários grupos de uma vez</p>
              </div>
              <div className="card">
                <div className="card-hd">
                  <div><div className="card-t">🎯 Nova Campanha</div><div className="card-s">Selecione o bot, os grupos e defina nome + foto</div></div>
                </div>
                <div className="fg">
                  <label className="fl">WhatsApp</label>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                    {getAllowedBots(userPlan).map(b => (
                    <button key={b.id} className={`type-btn ${campaignBotId === b.id ? 'active' : ''}`} onClick={() => { setCampaignBotId(b.id); loadCampaignGroups(b.id); }} style={campaignBotId === b.id ? { background: 'var(--accent)', color: '#000' } : {}}>
                      📱 {b.label}
                    </button>
                  ))}
                  </div>
                  <button className="btn btn-g btn-sm" onClick={() => loadCampaignGroups(campaignBotId)} style={{ marginBottom: 10 }}>🔄 Carregar grupos</button>
                </div>
                <div className="fg">
                  <label className="fl">Nome base do grupo</label>
                  <input className="fi" value={campaignSubjectBase} onChange={e => setCampaignSubjectBase(e.target.value)} placeholder="Ex: 🔥 Transformação 30 Dias" />
                </div>
                <div className="fg">
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                    <input type="checkbox" checked={campaignNumbering} onChange={e => setCampaignNumbering(e.target.checked)} />
                    <span className="fl" style={{ margin: 0 }}>Adicionar numeração automática no final (¹ ²  ³...)</span>
                  </label>
                </div>
                <div className="fg">
                  {/* CAMPAIGN_CARDS_JSX_V1 */}
                  <label className="fl">Foto do grupo (opcional)</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <label className="btn btn-g btn-sm" style={{ cursor: 'pointer' }}>
                      {campaignImagePreview ? '🖼️ Trocar foto' : '🖼️ Escolher foto'}
                      <input type="file" accept="image/*" style={{ display: 'none' }} onChange={e => { handleCampaignImageChange(e.target.files[0]); e.target.value = ''; }} />
                    </label>
                    {campaignImagePreview && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <img src={campaignImagePreview} alt="preview" style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: '50%', border: '1px solid var(--border)' }} />
                        <button className="btn btn-d btn-sm" onClick={() => { setCampaignImageFile(null); setCampaignImagePreview(''); }}>✕</button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="fg">
                  <style>{GRP_STG_CSS}</style>
                  <div className="stg-head">
                    <label className="fl" style={{ margin: 0 }}>Grupos</label>
                    <span className="stg-count"><b>{campaignSelectedGroups.length}</b> / {campaignGroups.length} selecionados</span>
                  </div>
                  <button className="btn btn-g btn-sm" onClick={toggleAllCampaignGroups} style={{ margin: '8px 0' }}>
                    {campaignSelectedGroups.length === campaignGroups.length && campaignGroups.length > 0 ? '☐ Desmarcar todos' : '☑ Marcar todos'}
                  </button>
                  {/* CAMPAIGN_NUM_REMOVE_JSX_V1 */}
                  <button className="btn btn-d btn-sm" onClick={resetAllCampaignNums} style={{ margin: '8px 0 8px 8px' }}>🔄 Resetar números</button>
                  <div className="stg-grid">
                    {campaignGroups.length === 0 && <div style={{ gridColumn: '1 / -1', color: 'var(--text3)', fontSize: 13, padding: 12 }}>Nenhum grupo carregado. Clique em "Carregar grupos".</div>}
                    {campaignGroups.map(g => (
                      <div key={g.id} className={'stg-card ' + (campaignSelectedGroups.includes(g.id) ? 'sel' : '')} onClick={() => toggleCampaignGroup(g.id)} style={{ position: 'relative' }}>
                        {/* CAMPAIGN_NUM_BADGE_JSX_V1 */}
                        {campaignNums[g.id] && (
                          <span onClick={(e) => { e.stopPropagation(); removeCampaignNum(g.id); }} title="Clique para remover o número fixo" style={{ position: 'absolute', top: 6, right: 8, background: 'var(--accent)', color: '#000', fontSize: 11, fontWeight: 800, padding: '2px 7px', borderRadius: 999, lineHeight: 1.4, cursor: 'pointer' }}>#{campaignNums[g.id]} ✕</span>
                        )}
                        <div className="stg-ck">{campaignSelectedGroups.includes(g.id) ? '✓' : ''}</div>
                        <div className="stg-av" style={{ overflow: 'hidden' }}>
                          {campaignPics[g.id] ? <img src={campaignPics[g.id]} alt="" referrerPolicy="no-referrer" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={() => setCampaignPics(p => ({ ...p, [g.id]: null }))} /> : '👥'}
                        </div>
                        <div style={{ minWidth: 0, flex: 1 }}><div className="stg-name">{g.name}</div></div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="fg">
                  <label className="fl">Agendar para (opcional - deixe vazio para aplicar agora)</label>
                  <input type="datetime-local" className="fi" value={campaignScheduledAt} onChange={e => setCampaignScheduledAt(e.target.value)} />
                </div>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button className="btn btn-p" disabled={campaignSaving} onClick={() => handleSaveCampaign(true)}>
                    {campaignSaving ? '⏳ Aplicando...' : '⚡ Aplicar agora'}
                  </button>
                  {campaignScheduledAt && (
                    <button className="btn btn-g" disabled={campaignSaving} onClick={() => handleSaveCampaign(false)}>
                      🕐 Agendar
                    </button>
                  )}
                </div>
              </div>
              <div className="card" style={{ marginTop: 20 }}>
                <div className="card-hd">
                  <div><div className="card-t">📋 Histórico de Campanhas</div></div>
                </div>
                {campaigns.length === 0 && <div style={{ color: 'var(--text3)', fontSize: 13, padding: 12 }}>Nenhuma campanha ainda.</div>}
                {campaigns.map(c => (
                  <div key={c.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>{c.name}</div>
                      <div style={{ fontSize: 12, color: 'var(--text3)' }}>
                        {JSON.parse(c.groups_json || '[]').length} grupo(s) · Status: {c.status}
                        {c.scheduled_at && ` · Agendado: ${c.scheduled_at}`}
                      </div>
                    </div>
                    <button className="btn btn-danger btn-sm" onClick={() => handleDeleteCampaign(c.id)}>🗑️</button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {page === 'backup-instances' && (
            <BackupInstancesPage show={show} userPlan={userPlan} />
          )}

          {page === 'sales' && (
            <SalesPage show={show} botNumbers={botNumbers} botStatuses={botStatuses} userPlan={userPlan} />
          )}
          {page === 'recuperacao' && (
            <RecuperacaoPage show={show} userPlan={userPlan} />
          )}
          {page === 'history' && (
            <div className="fade-up">
              <div className="ph" style={{ marginBottom: 28 }}>
                <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, #f59e0b, #d97706)', fontSize: 18, boxShadow: '0 4px 16px rgba(245,158,11,.25)' }}>📂</span>
                  Histórico
                </h1>
                <p>Acompanhe seus envios</p>
              </div>
              <div className="stats-row">
                <div className="stat" style={{ borderRadius: 16, border: '1.5px solid var(--border)', position: 'relative', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', top: -15, right: -15, width: 60, height: 60, borderRadius: '50%', background: 'radial-gradient(circle, rgba(0,208,132,.06), transparent 70%)', pointerEvents: 'none' }} />
                  <div className="stat-n" style={{ color: 'var(--accent)' }}><AnimatedNumber value={stats.sent} color="var(--accent)" /></div><div className="stat-l">Enviados</div>
                </div>
                <div className="stat" style={{ borderRadius: 16, border: '1.5px solid var(--border)', position: 'relative', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', top: -15, right: -15, width: 60, height: 60, borderRadius: '50%', background: 'radial-gradient(circle, rgba(63,131,248,.06), transparent 70%)', pointerEvents: 'none' }} />
                  <div className="stat-n" style={{ color: 'var(--blue)' }}><AnimatedNumber value={stats.pending} color="var(--blue)" /></div><div className="stat-l">Pendentes</div>
                </div>
                <div className="stat" style={{ borderRadius: 16, border: '1.5px solid var(--border)', position: 'relative', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', top: -15, right: -15, width: 60, height: 60, borderRadius: '50%', background: 'radial-gradient(circle, rgba(240,82,82,.06), transparent 70%)', pointerEvents: 'none' }} />
                  <div className="stat-n" style={{ color: 'var(--red)' }}><AnimatedNumber value={stats.failed} color="var(--red)" /></div><div className="stat-l">Falhas</div>
                </div>
              </div>
              <div className="btn-bar">
                <button className="btn btn-g btn-sm" onClick={loadMsgs}>🔄 Atualizar</button>
                <button className="btn btn-w btn-sm" onClick={async () => { await api(`/messages/cancel-all?bot=${botId}`, { method: 'POST' }); show('Cancelados', 'warning'); loadMsgs(); }}>⏹ Cancelar Pendentes</button>
                <button className="btn btn-d btn-sm" onClick={async () => { if (!window.confirm('Limpar todo o histórico?')) return; await api(`/messages?bot=${botId}`, { method: 'DELETE' }); show('Limpo'); loadMsgs(); }}>🗑 Limpar tudo</button>
              </div>
              {/* Filtros do histórico — Período + Status */}
              <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, padding: '12px 14px', marginBottom: 16 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '.5px' }}>📅 Período</div>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
                  {[
                    { key: 'today', label: '📅 Hoje' },
                    { key: 'yesterday', label: '⏪ Ontem' },
                    { key: '7days', label: '📆 Últimos 7 dias' },
                    { key: 'month', label: '🗓️ Este mês' },
                    { key: 'all', label: '📂 Todos' },
                  ].map(p => {
                    const active = historyPeriod === p.key;
                    return (
                      <button key={p.key} onClick={() => setHistoryPeriod(p.key)}
                        style={{ padding: '6px 12px', fontSize: 12, fontWeight: 600, border: 'none', borderRadius: 20, cursor: 'pointer', fontFamily: 'Inter,sans-serif', background: active ? 'var(--accent)' : 'var(--bg3)', color: active ? '#000' : 'var(--text3)', transition: 'all .2s' }}>
                        {p.label}
                      </button>
                    );
                  })}
                </div>
                <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '.5px' }}>🏷️ Status</div>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {[
                    { key: 'all', label: 'Todos', color: '#94a3b8' },
                    { key: 'pending', label: '⏳ Pendentes', color: '#3f83f8' },
                    { key: 'sent', label: '✅ Enviados', color: '#00d084' },
                    { key: 'failed', label: '⚠️ Falhas', color: '#f05252' },
                    { key: 'canceled', label: '⏹ Cancelados', color: '#94a3b8' },
                  ].map(s => {
                    const active = historyStatus === s.key;
                    return (
                      <button key={s.key} onClick={() => setHistoryStatus(s.key)}
                        style={{ padding: '6px 12px', fontSize: 12, fontWeight: 600, border: 'none', borderRadius: 20, cursor: 'pointer', fontFamily: 'Inter,sans-serif', background: active ? (s.color + '33') : 'var(--bg3)', color: active ? s.color : 'var(--text3)', transition: 'all .2s' }}>
                        {s.label}
                      </button>
                    );
                  })}
                </div>
              </div>
              {messages.length === 0
                ? <div className="empty"><div className="empty-ico">📭</div><div className="empty-txt">Nenhum agendamento ainda</div></div>
                : <div className="feed">{(() => {
                  // Aplica filtros antes do agrupamento
                  const _localDate = (dt) => { const y = dt.getFullYear(); const mo = String(dt.getMonth() + 1).padStart(2,'0'); const dd = String(dt.getDate()).padStart(2,'0'); return y + '-' + mo + '-' + dd; };
                  const _today = _localDate(new Date());
                  const _dY = new Date(); _dY.setDate(_dY.getDate() - 1);
                  const _yesterday = _localDate(_dY);
                  const _d7 = new Date(); _d7.setDate(_d7.getDate() - 7);
                  const _last7 = _localDate(_d7);
                  const _monthStart = _today.slice(0, 8) + '01';
                  const filteredMessages = messages.filter(m => {
                    if (historyStatus !== 'all' && m.status !== historyStatus) return false;
                    const dateOnly = (m.schedule_at || '').slice(0, 10);
                    if (historyPeriod === 'today' && dateOnly !== _today) return false;
                    if (historyPeriod === 'yesterday' && dateOnly !== _yesterday) return false;
                    if (historyPeriod === '7days' && dateOnly < _last7) return false;
                    if (historyPeriod === 'month' && dateOnly < _monthStart) return false;
                    return true;
                  });
                  const grouped = new Map();
                  filteredMessages.forEach(m => {
                    // Agrupa por: texto + horário + instância (mesmo disparo)
                    const dateKey = (m.schedule_at || '').slice(0, 16);
                    const key = (m.instance_id || 'bot1') + '__' + dateKey + '__' + (m.text || '').trim().slice(0, 80);
                    if (!grouped.has(key)) grouped.set(key, { ...m, count: 0, ids: [], first_at: m.schedule_at, last_at: m.schedule_at });
                    const g = grouped.get(key); g.count++; g.ids.push(m.id);
                    if (m.schedule_at < g.first_at) g.first_at = m.schedule_at;
                    if (m.schedule_at > g.last_at) g.last_at = m.schedule_at;
                  });
                  return Array.from(grouped.values()).sort((a, b) => new Date(b.first_at) - new Date(a.first_at)).map(m => {
                    const ext = m.file_path?.split('.').pop()?.toLowerCase();
                    const isVideo = ['mp4','mov','avi','webm'].includes(ext);
                    const isImg = ['jpg','jpeg','png','gif','webp'].includes(ext);
                    const url = m.file_path ? (API_BASE + '/midias/' + m.file_path.split('/midias/').pop()) : null;
                    const dt1 = new Date(m.first_at);
                    const dt2 = new Date(m.last_at);
                    const fmt = d => d.toLocaleDateString('pt-BR',{day:'2-digit',month:'2-digit',year:'numeric'}) + ', ' + d.toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'});
                    return (
                      <div key={m.type+m.status+(m.text||'').slice(0,20)+m.first_at} className="feed-card">
                        {url && isImg && <div className="feed-media-wrap"><img src={url} alt="" onError={e => e.target.style.display='none'} /></div>}
                        {url && isVideo && <div className="feed-media-wrap"><video src={url} controls playsInline preload="metadata" style={{ width: "100%", maxHeight: 360, objectFit: "contain" }} /></div>}
                        <div className="feed-body">
                          <div className="feed-row1">
                            <div style={{minWidth:0}}>
                              <div className="feed-grp">{m.count} grupo(s) {m.mention_all ? '🔔' : ''} <span style={{fontSize:11,color:'var(--accent)',fontWeight:600,fontFamily:'JetBrains Mono,monospace'}}> WA{(m.instance_id||'bot1').replace('bot','')}{botNumbers[m.instance_id||'bot1'] ? ' · +'+botNumbers[m.instance_id||'bot1'].slice(-4) : ''}</span></div>
                              <div className="feed-time">{fmt(dt1)} → {fmt(dt2)}</div>
                            </div>
                            <div style={{display:'flex',gap:4}}>
                              <span className={'chip ch-' + m.type}>{m.type}</span>
                              <span className={'chip ch-' + m.status}>{m.status}</span>
                            </div>
                          </div>
                          {m.text && <div className="feed-msg" style={{whiteSpace:'pre-wrap'}}>{m.text}</div>}
                          {m.error && <div style={{fontSize:12,color:'var(--red)',marginTop:6}}>Erro: {m.error}</div>}
                          <div className="feed-footer">
                            <span className="feed-id">
                              {(() => {
                                const sent = m.ids ? m.ids.filter(id => messages.find(x => x.id === id && x.status === 'sent')).length : 0;
                                const total = m.count;
                                return m.status === 'pending' || m.status === 'processing' ? (
                                  <span style={{display:'flex',alignItems:'center',gap:6}}>
                                    <span style={{width:60,height:5,borderRadius:3,background:'var(--bg4)',overflow:'hidden',display:'inline-block'}}>
                                      <span style={{width:(sent/Math.max(total,1)*100)+'%',height:'100%',display:'block',background:'var(--accent)',borderRadius:3,transition:'width .3s'}}/>
                                    </span>
                                    <span style={{fontFamily:'JetBrains Mono,monospace',fontSize:11}}>{sent}/{total}</span>
                                  </span>
                                ) : <span>{m.count} msg(s) · {m.type}</span>;
                              })()}
                            </span>
                            <div className="feed-actions">
                              {m.status === 'pending' && <button className="btn btn-b btn-sm" onClick={() => setEditModal({ m, editText: m.text || '', editFilePath: m.file_path || '', editFileName: '', editTime: (m.first_at || '').slice(0, 16), uploading: false })}>✏️ Editar</button>}
                              <button className="btn btn-g btn-sm" onClick={() => { setRescheduleModal(m); setNewTime(''); }}>📅 Reagenda</button>
                              {m.status === 'pending' && <button className="btn btn-o btn-sm" onClick={async () => { if(!window.confirm('Cancelar '+m.count+' agendamento(s)?')) return; for(const id of m.ids) await api('/messages/'+id+'/cancel',{method:'POST'}); show('Cancelados','warning'); loadMsgs(); }}>⏹ Cancelar ({m.count})</button>}
                              <button className="btn btn-d btn-sm" onClick={async () => { if(!window.confirm('Excluir '+m.count+' agendamento(s)?')) return; for(const id of m.ids) await api('/messages/'+id,{method:'DELETE'}); show('Excluídos'); loadMsgs(); }}>🗑 ({m.count})</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  });
                })()}</div>}
            </div>
          )}
        </div>
      </div>

      {/* Modal edição de grupos da sequência */}
      {seqEditGroups && (
        <div className="modal-bg" onClick={e => e.target === e.currentTarget && setSeqEditGroups(null)}>
          <div className="modal" style={{ maxWidth: 500 }}>
            <div className="modal-t">👥 Grupos — {seqEditGroups.seqName}</div>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12 }}>
              WhatsApp selecionado: <strong style={{ color: 'var(--text)' }}>{seqEditGroups.botId === 'bot1' ? 'WhatsApp 1' : seqEditGroups.botId === 'bot2' ? 'WhatsApp 2' : 'WhatsApp 3'}</strong>
              {' — '}{seqEditGroups.groups.length} grupo(s) selecionado(s)
            </div>
            {/* Seletor de WhatsApp */}
            <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
              {['bot1','bot2','bot3'].map((b,i) => (
                <button key={b} className={`btn btn-sm ${seqEditGroups.botId === b ? 'btn-p' : 'btn-g'}`}
                  onClick={async () => {
                    const r = await api('/groups?bot=' + b);
                    setSeqEditGroups(prev => ({ ...prev, botId: b, allGroups: r.ok ? r.data : [], groups: [] }));
                  }}>📱 WA{i+1}</button>
              ))}
            </div>
            {/* Lista de grupos */}
            <div style={{ maxHeight: 280, overflowY: 'auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 14 }}>
              {seqEditGroups.allGroups.length === 0 && (
                <div style={{ gridColumn: '1/-1', textAlign: 'center', color: 'var(--text3)', fontSize: 13, padding: 16 }}>Nenhum grupo carregado. Troque o WhatsApp acima.</div>
              )}
              {seqEditGroups.allGroups.map(g => {
                const sel = seqEditGroups.groups.includes(g.id);
                return (
                  <div key={g.id} className={`gi ${sel ? 'sel' : ''}`}
                    onClick={() => setSeqEditGroups(prev => ({ ...prev, groups: sel ? prev.groups.filter(x => x !== g.id) : [...prev.groups, g.id] }))}>
                    <div className="gck">{sel ? '✓' : ''}</div>
                    <div style={{display:'flex',flexDirection:'column',flex:1,minWidth:0}}>
              <span className="gn">{g.name.length > 22 ? g.name.slice(0,22) + '...' : g.name}</span>
              {g.name.length > 22 && <span style={{fontSize:10,color:'var(--text3)',marginTop:2}}>{g.name}</span>}
            </div>
                  </div>
                );
              })}
            </div>
            <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
              <button className="btn btn-g btn-sm" onClick={() => setSeqEditGroups(prev => ({ ...prev, groups: prev.allGroups.map(g => g.id) }))}>Todos</button>
              <button className="btn btn-g btn-sm" onClick={() => setSeqEditGroups(prev => ({ ...prev, groups: [] }))}>Limpar</button>
            </div>
            <div className="modal-ft">
              <button className="btn btn-g" onClick={() => setSeqEditGroups(null)}>Cancelar</button>
              <button className="btn btn-p" onClick={seqSaveGroups} disabled={seqEditGroups.groups.length === 0}>💾 Salvar grupos</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal edição de grupos de um item da agenda */}
      {agendaEditModal && (
        <div className="modal-bg" onClick={e => e.target === e.currentTarget && setAgendaEditModal(null)}>
          <div className="modal" style={{ maxWidth: 500 }}>
            <div className="modal-t">👥 Editar grupos</div>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 4 }}>
              Horário: <strong style={{ color: 'var(--accent)' }}>{agendaEditModal.item.time}</strong>
              {' · '}{agendaEditModal.selectedIds.length} grupo(s) selecionado(s)
            </div>
            <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 12, background: 'var(--bg3)', padding: '8px 12px', borderRadius: 8, fontStyle: 'italic' }}>
              "{(agendaEditModal.item.text || 'Mídia').slice(0, 60)}{agendaEditModal.item.text?.length > 60 ? '...' : ''}"
            </div>
            {/* Seletor de WhatsApp */}
            <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
              {['bot1','bot2','bot3'].map((b,i) => (
                <button key={b} className={`btn btn-sm ${agendaEditModal.botId === b ? 'btn-p' : 'btn-g'}`}
                  onClick={async () => {
                    const r = await api('/groups?bot=' + b);
                    setAgendaEditModal(prev => ({ ...prev, botId: b, allGroups: r.ok ? r.data : [], selectedIds: [] }));
                  }}>📱 WA{i+1}</button>
              ))}
            </div>
            {/* Selecionar todos / limpar */}
            <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
              <button className="btn btn-g btn-sm" onClick={() => setAgendaEditModal(prev => ({ ...prev, selectedIds: prev.allGroups.map(g => g.id) }))}>Todos</button>
              <button className="btn btn-g btn-sm" onClick={() => setAgendaEditModal(prev => ({ ...prev, selectedIds: [] }))}>Limpar</button>
              <span style={{ fontSize: 11, color: 'var(--text3)', alignSelf: 'center', marginLeft: 4 }}>{agendaEditModal.selectedIds.length}/{agendaEditModal.allGroups.length}</span>
            </div>
            {/* Lista de grupos */}
            <div style={{ maxHeight: 260, overflowY: 'auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 14 }}>
              {agendaEditModal.allGroups.length === 0 && (
                <div style={{ gridColumn: '1/-1', textAlign: 'center', color: 'var(--text3)', fontSize: 13, padding: 16 }}>Nenhum grupo. Troque o WhatsApp acima.</div>
              )}
              {agendaEditModal.allGroups.map(g => {
                const sel = agendaEditModal.selectedIds.includes(g.id);
                return (
                  <div key={g.id} className={`gi ${sel ? 'sel' : ''}`}
                    onClick={() => setAgendaEditModal(prev => ({ ...prev, selectedIds: sel ? prev.selectedIds.filter(x => x !== g.id) : [...prev.selectedIds, g.id] }))}>
                    <div className="gck">{sel ? '✓' : ''}</div>
                    <div style={{display:'flex',flexDirection:'column',flex:1,minWidth:0}}>
              <span className="gn">{g.name.length > 22 ? g.name.slice(0,22) + '...' : g.name}</span>
              {g.name.length > 22 && <span style={{fontSize:10,color:'var(--text3)',marginTop:2}}>{g.name}</span>}
            </div>
                  </div>
                );
              })}
            </div>
            <div style={{ fontSize: 11, color: 'var(--yellow)', marginBottom: 12, fontWeight: 600 }}>
              ⚠️ Grupos desmarcados serão cancelados, novos marcados serão agendados
            </div>
            <div className="modal-ft">
              <button className="btn btn-g" onClick={() => setAgendaEditModal(null)}>Cancelar</button>
              <button className="btn btn-p" onClick={async () => {
                const { item, selectedIds: sel, botId: modalBotId } = agendaEditModal;
                if (!sel || !sel.length) return;
                // Descobre quais grupos já têm pendente
                const pendingMsgs = messages.filter(m => (item.pendingIds || []).includes(m.id));
                const currentPendingGroupIds = pendingMsgs.map(m => m.to_id);
                // Grupos REMOVIDOS: tinham pendente mas foram desmarcados
                const removedGroupIds = currentPendingGroupIds.filter(gid => !sel.includes(gid));
                // Grupos ADICIONADOS: marcados mas não tinham pendente
                const addedGroupIds = sel.filter(gid => !currentPendingGroupIds.includes(gid));
                // Cancela só os pendentes dos grupos removidos
                let cancelled = 0;
                for (const msg of pendingMsgs) {
                  if (removedGroupIds.includes(msg.to_id)) {
                    await api('/messages/' + msg.id + '/cancel', { method: 'POST' });
                    cancelled++;
                  }
                }
                // Cria agendamentos só para grupos adicionados
                const schAt = item.date + 'T' + item.time + ':00';
                let created = 0;
                for (const to_id of addedGroupIds) {
                  const r = await api('/messages', { method: 'POST', body: JSON.stringify({ to_id, type: item.type || 'text', text: item.text, file_path: item.file_path, schedule_at: schAt, instance_id: modalBotId, mention_all: false }) });
                  if (r.ok) created++;
                }
                const parts = [];
                if (cancelled > 0) parts.push(cancelled + ' removido(s)');
                if (created > 0) parts.push(created + ' adicionado(s)');
                show(parts.length > 0 ? '✅ ' + parts.join(', ') : '✅ Nenhuma alteração');
                setAgendaEditModal(null); loadMsgs();
              }} disabled={!agendaEditModal.selectedIds || agendaEditModal.selectedIds.length === 0}>
                💾 Salvar ({(agendaEditModal.selectedIds || []).length} grupos)
              </button>
            </div>
          </div>
        </div>
      )}

      {editModal && (
        <div className="modal-bg" onClick={e => e.target === e.currentTarget && setEditModal(null)}>
          <div className="modal" style={{ maxWidth: 520 }}>
            <div className="modal-t">✏️ Editar Mensagem</div>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 14 }}>
              <strong style={{ color: 'var(--accent)' }}>{editModal.m.count} grupo(s)</strong> · {(editModal.m.first_at || '').slice(0, 16).replace('T', ' ')}
            </div>

            {/* Toggle tipo */}
            <div className="fg">
              <label className="fl">Tipo de conteúdo</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <button
                  className={`btn btn-sm ${!editModal.editFilePath ? 'btn-p' : 'btn-g'}`}
                  onClick={() => setEditModal(prev => ({ ...prev, editFilePath: '', editFileName: '' }))}>
                  💬 Texto
                </button>
                <button
                  className={`btn btn-sm ${editModal.editFilePath ? 'btn-p' : 'btn-g'}`}
                  onClick={() => {}}>
                  🖼 Mídia
                </button>
              </div>
            </div>

            {/* Textarea */}
            <div className="fg">
              <label className="fl">Texto / Legenda</label>
              <textarea
                className="fta"
                rows={5}
                value={editModal.editText}
                onChange={e => setEditModal(prev => ({ ...prev, editText: e.target.value }))}
                placeholder="Digite a mensagem ou legenda da mídia..."
                style={{ resize: 'vertical', minHeight: 100 }}
              />
            </div>

            {/* Upload de mídia */}
            <div className="fg">
              <label className="fl">Mídia (opcional — deixe vazio para manter atual)</label>
              {editModal.editFilePath && (
                <div style={{ fontSize: 12, color: 'var(--accent)', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span>📎 {editModal.editFileName || editModal.editFilePath.split('/').pop()}</span>
                  <button
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--red)', fontSize: 14 }}
                    onClick={() => setEditModal(prev => ({ ...prev, editFilePath: '', editFileName: '' }))}>
                    ✕
                  </button>
                </div>
              )}
              <label className="btn btn-g btn-sm" style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                {editModal.uploading ? '⏳ Enviando...' : '📤 Upload nova mídia'}
                <input
                  type="file"
                  accept="image/*,video/*"
                  style={{ display: 'none' }}
                  disabled={editModal.uploading}
                  onChange={async e => {
                    const file = e.target.files[0]; if (!file) return;
                    setEditModal(prev => ({ ...prev, uploading: true }));
                    const form = new FormData(); form.append('file', file);
                    const token = localStorage.getItem('zs_token');
                    const r = await fetch(`${API_BASE}/upload`, { method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: form }).then(x => x.json());
                    if (r.ok) {
                      setEditModal(prev => ({ ...prev, editFilePath: r.file_path, editFileName: file.name, uploading: false }));
                      show('Mídia enviada!');
                    } else {
                      show('Erro no upload', 'error');
                      setEditModal(prev => ({ ...prev, uploading: false }));
                    }
                  }}
                />
              </label>
            </div>

            {/* Horário */}
            <div className="fg">
              <label className="fl">Data e hora do envio</label>
              <input
                className="fi"
                type="datetime-local"
                value={editModal.editTime}
                onChange={e => setEditModal(prev => ({ ...prev, editTime: e.target.value }))}
              />
            </div>

            <div style={{ fontSize: 11, color: 'var(--yellow)', marginBottom: 12, fontWeight: 600 }}>
              ⚠️ Os agendamentos pendentes serão cancelados e recriados com o novo conteúdo
            </div>

            <div className="modal-ft">
              <button className="btn btn-g" onClick={() => setEditModal(null)}>Cancelar</button>
              <button
                className="btn btn-p"
                onClick={handleEditSave}
                disabled={editModal.uploading || (!editModal.editText.trim() && !editModal.editFilePath)}>
                💾 Salvar edição
              </button>
            </div>
          </div>
        </div>
      )}

      {rescheduleModal && (
        <div className="modal-bg" onClick={e => e.target === e.currentTarget && setRescheduleModal(null)}>
          <div className="modal">
            <div className="modal-t">📅 Reagendar Mensagem</div>
            <div style={{ fontSize: 13, color: 'var(--text3)', marginBottom: 16, fontWeight: 600 }}>
              {getStoredGroups(botId).find(g => g.id === rescheduleModal.to_id)?.name || rescheduleModal.to_id}
            </div>
            <div className="fg">
              <label className="fl">Nova data e hora</label>
              <input className="fi" type="datetime-local" value={newTime} onChange={e => setNewTime(e.target.value)} />
            </div>
            <div className="modal-ft">
              <button className="btn btn-g" onClick={() => setRescheduleModal(null)}>Cancelar</button>
              <button className="btn btn-p" onClick={handleReschedule} disabled={!newTime}>Reagendar</button>
            </div>
          </div>
        </div>
      )}
      <TC />


    </div>
  );
}

// ── ADMIN PANEL ───────────────────────────────────────────────────────────
function AdminPanel({ onLogout, userEmail, theme, toggleTheme }) {
  const [clients, setClients] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ email: '', password: '', plan: 'prime', expires_at: '' });
  const [sideOpen, setSideOpen] = useState(false);
  const [sequences, setSequences] = useState([]);
  const [seqSearch, setSeqSearch] = useState('');
  const [seqExpanded, setSeqExpanded] = useState({});
  const [seqName, setSeqName] = useState('');
  const [seqEditId, setSeqEditId] = useState(null);
  const [seqItems, setSeqItems] = useState([{ type: 'text', text: '', file_path: '', time_offset: '07:00', mention_all: false }]);
  const [seqUploadingIdx, setSeqUploadingIdx] = useState(-1);
  const [seqDispatchId, setSeqDispatchId] = useState(null);
  const [seqDispatchDate, setSeqDispatchDate] = useState('');
  const [seqDispatchBot, setSeqDispatchBot] = useState('bot1');
  const [seqMsg, setSeqMsg] = useState('');
  const [seqEditGroups, setSeqEditGroups] = useState(null); // { seqId, botId, groups, allGroups }
  const [seqCancelId, setSeqCancelId] = useState(null);
  const [linkConfigs, setLinkConfigs] = useState([]);
  const [linkGroups, setLinkGroups] = useState([]);
  const [linkBotId, setLinkBotId] = useState('bot1');
  const [linkNewGroup, setLinkNewGroup] = useState('');
  const [linkNewSrc, setLinkNewSrc] = useState('');
  const [linkNewUrl, setLinkNewUrl] = useState('');
  const [campaigns, setCampaigns] = useState([]);
  const [campaignBotId, setCampaignBotId] = useState('bot2');
  const [campaignGroups, setCampaignGroups] = useState([]);
  const [campaignSelectedGroups, setCampaignSelectedGroups] = useState([]);
  const [campaignSubjectBase, setCampaignSubjectBase] = useState('');
  const [campaignNumbering, setCampaignNumbering] = useState(true);
  const [campaignImageFile, setCampaignImageFile] = useState(null);
  const [campaignImagePreview, setCampaignImagePreview] = useState('');
  const [campaignScheduledAt, setCampaignScheduledAt] = useState('');
  const [campaignSaving, setCampaignSaving] = useState(false);
  const { show, TC } = useToast();
  const load = useCallback(async () => { const r = await api('/admin/clients'); if (r.ok) setClients(r.data); }, []);
  useEffect(() => { load(); }, [load]);
  const save = async () => {
    if (modal === 'add') {
      const r = await api('/admin/clients', { method: 'POST', body: JSON.stringify(form) });
      if (r.ok) { show('Cliente criado!'); load(); setModal(null); } else show(r.error, 'error');
    } else {
      const body = { plan: form.plan, expires_at: form.expires_at || null };
      if (form.password) body.password = form.password;
      await api(`/admin/clients/${modal.client.id}`, { method: 'PUT', body: JSON.stringify(body) });
      show('Atualizado!'); load(); setModal(null);
    }
  };
  const bc = s => s === 'open' ? 'var(--accent)' : s === 'qr' ? 'var(--yellow)' : 'var(--red)';
  const closeSide = () => setSideOpen(false);
  return (
    <div className="layout">
      <aside className={`sidebar ${sideOpen ? 'open' : ''}`}>
        <div className="logo">
          <div className="logo-row">
            <div className="logo-icon">⚡</div>
            <div className="logo-text"><div className="logo-n">Pulse<span>nd</span></div><div className="logo-t">Admin</div></div>
          </div>
        </div>
        <nav className="nav"><button className="nb active"><span className="nb-ico">👥</span>Clientes</button></nav>
        <div className="sfoot">
          <button className="theme-btn" onClick={toggleTheme}>
            <span style={{ fontSize: 16 }}>{theme === 'dark' ? '🌙' : '☀️'}</span>
            <span className="theme-label">{theme === 'dark' ? 'Tema Escuro' : 'Tema Claro'}</span>
            <div className={`toggle ${theme === 'dark' ? 'on' : ''}`} />
          </button>
          <div className="urow">
            <div className="av adm">A</div>
            <div className="ue">{userEmail}</div>
            <button className="lob" onClick={onLogout}>✕</button>
          </div>
        </div>
      </aside>
      {sideOpen && <div className="overlay show" onClick={closeSide} />}
      <div className="content">
        <div className="topbar">
          <button className="ham" onClick={() => setSideOpen(s => !s)}>☰</button>
          <span className="topbar-name">Pulse<span>nd</span> <span style={{ color: 'var(--text3)', fontSize: 13, fontWeight: 600 }}>Admin</span></span>
          <button className="btn btn-p btn-sm" onClick={() => { setForm({ email: '', password: '', plan: 'prime', expires_at: '' }); setModal('add'); }}>+ Novo</button>
        </div>
        <div className="inner">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 22 }}>
            <div className="ph" style={{ marginBottom: 0 }}><h1>Clientes</h1><p>{clients.length} cadastrados</p></div>
            <button className="btn btn-p" onClick={() => { setForm({ email: '', password: '', plan: 'prime', expires_at: '' }); setModal('add'); }}>+ Novo Cliente</button>
          </div>
          <div className="tbl-wrap">
            <table>
              <thead><tr><th>ID</th><th>Email</th><th>Plano</th><th>Vencimento</th><th>WA 1</th><th>Status</th><th>Ações</th></tr></thead>
              <tbody>
                {clients.map(c => (
                  <tr key={c.id}>
                    <td style={{ color: 'var(--text3)', fontSize: 12, fontFamily: 'JetBrains Mono, monospace' }}>{c.id}</td>
                    <td style={{ fontSize: 13.5, fontWeight: 500 }}>{c.email}</td>
                    <td><span className="chip" style={{
  background: c.plan === 'pro' ? 'rgba(168,85,247,.15)' : c.plan === 'premium' ? 'rgba(0,208,132,.12)' : 'rgba(63,131,248,.12)',
  color: c.plan === 'pro' ? '#a855f7' : c.plan === 'premium' ? 'var(--accent)' : 'var(--blue)'
}}>{c.plan === 'prime' ? 'Prime' : c.plan === 'premium' ? 'Premium' : c.plan === 'pro' ? 'Pro' : c.plan}</span></td>
                    <td style={{ fontSize: 12.5, whiteSpace: 'nowrap', fontFamily: 'JetBrains Mono, monospace' }}>{c.expires_at ? new Date(c.expires_at).toLocaleDateString('pt-BR') : '—'}</td>
                    <td><span style={{ fontSize: 11, fontWeight: 800, color: bc(c.instance_status_bot1), background: 'var(--bg3)', padding: '3px 9px', borderRadius: 20 }}>{c.instance_status_bot1 || 'offline'}</span></td>
                    <td><span className={`chip ${c.active ? 'ch-sent' : 'ch-failed'}`}>{c.active ? 'Ativo' : 'Bloqueado'}</span></td>
                    <td>
                      <div className="act-col">
                        <button className="ib" onClick={() => { setForm({ email: c.email, password: '', plan: c.plan, expires_at: c.expires_at?.slice(0, 10) || '' }); setModal({ mode: 'edit', client: c }); }}>✏️</button>
                        <button className="ib" onClick={async () => { await api(`/admin/clients/${c.id}`, { method: 'PUT', body: JSON.stringify({ active: c.active ? 0 : 1 }) }); load(); }}>{c.active ? '🔒' : '✅'}</button>
                        <button className="ib del" onClick={async () => { if (!window.confirm('Deletar?')) return; await api(`/admin/clients/${c.id}`, { method: 'DELETE' }); show('Deletado'); load(); }}>🗑</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {clients.length === 0 && <tr><td colSpan={7}><div className="empty"><div className="empty-ico">👥</div><div className="empty-txt">Nenhum cliente</div></div></td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {modal && (
        <div className="modal-bg" onClick={e => e.target === e.currentTarget && setModal(null)}>
          <div className="modal">
            <div className="modal-t">{modal === 'add' ? '➕ Novo Cliente' : '✏️ Editar'}</div>
            {modal === 'add' && <div className="fg"><label className="fl">Email</label><input className="fi" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="cliente@email.com" /></div>}
            <div className="fg"><label className="fl">{modal === 'add' ? 'Senha' : 'Nova Senha (opcional)'}</label><input className="fi" type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="••••••••" /></div>
            <div className="fg"><label className="fl">Plano</label><select className="fs" value={form.plan} onChange={e => setForm(f => ({ ...f, plan: e.target.value }))}><option value="prime">Prime — 1 WhatsApp</option><option value="premium">Premium — 2 WhatsApp</option><option value="pro">Pro — 3 WhatsApp</option></select></div>
            <div className="fg"><label className="fl">Vencimento</label><input className="fi" type="date" value={form.expires_at} onChange={e => setForm(f => ({ ...f, expires_at: e.target.value }))} /></div>
            <div className="modal-ft"><button className="btn btn-g" onClick={() => setModal(null)}>Cancelar</button><button className="btn btn-p" onClick={save}>Salvar</button></div>
          </div>
        </div>
      )}
      <TC />
    </div>
  );
}

// PATCH_SENHA_V1 — modal de troca de senha
function ChangePasswordModal({ forced, onClose }) {
  const [cur, setCur] = useState('');
  const [nw, setNw] = useState('');
  const [nw2, setNw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [show, setShow] = useState(false);
  const inp = { width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8, border: '1px solid #334155', background: '#0b1220', color: '#f1f5f9', fontSize: 14, outline: 'none' };
  const lbl = { display: 'block', fontSize: 12, color: '#94a3b8', margin: '12px 0 4px' };
  const submit = async (e) => {
    if (e) e.preventDefault();
    setMsg(null);
    if (!cur) return setMsg({ ok: false, t: 'Informe a senha atual.' });
    if (nw.length < 8) return setMsg({ ok: false, t: 'A nova senha precisa ter pelo menos 8 caracteres.' });
    if (nw !== nw2) return setMsg({ ok: false, t: 'A confirmação não é igual à nova senha.' });
    if (nw === cur) return setMsg({ ok: false, t: 'A nova senha precisa ser diferente da atual.' });
    setBusy(true);
    const r = await api('/auth/change-password', { method: 'POST', body: JSON.stringify({ current_password: cur, new_password: nw }) });
    setBusy(false);
    if (r && r.ok) { setMsg({ ok: true, t: 'Senha alterada com sucesso!' }); setTimeout(onClose, 1400); }
    else setMsg({ ok: false, t: (r && r.error) || 'Não foi possível alterar a senha.' });
  };
  const t = show ? 'text' : 'password';
  return createPortal(
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <form onSubmit={submit} style={{ width: '100%', maxWidth: 400, background: '#111827', color: '#f1f5f9', border: '1px solid #334155', borderRadius: 14, padding: 22, boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>🔑 Trocar senha</div>
        <div style={{ fontSize: 13, color: '#94a3b8' }}>
          {forced ? 'Sua senha atual é provisória. Por segurança, crie uma senha só sua.' : 'Escolha uma senha nova para a sua conta.'}
        </div>
        <label style={lbl}>Senha atual</label>
        <input type={t} value={cur} onChange={e => setCur(e.target.value)} autoComplete="current-password" style={inp} autoFocus />
        <label style={lbl}>Nova senha (mínimo 8 caracteres)</label>
        <input type={t} value={nw} onChange={e => setNw(e.target.value)} autoComplete="new-password" style={inp} />
        <label style={lbl}>Repita a nova senha</label>
        <input type={t} value={nw2} onChange={e => setNw2(e.target.value)} autoComplete="new-password" style={inp} />
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#94a3b8', marginTop: 10, cursor: 'pointer' }}>
          <input type="checkbox" checked={show} onChange={e => setShow(e.target.checked)} /> Mostrar senhas
        </label>
        {msg && <div style={{ marginTop: 12, fontSize: 13, padding: '8px 10px', borderRadius: 8, background: msg.ok ? 'rgba(34,197,94,0.15)' : 'rgba(239,68,68,0.15)', color: msg.ok ? '#4ade80' : '#f87171' }}>{msg.t}</div>}
        <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end' }}>
          <button type="button" onClick={onClose} disabled={busy} style={{ padding: '9px 14px', borderRadius: 8, border: '1px solid #334155', background: 'transparent', color: '#cbd5e1', cursor: 'pointer', fontSize: 13 }}>{forced ? 'Lembrar depois' : 'Cancelar'}</button>
          <button type="submit" disabled={busy} style={{ padding: '9px 16px', borderRadius: 8, border: 'none', background: '#22c55e', color: '#052e16', fontWeight: 700, cursor: 'pointer', fontSize: 13, opacity: busy ? 0.6 : 1 }}>{busy ? 'Salvando...' : 'Salvar senha'}</button>
        </div>
      </form>
    </div>,
    document.body
  );
}

function Login({ onLogin, theme, toggleTheme }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oauthError = params.get('error');
    const oauthEmail = params.get('email');
    if (oauthError) {
      let msg = 'Erro ao entrar com Google.';
      if (oauthError === 'not_registered') msg = 'E-mail ' + (oauthEmail ? decodeURIComponent(oauthEmail) : '') + ' não está cadastrado no Pulsend.';
      if (oauthError === 'inactive') msg = 'Sua conta está inativa. Fale com o administrador.';
      if (oauthError === 'no_code') msg = 'Autenticação cancelada.';
      if (oauthError === 'oauth_failed') msg = 'Falha na autenticação com Google. Tente novamente.';
      setError(msg);
      window.history.replaceState({}, document.title, '/');
    }
  }, []);

  const go = async () => {
    setLoading(true); setError('');
    const r = await api('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) });
    if (r.ok) { localStorage.setItem('zs_token', r.token); localStorage.setItem('zs_plan', r.plan || 'prime'); onLogin(r.role, r.plan || 'prime'); }
    else setError(r.error || 'Credenciais inválidas');
    setLoading(false);
  };

  const handleGoogleLogin = () => {
    window.location.href = 'https://app.pulsend.online/oauth/google';
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo-row">
          <div className="login-icon">⚡</div>
          <div className="login-logo">Pulse<span>nd</span></div>
        </div>
        <div className="login-sub">Automação profissional de WhatsApp</div>
        {error && <div className="err-box">{error}</div>}
        <div className="fg"><label className="fl">Email</label><input className="fi" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" /></div>
        <div className="fg"><label className="fl">Senha</label><input className="fi" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" onKeyDown={e => e.key === 'Enter' && go()} /></div>
        <button className="btn btn-p btn-full" onClick={go} disabled={loading} style={{ marginTop: 6 }}>
          {loading ? '⏳ Entrando...' : 'Entrar →'}
        </button>

        {/* Divisor */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '16px 0 12px' }}>
          <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
          <span style={{ fontSize: 12, color: 'var(--text3)', fontWeight: 500 }}>ou</span>
          <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
        </div>

        {/* Botão Google */}
        <button
          onClick={handleGoogleLogin}
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
            width: '100%', padding: '11px 0', borderRadius: 10,
            border: '1.5px solid var(--border)', background: 'var(--bg3)',
            color: 'var(--text)', fontSize: 14, fontWeight: 600,
            cursor: 'pointer', transition: 'all 0.2s', fontFamily: 'Inter, sans-serif'
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'var(--bg4)'; e.currentTarget.style.borderColor = 'var(--accent)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'var(--bg3)'; e.currentTarget.style.borderColor = 'var(--border)'; }}
        >
          <svg width="18" height="18" viewBox="0 0 48 48">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          Entrar com Google
        </button>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <button onClick={toggleTheme} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text3)', fontSize: 13, fontWeight: 600, fontFamily: 'Inter, sans-serif', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            {theme === 'dark' ? '☀️ Modo Claro' : '🌙 Modo Escuro'}
          </button>
        </div>
      </div>
    </div>
  );
}


const previewStyles = `
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes slideUp {
  from { 
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to { 
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
`;

if (typeof document !== 'undefined' && !document.getElementById('preview-styles')) {
  const style = document.createElement('style');
  style.id = 'preview-styles';
  style.textContent = previewStyles;
  document.head.appendChild(style);
}

export default function App() {
  const [role, setRole] = useState(null);
  const [userPlan, setUserPlan] = useState(localStorage.getItem('zs_plan') || 'prime');

  useEffect(() => {
    api('/auth/me').then(r => {
      if (r && r.plan) {
        localStorage.setItem('zs_plan', r.plan);
        setUserPlan(r.plan);
      }
    }).catch(() => {});
  }, []);
  const [userEmail, setUserEmail] = useState('');
  const [theme, setTheme] = useState(getTheme);
  const styleRef = useRef(null);

  const applyTheme = useCallback((t) => {
    if (!styleRef.current) { styleRef.current = document.createElement('style'); document.head.appendChild(styleRef.current); }
    styleRef.current.textContent = buildStyles(t);
  }, []);
  useEffect(() => { applyTheme(theme); }, [theme, applyTheme]);

  const toggleTheme = () => { const t = theme === 'dark' ? 'light' : 'dark'; setTheme(t); setThemePref(t); };

  // Captura token do Google OAuth na URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const googleToken = params.get('google_token');
    const googlePlan = params.get('plan');
    const oauthError = params.get('error');
    const oauthEmail = params.get('email');
    if (googleToken) {
      localStorage.setItem('zs_token', googleToken);
      if (googlePlan) localStorage.setItem('zs_plan', googlePlan);
      window.history.replaceState({}, document.title, '/');
      try {
        const p = JSON.parse(atob(googleToken.split('.')[1]));
        setRole(p.role);
        setUserEmail(p.email);
        setUserPlan(googlePlan || p.plan || 'prime');
      } catch {}
    }
    if (oauthError) {
      let msg = 'Erro ao entrar com Google.';
      if (oauthError === 'not_registered') msg = 'E-mail ' + (oauthEmail ? decodeURIComponent(oauthEmail) : '') + ' não está cadastrado no Pulsend.';
      if (oauthError === 'inactive') msg = 'Sua conta está inativa. Fale com o administrador.';
      if (oauthError === 'no_code') msg = 'Autenticação cancelada.';
      if (oauthError === 'oauth_failed') msg = 'Falha na autenticação com Google. Tente novamente.';
      window.history.replaceState({}, document.title, '/');
      // Armazena erro para o componente Login exibir
      window.__googleOAuthError = msg;
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('zs_token');
    if (!token) return;
    try {
      const p = JSON.parse(atob(token.split('.')[1]));
      if (p.exp * 1000 > Date.now()) { setRole(p.role); setUserEmail(p.email); }
      else localStorage.removeItem('zs_token');
    } catch { localStorage.removeItem('zs_token'); }
  }, []);

  const onLogin = (r, p) => {
    setRole(r);
    setUserPlan(p || localStorage.getItem('zs_plan') || 'prime');
    try { const p = JSON.parse(atob(localStorage.getItem('zs_token').split('.')[1])); setUserEmail(p.email); } catch {}
  };
  const onLogout = () => { localStorage.removeItem('zs_token'); setRole(null); setUserEmail(''); };

  if (!role) return <Login onLogin={onLogin} theme={theme} toggleTheme={toggleTheme} />;
  if (role === 'admin') return <AdminPanel onLogout={onLogout} userEmail={userEmail} theme={theme} toggleTheme={toggleTheme} />;
  return <ClientPanel onLogout={onLogout} userEmail={userEmail} theme={theme} toggleTheme={toggleTheme} userPlan={userPlan} />;
}

